import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, ViewChildren, ViewChild, NgModule, Injectable, Directive, Optional, InjectionToken, ViewContainerRef, SkipSelf, HostBinding, Pipe, Inject, ContentChild, TemplateRef } from '@angular/core';
import * as i1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i5$1 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i1$1 from '@angular/forms';
import { FormsModule, FormControl, Validators, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { some, cloneDeep, isEqual, assign, transform, isObject, isEmpty, every as every$1 } from 'lodash-es';
import _isEqual from 'lodash-es/isEqual';
import * as i1$3 from 'rxjs';
import { Observable, of, BehaviorSubject, Subject, ReplaySubject, timer, EMPTY, asyncScheduler, from, combineLatest, merge } from 'rxjs';
import * as i1$6 from '@xpo-ltl/ngx-ltl-core/utils';
import { DateUtils, XpoUtilsModule } from '@xpo-ltl/ngx-ltl-core/utils';
import { takeUntil, take, distinctUntilChanged, debounce, filter, concatMap, observeOn, map, catchError, tap, shareReplay, finalize, debounceTime, share, switchMap, mapTo } from 'rxjs/operators';
import * as i3$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2$1 from '@xpo-ltl/ngx-ltl-core/button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { every, each, cloneDeep as cloneDeep$1 } from 'lodash';
import * as i1$2 from '@angular/material/datepicker';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import moment from 'moment';
import _invert from 'lodash-es/invert';
import * as i2$2 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import _get from 'lodash-es/get';
import * as i4$1 from '@xpo-ltl/ngx-ltl-core/popover';
import { XpoPopoverModule } from '@xpo-ltl/ngx-ltl-core/popover';
import * as i1$4 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i7 from '@xpo-ltl/ngx-ltl-core/autofocus';
import { XpoAutofocusModule } from '@xpo-ltl/ngx-ltl-core/autofocus';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatBadgeModule } from '@angular/material/badge';
import * as i7$3 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import * as i5$2 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import * as i7$1 from '@xpo-ltl/ngx-ltl-core/responsive-loading-spinner';
import { XpoResponsiveLoadingSpinnerModule } from '@xpo-ltl/ngx-ltl-core/responsive-loading-spinner';
import * as i3$2 from '@xpo-ltl/ngx-ltl-core/chips';
import { XpoChipsModule } from '@xpo-ltl/ngx-ltl-core/chips';
import * as i1$5 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import * as i2$3 from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import * as i7$2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i3$3 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i6 from '@angular/material/menu';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import * as i15 from '@xpo-ltl/ngx-ltl-core/download-button';
import { XpoDownloadButtonModule } from '@xpo-ltl/ngx-ltl-core/download-button';
import * as i6$1 from '@xpo-ltl/ngx-ltl-core/select';
import { XpoSelectModule } from '@xpo-ltl/ngx-ltl-core/select';
import * as i3$4 from '@angular/router';
import * as i8 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import * as i8$1 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import { XpoConfirmDialogModule } from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import * as i10 from '@angular/material/divider';
import * as i1$7 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { XpoCheckboxModule } from '@xpo-ltl/ngx-ltl-core/checkbox';
import * as i2$4 from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoTabsModule } from '@xpo-ltl/ngx-ltl-core/tabs';
import * as i9 from '@xpo-ltl/ngx-ltl-core/xpo-ltl-popover';
import { XpoLtlPopoverModule } from '@xpo-ltl/ngx-ltl-core/xpo-ltl-popover';

function XpoAdvancedSelectTreeNodeComponent_ng_container_2_xpo_advanced_select_tree_node_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "xpo-advanced-select-tree-node", 3);
    i0.ɵɵlistener("optionSelected", function XpoAdvancedSelectTreeNodeComponent_ng_container_2_xpo_advanced_select_tree_node_1_Template_xpo_advanced_select_tree_node_optionSelected_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.onChildCheckboxClicked($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r2 = ctx.$implicit;
    i0.ɵɵproperty("option", child_r2);
} }
function XpoAdvancedSelectTreeNodeComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoAdvancedSelectTreeNodeComponent_ng_container_2_xpo_advanced_select_tree_node_1_Template, 1, 1, "xpo-advanced-select-tree-node", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.option.children);
} }
class XpoAdvancedSelectTreeNodeComponent {
    constructor(cd) {
        this.cd = cd;
        this.optionSelected = new EventEmitter();
    }
    onCheckboxClicked(event) {
        this.setSelected(event.checked);
        this.emitUpdate();
    }
    setSelected(checked) {
        this.option.selected = checked;
        this.option.indeterminate = false;
        this.cd.markForCheck();
        if (this.childTreeNodes && this.childTreeNodes.length) {
            this.childTreeNodes.forEach((v) => v.setSelected(checked));
        }
    }
    onChildCheckboxClicked(childOption) {
        if (this.option.children && this.option.children.length) {
            this.option.indeterminate =
                this.option.children.some((ch) => ch.selected) && !this.option.children.every((ch) => ch.selected);
            this.option.selected = this.option.children.every((ch) => ch.selected);
        }
        this.emitUpdate();
    }
    emitUpdate() {
        this.optionSelected.emit(this.option);
    }
}
XpoAdvancedSelectTreeNodeComponent.ɵfac = function XpoAdvancedSelectTreeNodeComponent_Factory(t) { return new (t || XpoAdvancedSelectTreeNodeComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoAdvancedSelectTreeNodeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAdvancedSelectTreeNodeComponent, selectors: [["xpo-advanced-select-tree-node"]], viewQuery: function XpoAdvancedSelectTreeNodeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(XpoAdvancedSelectTreeNodeComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childTreeNodes = _t);
    } }, hostAttrs: [1, "xpo-AdvancedSelectTreeNode"], hostVars: 2, hostBindings: function XpoAdvancedSelectTreeNodeComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("xpo-AdvancedSelectTreeNode--hidden", ctx.option.hidden);
    } }, inputs: { option: "option" }, outputs: { optionSelected: "optionSelected" }, decls: 3, vars: 4, consts: [[1, "xpo-AdvancedSelectTreeNode-option", 3, "checked", "indeterminate", "change"], [4, "ngIf"], ["class", "xpo-AdvancedSelectTreeNode-child xpo-AdvancedSelectTreeNode-option", 3, "option", "optionSelected", 4, "ngFor", "ngForOf"], [1, "xpo-AdvancedSelectTreeNode-child", "xpo-AdvancedSelectTreeNode-option", 3, "option", "optionSelected"]], template: function XpoAdvancedSelectTreeNodeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-checkbox", 0);
        i0.ɵɵlistener("change", function XpoAdvancedSelectTreeNodeComponent_Template_mat_checkbox_change_0_listener($event) { return ctx.onCheckboxClicked($event); });
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, XpoAdvancedSelectTreeNodeComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("checked", ctx.option.selected)("indeterminate", ctx.option.indeterminate);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.option.label, "\n");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.option.children == null ? null : ctx.option.children.length) > 0);
    } }, directives: [i1.MatCheckbox, i2.NgIf, i2.NgForOf, XpoAdvancedSelectTreeNodeComponent], styles: [".flex--stretch{flex:1}.xpo-AdvancedSelectTreeNode{cursor:pointer;display:block;flex-shrink:0}.xpo-AdvancedSelectTreeNode-option{height:32px;line-height:32px;padding:0 8px}.xpo-AdvancedSelectTreeNode-option:first-child{margin-top:0}.xpo-AdvancedSelectTreeNode-option:hover{background-color:#e8f5fe}.xpo-AdvancedSelectTreeNode--hidden{display:none}.xpo-AdvancedSelectTreeNode>.mat-checkbox{display:flex}.xpo-AdvancedSelectTreeNode>.mat-checkbox .mat-checkbox-layout{align-items:center;width:100%}.xpo-AdvancedSelectTreeNode>.mat-checkbox .mat-checkbox-layout .mat-checkbox-inner-container{margin-left:0}.xpo-AdvancedSelectTreeNode-child{padding-left:16px}.xpo-AdvancedSelectTreeNode-child>.xpo-FilterContainer-option:hover{background-color:unset}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAdvancedSelectTreeNodeComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-advanced-select-tree-node',
                templateUrl: './advanced-select-tree-node.component.html',
                styleUrls: ['./advanced-select-tree-node.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-AdvancedSelectTreeNode',
                    // Used for filtering. Instead of destroying the component, we hide it, that way the `indeterminate`
                    // logic for the parent node still works.
                    '[class.xpo-AdvancedSelectTreeNode--hidden]': 'option.hidden',
                },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { option: [{
            type: Input
        }], optionSelected: [{
            type: Output
        }], childTreeNodes: [{
            type: ViewChildren,
            args: [XpoAdvancedSelectTreeNodeComponent]
        }] }); })();

const _c0$X = ["searchBox"];
function XpoAdvancedSelectPanelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "mat-form-field", 4);
    i0.ɵɵelementStart(2, "input", 5, 6);
    i0.ɵɵlistener("keyup", function XpoAdvancedSelectPanelComponent_div_0_Template_input_keyup_2_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.filterOptions($event.target.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon", 7);
    i0.ɵɵtext(5, "search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoAdvancedSelectPanelComponent_mat_radio_group_1_mat_radio_button_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", opt_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", opt_r8.label, " ");
} }
function XpoAdvancedSelectPanelComponent_mat_radio_group_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-group", 8);
    i0.ɵɵlistener("ngModelChange", function XpoAdvancedSelectPanelComponent_mat_radio_group_1_Template_mat_radio_group_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.onOptionSelected($event); });
    i0.ɵɵtemplate(1, XpoAdvancedSelectPanelComponent_mat_radio_group_1_mat_radio_button_1_Template, 2, 2, "mat-radio-button", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1.selectedValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.filteredOptions);
} }
function XpoAdvancedSelectPanelComponent_ng_template_2_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 14);
    i0.ɵɵlistener("ngModelChange", function XpoAdvancedSelectPanelComponent_ng_template_2_mat_checkbox_1_Template_mat_checkbox_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.handleSelectAllClicked($event); });
    i0.ɵɵtext(1, " Select All ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngModel", ctx_r11.isSelectAllSelected);
} }
function XpoAdvancedSelectPanelComponent_ng_template_2_xpo_advanced_select_tree_node_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "xpo-advanced-select-tree-node", 15);
    i0.ɵɵlistener("optionSelected", function XpoAdvancedSelectPanelComponent_ng_template_2_xpo_advanced_select_tree_node_2_Template_xpo_advanced_select_tree_node_optionSelected_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const opt_r15 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.onOptionSelected(opt_r15); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r15 = ctx.$implicit;
    i0.ɵɵproperty("option", opt_r15);
} }
function XpoAdvancedSelectPanelComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, XpoAdvancedSelectPanelComponent_ng_template_2_mat_checkbox_1_Template, 2, 1, "mat-checkbox", 12);
    i0.ɵɵtemplate(2, XpoAdvancedSelectPanelComponent_ng_template_2_xpo_advanced_select_tree_node_2_Template, 1, 1, "xpo-advanced-select-tree-node", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.showSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.filteredOptions);
} }
class XpoAdvancedSelectPanelComponent {
    constructor() {
        this.isSelectAllSelected = false;
        this.isSingleSelectValue = false;
        this.showSelectAllValue = false;
        this.optionsValue = [];
        this.selectionChange = new EventEmitter();
    }
    /** Whether or not only a single option can be selected */
    get isSingleSelect() {
        return this.isSingleSelectValue;
    }
    set isSingleSelect(v) {
        this.isSingleSelectValue = coerceBooleanProperty(v);
    }
    /** Whether or not the select all checkbox is shown */
    get showSelectAll() {
        return this.showSelectAllValue;
    }
    set showSelectAll(v) {
        this.showSelectAllValue = coerceBooleanProperty(v);
    }
    /** Options of the select filter */
    get options() {
        return this.optionsValue;
    }
    set options(v) {
        this.optionsValue = this.toComponentOptions(v);
        // Only show search-bar if there is a scroll bar in the container of the options.
        this.hasSearchBar = this.optionsValue.length > 5;
        this.filteredOptions = this.optionsValue;
    }
    get selection() {
        return this.selectionValue;
    }
    set selection(value) {
        if (this.selectionValue !== value) {
            this.selectionValue = value;
            this.updateSelectedOptions(value);
        }
    }
    /**
     * Code inspired by https://github.com/anas-aljabri/angular-tree-search/blob/master/projects/tree/src/lib/globals.ts
     */
    static filterTree(tree, keyword) {
        //  If the entry is empty string return the full tree without filtering and update the matches
        if (!keyword.length || !keyword.trim().length) {
            return tree;
        }
        return tree.map(function filterCallback(node) {
            node.hidden = true;
            if (node.label.toLocaleLowerCase().indexOf(keyword) > -1) {
                node.hidden = false;
            }
            else if (node.children && node.children.length) {
                const mappedChildren = node.children.map(filterCallback);
                if (mappedChildren.some((x) => !x.hidden)) {
                    node.hidden = false;
                }
            }
            return node;
        });
    }
    ngAfterViewInit() {
        if (this.searchBox) {
            this.searchBox.nativeElement.focus();
        }
    }
    filterOptions(value) {
        this.filteredOptions = XpoAdvancedSelectPanelComponent.filterTree(this.getOptionsClone(), value);
    }
    handleSelectAllClicked(isChecked) {
        this.isSelectAllSelected = !!isChecked;
        // Set view checkboxes
        if (this.childTreeNodes && this.childTreeNodes.length) {
            this.childTreeNodes.forEach((v) => v.setSelected(isChecked));
        }
        // Set options 'selected' value
        const selectOption = (opt, value) => {
            opt.selected = value;
            if (opt.children && opt.children.length) {
                opt.children.forEach((ch) => selectOption(ch, value));
            }
        };
        this.options.forEach((x) => selectOption(x, this.isSelectAllSelected));
        const values = this.getMultiSelectCheckedValues();
        this.selectionChange.emit(values);
    }
    /** Updates the selected criterion of filter */
    onOptionSelected(selectedValue) {
        this.updateValueInOptions(selectedValue);
        let value;
        if (this.isSingleSelect) {
            this.selectedValue = selectedValue;
            value = selectedValue.value;
        }
        else {
            value = this.getMultiSelectCheckedValues();
        }
        this.selectionChange.emit(value);
    }
    toComponentOptions(options) {
        const toComponentFilterOption = (option) => {
            const children = option.children && option.children.length ? option.children.map(toComponentFilterOption) : [];
            return Object.assign(Object.assign({}, option), { indeterminate: false, selected: false, children });
        };
        return (options || []).map(toComponentFilterOption);
    }
    updateSelectedOptions(fieldValue) {
        if (this.isSingleSelect) {
            this.selectedValue = this.options.find((v) => v.value === fieldValue) || undefined;
            return;
        }
        const val = fieldValue || [];
        const loadCheckboxesState = (criteriaValues, opt) => {
            criteriaValues = typeof criteriaValues === 'string' ? [criteriaValues] : criteriaValues;
            const matchedOption = criteriaValues.find((x) => opt.value === x);
            opt.selected = !!matchedOption;
            if (opt.children && opt.children.length > 0) {
                opt.children.forEach((ch) => loadCheckboxesState(criteriaValues, ch));
            }
            opt.indeterminate =
                opt.children &&
                    opt.children.length > 0 &&
                    !opt.children.every((ch) => ch.selected) &&
                    opt.children.some((ch) => ch.selected);
        };
        const updatedOptions = this.getOptionsClone();
        updatedOptions.forEach((opt) => {
            loadCheckboxesState(val, opt);
        });
        this.optionsValue = updatedOptions;
        // TODO: we may need to account for the current input of this filter.
        // Updating the filtered options reference so that the selection appears in the view.
        this.filteredOptions = this.optionsValue;
        this.isSelectAllSelected = updatedOptions.every((o) => o.selected === true);
    }
    getMultiSelectCheckedValues() {
        const mapOptionsToValue = (options) => {
            return options
                .filter((opt) => opt.selected || opt.indeterminate)
                .map((opt) => {
                if (!opt.children || opt.children.length === 0) {
                    return opt.value;
                }
                else if (opt.children.every((ch) => ch.selected)) {
                    return [opt.value, ...mapOptionsToValue(opt.children)];
                }
                return mapOptionsToValue(opt.children);
            });
        };
        return mapOptionsToValue(this.options).flat();
    }
    updateValueInOptions(updatedValue) {
        const optionsClone = this.getOptionsClone();
        const selectedValueIndex = optionsClone.findIndex((v) => v.value === updatedValue.value);
        // visibility flags should not get passed to the original options observable
        // these flags should be present only on filteredOptions$
        // So here we are just clearing out whatever flags are set
        this.setNodeVisibility(updatedValue, false);
        optionsClone[selectedValueIndex] = updatedValue;
        this.optionsValue = optionsClone;
    }
    getOptionsClone() {
        // Cloning it this way since Object.assign only clones shallow.
        return JSON.parse(JSON.stringify(this.options));
    }
    setNodeVisibility(option, hidden) {
        option.hidden = hidden;
        option.children.forEach((x) => this.setNodeVisibility(x, hidden));
    }
}
XpoAdvancedSelectPanelComponent.ɵfac = function XpoAdvancedSelectPanelComponent_Factory(t) { return new (t || XpoAdvancedSelectPanelComponent)(); };
XpoAdvancedSelectPanelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAdvancedSelectPanelComponent, selectors: [["xpo-advanced-select-panel"]], viewQuery: function XpoAdvancedSelectPanelComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$X, 5);
        i0.ɵɵviewQuery(XpoAdvancedSelectTreeNodeComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childTreeNodes = _t);
    } }, hostAttrs: [1, "xpo-AdvancedSelectPanel"], inputs: { isSingleSelect: "isSingleSelect", showSelectAll: "showSelectAll", options: "options", selection: "selection" }, outputs: { selectionChange: "selectionChange" }, decls: 4, vars: 3, consts: [["class", "xpo-AdvancedSelectPanel-searchContainer", 4, "ngIf"], ["class", "xpo-FilterContainer-optionsContainer", 3, "ngModel", "ngModelChange", 4, "ngIf", "ngIfElse"], ["multiSelect", ""], [1, "xpo-AdvancedSelectPanel-searchContainer"], ["floatLabel", "never", 1, "xpo-AdvancedSelectPanel-search", "ngx-FormField--inline"], ["autocomplete", "off", "matInput", "", "type", "text", "placeholder", "Search", 3, "keyup"], ["searchBox", ""], ["matSuffix", "", 1, "xpo-AdvancedSelectPanel-search-icon"], [1, "xpo-FilterContainer-optionsContainer", 3, "ngModel", "ngModelChange"], ["class", "xpo-FilterContainer-option", 3, "value", 4, "ngFor", "ngForOf"], [1, "xpo-FilterContainer-option", 3, "value"], [1, "xpo-FilterContainer-optionsContainer"], ["class", "xpo-AdvancedSelectPanel-selectAll", 3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "option", "optionSelected", 4, "ngFor", "ngForOf"], [1, "xpo-AdvancedSelectPanel-selectAll", 3, "ngModel", "ngModelChange"], [3, "option", "optionSelected"]], template: function XpoAdvancedSelectPanelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, XpoAdvancedSelectPanelComponent_div_0_Template, 6, 0, "div", 0);
        i0.ɵɵtemplate(1, XpoAdvancedSelectPanelComponent_mat_radio_group_1_Template, 2, 2, "mat-radio-group", 1);
        i0.ɵɵtemplate(2, XpoAdvancedSelectPanelComponent_ng_template_2_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(3);
        i0.ɵɵproperty("ngIf", ctx.hasSearchBar);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSingleSelect)("ngIfElse", _r2);
    } }, directives: [i2.NgIf, i4.MatFormField, i5.MatInput, i3.MatIcon, i4.MatSuffix, i5$1.MatRadioGroup, i1$1.NgControlStatus, i1$1.NgModel, i2.NgForOf, i5$1.MatRadioButton, i1.MatCheckbox, XpoAdvancedSelectTreeNodeComponent], styles: [".flex--stretch{flex:1}.xpo-AdvancedSelectPanel-searchContainer{padding:16px 8px 8px}.xpo-AdvancedSelectPanel-search{width:100%}.xpo-AdvancedSelectPanel-search-icon{font-size:.875rem}.xpo-AdvancedSelectPanel-selectAll{display:flex;font-weight:500;height:32px;line-height:32px;padding:0 8px}.xpo-AdvancedSelectPanel-selectAll .mat-checkbox-label{line-height:32px}.xpo-AdvancedSelectPanel-selectAll:hover{background-color:#e8f5fe}.xpo-AdvancedSelectPanel .mat-radio-button{display:inline-flex}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAdvancedSelectPanelComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-advanced-select-panel',
                templateUrl: './advanced-select-panel.component.html',
                styleUrls: ['./advanced-select-panel.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-AdvancedSelectPanel' },
            }]
    }], null, { isSingleSelect: [{
            type: Input
        }], showSelectAll: [{
            type: Input
        }], options: [{
            type: Input
        }], selection: [{
            type: Input
        }], selectionChange: [{
            type: Output
        }], childTreeNodes: [{
            type: ViewChildren,
            args: [XpoAdvancedSelectTreeNodeComponent]
        }], searchBox: [{
            type: ViewChild,
            args: ['searchBox']
        }] }); })();

class XpoAdvancedSelectModule {
}
XpoAdvancedSelectModule.ɵfac = function XpoAdvancedSelectModule_Factory(t) { return new (t || XpoAdvancedSelectModule)(); };
XpoAdvancedSelectModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoAdvancedSelectModule });
XpoAdvancedSelectModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MatCheckboxModule,
            MatFormFieldModule,
            MatInputModule,
            MatIconModule,
            MatRadioModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAdvancedSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoAdvancedSelectPanelComponent, XpoAdvancedSelectTreeNodeComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    MatCheckboxModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatIconModule,
                    MatRadioModule,
                ],
                exports: [XpoAdvancedSelectPanelComponent, XpoAdvancedSelectTreeNodeComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoAdvancedSelectModule, { declarations: [XpoAdvancedSelectPanelComponent, XpoAdvancedSelectTreeNodeComponent], imports: [CommonModule,
        FormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatRadioModule], exports: [XpoAdvancedSelectPanelComponent, XpoAdvancedSelectTreeNodeComponent] }); })();

class XpoFilter {
    constructor(field, label, filterComponentType, type) {
        this.field = field;
        this.label = label;
        this.filterComponentType = filterComponentType;
        this.type = type;
    }
    /** Gets the initial value of the filter, based on the current filter value */
    getInitialFilterValue(val) {
        return val;
    }
}

/** Filter class to inherit when you want your filter to render inline on the box */
class XpoInlineFilter extends XpoFilter {
    constructor(field, label, filterComponentType) {
        super(field, label, filterComponentType);
    }
}

const DEFAULT_FILER_STRATEGY = 'container';

var ConditionalFilterCombiner;
(function (ConditionalFilterCombiner) {
    ConditionalFilterCombiner["And"] = "AND";
    ConditionalFilterCombiner["Or"] = "OR";
})(ConditionalFilterCombiner || (ConditionalFilterCombiner = {}));

class XpoDateFilterBase extends XpoFilter {
    constructor(field, label, filterComponentType, dateFilterConfigValue) {
        super(field, label, filterComponentType);
        this.dateFilterConfig$ =
            dateFilterConfigValue instanceof Observable ? dateFilterConfigValue : of(dateFilterConfigValue);
    }
    getDisplayValue(val) {
        if (!val) {
            return 'Any';
        }
        return DateUtils.formatDate(val instanceof Date ? val : new Date(val));
    }
}

let nextUniqueId$2 = 0;
class XpoFiltersService {
    constructor() {
        this.uid = `xpo-Filters-${nextUniqueId$2++}`;
        this.applyFilterStrategyValue = DEFAULT_FILER_STRATEGY;
        this.currentCriteria = undefined;
        this.criteriaSource$ = new BehaviorSubject(null);
        this.pendingCriteriaSource$ = new BehaviorSubject(null);
    }
    get criteria() {
        return this.criteriaSource$.getValue();
    }
    get criteria$() {
        return this.criteriaSource$.asObservable();
    }
    get pendingCriteria() {
        return this.pendingCriteriaSource$.getValue();
    }
    get pendingCriteria$() {
        return this.pendingCriteriaSource$.asObservable();
    }
    /** Id used to uniquely identify components inside this instance of the filter bar */
    get id() {
        return this.idValue;
    }
    set id(value) {
        this.idValue = value || this.uid;
    }
    get applyFilterStrategy() {
        return this.applyFilterStrategyValue;
    }
    set applyFilterStrategy(applyStrategy) {
        this.applyFilterStrategyValue = applyStrategy || DEFAULT_FILER_STRATEGY;
    }
    apply() {
        this.setCriteria(this.criteriaSource$.getValue());
    }
    setCriteria(criteria, filters = null) {
        const c = criteria || {};
        if (this.currentCriteria !== c) {
            this.currentCriteria = c;
            // this.initializeWithFilterDefaults(c, filters || []);
            this.criteriaSource$.next(c);
        }
    }
    /** Sets current criteria that may have not been applied yet based on the applyFilterStrategy */
    setPendingCriteria(field, val) {
        const obj = Object.assign({}, this.pendingCriteria);
        obj[field] = val;
        this.pendingCriteriaSource$.next(obj);
    }
    setFieldCriteria(field, val) {
        const obj = Object.assign({}, this.criteriaSource$.getValue());
        obj[field] = val;
        this.criteriaSource$.next(obj);
    }
    clearFieldCriteria(field) {
        const currentCriteria = Object.assign({}, this.criteriaSource$.getValue());
        delete currentCriteria[field];
        this.criteriaSource$.next(currentCriteria);
    }
    reset(initialCriteria) {
        this.criteriaSource$.next(initialCriteria || {});
    }
    /** Initialize the criteria object for the default value for each filter */
    initializeWithFilterDefaults(criteria, filters) {
        filters.forEach((f) => {
            const filterValue = f.getInitialFilterValue(criteria[f.field] || null);
            if (filterValue != null) {
                criteria[f.field] = filterValue;
            }
        });
    }
}
XpoFiltersService.ɵfac = function XpoFiltersService_Factory(t) { return new (t || XpoFiltersService)(); };
XpoFiltersService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoFiltersService, factory: XpoFiltersService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFiltersService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0$W = ["*"];
class XpoFilterContainer {
    constructor(filterService) {
        this.showApplyButton = false;
        this.apply = new EventEmitter();
        this.clear = new EventEmitter();
        this.close = new EventEmitter();
        this.showApplyButton = filterService.applyFilterStrategy === 'container';
    }
}
XpoFilterContainer.ɵfac = function XpoFilterContainer_Factory(t) { return new (t || XpoFilterContainer)(i0.ɵɵdirectiveInject(XpoFiltersService)); };
XpoFilterContainer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFilterContainer, selectors: [["xpo-filter-container"]], hostAttrs: [1, "xpo-FilterContainer"], inputs: { showApplyButton: "showApplyButton" }, outputs: { apply: "apply", clear: "clear", close: "close" }, ngContentSelectors: _c0$W, decls: 7, vars: 1, consts: [[1, "xpo-FilterContainer-content"], [1, "xpo-FilterContainer-actions"], ["mat-button", "", "xpo-small-button", "", "color", "primary", 3, "click"], ["mat-flat-button", "", "xpo-small-button", "", "color", "primary", 3, "click"]], template: function XpoFilterContainer_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "button", 2);
        i0.ɵɵlistener("click", function XpoFilterContainer_Template_button_click_3_listener() { return ctx.clear.emit(); });
        i0.ɵɵtext(4, "Clear");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "button", 3);
        i0.ɵɵlistener("click", function XpoFilterContainer_Template_button_click_5_listener() { return ctx.showApplyButton ? ctx.apply.emit() : ctx.close.emit(); });
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.showApplyButton ? "Apply" : "Done", " ");
    } }, directives: [i3$1.MatButton, i2$1.XpoSmallButton], styles: [".flex--stretch{flex:1}.xpo-FilterContainer{background-color:#fff;display:block}.xpo-FilterContainer-content{display:flex;flex-direction:column;max-height:500px;overflow-y:auto}.xpo-FilterContainer-actions{border-top:1px solid #d8d8d8;display:flex;flex-direction:row;justify-content:flex-end;padding:8px}.xpo-FilterContainer-actions button{margin:0 16px}.xpo-FilterContainer-actions button:last-child{margin-right:0}.xpo-FilterContainer-optionsContainer{display:flex;flex-direction:column;max-height:176px;overflow-y:auto}.xpo-FilterContainer-option{cursor:pointer;flex-shrink:0;height:32px;line-height:32px;padding:0 8px}.xpo-FilterContainer-option:first-child{margin-top:0}.xpo-FilterContainer-option:hover{background-color:#e8f5fe}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterContainer, [{
        type: Component,
        args: [{
                selector: 'xpo-filter-container',
                templateUrl: './filter-container.component.html',
                styleUrls: ['./filter-container.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-FilterContainer' },
            }]
    }], function () { return [{ type: XpoFiltersService }]; }, { showApplyButton: [{
            type: Input
        }], apply: [{
            type: Output
        }], clear: [{
            type: Output
        }], close: [{
            type: Output
        }] }); })();

/**
 * Interface to be implemented by the component that renders the filter
 */
class XpoFilterComponentBase {
    constructor() {
        /** Whether or not the component renders inline on the filter-bar (like quicksearch) */
        this.inline = false;
        /** If the popup should close immediately when an option is clicked (like singleSelect) */
        this.closeOnApply = false;
        this.applyFilterStrategy = DEFAULT_FILER_STRATEGY;
        /** Callback to close popup if filter is in a popup */
        this.closePopup = new EventEmitter();
        this.componentDestroyed = new Subject();
    }
    ngOnInit() {
        this.initialize();
        this.filtersService.criteria$.pipe(takeUntil(this.componentDestroyed)).subscribe((c) => {
            const criteriaValue = c ? c[this.field] || null : null;
            this.currentCriteria = criteriaValue;
            this.onCriteriaModified(criteriaValue, c);
        });
        this.id = `${this.filtersService.id}-filter-${this.field}`;
    }
    ngAfterViewInit() {
        if (!this.filterContainer) {
            return;
        }
        if (this.configuration.onOpen) {
            this.configuration.onOpen();
        }
        // On Apply Clicked
        this.filterContainer.apply.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
            // We close the popup here instead of calling `applyCriteria` when its `container` since both clicking
            // outside of the popover and clicking `Apply` will apply the criteria, so this avoids a double call.
            this.filtersService.applyFilterStrategy === 'container' ? this.closePopup.emit() : this.applyCriteria(false);
        });
        // On Clear Clicked
        this.filterContainer.clear.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
            this.currentCriteria = null;
            this.applyCriteria(false);
        });
        // On Close Clicked
        this.filterContainer.close.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
            this.closePopup.emit();
        });
    }
    ngOnDestroy() {
        if (this.filterContainer && this.configuration.onClose) {
            this.configuration.onClose();
        }
        this.componentDestroyed.next();
        this.componentDestroyed.complete();
    }
    /**
     * Stores the current criteria, if the filter has no filter container (apply/clear buttons) it will apply
     * the criteria
     *
     * @param criteriaValue
     */
    storeCriteria(criteriaValue) {
        this.currentCriteria = criteriaValue;
        // Set pending criteria that may not have been applied yet
        // This may only be applicable for applyFilterStrategy="global"
        this.filtersService.setPendingCriteria(this.field, criteriaValue);
        // If filter has no filter container, or doesn't have the apply button then apply criteria on change,
        if (!this.filterContainer || this.filtersService.applyFilterStrategy !== 'container' || this.closeOnApply) {
            // close the popup  only on Single select filter
            this.applyCriteria(true);
        }
    }
    /** Applies filter's criteria value to view */
    applyCriteria(applyCloseStrategy) {
        this.filtersService.setFieldCriteria(this.field, this.currentCriteria);
        const closePopup = applyCloseStrategy ? this.closeOnApply : true;
        if (closePopup) {
            this.closePopup.emit();
        }
    }
}
XpoFilterComponentBase.ɵfac = function XpoFilterComponentBase_Factory(t) { return new (t || XpoFilterComponentBase)(); };
XpoFilterComponentBase.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoFilterComponentBase, viewQuery: function XpoFilterComponentBase_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(XpoFilterContainer, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterContainer = _t.first);
    } }, inputs: { configuration: "configuration", field: "field", filtersService: "filtersService", applyFilterStrategy: "applyFilterStrategy" }, outputs: { closePopup: "closePopup" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterComponentBase, [{
        type: Directive
    }], null, { configuration: [{
            type: Input
        }], field: [{
            type: Input
        }], filtersService: [{
            type: Input
        }], applyFilterStrategy: [{
            type: Input
        }], closePopup: [{
            type: Output
        }], filterContainer: [{
            type: ViewChild,
            args: [XpoFilterContainer]
        }] }); })();

class XpoDateFilterComponentBase extends XpoFilterComponentBase {
    constructor(cd) {
        super();
        this.cd = cd;
    }
    initialize() {
        // TODO: Maybe disable the calender until this loads?
        this.configuration.dateFilterConfig$.pipe(takeUntil(this.componentDestroyed)).subscribe((config) => {
            this.minDate = config ? config.minDate : null;
            this.maxDate = config ? config.maxDate : null;
            this.dateFilter = config ? config.dateFilter : null;
            this.cd.markForCheck();
        });
    }
}
XpoDateFilterComponentBase.ɵfac = function XpoDateFilterComponentBase_Factory(t) { return new (t || XpoDateFilterComponentBase)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoDateFilterComponentBase.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDateFilterComponentBase, features: [i0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDateFilterComponentBase, [{
        type: Directive
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, null); })();

class XpoInMemoryFilterFactory {
    constructor(builders) {
        this.builders = builders;
    }
    get(filterParam) {
        const func = this.builders.get(filterParam.type);
        return func ? func(filterParam) : null;
    }
    getAll(filterParams) {
        return filterParams.map((x) => this.get(x)).filter((x) => x !== null);
    }
}

var OperatorText;
(function (OperatorText) {
    OperatorText["Is"] = "is";
    OperatorText["IsNot"] = "is not";
    OperatorText["Empty"] = "is empty";
    OperatorText["NotEmpty"] = "is not empty";
    OperatorText["Greater"] = "is greater than";
    OperatorText["GreaterEqual"] = "is greater or equal to";
    OperatorText["Less"] = "is less than";
    OperatorText["LessEqual"] = "is less or equal to";
    OperatorText["Between"] = "is between";
    OperatorText["NotBetween"] = "is not between";
    OperatorText["Contains"] = "contains";
    OperatorText["NotContains"] = "does not contain";
    OperatorText["None"] = "";
    OperatorText["EndsWith"] = "ends with";
    OperatorText["StartsWith"] = "starts with";
    OperatorText["Exactly"] = "is exactly";
    OperatorText["NotExactly"] = "is not exactly";
    OperatorText["OneOf"] = "is one of";
    OperatorText["True"] = "is true";
    OperatorText["False"] = "is false";
    OperatorText["After"] = "is after";
    OperatorText["OnOrAfter"] = "is on or after";
    OperatorText["Before"] = "is before";
    OperatorText["OnOrBefore"] = "is on or before";
})(OperatorText || (OperatorText = {}));

var Operators;
(function (Operators) {
    Operators["Empty"] = "EMPTY";
    Operators["NotEmpty"] = "NOT_EMPTY";
    Operators["True"] = "TRUE";
    Operators["NotTrue"] = "NOT_TRUE";
    Operators["Contains"] = "CONTAINS";
    Operators["NotContains"] = "NOT_CONTAINS";
    Operators["StartsWith"] = "STARTS_WITH";
    Operators["EndsWith"] = "ENDS_WITH";
    Operators["Relative"] = "RELATIVE";
    Operators["Equals"] = "EQUALS";
    Operators["NotEquals"] = "NOT_EQUALS";
    Operators["OneOf"] = "ONE_OF";
    Operators["Between"] = "BETWEEN";
    Operators["NotBetween"] = "NOT_BETWEEN";
    Operators["Less"] = "LESS";
    Operators["Greater"] = "GREATER_THAN";
    Operators["LessEqual"] = "LESS_EQUAL";
    Operators["GreaterEqual"] = "GREATER_EQUAL";
    Operators["Before"] = "BEFORE";
    Operators["OnOrBefore"] = "ON_OR_BEFORE";
    Operators["After"] = "AFTER";
    Operators["OnOrAfter"] = "ON_OR_AFTER";
    Operators["Exists"] = "EXISTS";
})(Operators || (Operators = {}));

/**
 * Im'm just moving OperatorsToOperatorText out of applied filters. This deserves a refactor.
 * that will require filters operators updates.
 */
/**
 * TODO: Refactor Operators, OperatorText and OperatorsToOperatorText.
 */
const OperatorsToOperatorText = {
    [Operators.Equals]: OperatorText.Is,
    [Operators.NotEquals]: OperatorText.IsNot,
    [Operators.Empty]: OperatorText.Empty,
    [Operators.NotEmpty]: OperatorText.NotEmpty,
    [Operators.Greater]: OperatorText.Greater,
    [Operators.GreaterEqual]: OperatorText.GreaterEqual,
    [Operators.Less]: OperatorText.Less,
    [Operators.LessEqual]: OperatorText.LessEqual,
    [Operators.Between]: OperatorText.Between,
    [Operators.NotBetween]: OperatorText.NotBetween,
    [Operators.Contains]: OperatorText.Contains,
    [Operators.NotContains]: OperatorText.NotContains,
    [Operators.EndsWith]: OperatorText.EndsWith,
    [Operators.StartsWith]: OperatorText.StartsWith,
    [Operators.OneOf]: OperatorText.OneOf,
    [Operators.True]: OperatorText.True,
    [Operators.NotTrue]: OperatorText.False,
    [Operators.After]: OperatorText.After,
    [Operators.OnOrAfter]: OperatorText.OnOrAfter,
    [Operators.Before]: OperatorText.Before,
    [Operators.OnOrBefore]: OperatorText.OnOrBefore,
    [Operators.Relative]: OperatorText.Is,
};

const filterFormats = {
    default: {
        match(model) {
            return true;
        },
    },
    number: {
        match(model) {
            return matchNumber(model);
        },
    },
    time: {
        match(model) {
            return model.split(':').every((val) => matchNumber(val));
        },
    },
    range: {
        match(model) {
            return every([model.from, model.to], (num) => matchNumber(num));
        },
        range: { from: (model) => matchNumber(model.from), to: (model) => matchNumber(model.to) },
    },
    stringRange: {
        match(model) {
            return every([model.from, model.to], () => true);
        },
        range: { from: () => true, to: () => true },
    },
    dateTimeRange: {
        match(model) {
            return every([model.dateFrom, model.dateTo], () => true);
        },
        dateRange: { from: () => true, to: () => true },
    },
};
function matchNumber(number) {
    return (number === '' ||
        (number && number.toString().match(/^-{0,1}\d+$/)) ||
        (number && number.toString().match(/^-{0,1}\d+(\.\d{0,5})?$/)));
}

class XpoCheckboxFilterComponent extends XpoFilterComponentBase {
    constructor() {
        super();
        this.checkedSource$ = new BehaviorSubject(false);
        this.inline = true;
    }
    get checked() {
        return this.checkedSource$.value;
    }
    set checked(value) {
        this.checkedSource$.next(value);
    }
    get checked$() {
        return this.checkedSource$.asObservable();
    }
    /**
     * Emits Checkbox value change
     */
    onCheckboxClicked(event) {
        this.checked = event.checked;
        this.storeCriteria(this.checked);
    }
    initialize() { }
    onCriteriaModified(fieldValue, criteria) {
        this.checked = !!fieldValue;
    }
}
XpoCheckboxFilterComponent.ɵfac = function XpoCheckboxFilterComponent_Factory(t) { return new (t || XpoCheckboxFilterComponent)(); };
XpoCheckboxFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoCheckboxFilterComponent, selectors: [["xpo-checkbox-filter"]], hostAttrs: [1, "xpo-CheckboxFilter"], hostVars: 1, hostBindings: function XpoCheckboxFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [["labelPosition", "right", 1, "xpo-CheckboxFilter-checkbox", 3, "checked", "change"]], template: function XpoCheckboxFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-checkbox", 0);
        i0.ɵɵlistener("change", function XpoCheckboxFilterComponent_Template_mat_checkbox_change_0_listener($event) { return ctx.onCheckboxClicked($event); });
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("checked", i0.ɵɵpipeBind1(1, 2, ctx.checked$));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.configuration.label, "\n");
    } }, directives: [i1.MatCheckbox], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-CheckboxFilter-checkbox{display:inline-block;font-size:.875rem;height:24px;margin:8px 0 8px 8px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCheckboxFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-checkbox-filter',
                templateUrl: 'checkbox-filter.component.html',
                styleUrls: ['checkbox-filter.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-CheckboxFilter', '[attr.id]': 'id' },
            }]
    }], function () { return []; }, null); })();

class XpoCheckboxFilter extends XpoInlineFilter {
    constructor(field, label) {
        super(field, label, XpoCheckboxFilterComponent);
        this.field = field;
        this.label = label;
    }
    getDisplayValue(val) {
        return '';
    }
}

class XpoConditionalFilter {
    constructor(conditions, selectCondition) {
        this.conditions = conditions;
        if (selectCondition) {
            this.selectedCondition = conditions[this.getIndexOfCondition(conditions, selectCondition)];
        }
        else {
            this.selectedCondition = conditions[0];
        }
    }
    saveComponentReference(ref) {
        this.componentReference = ref;
    }
    /**
     * Gets you the index of the condition you're looking for.
     *
     * TODO: Catch if it doesn't find the value.
     * @param conditions The conditions for this filter
     * @param conditionValueToFind The value of the condition to find
     * @returns the index of the condition you are trying to find
     */
    getIndexOfCondition(conditions, conditionValueToFind) {
        let index = 0;
        for (const condition of conditions) {
            if (condition.operator === conditionValueToFind) {
                return index;
            }
            else {
                index++;
            }
        }
        return index;
    }
    validate(cellValue) {
        return this.componentReference.instance.validate(cellValue);
    }
}

/**
 * Check if value is valid to be filtered
 * @param value
 */
function isValueFilterValid(value) {
    return value !== null && value !== undefined;
}

class XpoConditionComponentDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
XpoConditionComponentDirective.ɵfac = function XpoConditionComponentDirective_Factory(t) { return new (t || XpoConditionComponentDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
XpoConditionComponentDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoConditionComponentDirective, selectors: [["", "xpo-condition-component-host", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionComponentDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-condition-component-host]',
            }]
    }], function () { return [{ type: i0.ViewContainerRef }]; }, null); })();

function XpoConditionsComponent_select_1_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const condition_r5 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", condition_r5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", condition_r5 == null ? null : condition_r5.text, " ");
} }
function XpoConditionsComponent_select_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 5);
    i0.ɵɵlistener("ngModelChange", function XpoConditionsComponent_select_1_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.filter.selectedCondition = $event; })("change", function XpoConditionsComponent_select_1_Template_select_change_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.conditionChange(); });
    i0.ɵɵtemplate(1, XpoConditionsComponent_select_1_option_1_Template, 2, 2, "option", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r0.filter.selectedCondition);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.filter.conditions);
} }
function XpoConditionsComponent_ng_template_2_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.filter.conditions[0] == null ? null : ctx_r9.filter.conditions[0].text);
} }
function XpoConditionsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, XpoConditionsComponent_ng_template_2_span_0_Template, 2, 1, "span", 8);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.filter == null ? null : ctx_r2.filter.conditions == null ? null : ctx_r2.filter.conditions.length);
} }
function XpoConditionsComponent_ng_template_5_Template(rf, ctx) { }
class XpoConditionsComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.conditionChanged = new EventEmitter();
        this.inputChanged = new EventEmitter();
    }
    ngOnChanges() {
        this.loadComponent();
    }
    ngAfterViewInit() {
        this.loadComponent();
    }
    loadComponent() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.filter.selectedCondition);
        const viewContainerRef = this.xpoConditionInputHost.viewContainerRef;
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        this.filter.saveComponentReference(componentRef);
        if (componentRef.instance.inputChanged) {
            componentRef.instance.inputChanged.subscribe(() => {
                this.inputChanged.emit();
            });
        }
        if (this.customFilterParams) {
            componentRef.instance.customFilterParams = this.customFilterParams;
        }
        this.conditionChanged.emit(componentRef);
    }
    conditionChange() {
        this.loadComponent();
    }
}
XpoConditionsComponent.ɵfac = function XpoConditionsComponent_Factory(t) { return new (t || XpoConditionsComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver)); };
XpoConditionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionsComponent, selectors: [["xpo-conditions"]], viewQuery: function XpoConditionsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(XpoConditionComponentDirective, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.xpoConditionInputHost = _t.first);
    } }, inputs: { filter: "filter", customFilterParams: "customFilterParams" }, outputs: { conditionChanged: "conditionChanged", inputChanged: "inputChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 2, consts: [[1, "xpo-ConditionalFilter-conditions"], [3, "ngModel", "ngModelChange", "change", 4, "ngIf", "ngIfElse"], ["singleCondition", ""], [1, "xpo-ConditionalFilter-components"], ["xpo-condition-component-host", ""], [3, "ngModel", "ngModelChange", "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], ["class", "xpo-ConditionalFilter-singleCondition", 4, "ngIf"], [1, "xpo-ConditionalFilter-singleCondition"]], template: function XpoConditionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, XpoConditionsComponent_select_1_Template, 2, 2, "select", 1);
        i0.ɵɵtemplate(2, XpoConditionsComponent_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, XpoConditionsComponent_ng_template_5_Template, 0, 0, "ng-template", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.filter == null ? null : ctx.filter.conditions == null ? null : ctx.filter.conditions.length) > 1)("ngIfElse", _r1);
    } }, directives: [i2.NgIf, XpoConditionComponentDirective, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgForOf, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter-conditions[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-ConditionalFilter-conditions[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{display:flex;margin-right:8px}.xpo-ConditionalFilter-singleCondition[_ngcontent-%COMP%]{align-items:flex-start;display:flex;margin:6px 8px 0 0}.xpo-ConditionalFilter-components[_ngcontent-%COMP%]{display:flex}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionsComponent, [{
        type: Component,
        args: [{
                templateUrl: './conditions.component.html',
                selector: 'xpo-conditions',
                styleUrls: ['./conditions.component.scss'],
            }]
    }], function () { return [{ type: i0.ComponentFactoryResolver }]; }, { xpoConditionInputHost: [{
            type: ViewChild,
            args: [XpoConditionComponentDirective, { static: true }]
        }], filter: [{
            type: Input,
            args: ['filter']
        }], customFilterParams: [{
            type: Input,
            args: ['customFilterParams']
        }], conditionChanged: [{
            type: Output
        }], inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionalFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoConditionalFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoConditionalFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoConditionalFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoConditionalFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoConditionalFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoConditionalFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoConditionalFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoConditionalFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoConditionalFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoConditionalFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoConditionalFilterComponent {
    constructor(cdRef, filtersService, elementRef) {
        this.filtersService = filtersService;
        this.elementRef = elementRef;
        this.AG_MODAL_CLASS = 'ag-menu';
        this.AG_BOARD_CLASS = 'xpo-Board';
        this.isfilterApplied = false;
        this.displayAddButton = true;
        this.allowMultipleFilterRows = true;
        this.filters = [];
        this.conditions = [];
        this.defaultConditions = [];
        this.applyButtonDisabled = true;
        this.ConditionalFilterCombiner = ConditionalFilterCombiner; // For use in template
        this.cachedModel = { conditions: [] };
        this.cdRef = cdRef;
        this.andOr = ConditionalFilterCombiner.Or;
    }
    // TODO: params can't be set an IFilterParams type because of custom params, improve anyways to not be any
    agInit(params) {
        this.params = params;
        this.valueGetter = params.valueGetter;
        this.filterValueGetter = params.filterValueGetter;
        this.column = params.column.colDef;
        this.conditions = params.operators ? this.setConditions(params.operators) : this.defaultConditions;
    }
    setConditions(operators) {
        return this.defaultConditions.filter((condition) => {
            return operators.includes(condition.operator);
        });
    }
    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }
    /**
     * Creates a new filter. This adapts to keep the previously selected filter.
     */
    createFilter(selectedCondition) {
        /* TODO: do some clean up and check scenarios for selectedCondition being passed
        and totalFilters !== 0
        */
        const totalFilters = this.filters.length;
        let filter;
        if (totalFilters !== 0) {
            filter = new XpoConditionalFilter(this.conditions, this.filters[totalFilters - 1].selectedCondition.value);
        }
        if (selectedCondition) {
            filter = new XpoConditionalFilter(this.conditions, selectedCondition);
        }
        else {
            filter = new XpoConditionalFilter(this.conditions);
        }
        return filter;
    }
    doesFilterPass(params) {
        return this.doesNodeFilterPass(params.node);
    }
    doesNodeFilterPass(node) {
        const getterValue = this.getGetterValue(this.column, node);
        const value = isValueFilterValid(getterValue) ? getterValue : this.getFieldValue(this.column.field, node.data);
        if (this.andOr === ConditionalFilterCombiner.And) {
            return this.doesANDFilterPass(value);
        }
        else {
            return this.doesORFilterPass(value);
        }
    }
    doesANDFilterPass(value) {
        let filterPass = true;
        this.filters.forEach((filter) => {
            if (!filter.validate(value)) {
                filterPass = false;
            }
        });
        return filterPass;
    }
    doesORFilterPass(value) {
        let filterPass = false;
        this.filters.forEach((filter) => {
            if (filter.validate(value)) {
                filterPass = true;
            }
        });
        return filterPass;
    }
    getModel() {
        if (!this.isFilterActive()) {
            return null;
        }
        else {
            return {
                filter: this.getFiltersCriteria(),
            };
        }
    }
    setModel(model) {
        /*
        Reverse functinoality for filters logic. This sets the filters UI based on a
        criteria change in the board state.
        */
        this.clearFiltersInModal();
        if (!model || !model.filter) {
            this.isfilterApplied = false;
            this.cachedModel = { conditions: [] };
            return;
        }
        const criteria = model.filter;
        if (criteria.combiner) {
            this.andOr = criteria.combiner;
        }
        if (criteria.conditions && criteria.conditions.length > 0) {
            criteria.conditions.forEach((condition) => {
                // Create the new filter
                const conditionRef = this.createFilter(condition.operator);
                this.filters.push(conditionRef);
                this.cdRef.detectChanges();
                if (!!condition.valueTo) {
                    conditionRef.componentReference.instance.model.from = condition.value;
                    conditionRef.componentReference.instance.model.to = condition.valueTo;
                }
                else {
                    conditionRef.componentReference.instance.model = condition.value;
                }
            });
        }
        this.isfilterApplied = this.filters.length ? true : false;
        this.cachedModel = this.getFiltersCriteria();
    }
    afterGuiAttached(params) {
        this.adjustModalAlignment();
        // Attach ag-grid hide's method to our to execute us the behavior
        this.hideFilter = params.hidePopup;
        // Init config
        this.setModel({ filter: this.cachedModel });
        if (this.cachedModel.conditions && !this.cachedModel.conditions.length) {
            this.clearFiltersInModal();
            if (this.params.initializeFilterOnOpen) {
                this.addFilter();
            }
            this.cdRef.detectChanges();
        }
    }
    isFilterActive() {
        return this.isfilterApplied;
    }
    getFiltersCriteria() {
        const criteria = {
            conditions: [],
        };
        if (this.filters.length > 1) {
            criteria.combiner = this.andOr;
        }
        this.filters.forEach((filter) => {
            criteria.conditions.push(filter.componentReference.instance.getCriteria());
        });
        return criteria;
    }
    checkAddFilterAvailability() {
        this.filters.forEach((filter) => {
            if (filter.selectedCondition.applyAlwaysEnabled) {
                this.applyButtonDisabled = false;
            }
        });
    }
    /**
     * This will tell you whether all the conditions are logically negative.
     */
    get areAllConditionsNegative() {
        let positiveIndicator = false; // Update this if a positive is found
        this.filters.forEach((filter) => {
            if (!filter.selectedCondition.isNegative) {
                positiveIndicator = true;
            }
        });
        return !positiveIndicator;
    }
    onConditionChanged() {
        /**
         * Only if they are all negative change.
         * This is a UX touch requested by rohit.colaco@xpo.com
         *  If you think about it, though. If all your conditions
         *  are negative you'll exclude everything so you will
         *  want it to be an AND operation. - Good call Rohit
         */
        if (this.areAllConditionsNegative) {
            this.andOr = ConditionalFilterCombiner.And;
        }
        this.checkAddFilterAvailability();
    }
    isFormInvalid() {
        return this.isFormDirty();
    }
    isFormDirty() {
        // Ask for each field and show error in all of corresponding them also return true if just one has an error.
        let error = false;
        each(this.filters, (filter) => {
            if (!filter.componentReference.instance.isValid()) {
                error = true;
            }
        });
        return error;
    }
    addFilter() {
        this.filters.push(this.createFilter());
    }
    cancelFilter() {
        this.setModel({ filter: this.cachedModel });
        this.closeFilter();
    }
    closeFilter() {
        if (this.hideFilter) {
            this.hideFilter();
        }
    }
    removeFilter(filterIndex) {
        this.filters.splice(filterIndex, 1);
        this.checkAddFilterAvailability();
    }
    applyFilter() {
        if (this.isFormInvalid()) {
            return;
        }
        this.isfilterApplied = this.filters.length ? true : false;
        this.cachedModel = this.getFiltersCriteria();
        this.params.filterChangedCallback();
        this.filtersService.setFieldCriteria(this.params.colDef.field, this.getFiltersCriteria());
        this.closeFilter();
    }
    getFiltersDiff() {
        // TODO: returns filter diff in comparison with applied filters, returns null if no diff
        return null;
    }
    /**
     * Clears the filters but does not activate the change.
     */
    clearFiltersInModal() {
        this.filters = [];
        this.applyButtonDisabled = false;
    }
    getFieldValue(field, data) {
        const columnFields = field.split('.');
        if (columnFields.length) {
            return columnFields.reduce((obj, property) => {
                // isValueFilterValid allows zero as valid value for numbers
                return isValueFilterValid(obj[property]) ? obj[property] : '';
            }, data);
        }
        return null;
    }
    /**
     * Checks either for filterValueGetter or valueGetter in that order.
     */
    getGetterValue(column, rowNode) {
        const getter = column.filterValueGetter || column.valueGetter;
        return getter ? getter(rowNode) : null;
    }
    /**
     * Prevent modal to be cut when it doesen't fit in the board due to columns position close to right
     * adjustModalAlignment
     */
    adjustModalAlignment() {
        const modalRef = this.elementRef.nativeElement.closest(`.${this.AG_MODAL_CLASS}`);
        const boardRef = this.elementRef.nativeElement.closest(`.${this.AG_BOARD_CLASS}`);
        if (modalRef && boardRef) {
            const popoverRect = modalRef.getBoundingClientRect();
            const boardRect = boardRef.getBoundingClientRect();
            if (popoverRect.x + popoverRect.width > boardRect.x + boardRect.width) {
                modalRef.style.right = 0;
                modalRef.style.left = 'auto';
            }
        }
    }
}
XpoConditionalFilterComponent.ɵfac = function XpoConditionalFilterComponent_Factory(t) { return new (t || XpoConditionalFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XpoFiltersService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
XpoConditionalFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionalFilterComponent, selectors: [["ng-component"]], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoConditionalFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoConditionalFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoConditionalFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoConditionalFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoConditionalFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoConditionalFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoConditionalFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch{flex:1}:host input,:host select,:host textarea,.xpo-FilterCondition input,.xpo-FilterCondition select,.xpo-FilterCondition textarea{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}:host input.error,:host textarea.error,:host select.error,.xpo-FilterCondition input.error,.xpo-FilterCondition textarea.error,.xpo-FilterCondition select.error{border-color:#d32f2f}:host-control,.xpo-FilterCondition-control{display:flex;flex-direction:column;padding:0 4px}:host--between,.xpo-FilterCondition--between{align-items:center;display:flex}:host--between span,.xpo-FilterCondition--between span{padding:0 4px}:host--between input,.xpo-FilterCondition--between input{width:130px}:host--number,.xpo-FilterCondition--number{min-width:235px}:host--number input,.xpo-FilterCondition--number input{-moz-appearance:textfield;max-width:90px}:host--number input::-webkit-outer-spin-button,:host--number input::-webkit-inner-spin-button,.xpo-FilterCondition--number input::-webkit-outer-spin-button,.xpo-FilterCondition--number input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}:host input,:host select,.xpo-FilterCondition input,.xpo-FilterCondition select{height:27px}:host input:focus,:host select:focus,.xpo-FilterCondition input:focus,.xpo-FilterCondition select:focus{outline:none}:host textarea,.xpo-FilterCondition textarea{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}:host p.error,.xpo-FilterCondition p.error{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}:host p.error mat-icon,.xpo-FilterCondition p.error mat-icon{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper{display:flex;flex-direction:row}.xpo-DateTime-control{display:flex;flex-direction:column}.xpo-DateTime-control input[type=date],.xpo-DateTime-control input[type=time]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter{padding:16px}.xpo-ConditionalFilter *:focus{outline:none}.xpo-ConditionalFilter-list{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator{padding-right:8px}.xpo-ConditionalFilter-title{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item:first-child{margin-right:8px}.xpo-ConditionalFilter-item:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or{height:27px;width:62px}.xpo-ConditionalFilter-item-segment button{font-weight:normal;width:auto}.xpo-ConditionalFilter-add{cursor:pointer}.xpo-ConditionalFilter-add-wrapper{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper button{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper button:hover,.xpo-ConditionalFilter-add-wrapper button:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper button[disabled]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper button span{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper button .material-icons{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions button{display:flex;text-transform:uppercase}.xpo-ConditionalFilter .xpo-ConditionalFilter-list{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter .xpo-ConditionalFilter-list{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter .xpo-ConditionalFilter-list{max-height:300px}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionalFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: './conditional-filter.component.html',
                styleUrls: ['./conditional-filter.component.scss'],
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: XpoFiltersService }, { type: i0.ElementRef }]; }, null); })();

var FormatValidationsErrorMessages;
(function (FormatValidationsErrorMessages) {
    FormatValidationsErrorMessages["InvalidFormat"] = "Use valid format";
    FormatValidationsErrorMessages["FieldRequired"] = "Field is required";
})(FormatValidationsErrorMessages || (FormatValidationsErrorMessages = {}));

class XpoConditionBase {
    constructor(format = filterFormats.default, isRequired = true, isDateTime = false) {
        this.isRequiredField = true;
        this.errors = {
            format: false,
            required: false,
            to: { format: false, required: false },
            from: { format: false, required: false },
        };
        this.isEmpty = true;
        this.isDateTime = false;
        this.format = format;
        this.isRequiredField = isRequired;
        this.isDateTime = isDateTime;
    }
    isValid() {
        this.validateFormat();
        this.validateRequired();
        return !this.errors.format && !this.errors.required;
    }
    validateFormat() {
        this.resetRequiredFlag();
        this.format.range ? this.validateRangeFormat() : this.validateSingleFormat();
    }
    changeFormat(format) {
        this.format = format;
    }
    validateSingleFormat() {
        const isMatchingFormat = this.format.match(this.model);
        this.errors.format = !isMatchingFormat;
        this.errorMessageHandler(this.errors.format, FormatValidationsErrorMessages.InvalidFormat);
    }
    validateRangeFormat() {
        this.validateSingleFormat();
        this.errors.from.format = !this.format.range.from(this.model);
        this.errors.to.format = !this.format.range.to(this.model);
    }
    validateRequired() {
        this.errors.required = this.isEmptyRequired();
        this.errorMessageHandler(this.errors.required, FormatValidationsErrorMessages.FieldRequired);
    }
    isEmptyRequired() {
        return this.isRequiredField && this.validateEmpty();
    }
    validateEmpty() {
        if (this.format.range) {
            this.errors.from.required = this.isFieldEmpty(this.model.from);
            this.errors.to.required = this.isFieldEmpty(this.model.to);
            this.isEmpty = this.errors.to.required || this.errors.from.required;
        }
        else if (this.format.dateRange) {
            this.errors.from.required = this.isFieldEmpty(this.model.dateFrom);
            this.errors.to.required = this.isFieldEmpty(this.model.dateTo);
            this.isEmpty = this.errors.to.required || this.errors.from.required;
        }
        else {
            this.isEmpty = this.isFieldEmpty(this.model);
        }
        return this.isEmpty;
    }
    isFieldEmpty(model) {
        return (model === '' ||
            model === undefined ||
            model === null ||
            (!this.isDateTime && !model.length) ||
            ((this.isDateTime && !model.date) || model.time === ''));
    }
    errorMessageHandler(error, errorMessage) {
        if (error) {
            this.errorMessage = errorMessage;
        }
    }
    resetRequiredFlag() {
        this.errors.required = false;
    }
}

class XpoConditionBooleanTrueComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, false);
        this.isNegative = false;
        this.model = null;
    }
    validate(cellValue) {
        return cellValue === true;
    }
    getCriteria() {
        return {
            operator: Operators.True,
            value: true,
            display: ' ',
        };
    }
}
XpoConditionBooleanTrueComponent.text = OperatorText.True;
XpoConditionBooleanTrueComponent.applyAlwaysEnabled = true;
XpoConditionBooleanTrueComponent.operator = Operators.True;
XpoConditionBooleanTrueComponent.ɵfac = function XpoConditionBooleanTrueComponent_Factory(t) { return new (t || XpoConditionBooleanTrueComponent)(); };
XpoConditionBooleanTrueComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionBooleanTrueComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function XpoConditionBooleanTrueComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionBooleanTrueComponent, [{
        type: Component,
        args: [{
                template: ' ',
            }]
    }], function () { return []; }, null); })();

class XpoConditionBooleanFalseComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, false);
        this.isNegative = false; // not intuitive but this is actually just metadata
        this.model = null;
    }
    validate(cellValue) {
        return cellValue === false;
    }
    getCriteria() {
        return {
            operator: Operators.NotTrue,
            value: false,
            display: ' ',
        };
    }
}
XpoConditionBooleanFalseComponent.text = OperatorText.False;
XpoConditionBooleanFalseComponent.applyAlwaysEnabled = true;
XpoConditionBooleanFalseComponent.operator = Operators.NotTrue;
XpoConditionBooleanFalseComponent.ɵfac = function XpoConditionBooleanFalseComponent_Factory(t) { return new (t || XpoConditionBooleanFalseComponent)(); };
XpoConditionBooleanFalseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionBooleanFalseComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function XpoConditionBooleanFalseComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionBooleanFalseComponent, [{
        type: Component,
        args: [{
                template: ' ',
            }]
    }], function () { return []; }, null); })();

const _c0$V = ["calendar"];
class XpoCalendarComponent {
    constructor() {
        this.dateChange = new EventEmitter();
    }
    dateChanged(e) {
        this.dateChange.emit(e);
    }
}
XpoCalendarComponent.ɵfac = function XpoCalendarComponent_Factory(t) { return new (t || XpoCalendarComponent)(); };
XpoCalendarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoCalendarComponent, selectors: [["xpo-calendar-component"]], viewQuery: function XpoCalendarComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$V, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendar = _t.first);
    } }, outputs: { dateChange: "dateChange" }, decls: 3, vars: 1, consts: [[1, "xpo-InlineCalendar"], [3, "selected", "selectedChange"], ["calendar", ""]], template: function XpoCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "mat-calendar", 1, 2);
        i0.ɵɵlistener("selectedChange", function XpoCalendarComponent_Template_mat_calendar_selectedChange_1_listener($event) { return ctx.selectedDate = $event; })("selectedChange", function XpoCalendarComponent_Template_mat_calendar_selectedChange_1_listener($event) { return ctx.dateChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("selected", ctx.selectedDate);
    } }, directives: [i1$2.MatCalendar], styles: [".flex--stretch{flex:1}.xpo-InlineCalendar-input{text-align:center;width:100%}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-table-header{color:#171717;font-weight:500;padding:4px}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-table-header tr th{background-color:#fff}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-selected{background:#4a4a4a;color:#fff}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content{height:100%;top:0;width:100%}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-cell:hover .mat-calendar-body-cell-content{background:#4a4a4a;color:#fff}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-cell:hover .mat-calendar-body-cell-content:after{display:none!important}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-today{background:#ffffff!important;border:1px solid #6f6f6f;color:#6f6f6f!important}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-today.mat-calendar-body-selected{background:#4a4a4a!important;color:#fff!important}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-today:hover{border:1px solid #6f6f6f}.xpo-InlineCalendar .mat-calendar .mat-calendar-table .mat-calendar-body .mat-calendar-body-today:after{display:none}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-calendar-component',
                templateUrl: './calendar.component.html',
                styleUrls: ['./calendar.component.scss'],
                encapsulation: ViewEncapsulation.None,
            }]
    }], null, { dateChange: [{
            type: Output
        }], calendar: [{
            type: ViewChild,
            args: ['calendar', { static: true }]
        }] }); })();

/**
 * Converts either what the users passes in or ISO into XPO LTL's preferred format
 * @param params ag-Grid params
 */
function xpoDateFormatter(params, inputFormat = 'YYYY-MM-DD') {
    if (params.value) {
        return moment(params.value, inputFormat).format('MM/DD/YYYY');
    }
}
/**
 * Converts 2012-04-23T18:25:43.511Z into XPO LTL's preferred format
 * @param params ag-Grid params
 */
function xpoShortDateFormatter(params, inputFormat = 'YYYY-MM-DD') {
    if (params.value) {
        return moment(params.value, inputFormat).format('MM/DD');
    }
}
/**
 * Converts either what the users passes in or ISO into XPO LTL's preferred format
 * @param params ag-Grid params
 */
function xpoDateTimeFormatter(params, inputFormat = 'YYYY-MM-DD HH:mm:ssZ') {
    if (params.value) {
        return moment(params.value, inputFormat).format('MM/DD/YYYY HH:mm');
    }
}
/**
 * Converts either what the users passes in or ISO into XPO LTL's preferred format
 * @param params ag-Grid params
 */
function xpoTimeFormatter(params, inputFormat = 'HH:mm:ss') {
    if (params.value) {
        return moment(params.value, inputFormat).format('HH:mm');
    }
}

function XpoConditionDateTimeAfterSameComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$U = function (a0) { return { "error": a0 }; };
class XpoConditionDateTimeAfterSameComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, true, true);
        this.isNegative = false;
        this.model = {
            date: null,
            time: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isSameOrAfter(moment(`${this.model.date} ${this.model.time}`));
    }
    getCriteria() {
        return {
            operator: Operators.OnOrAfter,
            value: this.model,
            display: xpoDateTimeFormatter(moment(`${this.model.date} ${this.model.time}`)),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateTimeAfterSameComponent.text = OperatorText.OnOrAfter;
XpoConditionDateTimeAfterSameComponent.operator = Operators.OnOrAfter;
XpoConditionDateTimeAfterSameComponent.ɵfac = function XpoConditionDateTimeAfterSameComponent_Factory(t) { return new (t || XpoConditionDateTimeAfterSameComponent)(); };
XpoConditionDateTimeAfterSameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateTimeAfterSameComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 9, consts: [[1, "xpo-Datetime-wrapper"], [1, "xpo-Datetime-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateTimeAfterSameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeAfterSameComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.date = $event; })("input", function XpoConditionDateTimeAfterSameComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeAfterSameComponent_Template_input_ngModelChange_3_listener($event) { return ctx.model.time = $event; })("input", function XpoConditionDateTimeAfterSameComponent_Template_input_input_3_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, XpoConditionDateTimeAfterSameComponent_p_4_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.date)("ngClass", i0.ɵɵpureFunction1(5, _c0$U, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.time)("ngClass", i0.ɵɵpureFunction1(7, _c0$U, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateTimeAfterSameComponent, [{
        type: Component,
        args: [{
                templateUrl: './after-same.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateTimeAfterComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$T = function (a0) { return { "error": a0 }; };
class XpoConditionDateTimeAfterComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, true, true);
        this.isNegative = false;
        this.model = {
            date: null,
            time: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isAfter(moment(`${this.model.date} ${this.model.time}`));
    }
    getCriteria() {
        return {
            operator: Operators.After,
            value: this.model,
            display: xpoDateTimeFormatter({ value: moment(`${this.model.date} ${this.model.time}`).add(1, 'minute') }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateTimeAfterComponent.text = OperatorText.After;
XpoConditionDateTimeAfterComponent.operator = Operators.After;
XpoConditionDateTimeAfterComponent.ɵfac = function XpoConditionDateTimeAfterComponent_Factory(t) { return new (t || XpoConditionDateTimeAfterComponent)(); };
XpoConditionDateTimeAfterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateTimeAfterComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 9, consts: [[1, "xpo-Datetime-wrapper"], [1, "xpo-Datetime-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateTimeAfterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeAfterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.date = $event; })("input", function XpoConditionDateTimeAfterComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeAfterComponent_Template_input_ngModelChange_3_listener($event) { return ctx.model.time = $event; })("input", function XpoConditionDateTimeAfterComponent_Template_input_input_3_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, XpoConditionDateTimeAfterComponent_p_4_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.date)("ngClass", i0.ɵɵpureFunction1(5, _c0$T, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.time)("ngClass", i0.ɵɵpureFunction1(7, _c0$T, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateTimeAfterComponent, [{
        type: Component,
        args: [{
                templateUrl: './after.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateTimeBeforeSameComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$S = function (a0) { return { "error": a0 }; };
class XpoConditionDateTimeBeforeSameComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, true, true);
        this.isNegative = false;
        this.model = {
            date: null,
            time: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isSameOrBefore(moment(`${this.model.date} ${this.model.time}`));
    }
    getCriteria() {
        return {
            operator: Operators.OnOrBefore,
            value: this.model,
            display: xpoDateTimeFormatter(moment(`${this.model.date} ${this.model.time}`)),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateTimeBeforeSameComponent.text = OperatorText.OnOrBefore;
XpoConditionDateTimeBeforeSameComponent.operator = Operators.OnOrBefore;
XpoConditionDateTimeBeforeSameComponent.ɵfac = function XpoConditionDateTimeBeforeSameComponent_Factory(t) { return new (t || XpoConditionDateTimeBeforeSameComponent)(); };
XpoConditionDateTimeBeforeSameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateTimeBeforeSameComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 9, consts: [[1, "xpo-Datetime-wrapper"], [1, "xpo-Datetime-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateTimeBeforeSameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBeforeSameComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.date = $event; })("input", function XpoConditionDateTimeBeforeSameComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBeforeSameComponent_Template_input_ngModelChange_3_listener($event) { return ctx.model.time = $event; })("input", function XpoConditionDateTimeBeforeSameComponent_Template_input_input_3_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, XpoConditionDateTimeBeforeSameComponent_p_4_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.date)("ngClass", i0.ɵɵpureFunction1(5, _c0$S, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.time)("ngClass", i0.ɵɵpureFunction1(7, _c0$S, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateTimeBeforeSameComponent, [{
        type: Component,
        args: [{
                templateUrl: './before-same.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateTimeBeforeComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$R = function (a0) { return { "error": a0 }; };
class XpoConditionDateTimeBeforeComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, true, true);
        this.isNegative = false;
        this.model = {
            date: null,
            time: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isBefore(moment(`${this.model.date} ${this.model.time}`));
    }
    getCriteria() {
        return {
            operator: Operators.Before,
            value: this.model,
            display: xpoDateTimeFormatter({ value: moment(`${this.model.date} ${this.model.time}`).subtract(1, 'minute') }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateTimeBeforeComponent.text = OperatorText.Before;
XpoConditionDateTimeBeforeComponent.operator = Operators.Before;
XpoConditionDateTimeBeforeComponent.ɵfac = function XpoConditionDateTimeBeforeComponent_Factory(t) { return new (t || XpoConditionDateTimeBeforeComponent)(); };
XpoConditionDateTimeBeforeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateTimeBeforeComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 9, consts: [[1, "xpo-Datetime-wrapper"], [1, "xpo-Datetime-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateTimeBeforeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBeforeComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.date = $event; })("input", function XpoConditionDateTimeBeforeComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBeforeComponent_Template_input_ngModelChange_3_listener($event) { return ctx.model.time = $event; })("input", function XpoConditionDateTimeBeforeComponent_Template_input_input_3_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, XpoConditionDateTimeBeforeComponent_p_4_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.date)("ngClass", i0.ɵɵpureFunction1(5, _c0$R, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.time)("ngClass", i0.ɵɵpureFunction1(7, _c0$R, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateTimeBeforeComponent, [{
        type: Component,
        args: [{
                templateUrl: './before.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

/**
 * Takes two date time formatted strings and figures out which one comes first
 *
 * @param a string formatted such that they can be string compared ie YYYY-MM-DD HH:mm:ss
 * @param b string formatted such that they can be string compared ie YYYY-MM-DD HH:mm:ss
 *
 * @return Object keyed from, to with the smaller date time in from and larger in to
 */
function ordersMinMaxDateTime(a, b) {
    if (a >= b) {
        return { from: b, to: a };
    }
    return { from: a, to: b };
}

function XpoConditionDateTimeBetweenComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$Q = function (a0) { return { "error": a0 }; };
class XpoConditionDateTimeBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.dateTimeRange);
        this.value = 'datetimeBetween';
        this.isNegative = false;
        this.model = {
            dateFrom: null,
            dateTo: null,
            timeFrom: '',
            timeTo: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const ordered = ordersMinMaxDateTime(`${this.model.dateFrom} ${this.model.timeFrom}`, `${this.model.dateTo} ${this.model.timeTo}`);
        return moment(cellValue).isBetween(ordered.from, ordered.to);
    }
    getCriteria() {
        const ordered = ordersMinMaxDateTime(`${this.model.dateFrom} ${this.model.timeFrom}`, `${this.model.dateTo} ${this.model.timeTo}`);
        return {
            operator: Operators.Between,
            value: ordered.from,
            valueTo: ordered.to,
            display: xpoDateTimeFormatter({ value: ordered.from }),
            displayTo: xpoDateTimeFormatter({ value: ordered.to }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateTimeBetweenComponent.text = OperatorText.Between;
XpoConditionDateTimeBetweenComponent.operator = Operators.Between;
XpoConditionDateTimeBetweenComponent.ɵfac = function XpoConditionDateTimeBetweenComponent_Factory(t) { return new (t || XpoConditionDateTimeBetweenComponent)(); };
XpoConditionDateTimeBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateTimeBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 17, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], [1, "xpo-FilterCondition-control"], ["type", "date", "name", "dateFrom", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", "name", "timeFrom", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "date", "name", "dateTo", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", "name", "timeTo", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateTimeBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBetweenComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.dateFrom = $event; })("input", function XpoConditionDateTimeBetweenComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBetweenComponent_Template_input_ngModelChange_3_listener($event) { return ctx.model.timeFrom = $event; })("input", function XpoConditionDateTimeBetweenComponent_Template_input_input_3_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 1);
        i0.ɵɵelementStart(5, "input", 4);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBetweenComponent_Template_input_ngModelChange_5_listener($event) { return ctx.model.dateTo = $event; })("input", function XpoConditionDateTimeBetweenComponent_Template_input_input_5_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "input", 5);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeBetweenComponent_Template_input_ngModelChange_6_listener($event) { return ctx.model.timeTo = $event; })("input", function XpoConditionDateTimeBetweenComponent_Template_input_input_6_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, XpoConditionDateTimeBetweenComponent_p_7_Template, 4, 1, "p", 6);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.dateFrom)("ngClass", i0.ɵɵpureFunction1(9, _c0$Q, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.timeFrom)("ngClass", i0.ɵɵpureFunction1(11, _c0$Q, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.dateTo)("ngClass", i0.ɵɵpureFunction1(13, _c0$Q, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.timeTo)("ngClass", i0.ɵɵpureFunction1(15, _c0$Q, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-FilterCondition-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{width:145px}.xpo-FilterCondition-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%]{margin-bottom:6px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateTimeBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './between.component.html',
                styleUrls: ['./between.component.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateTimeNotBetweenComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$P = function (a0) { return { "error": a0 }; };
class XpoConditionDateTimeNotBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.dateTimeRange);
        this.value = 'datetimeNotBetween';
        this.isNegative = false;
        this.model = {
            dateFrom: null,
            dateTo: null,
            timeFrom: '',
            timeTo: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const ordered = ordersMinMaxDateTime(`${this.model.dateFrom} ${this.model.timeFrom}`, `${this.model.dateTo} ${this.model.timeTo}`);
        return !moment(cellValue).isBetween(ordered.from, ordered.to, null, '[]' // This signifies that the extent is exclusive
        );
    }
    getCriteria() {
        const ordered = ordersMinMaxDateTime(`${this.model.dateFrom} ${this.model.timeFrom}`, `${this.model.dateTo} ${this.model.timeTo}`);
        return {
            operator: Operators.Equals,
            value: ordered.from,
            valueTo: ordered.to,
            display: xpoDateTimeFormatter({ value: ordered.from }),
            displayTo: xpoDateTimeFormatter({ value: ordered.to }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateTimeNotBetweenComponent.text = OperatorText.NotBetween;
XpoConditionDateTimeNotBetweenComponent.operator = Operators.NotBetween;
XpoConditionDateTimeNotBetweenComponent.ɵfac = function XpoConditionDateTimeNotBetweenComponent_Factory(t) { return new (t || XpoConditionDateTimeNotBetweenComponent)(); };
XpoConditionDateTimeNotBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateTimeNotBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 17, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], [1, "xpo-FilterCondition-control"], ["type", "date", "name", "dateFrom", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", "name", "timeFrom", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "date", "name", "dateTo", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["type", "time", "name", "timeTo", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateTimeNotBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeNotBetweenComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.dateFrom = $event; })("input", function XpoConditionDateTimeNotBetweenComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeNotBetweenComponent_Template_input_ngModelChange_3_listener($event) { return ctx.model.timeFrom = $event; })("input", function XpoConditionDateTimeNotBetweenComponent_Template_input_input_3_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 1);
        i0.ɵɵelementStart(5, "input", 4);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeNotBetweenComponent_Template_input_ngModelChange_5_listener($event) { return ctx.model.dateTo = $event; })("input", function XpoConditionDateTimeNotBetweenComponent_Template_input_input_5_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "input", 5);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateTimeNotBetweenComponent_Template_input_ngModelChange_6_listener($event) { return ctx.model.timeTo = $event; })("input", function XpoConditionDateTimeNotBetweenComponent_Template_input_input_6_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, XpoConditionDateTimeNotBetweenComponent_p_7_Template, 4, 1, "p", 6);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.dateFrom)("ngClass", i0.ɵɵpureFunction1(9, _c0$P, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.timeFrom)("ngClass", i0.ɵɵpureFunction1(11, _c0$P, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.dateTo)("ngClass", i0.ɵɵpureFunction1(13, _c0$P, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.timeTo)("ngClass", i0.ɵɵpureFunction1(15, _c0$P, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-FilterCondition-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{width:145px}.xpo-FilterCondition-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%]{margin-bottom:6px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateTimeNotBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './not-between.component.html',
                styleUrls: ['./not-between.component.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateAfterSameComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$O = function (a0) { return { "error": a0 }; };
class XpoConditionDateAfterSameComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isSameOrAfter(moment(this.model).startOf('day'));
    }
    getCriteria() {
        return {
            operator: Operators.OnOrAfter,
            value: this.model,
            display: xpoDateFormatter({ value: moment(this.model).startOf('day') }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateAfterSameComponent.text = OperatorText.OnOrAfter;
XpoConditionDateAfterSameComponent.operator = Operators.OnOrAfter;
XpoConditionDateAfterSameComponent.ɵfac = function XpoConditionDateAfterSameComponent_Factory(t) { return new (t || XpoConditionDateAfterSameComponent)(); };
XpoConditionDateAfterSameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateAfterSameComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateAfterSameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateAfterSameComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model = $event; })("input", function XpoConditionDateAfterSameComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionDateAfterSameComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$O, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateAfterSameComponent, [{
        type: Component,
        args: [{
                templateUrl: './after-same.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateAfterComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$N = function (a0) { return { "error": a0 }; };
class XpoConditionDateAfterComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isAfter(moment(this.model).startOf('day'));
    }
    getCriteria() {
        return {
            operator: Operators.After,
            value: this.model,
            display: xpoDateFormatter({ value: moment(this.model).startOf('day') }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateAfterComponent.text = OperatorText.After;
XpoConditionDateAfterComponent.operator = Operators.After;
XpoConditionDateAfterComponent.ɵfac = function XpoConditionDateAfterComponent_Factory(t) { return new (t || XpoConditionDateAfterComponent)(); };
XpoConditionDateAfterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateAfterComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateAfterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateAfterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model = $event; })("input", function XpoConditionDateAfterComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionDateAfterComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$N, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateAfterComponent, [{
        type: Component,
        args: [{
                templateUrl: './after.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateBeforeSameComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$M = function (a0) { return { "error": a0 }; };
class XpoConditionDateBeforeSameComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isSameOrBefore(moment(this.model).startOf('day'));
    }
    getCriteria() {
        return {
            operator: Operators.OnOrBefore,
            value: this.model,
            display: xpoDateFormatter({ value: moment(this.model).startOf('day') }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateBeforeSameComponent.text = OperatorText.OnOrBefore;
XpoConditionDateBeforeSameComponent.operator = Operators.OnOrBefore;
XpoConditionDateBeforeSameComponent.ɵfac = function XpoConditionDateBeforeSameComponent_Factory(t) { return new (t || XpoConditionDateBeforeSameComponent)(); };
XpoConditionDateBeforeSameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateBeforeSameComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateBeforeSameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateBeforeSameComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model = $event; })("input", function XpoConditionDateBeforeSameComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionDateBeforeSameComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$M, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateBeforeSameComponent, [{
        type: Component,
        args: [{
                templateUrl: './before-same.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateBeforeComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$L = function (a0) { return { "error": a0 }; };
class XpoConditionDateBeforeComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return moment(cellValue)
            .startOf('day')
            .isBefore(moment(this.model).startOf('day'));
    }
    getCriteria() {
        return {
            operator: Operators.Before,
            value: this.model,
            display: xpoDateFormatter({ value: moment(this.model).startOf('day') }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateBeforeComponent.text = OperatorText.Before;
XpoConditionDateBeforeComponent.operator = Operators.Before;
XpoConditionDateBeforeComponent.ɵfac = function XpoConditionDateBeforeComponent_Factory(t) { return new (t || XpoConditionDateBeforeComponent)(); };
XpoConditionDateBeforeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateBeforeComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateBeforeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateBeforeComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model = $event; })("input", function XpoConditionDateBeforeComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionDateBeforeComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$L, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateBeforeComponent, [{
        type: Component,
        args: [{
                templateUrl: './before.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

/**
 * Takes two date time formatted strings and figures out which one comes first
 *
 * @param a string formatted such that they can be string compared ie YYYY-MM-DD
 * @param b string formatted such that they can be string compared ie YYYY-MM-DD
 *
 * @return Object keyed from, to with the smaller date time in from and larger in to
 */
function ordersMinMaxDate(a, b) {
    if (a >= b) {
        return { from: b, to: a };
    }
    return { from: a, to: b };
}

function XpoConditionDateBetweenComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$K = function (a0) { return { "error": a0 }; };
class XpoConditionDateBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.stringRange);
        this.isNegative = false;
        this.model = {
            from: '',
            to: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const ordered = ordersMinMaxDate(this.model.from, this.model.to);
        return moment(cellValue)
            .startOf('day')
            .isBetween(moment(ordered.from).startOf('day'), moment(ordered.to).endOf('day'), null, '()');
    }
    getCriteria() {
        const ordered = ordersMinMaxDate(this.model.from, this.model.to);
        return {
            operator: Operators.Between,
            value: ordered.from,
            valueTo: ordered.to,
            display: xpoDateFormatter({ value: ordered.from }),
            displayTo: xpoDateFormatter({ value: ordered.to }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateBetweenComponent.text = OperatorText.Between;
XpoConditionDateBetweenComponent.operator = Operators.Between;
XpoConditionDateBetweenComponent.ɵfac = function XpoConditionDateBetweenComponent_Factory(t) { return new (t || XpoConditionDateBetweenComponent)(); };
XpoConditionDateBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 9, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], [1, "xpo-Date-controlSeparator"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateBetweenComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.from = $event; })("input", function XpoConditionDateBetweenComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4, " and ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 1);
        i0.ɵɵelementStart(6, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateBetweenComponent_Template_input_ngModelChange_6_listener($event) { return ctx.model.to = $event; })("input", function XpoConditionDateBetweenComponent_Template_input_input_6_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, XpoConditionDateBetweenComponent_p_7_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.from)("ngClass", i0.ɵɵpureFunction1(5, _c0$K, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.model.to)("ngClass", i0.ɵɵpureFunction1(7, _c0$K, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-Date-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-Date-controlSeparator[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center;padding:6px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './between.component.html',
                styleUrls: ['./between.component.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateEqualsComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$J = function (a0) { return { "error": a0 }; };
class XpoConditionDateEqualsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        // remove time part and compare
        return moment(this.model)
            .startOf('day')
            .isSame(moment(cellValue).startOf('day'));
    }
    getCriteria() {
        return {
            operator: Operators.Equals,
            value: this.model,
            display: xpoDateFormatter({ value: this.model }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateEqualsComponent.text = OperatorText.Exactly;
XpoConditionDateEqualsComponent.operator = Operators.Equals;
XpoConditionDateEqualsComponent.ɵfac = function XpoConditionDateEqualsComponent_Factory(t) { return new (t || XpoConditionDateEqualsComponent)(); };
XpoConditionDateEqualsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateEqualsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateEqualsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateEqualsComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model = $event; })("input", function XpoConditionDateEqualsComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionDateEqualsComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$J, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateEqualsComponent, [{
        type: Component,
        args: [{
                templateUrl: './equals.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

/*
  TODO: This whole component needs refactoring. valueMap, RelativeTime and comparisonMap are way too complex to maintain
  and should be re-designed. This whole class is temporary and will be re-worked ASAP. Please avoid the use of this
  class anytime you can.
*/
var RelativeTime$1;
(function (RelativeTime) {
    RelativeTime["today"] = "Today";
    RelativeTime["yesterday"] = "Yesterday";
    RelativeTime["tomorrow"] = "Tomorrow";
    RelativeTime["thisWeek"] = "This Week";
    RelativeTime["lastWeek"] = "Last Week";
    RelativeTime["nextWeek"] = "Next Week";
})(RelativeTime$1 || (RelativeTime$1 = {}));
class XpoConditionDateIsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        // TODO: This needs refactor
        this.valueMap = {
            [RelativeTime$1.today]: '0d',
            [RelativeTime$1.yesterday]: '-1d',
            [RelativeTime$1.tomorrow]: '+1d',
            [RelativeTime$1.thisWeek]: '0w',
            [RelativeTime$1.lastWeek]: '-1w',
            [RelativeTime$1.nextWeek]: '+1w',
        };
        this.isNegative = false;
        this.model = this.valueMap[RelativeTime$1.today];
        this.RelativeTime = RelativeTime$1; // For Select
        // Don't think; Only do
        this.comparisonMap = {
            [RelativeTime$1.today]: (v) => moment(v)
                .startOf('day')
                .isSame(moment().startOf('day')),
            [RelativeTime$1.yesterday]: (v) => moment(v)
                .startOf('day')
                .isSame(moment()
                .subtract(1, 'day')
                .startOf('day')),
            [RelativeTime$1.tomorrow]: (v) => moment(v)
                .startOf('day')
                .isSame(moment()
                .add(1, 'day')
                .startOf('day')),
            [RelativeTime$1.thisWeek]: (v) => moment(v).isBetween(moment().startOf('week'), moment().endOf('week')),
            [RelativeTime$1.lastWeek]: (v) => moment(v).isBetween(moment()
                .subtract(1, 'week')
                .startOf('week'), moment()
                .subtract(1, 'week')
                .endOf('week')),
            [RelativeTime$1.nextWeek]: (v) => moment(v).isBetween(moment()
                .add(1, 'week')
                .startOf('week'), moment()
                .add(1, 'week')
                .endOf('week')),
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const relativeTimeKey = _invert(this.valueMap)[this.model];
        return this.comparisonMap[relativeTimeKey](cellValue);
    }
    getCriteria() {
        /*
          TODO: The use of _invert here is totally temporary. It's a fix for model implementation here.
          This will be updated on the refactor of this whole thing
        */
        return {
            operator: Operators.Relative,
            value: this.model,
            display: _invert(this.valueMap)[this.model],
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateIsComponent.text = OperatorText.Is;
XpoConditionDateIsComponent.operator = Operators.Relative;
XpoConditionDateIsComponent.ɵfac = function XpoConditionDateIsComponent_Factory(t) { return new (t || XpoConditionDateIsComponent)(); };
XpoConditionDateIsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateIsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 15, vars: 13, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], [3, "ngModel", "ngModelChange", "input"], [3, "value"]], template: function XpoConditionDateIsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "select", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateIsComponent_Template_select_ngModelChange_2_listener($event) { return ctx.model = $event; })("input", function XpoConditionDateIsComponent_Template_select_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementStart(3, "option", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "option", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "option", 3);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "option", 3);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "option", 3);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "option", 3);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.valueMap[ctx.RelativeTime.today]);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.RelativeTime.today);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.valueMap[ctx.RelativeTime.yesterday]);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.RelativeTime.yesterday);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.valueMap[ctx.RelativeTime.tomorrow]);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.RelativeTime.tomorrow);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.valueMap[ctx.RelativeTime.thisWeek]);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.RelativeTime.thisWeek);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.valueMap[ctx.RelativeTime.lastWeek]);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.RelativeTime.lastWeek);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.valueMap[ctx.RelativeTime.nextWeek]);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.RelativeTime.nextWeek);
    } }, directives: [i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateIsComponent, [{
        type: Component,
        args: [{
                templateUrl: './is.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDateNotBetweenComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$I = function (a0) { return { "error": a0 }; };
class XpoConditionDateNotBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.stringRange);
        this.isNegative = false;
        this.model = {
            from: '',
            to: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const ordered = ordersMinMaxDate(this.model.from, this.model.to);
        return !moment(cellValue).startOf('day').isBetween(moment(ordered.from).startOf('day'), moment(ordered.to).endOf('day'), null, '[]' // This signifies that the extent is exclusive
        );
    }
    getCriteria() {
        const ordered = ordersMinMaxDate(this.model.from, this.model.to);
        return {
            operator: Operators.NotBetween,
            value: ordered.from,
            valueTo: ordered.to,
            display: xpoDateFormatter({ value: ordered.from }),
            displayTo: xpoDateFormatter({ value: ordered.to }),
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionDateNotBetweenComponent.text = OperatorText.NotBetween;
XpoConditionDateNotBetweenComponent.operator = Operators.NotBetween;
XpoConditionDateNotBetweenComponent.ɵfac = function XpoConditionDateNotBetweenComponent_Factory(t) { return new (t || XpoConditionDateNotBetweenComponent)(); };
XpoConditionDateNotBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDateNotBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 9, consts: [[1, "xpo-Date-wrapper"], [1, "xpo-Date-control"], ["type", "date", 3, "ngModel", "ngClass", "ngModelChange", "input"], [1, "xpo-Date-controlSeparator"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionDateNotBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateNotBetweenComponent_Template_input_ngModelChange_2_listener($event) { return ctx.model.from = $event; })("input", function XpoConditionDateNotBetweenComponent_Template_input_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4, " and ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 1);
        i0.ɵɵelementStart(6, "input", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionDateNotBetweenComponent_Template_input_ngModelChange_6_listener($event) { return ctx.model.to = $event; })("input", function XpoConditionDateNotBetweenComponent_Template_input_input_6_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, XpoConditionDateNotBetweenComponent_p_7_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model.from)("ngClass", i0.ɵɵpureFunction1(5, _c0$I, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.model.to)("ngClass", i0.ɵɵpureFunction1(7, _c0$I, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-Date-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-Date-controlSeparator[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center;padding:6px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDateNotBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './not-between.component.html',
                styleUrls: ['./not-between.component.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionEnumEqualsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "mat-checkbox", 6);
    i0.ɵɵlistener("change", function XpoConditionEnumEqualsComponent_div_4_Template_mat_checkbox_change_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r4); const option_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onInputChange($event, option_r2.key); })("ngModelChange", function XpoConditionEnumEqualsComponent_div_4_Template_mat_checkbox_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r4); const option_r2 = restoredCtx.$implicit; return option_r2.value.checked = $event; });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", option_r2.value.checked);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r2.value.text, " ");
} }
function XpoConditionEnumEqualsComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, "\n");
} }
class XpoConditionEnumEqualsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.ALL_DISPLAY_VALUE = 'all';
        this.defValuesChecked = false;
        this.isNegative = false;
        this.model = [];
        this.allOptionsSelected = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.values = this.mapValues(params.enumValues);
        // adding the empty condition
        this.values = Object.assign({
            [Operators.Empty]: {
                text: OperatorText.Empty,
                checked: this.defValuesChecked,
            },
        }, this.values);
    }
    ngAfterViewInit() {
        this.model.forEach((item) => {
            this.values[item].checked = true;
        });
        this.checkAllSelection();
    }
    mapValues(enumValues) {
        const values = {};
        const checked = this.defValuesChecked;
        Object.keys(enumValues).map((key) => {
            values[key] = {
                text: enumValues[key],
                checked: checked,
            };
        });
        return values;
    }
    validate(cellValue) {
        return Array.isArray(cellValue) ? this.arrayMatchChecker(cellValue) : this.matchAnyChecked(cellValue);
    }
    arrayMatchChecker(cellValue) {
        return cellValue.length === 0 ? this.matchAnyChecked('') : some(cellValue, (value) => this.matchAnyChecked(value));
    }
    matchAnyChecked(cellValue) {
        return !this.model || some(this.model, (item) => this.hasCoincidence(item, cellValue));
    }
    hasCoincidence(item, value) {
        return (item === Operators.Empty && !value.toString().trim()) || item === value.toString().trim();
    }
    sortValues() {
        // preserve map order
        return 1;
    }
    getCriteria() {
        return {
            operator: Operators.Equals,
            value: this.model,
            display: this.getModelDisplayValues(),
        };
    }
    selectAll(e) {
        this.model = [];
        Object.keys(this.values).forEach((val) => {
            this.values[val].checked = e.checked;
            const updatedModel = this.updateModel(e.checked, val);
            this.model = updatedModel;
        });
        this.allOptionsSelected = e.checked;
    }
    checkAllSelection() {
        this.allOptionsSelected = Object.keys(this.values).length === this.model.length && this.checkAllSelected();
    }
    onInputChange(e, value) {
        const updatedModel = this.updateModel(e.checked, value);
        this.model = updatedModel;
        this.inputChanged.emit(updatedModel.join(','));
        this.checkAllSelection();
        this.validateFormat();
    }
    updateModel(checked, value) {
        const updatedModel = cloneDeep(this.model);
        if (checked) {
            updatedModel.push(value);
        }
        else {
            // this.allOptionsSelected = false;
            const index = updatedModel.indexOf(value);
            if (index > -1) {
                updatedModel.splice(index, 1);
            }
        }
        return updatedModel;
    }
    getModelDisplayValues() {
        if (this.allOptionsSelected) {
            return this.ALL_DISPLAY_VALUE;
        }
        const mappedValues = [];
        this.model.forEach((element) => {
            mappedValues.push(this.values[element].text);
        });
        // if empty was selected, switch it to last for displaying purposes
        if (mappedValues[0] === OperatorText.Empty) {
            mappedValues.push(mappedValues.shift());
        }
        return mappedValues.join(', ');
    }
    checkAllSelected() {
        let allChecked = true;
        Object.keys(this.values).map((val) => {
            if (!this.values[val].checked) {
                allChecked = false;
            }
        });
        return allChecked;
    }
}
XpoConditionEnumEqualsComponent.text = OperatorText.None; // value used in dropdown
XpoConditionEnumEqualsComponent.operator = Operators.Equals;
XpoConditionEnumEqualsComponent.ɵfac = function XpoConditionEnumEqualsComponent_Factory(t) { return new (t || XpoConditionEnumEqualsComponent)(); };
XpoConditionEnumEqualsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionEnumEqualsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 6, consts: [[1, "xpo-Enum-wrapper"], ["data-cy", "enum-control", 1, "xpo-Enum-control"], [3, "ngModel", "change"], ["class", "xpo-Enum-item", 4, "ngFor", "ngForOf"], ["class", "error", 4, "ngIf"], [1, "xpo-Enum-item"], ["data-cy", "enum-item-checkbox", 3, "ngModel", "change", "ngModelChange"], [1, "error"]], template: function XpoConditionEnumEqualsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "mat-checkbox", 2);
        i0.ɵɵlistener("change", function XpoConditionEnumEqualsComponent_Template_mat_checkbox_change_2_listener($event) { return ctx.selectAll($event); });
        i0.ɵɵtext(3, "Select All");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, XpoConditionEnumEqualsComponent_div_4_Template, 3, 2, "div", 3);
        i0.ɵɵpipe(5, "keyvalue");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, XpoConditionEnumEqualsComponent_p_6_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.allOptionsSelected);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 3, ctx.values, ctx.sortValues));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1.MatCheckbox, i1$1.NgControlStatus, i1$1.NgModel, i2.NgForOf, i2.NgIf, i3.MatIcon], pipes: [i2.KeyValuePipe], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-Enum-wrapper[_ngcontent-%COMP%]   .xpo-Enum-control[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:75px}.xpo-Enum-wrapper[_ngcontent-%COMP%]   .xpo-Enum-control[_ngcontent-%COMP%]   .xpo-Enum-item[_ngcontent-%COMP%]:first-child{text-transform:capitalize}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionEnumEqualsComponent, [{
        type: Component,
        args: [{
                templateUrl: './equals.component.html',
                styleUrls: ['./equals.component.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionDynamicEnumEqualsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "mat-checkbox", 6);
    i0.ɵɵlistener("change", function XpoConditionDynamicEnumEqualsComponent_div_4_Template_mat_checkbox_change_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r4); const option_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onInputChange($event, option_r2.key); })("ngModelChange", function XpoConditionDynamicEnumEqualsComponent_div_4_Template_mat_checkbox_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r4); const option_r2 = restoredCtx.$implicit; return option_r2.value.checked = $event; });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", option_r2.value.checked);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r2.value.text, " ");
} }
function XpoConditionDynamicEnumEqualsComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, "\n");
} }
class XpoConditionDynamicEnumEqualsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.ALL_DISPLAY_VALUE = 'all';
        this.defValuesChecked = false;
        this.isNegative = false;
        this.model = [];
        this.allOptionsSelected = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.values = this.mapValues(params);
    }
    ngAfterViewInit() {
        this.model.forEach((item) => {
            this.values[item].checked = true;
        });
        this.checkAllSelection();
    }
    mapValues(params) {
        let values = {};
        let emptyValues = false;
        params.api.forEachNode((node) => {
            if (!params.colDef || !params.colDef.field) {
                return;
            }
            const nodeValues = this.getNodeValues(node, params.colDef.field);
            nodeValues.forEach((value) => {
                // only add it if not already in
                if (!(node.data[params.colDef.field] in values)) {
                    // just add the new value to the object
                    values = Object.assign(Object.assign({}, values), { [value]: { text: value, checked: this.defValuesChecked } });
                }
            });
            if (!nodeValues.length) {
                emptyValues = true;
            }
        });
        if (emptyValues) {
            values = Object.assign(this.getEmptyValue(), values);
        }
        return values;
    }
    getEmptyValue() {
        return {
            [Operators.Empty]: {
                text: OperatorText.Empty,
                checked: this.defValuesChecked,
            },
        };
    }
    getNodeValues(node, col) {
        if (!node.data || !node.data[col] || !node.data[col].length) {
            return [];
        }
        // Support for array of values in cell. Cell value can be string, number or array
        return Array.isArray(node.data[col]) ? node.data[col] : [node.data[col]];
    }
    validate(cellValue) {
        return Array.isArray(cellValue) ? this.arrayMatchChecker(cellValue) : this.matchAnyChecked(cellValue);
    }
    arrayMatchChecker(cellValue) {
        return cellValue.length === 0 ? this.matchAnyChecked('') : some(cellValue, (value) => this.matchAnyChecked(value));
    }
    matchAnyChecked(cellValue) {
        return !this.model || some(this.model, (item) => this.hasCoincidence(item, cellValue));
    }
    hasCoincidence(item, value) {
        return (item === Operators.Empty && !value.toString().trim()) || item === value.toString().trim();
    }
    sortValues() {
        // preserve map order
        return 1;
    }
    getCriteria() {
        return {
            operator: Operators.Equals,
            value: this.model,
            display: this.getModelDisplayValues(),
        };
    }
    selectAll(e) {
        this.model = [];
        Object.keys(this.values).forEach((val) => {
            this.values[val].checked = e.checked;
            this.model.push(val);
        });
        this.allOptionsSelected = e.checked;
    }
    checkAllSelection() {
        this.allOptionsSelected = Object.keys(this.values).length === this.model.length;
    }
    onInputChange(e, value) {
        const updatedModel = cloneDeep(this.model);
        if (e.checked) {
            updatedModel.push(value);
        }
        else {
            // this.allOptionsSelected = false;
            const index = updatedModel.indexOf(value);
            if (index > -1) {
                updatedModel.splice(index, 1);
            }
        }
        this.model = updatedModel;
        this.inputChanged.emit(updatedModel.join(','));
        this.checkAllSelection();
        this.validateFormat();
    }
    getModelDisplayValues() {
        if (this.allOptionsSelected) {
            return this.ALL_DISPLAY_VALUE;
        }
        const mappedValues = [];
        this.model.forEach((element) => {
            mappedValues.push(this.values[element].text);
        });
        // if empty was selected, switch it to last for displaying purposes
        if (mappedValues[0] === OperatorText.Empty) {
            mappedValues.push(mappedValues.shift());
        }
        return mappedValues.join(', ');
    }
}
XpoConditionDynamicEnumEqualsComponent.text = OperatorText.None; // value used in dropdown
XpoConditionDynamicEnumEqualsComponent.operator = Operators.Equals;
XpoConditionDynamicEnumEqualsComponent.ɵfac = function XpoConditionDynamicEnumEqualsComponent_Factory(t) { return new (t || XpoConditionDynamicEnumEqualsComponent)(); };
XpoConditionDynamicEnumEqualsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionDynamicEnumEqualsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 6, consts: [[1, "xpo-Enum-wrapper"], [1, "xpo-Enum-control"], [3, "ngModel", "change"], ["class", "xpo-Enum-item", 4, "ngFor", "ngForOf"], ["class", "error", 4, "ngIf"], [1, "xpo-Enum-item"], [3, "ngModel", "change", "ngModelChange"], [1, "error"]], template: function XpoConditionDynamicEnumEqualsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "mat-checkbox", 2);
        i0.ɵɵlistener("change", function XpoConditionDynamicEnumEqualsComponent_Template_mat_checkbox_change_2_listener($event) { return ctx.selectAll($event); });
        i0.ɵɵtext(3, "Select All");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, XpoConditionDynamicEnumEqualsComponent_div_4_Template, 3, 2, "div", 3);
        i0.ɵɵpipe(5, "keyvalue");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, XpoConditionDynamicEnumEqualsComponent_p_6_Template, 4, 1, "p", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.allOptionsSelected);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 3, ctx.values, ctx.sortValues));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1.MatCheckbox, i1$1.NgControlStatus, i1$1.NgModel, i2.NgForOf, i2.NgIf, i3.MatIcon], pipes: [i2.KeyValuePipe], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-Enum-wrapper[_ngcontent-%COMP%]   .xpo-Enum-control[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:75px}.xpo-Enum-wrapper[_ngcontent-%COMP%]   .xpo-Enum-control[_ngcontent-%COMP%]   .xpo-Enum-item[_ngcontent-%COMP%]:first-child{text-transform:capitalize}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionDynamicEnumEqualsComponent, [{
        type: Component,
        args: [{
                templateUrl: './equals.component.html',
                styleUrls: ['./equals.component.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberEqualsComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$H = function (a0) { return { "error": a0 }; };
class XpoConditionNumberEqualsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.number);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        return parseFloat(cellValue) === parseFloat(this.model);
    }
    getCriteria() {
        return {
            operator: Operators.Equals,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberEqualsComponent.text = OperatorText.Is;
XpoConditionNumberEqualsComponent.operator = Operators.Equals;
XpoConditionNumberEqualsComponent.ɵfac = function XpoConditionNumberEqualsComponent_Factory(t) { return new (t || XpoConditionNumberEqualsComponent)(); };
XpoConditionNumberEqualsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberEqualsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberEqualsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberEqualsComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionNumberEqualsComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionNumberEqualsComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$H, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-NumberCondition[_ngcontent-%COMP%]{min-width:235px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberEqualsComponent, [{
        type: Component,
        args: [{
                templateUrl: './equals.component.html',
                styleUrls: ['../number.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberGreaterEqualThanComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$G = function (a0) { return { "error": a0 }; };
class XpoConditionNumberGreaterEqualThanComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.number);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        return parseFloat(cellValue) >= parseFloat(this.model);
    }
    getCriteria() {
        return {
            operator: Operators.GreaterEqual,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberGreaterEqualThanComponent.text = OperatorText.GreaterEqual;
XpoConditionNumberGreaterEqualThanComponent.operator = Operators.GreaterEqual;
XpoConditionNumberGreaterEqualThanComponent.ɵfac = function XpoConditionNumberGreaterEqualThanComponent_Factory(t) { return new (t || XpoConditionNumberGreaterEqualThanComponent)(); };
XpoConditionNumberGreaterEqualThanComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberGreaterEqualThanComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberGreaterEqualThanComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberGreaterEqualThanComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionNumberGreaterEqualThanComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionNumberGreaterEqualThanComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$G, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-NumberCondition[_ngcontent-%COMP%]{min-width:235px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberGreaterEqualThanComponent, [{
        type: Component,
        args: [{
                templateUrl: './greater-equal-than.component.html',
                styleUrls: ['../number.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberGreaterThanComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$F = function (a0) { return { "error": a0 }; };
class XpoConditionNumberGreaterThanComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.number);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return parseFloat(cellValue) > parseFloat(this.model);
    }
    getCriteria() {
        return {
            operator: Operators.Greater,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberGreaterThanComponent.text = OperatorText.Greater; // value used in dropdown
XpoConditionNumberGreaterThanComponent.operator = Operators.Greater;
XpoConditionNumberGreaterThanComponent.ɵfac = function XpoConditionNumberGreaterThanComponent_Factory(t) { return new (t || XpoConditionNumberGreaterThanComponent)(); };
XpoConditionNumberGreaterThanComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberGreaterThanComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberGreaterThanComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberGreaterThanComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionNumberGreaterThanComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionNumberGreaterThanComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$F, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-NumberCondition[_ngcontent-%COMP%]{min-width:235px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberGreaterThanComponent, [{
        type: Component,
        args: [{
                templateUrl: './greater-than.component.html',
                styleUrls: ['../number.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberIsBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$E = function (a0) { return { "error": a0 }; };
class XpoConditionNumberIsBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.range);
        this.isNegative = false;
        this.model = {
            from: '',
            to: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model.from || !this.model.to) {
            return true;
        }
        return parseFloat(cellValue) >= parseFloat(this.model.from) && parseFloat(cellValue) <= parseFloat(this.model.to);
    }
    getCriteria() {
        return {
            operator: Operators.Between,
            value: this.model.from,
            valueTo: this.model.to,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberIsBetweenComponent.text = OperatorText.Between;
XpoConditionNumberIsBetweenComponent.operator = Operators.Between;
XpoConditionNumberIsBetweenComponent.ɵfac = function XpoConditionNumberIsBetweenComponent_Factory(t) { return new (t || XpoConditionNumberIsBetweenComponent)(); };
XpoConditionNumberIsBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberIsBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 9, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between", "xpo-FilterCondition--number"], ["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberIsBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberIsBetweenComponent_Template_input_ngModelChange_1_listener($event) { return ctx.model.from = $event; })("input", function XpoConditionNumberIsBetweenComponent_Template_input_input_1_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3, " and ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberIsBetweenComponent_Template_input_ngModelChange_4_listener($event) { return ctx.model.to = $event; })("input", function XpoConditionNumberIsBetweenComponent_Template_input_input_4_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionNumberIsBetweenComponent_p_5_Template, 4, 1, "p", 2);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.from)("ngClass", i0.ɵɵpureFunction1(5, _c0$E, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.model.to)("ngClass", i0.ɵɵpureFunction1(7, _c0$E, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberIsBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './is-between.component.html',
                styleUrls: ['./../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberIsNotBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$D = function (a0) { return { "error": a0 }; };
class XpoConditionNumberIsNotBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.range);
        this.isNegative = true;
        this.model = {
            from: '',
            to: '',
        };
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model.from || !this.model.to) {
            return true;
        }
        return parseFloat(cellValue) <= parseFloat(this.model.from) || parseFloat(cellValue) >= parseFloat(this.model.to);
    }
    getCriteria() {
        return {
            operator: Operators.NotBetween,
            value: this.model.from,
            valueTo: this.model.to,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberIsNotBetweenComponent.text = OperatorText.NotBetween;
XpoConditionNumberIsNotBetweenComponent.operator = Operators.NotBetween;
XpoConditionNumberIsNotBetweenComponent.ɵfac = function XpoConditionNumberIsNotBetweenComponent_Factory(t) { return new (t || XpoConditionNumberIsNotBetweenComponent)(); };
XpoConditionNumberIsNotBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberIsNotBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 9, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between", "xpo-FilterCondition--number"], ["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberIsNotBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberIsNotBetweenComponent_Template_input_ngModelChange_1_listener($event) { return ctx.model.from = $event; })("input", function XpoConditionNumberIsNotBetweenComponent_Template_input_input_1_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3, " and ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberIsNotBetweenComponent_Template_input_ngModelChange_4_listener($event) { return ctx.model.to = $event; })("input", function XpoConditionNumberIsNotBetweenComponent_Template_input_input_4_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionNumberIsNotBetweenComponent_p_5_Template, 4, 1, "p", 2);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.from)("ngClass", i0.ɵɵpureFunction1(5, _c0$D, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.model.to)("ngClass", i0.ɵɵpureFunction1(7, _c0$D, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberIsNotBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './is-not-between.component.html',
                styleUrls: ['./../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberLessEqualThanComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$C = function (a0) { return { "error": a0 }; };
class XpoConditionNumberLessEqualThanComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.number);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        return parseFloat(cellValue) <= parseFloat(this.model);
    }
    getCriteria() {
        return {
            operator: Operators.LessEqual,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberLessEqualThanComponent.text = OperatorText.LessEqual;
XpoConditionNumberLessEqualThanComponent.operator = Operators.LessEqual;
XpoConditionNumberLessEqualThanComponent.ɵfac = function XpoConditionNumberLessEqualThanComponent_Factory(t) { return new (t || XpoConditionNumberLessEqualThanComponent)(); };
XpoConditionNumberLessEqualThanComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberLessEqualThanComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberLessEqualThanComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberLessEqualThanComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionNumberLessEqualThanComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionNumberLessEqualThanComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$C, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-NumberCondition[_ngcontent-%COMP%]{min-width:235px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberLessEqualThanComponent, [{
        type: Component,
        args: [{
                templateUrl: './less-equal-than.component.html',
                styleUrls: ['../number.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberLessThanComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$B = function (a0) { return { "error": a0 }; };
class XpoConditionNumberLessThanComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.number);
        this.isNegative = false;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return parseFloat(cellValue) < parseFloat(this.model);
    }
    getCriteria() {
        return {
            operator: Operators.Less,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberLessThanComponent.text = OperatorText.Less;
XpoConditionNumberLessThanComponent.operator = Operators.Less;
XpoConditionNumberLessThanComponent.ɵfac = function XpoConditionNumberLessThanComponent_Factory(t) { return new (t || XpoConditionNumberLessThanComponent)(); };
XpoConditionNumberLessThanComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberLessThanComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberLessThanComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberLessThanComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionNumberLessThanComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionNumberLessThanComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$B, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-NumberCondition[_ngcontent-%COMP%]{min-width:235px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberLessThanComponent, [{
        type: Component,
        args: [{
                templateUrl: './less-than.component.html',
                styleUrls: ['../number.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionNumberNotEqualsComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$A = function (a0) { return { "error": a0 }; };
class XpoConditionNumberNotEqualsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.number);
        this.isNegative = true;
        this.model = '';
        this.inputChanged = new EventEmitter();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return parseFloat(cellValue) !== parseFloat(this.model);
    }
    getCriteria() {
        return {
            operator: Operators.NotEquals,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionNumberNotEqualsComponent.text = OperatorText.IsNot; // value used in dropdown
XpoConditionNumberNotEqualsComponent.operator = Operators.NotEquals;
XpoConditionNumberNotEqualsComponent.ɵfac = function XpoConditionNumberNotEqualsComponent_Factory(t) { return new (t || XpoConditionNumberNotEqualsComponent)(); };
XpoConditionNumberNotEqualsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionNumberNotEqualsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionNumberNotEqualsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionNumberNotEqualsComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionNumberNotEqualsComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionNumberNotEqualsComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$A, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-NumberCondition[_ngcontent-%COMP%]{min-width:235px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}.xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-NumberCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionNumberNotEqualsComponent, [{
        type: Component,
        args: [{
                templateUrl: './not-equals.component.html',
                styleUrls: ['../number.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionStringContainsComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$z = function (a0) { return { "error": a0 }; };
class XpoConditionStringContainsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        if (this.isCaseSensitive) {
            return cellValue.toString().indexOf(this.model) >= 0;
        }
        else {
            return (cellValue
                .toString()
                .toLowerCase()
                .indexOf(this.model.toLowerCase()) >= 0);
        }
    }
    getCriteria() {
        return {
            operator: Operators.Contains,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringContainsComponent.text = OperatorText.Contains;
XpoConditionStringContainsComponent.operator = Operators.Contains;
XpoConditionStringContainsComponent.ɵfac = function XpoConditionStringContainsComponent_Factory(t) { return new (t || XpoConditionStringContainsComponent)(); };
XpoConditionStringContainsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringContainsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringContainsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringContainsComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionStringContainsComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionStringContainsComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$z, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringContainsComponent, [{
        type: Component,
        args: [{
                templateUrl: './contains.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionStringDoesNotContainComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$y = function (a0) { return { "error": a0 }; };
class XpoConditionStringDoesNotContainComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = true;
        this.model = '';
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        if (this.isCaseSensitive) {
            return !(cellValue.toString().indexOf(this.model) >= 0);
        }
        else {
            return !(cellValue
                .toString()
                .toLowerCase()
                .indexOf(this.model.toLowerCase()) >= 0);
        }
    }
    getCriteria() {
        return {
            operator: Operators.NotContains,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringDoesNotContainComponent.text = OperatorText.NotContains;
XpoConditionStringDoesNotContainComponent.operator = Operators.NotContains;
XpoConditionStringDoesNotContainComponent.ɵfac = function XpoConditionStringDoesNotContainComponent_Factory(t) { return new (t || XpoConditionStringDoesNotContainComponent)(); };
XpoConditionStringDoesNotContainComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringDoesNotContainComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringDoesNotContainComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringDoesNotContainComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionStringDoesNotContainComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionStringDoesNotContainComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$y, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringDoesNotContainComponent, [{
        type: Component,
        args: [{
                templateUrl: './does-not-contain.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionStringEndsWithComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$x = function (a0) { return { "error": a0 }; };
class XpoConditionStringEndsWithComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        if (this.isCaseSensitive) {
            return cellValue.toString().endsWith(this.model);
        }
        else {
            return cellValue
                .toString()
                .toLowerCase()
                .endsWith(this.model.toLowerCase());
        }
    }
    getCriteria() {
        return {
            operator: Operators.EndsWith,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringEndsWithComponent.text = OperatorText.EndsWith;
XpoConditionStringEndsWithComponent.operator = Operators.EndsWith;
XpoConditionStringEndsWithComponent.ɵfac = function XpoConditionStringEndsWithComponent_Factory(t) { return new (t || XpoConditionStringEndsWithComponent)(); };
XpoConditionStringEndsWithComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringEndsWithComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringEndsWithComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringEndsWithComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionStringEndsWithComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionStringEndsWithComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$x, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringEndsWithComponent, [{
        type: Component,
        args: [{
                templateUrl: './ends-with.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionStringEqualsComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$w = function (a0) { return { "error": a0 }; };
class XpoConditionStringEqualsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        if (this.isCaseSensitive) {
            return cellValue.toString() === this.model;
        }
        else {
            return cellValue.toString().toLowerCase() === this.model.toLowerCase();
        }
    }
    getCriteria() {
        return {
            operator: Operators.Equals,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringEqualsComponent.text = OperatorText.Exactly;
XpoConditionStringEqualsComponent.operator = Operators.Equals;
XpoConditionStringEqualsComponent.ɵfac = function XpoConditionStringEqualsComponent_Factory(t) { return new (t || XpoConditionStringEqualsComponent)(); };
XpoConditionStringEqualsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringEqualsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringEqualsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringEqualsComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionStringEqualsComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionStringEqualsComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$w, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringEqualsComponent, [{
        type: Component,
        args: [{
                templateUrl: './equals.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

class XpoConditionEmptyComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, false);
        this.isNegative = false;
        this.model = null;
    }
    validate(cellValue) {
        if (cellValue !== undefined) {
            return !cellValue.toString().trim();
        }
        return true;
    }
    getCriteria() {
        return {
            operator: Operators.Empty,
            value: '',
        };
    }
}
XpoConditionEmptyComponent.text = OperatorText.Empty;
XpoConditionEmptyComponent.applyAlwaysEnabled = true;
XpoConditionEmptyComponent.operator = Operators.Empty;
XpoConditionEmptyComponent.ɵfac = function XpoConditionEmptyComponent_Factory(t) { return new (t || XpoConditionEmptyComponent)(); };
XpoConditionEmptyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionEmptyComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function XpoConditionEmptyComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionEmptyComponent, [{
        type: Component,
        args: [{ template: ' ' }]
    }], function () { return []; }, null); })();

function XpoConditionStringIsBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$v = function (a0) { return { "error": a0 }; };
class XpoConditionStringIsBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.stringRange);
        this.isNegative = false;
        this.model = {
            from: '',
            to: '',
        };
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model.from || !this.model.to) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        // if range is xpo45 to xpo90, xpo5 shouldn't show
        if (cellValue.length < this.model.from.length) {
            return false;
        }
        /**
         * If items are p0, p1, p2, p3, p4, p5, p6
         * range between p1 and p4 = p1, p2, p3, p4
         */
        let isGreater;
        let isLessThan;
        if (this.isCaseSensitive) {
            isGreater = cellValue.localeCompare(this.model.from);
            isLessThan = cellValue.localeCompare(this.model.to);
        }
        else {
            isGreater = cellValue
                .toString()
                .toLowerCase()
                .localeCompare(this.model.from.toLowerCase());
            isLessThan = cellValue
                .toString()
                .toLowerCase()
                .localeCompare(this.model.to.toLowerCase());
        }
        if (isGreater === 0 || isLessThan === 0) {
            return true;
        }
        else if (isGreater === 1 && isLessThan === -1) {
            return true;
        }
        return false;
    }
    getCriteria() {
        return {
            operator: Operators.Between,
            value: this.model.from,
            valueTo: this.model.to,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringIsBetweenComponent.text = OperatorText.Between;
XpoConditionStringIsBetweenComponent.operator = Operators.Between;
XpoConditionStringIsBetweenComponent.ɵfac = function XpoConditionStringIsBetweenComponent_Factory(t) { return new (t || XpoConditionStringIsBetweenComponent)(); };
XpoConditionStringIsBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringIsBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 9, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], ["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringIsBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringIsBetweenComponent_Template_input_ngModelChange_1_listener($event) { return ctx.model.from = $event; })("input", function XpoConditionStringIsBetweenComponent_Template_input_input_1_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3, " and ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringIsBetweenComponent_Template_input_ngModelChange_4_listener($event) { return ctx.model.to = $event; })("input", function XpoConditionStringIsBetweenComponent_Template_input_input_4_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionStringIsBetweenComponent_p_5_Template, 4, 1, "p", 2);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.from)("ngClass", i0.ɵɵpureFunction1(5, _c0$v, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.model.to)("ngClass", i0.ɵɵpureFunction1(7, _c0$v, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringIsBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './is-between.component.html',
                styleUrls: ['./../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionStringIsNotBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$u = function (a0) { return { "error": a0 }; };
class XpoConditionStringIsNotBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.stringRange);
        this.isNegative = true;
        this.model = {
            from: '',
            to: '',
        };
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model.from || !this.model.to) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        /**
         * If items are p0, p1, p2, p3, p4, p5, p6
         * range not between p1 and p4 = p0, p5, p6
         */
        let isGreater;
        let isLessThan;
        if (this.isCaseSensitive) {
            isGreater = cellValue.localeCompare(this.model.from);
            isLessThan = cellValue.localeCompare(this.model.to);
        }
        else {
            isGreater = cellValue
                .toString()
                .toLowerCase()
                .localeCompare(this.model.from.toLowerCase());
            isLessThan = cellValue
                .toString()
                .toLowerCase()
                .localeCompare(this.model.to.toLowerCase());
        }
        if (isGreater === 0 || isLessThan === 0) {
            return false;
        }
        else if (isGreater === 1 && isLessThan === -1) {
            return false;
        }
        return true;
    }
    getCriteria() {
        return {
            operator: Operators.NotBetween,
            value: this.model.from,
            valueTo: this.model.to,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringIsNotBetweenComponent.text = OperatorText.NotBetween;
XpoConditionStringIsNotBetweenComponent.operator = Operators.NotBetween;
XpoConditionStringIsNotBetweenComponent.ɵfac = function XpoConditionStringIsNotBetweenComponent_Factory(t) { return new (t || XpoConditionStringIsNotBetweenComponent)(); };
XpoConditionStringIsNotBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringIsNotBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 9, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], ["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringIsNotBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringIsNotBetweenComponent_Template_input_ngModelChange_1_listener($event) { return ctx.model.from = $event; })("input", function XpoConditionStringIsNotBetweenComponent_Template_input_input_1_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3, " and ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 1);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringIsNotBetweenComponent_Template_input_ngModelChange_4_listener($event) { return ctx.model.to = $event; })("input", function XpoConditionStringIsNotBetweenComponent_Template_input_input_4_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionStringIsNotBetweenComponent_p_5_Template, 4, 1, "p", 2);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.model.from)("ngClass", i0.ɵɵpureFunction1(5, _c0$u, ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.model.to)("ngClass", i0.ɵɵpureFunction1(7, _c0$u, ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringIsNotBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './is-not-between.component.html',
                styleUrls: ['./../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

class XpoConditionIsNotEmptyComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default, false);
        this.isNegative = true;
        this.model = null;
    }
    validate(cellValue) {
        if (cellValue !== undefined) {
            return cellValue.toString().trim();
        }
        return false;
    }
    getCriteria() {
        return {
            operator: Operators.NotEmpty,
            value: '',
        };
    }
}
XpoConditionIsNotEmptyComponent.text = OperatorText.NotEmpty;
XpoConditionIsNotEmptyComponent.applyAlwaysEnabled = true;
XpoConditionIsNotEmptyComponent.operator = Operators.NotEmpty;
XpoConditionIsNotEmptyComponent.ɵfac = function XpoConditionIsNotEmptyComponent_Factory(t) { return new (t || XpoConditionIsNotEmptyComponent)(); };
XpoConditionIsNotEmptyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionIsNotEmptyComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function XpoConditionIsNotEmptyComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionIsNotEmptyComponent, [{
        type: Component,
        args: [{ template: ' ' }]
    }], function () { return []; }, null); })();

function XpoConditionStringIsNotEqualComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$t = function (a0) { return { "error": a0 }; };
class XpoConditionStringIsNotEqualComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = true;
        this.model = '';
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        if (this.isCaseSensitive) {
            return cellValue.toString() !== this.model;
        }
        else {
            return cellValue.toString().toLowerCase() !== this.model.toLowerCase();
        }
    }
    getCriteria() {
        return {
            operator: Operators.NotEquals,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringIsNotEqualComponent.text = OperatorText.NotExactly;
XpoConditionStringIsNotEqualComponent.operator = Operators.NotEquals;
XpoConditionStringIsNotEqualComponent.ɵfac = function XpoConditionStringIsNotEqualComponent_Factory(t) { return new (t || XpoConditionStringIsNotEqualComponent)(); };
XpoConditionStringIsNotEqualComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringIsNotEqualComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringIsNotEqualComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringIsNotEqualComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionStringIsNotEqualComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionStringIsNotEqualComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$t, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringIsNotEqualComponent, [{
        type: Component,
        args: [{
                templateUrl: './is-not-equal.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionIsOneOfComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$s = function (a0) { return { "error": a0 }; };
class XpoConditionIsOneOfComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = [];
        this.userVal = '';
        this.inputChanged = new EventEmitter();
    }
    ngAfterViewInit() {
        // Transform array of values into string separated by new lines to be showed in textarea
        this.userVal = this.model.join('\n');
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const values = this.getArrayOfValues(this.model);
        let filterPass = false;
        values.forEach((val) => {
            if (val.toString().toLowerCase() === cellValue.toString().toLowerCase()) {
                filterPass = true;
            }
        });
        return filterPass;
    }
    getCriteria() {
        return {
            operator: Operators.OneOf,
            value: this.getArrayOfValues(this.model),
        };
    }
    onInputChange() {
        this.model = this.getArrayOfValues(this.userVal);
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
    getArrayOfValues(receivedModel) {
        let properArray;
        // If not an array create one with the received string value
        Array.isArray(receivedModel) ? (properArray = receivedModel) : (properArray = receivedModel.match(/[^\r\n]+/g));
        // If content is null assign a new array
        properArray = properArray || [];
        // Remove white spaces before and after each value
        properArray.forEach((value, index) => {
            properArray[index] = this.removeSpaces(value);
        });
        // Return expected array of values
        return properArray;
    }
    removeSpaces(value) {
        return value.trim();
    }
}
XpoConditionIsOneOfComponent.text = OperatorText.OneOf;
XpoConditionIsOneOfComponent.operator = Operators.OneOf;
XpoConditionIsOneOfComponent.ɵfac = function XpoConditionIsOneOfComponent_Factory(t) { return new (t || XpoConditionIsOneOfComponent)(); };
XpoConditionIsOneOfComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionIsOneOfComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["name", "name", "rows", "5", 1, "xpo-ConditionalFilter-one-of", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionIsOneOfComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "textarea", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionIsOneOfComponent_Template_textarea_ngModelChange_0_listener($event) { return ctx.userVal = $event; })("input", function XpoConditionIsOneOfComponent_Template_textarea_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionIsOneOfComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.userVal)("ngClass", i0.ɵɵpureFunction1(3, _c0$s, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionIsOneOfComponent, [{
        type: Component,
        args: [{
                templateUrl: './is-one-of.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionStringStartsWithComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
const _c0$r = function (a0) { return { "error": a0 }; };
class XpoConditionStringStartsWithComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '';
        this.isCaseSensitive = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.isCaseSensitive = params.isCaseSensitive || false;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        if (this.isCaseSensitive) {
            return cellValue.toString().startsWith(this.model);
        }
        else {
            return cellValue
                .toString()
                .toLowerCase()
                .startsWith(this.model.toLowerCase());
        }
    }
    getCriteria() {
        return {
            operator: Operators.StartsWith,
            value: this.model,
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
}
XpoConditionStringStartsWithComponent.text = OperatorText.StartsWith;
XpoConditionStringStartsWithComponent.operator = Operators.StartsWith;
XpoConditionStringStartsWithComponent.ɵfac = function XpoConditionStringStartsWithComponent_Factory(t) { return new (t || XpoConditionStringStartsWithComponent)(); };
XpoConditionStringStartsWithComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionStringStartsWithComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["type", "text", 3, "ngModel", "ngClass", "ngModelChange", "input"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionStringStartsWithComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0);
        i0.ɵɵlistener("ngModelChange", function XpoConditionStringStartsWithComponent_Template_input_ngModelChange_0_listener($event) { return ctx.model = $event; })("input", function XpoConditionStringStartsWithComponent_Template_input_input_0_listener() { return ctx.onInputChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, XpoConditionStringStartsWithComponent_p_1_Template, 4, 1, "p", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngModel", ctx.model)("ngClass", i0.ɵɵpureFunction1(3, _c0$r, ctx.errors.format || ctx.errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgClass, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionStringStartsWithComponent, [{
        type: Component,
        args: [{
                templateUrl: './starts-with.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

/**
 * Takes a parsable time and creates a moment object with today's date at that time
 *
 * @param time A date time (typically HH:mm) with a parsable timestamp by moment.
 * Also supports seconds, milliseconds, and 12hr time with meridiem present
 */
function getTodayAt(time) {
    let format;
    if (!!time) {
        const separatorCount = [...time].filter((char) => char === ':' || char === '.').length;
        const meridiemPresent = time.match('([AaPp].?[Mm].?)');
        // initialize to empty string
        format = '';
        // check if meridiem is present for hour format
        format += meridiemPresent ? 'hh' : 'HH';
        // add minutes
        if (separatorCount >= 1) {
            format += ':mm';
        }
        // if seconds present, add formatter
        if (separatorCount >= 2) {
            format += ':ss';
        }
        // if seconds milliseconds present, add formatter
        if (separatorCount >= 3) {
            format += '.SSS';
        }
        // if meridiem present, add meridiem formatter
        if (!!meridiemPresent) {
            format += ' A';
        }
    }
    return moment(time, format);
}
/**
 * Takes two military time strings and figures out which one comes first
 *
 * @param a string with the following moment equiv. format HH:mm
 * @param b string with the following moment equiv. format HH:mm
 *
 * @return Object keyed from, to with the smaller time in from and larger in to
 */
function ordersMinMaxTime(a, b) {
    if (Number.parseInt(a.substr(0, 2), 10) * 60 + Number.parseInt(a.substr(3, 2), 10) >=
        Number.parseInt(b.substr(0, 2), 10) * 60 + Number.parseInt(b.substr(3, 2), 10)) {
        return { from: b, to: a };
    }
    else {
        return { from: a, to: b };
    }
}

const INVALID_24HOUR_FORMAT_MSG = 'Must be a valid 24hr value';
const INVALID_AM_PM_FORMAT_MSG = 'Must be a valid "HH:mm am/pm" time value';

const _c0$q = function (a0) { return { "error": a0 }; };
function ExactTimeInputComponent_input_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 2);
    i0.ɵɵlistener("ngModelChange", function ExactTimeInputComponent_input_0_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.model = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r0.model)("formControl", ctx_r0.hour24)("ngClass", i0.ɵɵpureFunction1(3, _c0$q, ctx_r0.validationError));
} }
function ExactTimeInputComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 3);
    i0.ɵɵlistener("ngModelChange", function ExactTimeInputComponent_input_1_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.model = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1.model)("formControl", ctx_r1.hour12)("ngClass", i0.ɵɵpureFunction1(3, _c0$q, ctx_r1.validationError));
} }
class ExactTimeInputComponent {
    constructor() {
        this.formatError = new EventEmitter();
        this.inputValue = new EventEmitter();
        this.model = '';
        this.hour24 = new FormControl('', Validators.pattern('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$'));
        this.hour12 = new FormControl('', Validators.pattern('((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))'));
    }
    ngOnInit() {
        if (this.is24Hour) {
            this.valueSubscription = this.hour24.valueChanges.subscribe((value) => {
                if (!this.hour24.dirty) {
                    return;
                }
                if (this.hour24.valid) {
                    this.formatErrorEvent = {
                        isErrorFormat: false,
                        errorMsg: '',
                    };
                    this.formatError.emit(this.formatErrorEvent);
                }
                else {
                    this.formatErrorEvent = {
                        isErrorFormat: true,
                        errorMsg: INVALID_24HOUR_FORMAT_MSG,
                    };
                    this.formatError.emit(this.formatErrorEvent);
                }
                if (this.hour24.value.length > 5) {
                    this.hour24.setValue(this.hour24.value.slice(0, 5));
                }
                if (this.hour24.value.length > 2 && this.hour24.value.charAt(2) !== ':') {
                    this.hour24.setValue(this.hour24.value.slice(0, 2) + ':' + this.hour24.value.slice(2));
                }
                this.inputValue.emit(this.hour24.value);
            });
        }
        else {
            this.valueSubscription = this.hour12.valueChanges.subscribe((value) => {
                if (!this.hour12.dirty) {
                    return;
                }
                let eventValue;
                if (value) {
                    if (this.hour12.valid) {
                        this.formatErrorEvent = {
                            isErrorFormat: false,
                            errorMsg: '',
                        };
                        this.formatError.emit(this.formatErrorEvent);
                    }
                    else {
                        this.formatErrorEvent = {
                            isErrorFormat: true,
                            errorMsg: INVALID_AM_PM_FORMAT_MSG,
                        };
                        this.formatError.emit(this.formatErrorEvent);
                    }
                    if (this.hour12.value.length > 8) {
                        this.hour12.setValue(this.hour12.value.slice(0, 8));
                    }
                    if (this.hour12.value.length > 2 && this.hour12.value.charAt(2) !== ':') {
                        this.hour12.setValue(this.hour12.value.slice(0, 2) + ':' + this.hour12.value.slice(2));
                    }
                    if (this.hour12.value.length > 5 && this.hour12.value.charAt(5) !== ' ') {
                        this.hour12.setValue(this.hour12.value.slice(0, 5) + ' ' + this.hour12.value.slice(5));
                    }
                    eventValue = this.hour12.value;
                }
                this.inputValue.emit(eventValue);
            });
        }
    }
    ngOnDestroy() {
        this.valueSubscription.unsubscribe();
    }
}
ExactTimeInputComponent.ɵfac = function ExactTimeInputComponent_Factory(t) { return new (t || ExactTimeInputComponent)(); };
ExactTimeInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExactTimeInputComponent, selectors: [["xpo-exact-time-input"]], inputs: { is24Hour: "is24Hour", validationError: "validationError", model: "model" }, outputs: { formatError: "formatError", inputValue: "inputValue" }, decls: 2, vars: 2, consts: [["placeholder", "- - : - -", 3, "ngModel", "formControl", "ngClass", "ngModelChange", 4, "ngIf"], ["placeholder", "- - : - -  - -", 3, "ngModel", "formControl", "ngClass", "ngModelChange", 4, "ngIf"], ["placeholder", "- - : - -", 3, "ngModel", "formControl", "ngClass", "ngModelChange"], ["placeholder", "- - : - -  - -", 3, "ngModel", "formControl", "ngClass", "ngModelChange"]], template: function ExactTimeInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ExactTimeInputComponent_input_0_Template, 1, 5, "input", 0);
        i0.ɵɵtemplate(1, ExactTimeInputComponent_input_1_Template, 1, 5, "input", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.is24Hour);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.is24Hour);
    } }, directives: [i2.NgIf, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, i2.NgClass], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}input[_ngcontent-%COMP%]{text-transform:uppercase}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExactTimeInputComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-exact-time-input',
                templateUrl: './exact-time-input.component.html',
                styleUrls: ['./exact-time-input.component.scss'],
            }]
    }], function () { return []; }, { is24Hour: [{
            type: Input
        }], validationError: [{
            type: Input
        }], formatError: [{
            type: Output
        }], inputValue: [{
            type: Output
        }], model: [{
            type: Input
        }] }); })();

function XpoConditionTimeAfterSameComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeAfterSameComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.time);
        this.isNegative = false;
        this.model = '';
        this.format24Error = false;
        // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
        // in a more correct manner
        this.fakeDate = '01/01/2020';
        this.is24Hour = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
        // TODO: this fill be fixed when refactoring this whole thing
        if (!this.is24Hour) {
            this.changeFormat(filterFormats.default);
        }
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
        return ordersMinMaxTime(cell, this.model).from === this.model;
    }
    getCriteria() {
        return {
            operator: Operators.OnOrAfter,
            value: this.model,
        };
    }
    onInputChange(value) {
        this.model = value;
        // TODO: this fill be fixed when refactoring this whole thing
        if (this.is24Hour) {
            this.validateFormat();
        }
        this.inputChanged.emit(this.model);
    }
}
XpoConditionTimeAfterSameComponent.text = OperatorText.OnOrAfter;
XpoConditionTimeAfterSameComponent.operator = Operators.OnOrAfter;
XpoConditionTimeAfterSameComponent.ɵfac = function XpoConditionTimeAfterSameComponent_Factory(t) { return new (t || XpoConditionTimeAfterSameComponent)(); };
XpoConditionTimeAfterSameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeAfterSameComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeAfterSameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeAfterSameComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionTimeAfterSameComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.format || ctx.errors.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeAfterSameComponent, [{
        type: Component,
        args: [{
                templateUrl: './after-same.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeAfterComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeAfterComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.time);
        this.isNegative = false;
        this.model = '';
        this.format24Error = false;
        // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
        // in a more correct manner
        this.fakeDate = '01/01/2020';
        this.is24Hour = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
        // TODO: this fill be fixed when refactoring this whole thing
        if (!this.is24Hour) {
            this.changeFormat(filterFormats.default);
        }
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
        return ordersMinMaxTime(cell, this.model).from === this.model && cell !== this.model;
    }
    getCriteria() {
        return {
            operator: Operators.After,
            value: this.model,
        };
    }
    onInputChange(value) {
        this.model = value;
        // TODO: this fill be fixed when refactoring this whole thing
        if (this.is24Hour) {
            this.validateFormat();
        }
        this.inputChanged.emit(this.model);
    }
}
XpoConditionTimeAfterComponent.text = OperatorText.After;
XpoConditionTimeAfterComponent.operator = Operators.After;
XpoConditionTimeAfterComponent.ɵfac = function XpoConditionTimeAfterComponent_Factory(t) { return new (t || XpoConditionTimeAfterComponent)(); };
XpoConditionTimeAfterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeAfterComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeAfterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeAfterComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionTimeAfterComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.format || ctx.errors.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeAfterComponent, [{
        type: Component,
        args: [{
                templateUrl: './after.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeBeforeSameComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeBeforeSameComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.time);
        this.isNegative = false;
        this.model = '';
        this.format24Error = false;
        // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
        // in a more correct manner
        this.fakeDate = '01/01/2020';
        this.is24Hour = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
        // TODO: this fill be fixed when refactoring this whole thing
        if (!this.is24Hour) {
            this.changeFormat(filterFormats.default);
        }
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
        return ordersMinMaxTime(cell, this.model).to === this.model;
    }
    getCriteria() {
        return {
            operator: Operators.OnOrBefore,
            value: this.model,
        };
    }
    onInputChange(value) {
        this.model = value;
        // TODO: this fill be fixed when refactoring this whole thing
        if (this.is24Hour) {
            this.validateFormat();
        }
        this.inputChanged.emit(this.model);
    }
}
XpoConditionTimeBeforeSameComponent.text = OperatorText.OnOrBefore;
XpoConditionTimeBeforeSameComponent.operator = Operators.OnOrBefore;
XpoConditionTimeBeforeSameComponent.ɵfac = function XpoConditionTimeBeforeSameComponent_Factory(t) { return new (t || XpoConditionTimeBeforeSameComponent)(); };
XpoConditionTimeBeforeSameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeBeforeSameComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeBeforeSameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeBeforeSameComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionTimeBeforeSameComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.format || ctx.errors.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeBeforeSameComponent, [{
        type: Component,
        args: [{
                templateUrl: './before-same.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeBeforeComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeBeforeComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.time);
        this.isNegative = false;
        this.model = '';
        this.format24Error = false;
        // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
        // in a more correct manner
        this.fakeDate = '01/01/2020';
        this.is24Hour = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
        // TODO: this fill be fixed when refactoring this whole thing
        if (!this.is24Hour) {
            this.changeFormat(filterFormats.default);
        }
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
        return ordersMinMaxTime(cell, this.model).to === this.model && cell !== this.model;
    }
    getCriteria() {
        return {
            operator: Operators.Before,
            value: this.model,
        };
    }
    onInputChange(value) {
        this.model = value;
        // TODO: this fill be fixed when refactoring this whole thing
        if (this.is24Hour) {
            this.validateFormat();
        }
        this.inputChanged.emit(this.model);
    }
}
XpoConditionTimeBeforeComponent.text = OperatorText.Before;
XpoConditionTimeBeforeComponent.operator = Operators.Before;
XpoConditionTimeBeforeComponent.ɵfac = function XpoConditionTimeBeforeComponent_Factory(t) { return new (t || XpoConditionTimeBeforeComponent)(); };
XpoConditionTimeBeforeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeBeforeComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeBeforeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeBeforeComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionTimeBeforeComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.format || ctx.errors.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeBeforeComponent, [{
        type: Component,
        args: [{
                templateUrl: './before.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.stringRange);
        this.isNegative = false;
        this.model = {
            from: '',
            to: '',
        };
        this.format24Error = false;
        // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
        // in a more correct manner
        this.fakeDate = '01/01/2020';
        this.is24Hour = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
        // TODO: this fill be fixed when refactoring this whole thing
        if (!this.is24Hour) {
            this.changeFormat(filterFormats.default);
        }
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
        const ordered = ordersMinMaxTime(this.model.from, this.model.to);
        // moment.isBetween doesn't work for time or something
        return ordersMinMaxTime(cell, ordered.from).to === cell && ordersMinMaxTime(cell, ordered.to).from === cell;
    }
    getCriteria() {
        const ordered = ordersMinMaxTime(this.model.from, this.model.to);
        return {
            operator: Operators.Between,
            value: ordered.from,
            valueTo: ordered.to,
        };
    }
    onFromInputChange(value) {
        if (!value || !value.length) {
            return;
        }
        this.model.from = value;
        this.onInputChange();
    }
    onToInputChange(value) {
        this.model.to = value;
        this.onInputChange();
    }
    onInputChange() {
        // TODO: this fill be fixed when refactoring this whole thing
        if (this.is24Hour) {
            this.validateFormat();
        }
        this.inputChanged.emit(this.model);
    }
}
XpoConditionTimeBetweenComponent.text = OperatorText.Between;
XpoConditionTimeBetweenComponent.operator = Operators.Between;
XpoConditionTimeBetweenComponent.ɵfac = function XpoConditionTimeBetweenComponent_Factory(t) { return new (t || XpoConditionTimeBetweenComponent)(); };
XpoConditionTimeBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 7, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], [1, "xpo-FilterCondition-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeBetweenComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onFromInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeBetweenComponent_Template_xpo_exact_time_input_inputValue_4_listener($event) { return ctx.onToInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionTimeBetweenComponent_p_5_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.from)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.to)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './between.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeEqualsComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeEqualsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.time);
        this.isNegative = false;
        this.model = '';
        this.format24Error = false;
        // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
        // in a more correct manner
        this.fakeDate = '01/01/2020';
        this.is24Hour = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
        // TODO: this fill be fixed when refactoring this whole thing
        if (!this.is24Hour) {
            this.changeFormat(filterFormats.default);
        }
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
        return cell === this.model;
    }
    getCriteria() {
        return {
            operator: Operators.Equals,
            value: this.model,
        };
    }
    onInputChange(value) {
        this.model = value;
        // TODO: this fill be fixed when refactoring this whole thing
        if (this.is24Hour) {
            this.validateFormat();
        }
        this.inputChanged.emit(this.model);
    }
}
XpoConditionTimeEqualsComponent.text = OperatorText.Exactly;
XpoConditionTimeEqualsComponent.operator = Operators.Equals;
XpoConditionTimeEqualsComponent.ɵfac = function XpoConditionTimeEqualsComponent_Factory(t) { return new (t || XpoConditionTimeEqualsComponent)(); };
XpoConditionTimeEqualsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeEqualsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeEqualsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeEqualsComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionTimeEqualsComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.format || ctx.errors.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeEqualsComponent, [{
        type: Component,
        args: [{
                templateUrl: './equals.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeIsComponent_option_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r1.key);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r1.value);
} }
var RelativeTime;
(function (RelativeTime) {
    RelativeTime["lastHour"] = "Last hour";
    RelativeTime["lastSix"] = "Last 6 hours";
    RelativeTime["lastTwelve"] = "Last 12 hours";
    RelativeTime["nextHour"] = "Next hour";
    RelativeTime["nextSix"] = "Next 6 hours";
    RelativeTime["nextTwelve"] = "Next 12 hours";
})(RelativeTime || (RelativeTime = {}));
class XpoConditionTimeIsComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.default);
        this.isNegative = false;
        this.model = '-1h'; // This will be cleared when refactoring
        this.RelativeTime = RelativeTime; // For Select
        // Don't think; Only do
        this.comparisonMap = {
            [RelativeTime.lastHour]: (v) => getTodayAt(v).isBetween(moment().subtract(1, 'hour'), moment()),
            [RelativeTime.lastSix]: (v) => getTodayAt(v).isBetween(moment().subtract(6, 'hour'), moment()),
            [RelativeTime.lastTwelve]: (v) => getTodayAt(v).isBetween(moment().subtract(12, 'hour'), moment()),
            [RelativeTime.nextHour]: (v) => getTodayAt(v).isBetween(moment(), moment().add(1, 'hour')),
            [RelativeTime.nextSix]: (v) => getTodayAt(v).isBetween(moment(), moment().add(6, 'hour')),
            [RelativeTime.nextTwelve]: (v) => getTodayAt(v).isBetween(moment(), moment().add(12, 'hour')),
        };
        // Using 'any' as type instead of 'RelativeTime[]' because it is used as
        // index in the validate() function.
        // TODO: Look for a better solution in validation()
        this.valueMap = {
            '-1h': [RelativeTime.lastHour],
            '-6h': [RelativeTime.lastSix],
            '-12h': [RelativeTime.lastTwelve],
            '+1h': [RelativeTime.nextHour],
            '+6h': [RelativeTime.nextSix],
            '+12h': [RelativeTime.nextTwelve],
        };
        this.inputChanged = new EventEmitter();
    }
    ngOnInit() {
        this.onInputChange();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        return this.comparisonMap[this.valueMap[this.model]](cellValue);
    }
    getCriteria() {
        return {
            operator: Operators.Relative,
            value: this.model,
            display: this.valueMap[this.model],
        };
    }
    onInputChange() {
        this.validateFormat();
        this.inputChanged.emit(this.model);
    }
    // preserve order when iterating object: https://github.com/angular/angular/issues/31420
    asIsOrder(a, b) {
        return 0;
    }
}
XpoConditionTimeIsComponent.text = OperatorText.Is;
XpoConditionTimeIsComponent.operator = Operators.Relative;
XpoConditionTimeIsComponent.ɵfac = function XpoConditionTimeIsComponent_Factory(t) { return new (t || XpoConditionTimeIsComponent)(); };
XpoConditionTimeIsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeIsComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 5, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "ngModel", "ngModelChange", "input"], ["value", "", 3, "value", 4, "ngFor", "ngForOf"], ["value", "", 3, "value"]], template: function XpoConditionTimeIsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "select", 2);
        i0.ɵɵlistener("ngModelChange", function XpoConditionTimeIsComponent_Template_select_ngModelChange_2_listener($event) { return ctx.model = $event; })("input", function XpoConditionTimeIsComponent_Template_select_input_2_listener() { return ctx.onInputChange(); });
        i0.ɵɵtemplate(3, XpoConditionTimeIsComponent_option_3_Template, 2, 2, "option", 3);
        i0.ɵɵpipe(4, "keyvalue");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.model);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(4, 2, ctx.valueMap, ctx.asIsOrder));
    } }, directives: [i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.NgForOf, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption], pipes: [i2.KeyValuePipe], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeIsComponent, [{
        type: Component,
        args: [{
                templateUrl: './is.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeNotBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeNotBetweenComponent extends XpoConditionBase {
    constructor() {
        super(filterFormats.stringRange);
        this.isNegative = false;
        this.model = {
            from: '',
            to: '',
        };
        this.format24Error = false;
        // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
        // in a more correct manner
        this.fakeDate = '01/01/2020';
        this.is24Hour = false;
        this.inputChanged = new EventEmitter();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
        // TODO: this fill be fixed when refactoring this whole thing
        if (!this.is24Hour) {
            this.changeFormat(filterFormats.default);
        }
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue) {
            return false;
        }
        const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
        const ordered = ordersMinMaxTime(this.model.from, this.model.to);
        return ((ordersMinMaxTime(cell, ordered.from).from === cell && ordered.from !== cell) ||
            (ordersMinMaxTime(ordered.to, cell).to === cell && ordered.to !== cell));
    }
    getCriteria() {
        const ordered = ordersMinMaxTime(this.model.from, this.model.to);
        return {
            operator: Operators.NotBetween,
            value: ordered.from,
            valueTo: ordered.to,
        };
    }
    onFromInputChange(value) {
        if (!value || !value.length) {
            return;
        }
        this.model.from = value;
        this.onInputChange();
    }
    onToInputChange(value) {
        this.model.to = value;
        this.onInputChange();
    }
    onInputChange() {
        // TODO: this fill be fixed when refactoring this whole thing
        if (this.is24Hour) {
            this.validateFormat();
        }
        this.inputChanged.emit(this.model);
    }
}
XpoConditionTimeNotBetweenComponent.text = OperatorText.NotBetween;
XpoConditionTimeNotBetweenComponent.operator = Operators.NotBetween;
XpoConditionTimeNotBetweenComponent.ɵfac = function XpoConditionTimeNotBetweenComponent_Factory(t) { return new (t || XpoConditionTimeNotBetweenComponent)(); };
XpoConditionTimeNotBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeNotBetweenComponent, selectors: [["ng-component"]], outputs: { inputChanged: "inputChanged" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 7, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], [1, "xpo-FilterCondition-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeNotBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeNotBetweenComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onFromInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeNotBetweenComponent_Template_xpo_exact_time_input_inputValue_4_listener($event) { return ctx.onToInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionTimeNotBetweenComponent_p_5_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.from)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.to)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required || ctx.format24Error);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeNotBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './not-between.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, { inputChanged: [{
            type: Output
        }] }); })();

function XpoConditionTimeRangeBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeRangeBetweenComponent extends XpoConditionTimeBetweenComponent {
    constructor() {
        super();
    }
    set customFilterParams(params) {
        this.is24Hour = params.is24HourFormat;
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue || !cellValue.from || !cellValue.to) {
            return false;
        }
        const cellValueFrom = moment(cellValue.from, 'h:mma');
        const cellValueTo = moment(cellValue.to, 'h:mma');
        const modelFrom = moment(this.model.from, 'h:mma');
        const modelTo = moment(this.model.to, 'h:mma');
        // Common scenario when user set FROM lesser than TO
        if (modelFrom.isSameOrBefore(modelTo)) {
            return cellValueFrom.isSameOrAfter(modelFrom) && cellValueTo.isSameOrBefore(modelTo);
        }
        // Filter FROM is greater than TO, it means we only need to conside FROM, since TO will pass anyway
        return cellValueFrom.isSameOrAfter(modelFrom);
    }
    getCriteria() {
        return {
            operator: Operators.Between,
            value: this.model.from,
            valueTo: this.model.to,
        };
    }
}
XpoConditionTimeRangeBetweenComponent.text = OperatorText.Between;
XpoConditionTimeRangeBetweenComponent.operator = Operators.Between;
XpoConditionTimeRangeBetweenComponent.ɵfac = function XpoConditionTimeRangeBetweenComponent_Factory(t) { return new (t || XpoConditionTimeRangeBetweenComponent)(); };
XpoConditionTimeRangeBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeRangeBetweenComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 7, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], [1, "xpo-FilterCondition-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeRangeBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeRangeBetweenComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onFromInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeRangeBetweenComponent_Template_xpo_exact_time_input_inputValue_4_listener($event) { return ctx.onToInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionTimeRangeBetweenComponent_p_5_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.from)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.to)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeRangeBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './between.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, null); })();

function XpoConditionTimeRangeNotBetweenComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeRangeNotBetweenComponent extends XpoConditionTimeNotBetweenComponent {
    constructor() {
        super();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue || !cellValue.from || !cellValue.to) {
            return false;
        }
        const cellValueFrom = moment(cellValue.from, 'h:mma');
        const cellValueTo = moment(cellValue.to, 'h:mma');
        const modelFrom = moment(this.model.from, 'h:mma');
        const modelTo = moment(this.model.to, 'h:mma');
        // Common scenario when user set FROM lesser than TO
        if (modelFrom.isSameOrBefore(modelTo)) {
            return ((cellValueFrom.isBefore(modelFrom) && cellValueTo.isBefore(modelTo)) ||
                (cellValueFrom.isAfter(modelFrom) && cellValueTo.isAfter(modelTo)));
        }
        // If FROM is greather than TO on this no-bewteen filter, then whe need to do the oposite validation
        return cellValueFrom.isSameOrAfter(modelTo) && cellValueTo.isSameOrBefore(modelFrom);
    }
    getCriteria() {
        return {
            operator: Operators.NotBetween,
            value: this.model.from,
            valueTo: this.model.to,
        };
    }
}
XpoConditionTimeRangeNotBetweenComponent.text = OperatorText.NotBetween;
XpoConditionTimeRangeNotBetweenComponent.operator = Operators.NotBetween;
XpoConditionTimeRangeNotBetweenComponent.ɵfac = function XpoConditionTimeRangeNotBetweenComponent_Factory(t) { return new (t || XpoConditionTimeRangeNotBetweenComponent)(); };
XpoConditionTimeRangeNotBetweenComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeRangeNotBetweenComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 7, consts: [[1, "xpo-FilterCondition", "xpo-FilterCondition--between"], [1, "xpo-FilterCondition-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeRangeNotBetweenComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeRangeNotBetweenComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onFromInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeRangeNotBetweenComponent_Template_xpo_exact_time_input_inputValue_4_listener($event) { return ctx.onToInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoConditionTimeRangeNotBetweenComponent_p_5_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.from)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.from.format || ctx.errors.required && ctx.errors.from.required);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model.to)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.to.format || ctx.errors.required && ctx.errors.to.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeRangeNotBetweenComponent, [{
        type: Component,
        args: [{
                templateUrl: './not-between.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, null); })();

function XpoConditionTimeRangeAfterComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeRangeAfterComponent extends XpoConditionTimeAfterComponent {
    constructor() {
        super();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue || !cellValue.from || !cellValue.to) {
            return false;
        }
        const cellValueFrom = moment(cellValue.from, 'h:mma');
        const cellValueTo = moment(cellValue.to, 'h:mma');
        const model = moment(this.model, 'h:mma');
        return cellValueFrom.isAfter(model) || cellValueTo.isAfter(model);
    }
}
XpoConditionTimeRangeAfterComponent.text = OperatorText.After;
XpoConditionTimeRangeAfterComponent.operator = Operators.After;
XpoConditionTimeRangeAfterComponent.ɵfac = function XpoConditionTimeRangeAfterComponent_Factory(t) { return new (t || XpoConditionTimeRangeAfterComponent)(); };
XpoConditionTimeRangeAfterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeRangeAfterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeRangeAfterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeRangeAfterComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionTimeRangeAfterComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.format || ctx.errors.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeRangeAfterComponent, [{
        type: Component,
        args: [{
                templateUrl: './after.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, null); })();

function XpoConditionTimeRangeBeforeComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "\n");
} }
class XpoConditionTimeRangeBeforeComponent extends XpoConditionTimeBeforeComponent {
    constructor() {
        super();
    }
    validate(cellValue) {
        // Do not validate if input is empty
        if (!this.model) {
            return true;
        }
        if (!cellValue || !cellValue.from || !cellValue.to) {
            return false;
        }
        const cellValueFrom = moment(cellValue.from, 'h:mma');
        const cellValueTo = moment(cellValue.to, 'h:mma');
        const model = moment(this.model, 'h:mma');
        return cellValueFrom.isBefore(model) || cellValueTo.isBefore(model);
    }
}
XpoConditionTimeRangeBeforeComponent.text = OperatorText.Before;
XpoConditionTimeRangeBeforeComponent.operator = Operators.Before;
XpoConditionTimeRangeBeforeComponent.ɵfac = function XpoConditionTimeRangeBeforeComponent_Factory(t) { return new (t || XpoConditionTimeRangeBeforeComponent)(); };
XpoConditionTimeRangeBeforeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionTimeRangeBeforeComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "xpo-Time-wrapper"], [1, "xpo-Time-control"], [3, "model", "is24Hour", "validationError", "inputValue"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function XpoConditionTimeRangeBeforeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "xpo-exact-time-input", 2);
        i0.ɵɵlistener("inputValue", function XpoConditionTimeRangeBeforeComponent_Template_xpo_exact_time_input_inputValue_2_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoConditionTimeRangeBeforeComponent_p_3_Template, 4, 1, "p", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("model", ctx.model)("is24Hour", ctx.is24Hour)("validationError", ctx.errors.format || ctx.errors.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.format || ctx.errors.required);
    } }, directives: [ExactTimeInputComponent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionTimeRangeBeforeComponent, [{
        type: Component,
        args: [{
                templateUrl: './before.component.html',
                styleUrls: ['../../validator.scss'],
            }]
    }], function () { return []; }, null); })();

class XpoConditionRangeEmptyComponent extends XpoConditionEmptyComponent {
    constructor() {
        super();
        this.isNegative = false;
        this.model = null;
    }
    validate(cellValue) {
        if (!cellValue) {
            return false;
        }
        return !cellValue.from && !cellValue.to;
    }
}
XpoConditionRangeEmptyComponent.text = OperatorText.Empty;
XpoConditionRangeEmptyComponent.applyAlwaysEnabled = true;
XpoConditionRangeEmptyComponent.operator = Operators.Empty;
XpoConditionRangeEmptyComponent.ɵfac = function XpoConditionRangeEmptyComponent_Factory(t) { return new (t || XpoConditionRangeEmptyComponent)(); };
XpoConditionRangeEmptyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionRangeEmptyComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function XpoConditionRangeEmptyComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionRangeEmptyComponent, [{
        type: Component,
        args: [{ template: ' ' }]
    }], function () { return []; }, null); })();

class XpoConditionRangeNotEmptyComponent extends XpoConditionIsNotEmptyComponent {
    constructor() {
        super();
        this.isNegative = false;
        this.model = null;
    }
    validate(cellValue) {
        if (!cellValue) {
            return false;
        }
        if (cellValue.from || cellValue.to) {
            return (cellValue.from && cellValue.from.length) || (cellValue.to && cellValue.to.length);
        }
    }
}
XpoConditionRangeNotEmptyComponent.text = OperatorText.NotEmpty;
XpoConditionRangeNotEmptyComponent.applyAlwaysEnabled = true;
XpoConditionRangeNotEmptyComponent.operator = Operators.NotEmpty;
XpoConditionRangeNotEmptyComponent.ɵfac = function XpoConditionRangeNotEmptyComponent_Factory(t) { return new (t || XpoConditionRangeNotEmptyComponent)(); };
XpoConditionRangeNotEmptyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoConditionRangeNotEmptyComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function XpoConditionRangeNotEmptyComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoConditionRangeNotEmptyComponent, [{
        type: Component,
        args: [{ template: ' ' }]
    }], function () { return []; }, null); })();

function XpoBooleanFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoBooleanFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoBooleanFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoBooleanFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoBooleanFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoBooleanFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoBooleanFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoBooleanFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoBooleanFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoBooleanFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoBooleanFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoBooleanFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.defaultConditions = [
            XpoConditionBooleanTrueComponent,
            XpoConditionBooleanFalseComponent,
            XpoConditionEmptyComponent,
            XpoConditionIsNotEmptyComponent,
        ];
    }
}
XpoBooleanFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoBooleanFilterComponent_BaseFactory; return function XpoBooleanFilterComponent_Factory(t) { return (ɵXpoBooleanFilterComponent_BaseFactory || (ɵXpoBooleanFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoBooleanFilterComponent)))(t || XpoBooleanFilterComponent); }; }();
XpoBooleanFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBooleanFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoBooleanFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoBooleanFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoBooleanFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoBooleanFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoBooleanFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoBooleanFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoBooleanFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBooleanFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoDateOnlyFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoDateOnlyFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoDateOnlyFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoDateOnlyFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoDateOnlyFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoDateOnlyFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoDateOnlyFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoDateOnlyFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoDateOnlyFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoDateOnlyFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoDateOnlyFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoDateOnlyFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.defaultConditions = [
            XpoConditionDateIsComponent,
            XpoConditionDateEqualsComponent,
            XpoConditionDateAfterComponent,
            XpoConditionDateAfterSameComponent,
            XpoConditionDateBeforeComponent,
            XpoConditionDateBeforeSameComponent,
            XpoConditionDateBetweenComponent,
            XpoConditionDateNotBetweenComponent,
            XpoConditionEmptyComponent,
            XpoConditionIsNotEmptyComponent,
        ];
    }
}
XpoDateOnlyFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoDateOnlyFilterComponent_BaseFactory; return function XpoDateOnlyFilterComponent_Factory(t) { return (ɵXpoDateOnlyFilterComponent_BaseFactory || (ɵXpoDateOnlyFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoDateOnlyFilterComponent)))(t || XpoDateOnlyFilterComponent); }; }();
XpoDateOnlyFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDateOnlyFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoDateOnlyFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoDateOnlyFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoDateOnlyFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoDateOnlyFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoDateOnlyFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoDateOnlyFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoDateOnlyFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDateOnlyFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoDateTimeFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoDateTimeFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoDateTimeFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoDateTimeFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoDateTimeFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoDateTimeFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoDateTimeFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoDateTimeFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoDateTimeFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoDateTimeFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoDateTimeFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoDateTimeFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.defaultConditions = [
            XpoConditionDateIsComponent,
            XpoConditionDateEqualsComponent,
            XpoConditionDateTimeAfterComponent,
            XpoConditionDateTimeAfterSameComponent,
            XpoConditionDateTimeBeforeComponent,
            XpoConditionDateTimeBeforeSameComponent,
            XpoConditionDateTimeBetweenComponent,
            XpoConditionDateTimeNotBetweenComponent,
            XpoConditionEmptyComponent,
            XpoConditionIsNotEmptyComponent,
        ];
    }
}
XpoDateTimeFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoDateTimeFilterComponent_BaseFactory; return function XpoDateTimeFilterComponent_Factory(t) { return (ɵXpoDateTimeFilterComponent_BaseFactory || (ɵXpoDateTimeFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoDateTimeFilterComponent)))(t || XpoDateTimeFilterComponent); }; }();
XpoDateTimeFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDateTimeFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoDateTimeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoDateTimeFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoDateTimeFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoDateTimeFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoDateTimeFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoDateTimeFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoDateTimeFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDateTimeFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoEnumFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoEnumFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoEnumFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoEnumFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoEnumFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoEnumFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoEnumFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoEnumFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoEnumFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoEnumFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoEnumFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoEnumFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.allowMultipleFilterRows = false;
        this.defaultConditions = [
            XpoConditionEnumEqualsComponent,
        ];
    }
}
XpoEnumFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoEnumFilterComponent_BaseFactory; return function XpoEnumFilterComponent_Factory(t) { return (ɵXpoEnumFilterComponent_BaseFactory || (ɵXpoEnumFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoEnumFilterComponent)))(t || XpoEnumFilterComponent); }; }();
XpoEnumFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoEnumFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoEnumFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoEnumFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoEnumFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoEnumFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoEnumFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoEnumFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoEnumFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoEnumFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoDynamicEnumFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoDynamicEnumFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoDynamicEnumFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoDynamicEnumFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoDynamicEnumFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoDynamicEnumFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoDynamicEnumFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoDynamicEnumFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoDynamicEnumFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoDynamicEnumFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoDynamicEnumFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoDynamicEnumFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.allowMultipleFilterRows = false;
        this.defaultConditions = [XpoConditionDynamicEnumEqualsComponent];
        // TODO: row models must be standardized in all board. We'll do in separate ticket.
        this.clientSideRowModel = 'clientSide';
    }
    agInit(params) {
        super.agInit(params);
        this.checkRowModelType(params);
    }
    checkRowModelType(params) {
        if (params.rowModel.getType() !== this.clientSideRowModel) {
            // TODO: errors and warnings should be handled by a service or a more global way. We'll do in separate ticket.
            console.warn('XPO: XpoDynamicEnumFilterComponent only works with client-side row models');
        }
    }
}
XpoDynamicEnumFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoDynamicEnumFilterComponent_BaseFactory; return function XpoDynamicEnumFilterComponent_Factory(t) { return (ɵXpoDynamicEnumFilterComponent_BaseFactory || (ɵXpoDynamicEnumFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoDynamicEnumFilterComponent)))(t || XpoDynamicEnumFilterComponent); }; }();
XpoDynamicEnumFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDynamicEnumFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoDynamicEnumFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoDynamicEnumFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoDynamicEnumFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoDynamicEnumFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoDynamicEnumFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoDynamicEnumFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoDynamicEnumFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDynamicEnumFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoNumberFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoNumberFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoNumberFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoNumberFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoNumberFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoNumberFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoNumberFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoNumberFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoNumberFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoNumberFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoNumberFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoNumberFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.defaultConditions = [
            XpoConditionNumberEqualsComponent,
            XpoConditionNumberNotEqualsComponent,
            XpoConditionNumberGreaterThanComponent,
            XpoConditionNumberGreaterEqualThanComponent,
            XpoConditionNumberLessThanComponent,
            XpoConditionNumberLessEqualThanComponent,
            XpoConditionNumberIsBetweenComponent,
            XpoConditionNumberIsNotBetweenComponent,
            XpoConditionEmptyComponent,
            XpoConditionIsNotEmptyComponent,
            XpoConditionIsOneOfComponent,
        ];
    }
}
XpoNumberFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoNumberFilterComponent_BaseFactory; return function XpoNumberFilterComponent_Factory(t) { return (ɵXpoNumberFilterComponent_BaseFactory || (ɵXpoNumberFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoNumberFilterComponent)))(t || XpoNumberFilterComponent); }; }();
XpoNumberFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoNumberFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoNumberFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoNumberFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoNumberFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoNumberFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoNumberFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoNumberFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoNumberFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoNumberFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoStringFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoStringFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoStringFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoStringFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoStringFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoStringFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoStringFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoStringFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoStringFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoStringFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoStringFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoStringFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.defaultConditions = [
            XpoConditionStringContainsComponent,
            XpoConditionStringDoesNotContainComponent,
            XpoConditionStringEndsWithComponent,
            XpoConditionStringStartsWithComponent,
            XpoConditionStringEqualsComponent,
            XpoConditionStringIsNotEqualComponent,
            XpoConditionIsOneOfComponent,
            XpoConditionStringIsBetweenComponent,
            XpoConditionStringIsNotBetweenComponent,
            XpoConditionEmptyComponent,
            XpoConditionIsNotEmptyComponent,
        ];
    }
}
XpoStringFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoStringFilterComponent_BaseFactory; return function XpoStringFilterComponent_Factory(t) { return (ɵXpoStringFilterComponent_BaseFactory || (ɵXpoStringFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoStringFilterComponent)))(t || XpoStringFilterComponent); }; }();
XpoStringFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoStringFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoStringFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoStringFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoStringFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoStringFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoStringFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoStringFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoStringFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoStringFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoTimeFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoTimeFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoTimeFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoTimeFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoTimeFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoTimeFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoTimeFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoTimeFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoTimeFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoTimeFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoTimeFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoTimeFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.defaultConditions = [
            XpoConditionTimeIsComponent,
            XpoConditionTimeEqualsComponent,
            XpoConditionTimeAfterComponent,
            XpoConditionTimeAfterSameComponent,
            XpoConditionTimeBeforeComponent,
            XpoConditionTimeBeforeSameComponent,
            XpoConditionTimeBetweenComponent,
            XpoConditionTimeNotBetweenComponent,
            XpoConditionEmptyComponent,
            XpoConditionIsNotEmptyComponent,
        ];
    }
}
XpoTimeFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoTimeFilterComponent_BaseFactory; return function XpoTimeFilterComponent_Factory(t) { return (ɵXpoTimeFilterComponent_BaseFactory || (ɵXpoTimeFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoTimeFilterComponent)))(t || XpoTimeFilterComponent); }; }();
XpoTimeFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoTimeFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoTimeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoTimeFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoTimeFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoTimeFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoTimeFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoTimeFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoTimeFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTimeFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

function XpoTimeRangeFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "There are no filters for this column");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoTimeRangeFilterComponent_div_6_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 18);
    i0.ɵɵlistener("ngModelChange", function XpoTimeRangeFilterComponent_div_6_select_2_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.andOr = $event; });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "AND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 20);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r5.andOr)("disabled", i_r4 > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.And)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.And);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r5.ConditionalFilterCombiner.Or)("selected", ctx_r5.andOr === ctx_r5.ConditionalFilterCombiner.Or);
} }
function XpoTimeRangeFilterComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function XpoTimeRangeFilterComponent_div_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const i_r4 = i0.ɵɵnextContext().index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeFilter(i_r4); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoTimeRangeFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, XpoTimeRangeFilterComponent_div_6_select_2_Template, 5, 6, "select", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "xpo-conditions", 16);
    i0.ɵɵlistener("conditionChanged", function XpoTimeRangeFilterComponent_div_6_Template_xpo_conditions_conditionChanged_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onConditionChanged(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, XpoTimeRangeFilterComponent_div_6_button_6_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r4 > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("filter", filter_r3)("customFilterParams", ctx_r1.params);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.filters.length > 1);
} }
function XpoTimeRangeFilterComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function XpoTimeRangeFilterComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.addFilter(); });
    i0.ɵɵelementStart(1, "i", 23);
    i0.ɵɵtext(2, "add_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Add filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.displayAddButton);
} }
class XpoTimeRangeFilterComponent extends XpoConditionalFilterComponent {
    constructor() {
        super(...arguments);
        this.defaultConditions = [
            XpoConditionTimeRangeBetweenComponent,
            XpoConditionTimeRangeNotBetweenComponent,
            XpoConditionTimeRangeBeforeComponent,
            XpoConditionTimeRangeAfterComponent,
            XpoConditionRangeEmptyComponent,
            XpoConditionRangeNotEmptyComponent,
        ];
    }
}
XpoTimeRangeFilterComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoTimeRangeFilterComponent_BaseFactory; return function XpoTimeRangeFilterComponent_Factory(t) { return (ɵXpoTimeRangeFilterComponent_BaseFactory || (ɵXpoTimeRangeFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoTimeRangeFilterComponent)))(t || XpoTimeRangeFilterComponent); }; }();
XpoTimeRangeFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoTimeRangeFilterComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [[1, "xpo-ConditionalFilter"], [1, "xpo-ConditionalFilter-title"], [1, "xpo-ConditionalFilter-list"], [4, "ngIf"], ["class", "xpo-ConditionalFilter-item", 4, "ngFor", "ngForOf"], [1, "xpo-ConditionalFilter-add-wrapper"], ["data-cy", "conditionalFilter-action-add", "class", "xpo-ConditionalFilter-add", 3, "disabled", "click", 4, "ngIf"], [1, "xpo-ConditionalFilter-actions"], ["mat-flat-button", "", "data-cy", "conditionalFilter-action-apply", 3, "click"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-cancel", 3, "click"], [1, "xpo-ConditionalFilter-spacer"], ["mat-stroked-button", "", "data-cy", "conditionalFilter-action-clear", 3, "click"], [1, "xpo-ConditionalFilter-item"], [1, "xpo-ConditionalFilter-item-segment", "xpo-ConditionalFilter-item-segment--and-or"], [3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], [1, "xpo-ConditionalFilter-item-segment"], [3, "filter", "customFilterParams", "conditionChanged"], ["class", "xpo-ConditionalFilter-remove", "data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 3, "click", 4, "ngIf"], [3, "ngModel", "disabled", "ngModelChange"], ["data-cy", "conditionalFilder-combine-and", 3, "value", "selected"], ["data-cy", "conditionalFilder-combine-or", 3, "value", "selected"], ["data-cy", "conditionalFilter-remove", "disableRipple", "", "mat-icon-button", "", 1, "xpo-ConditionalFilter-remove", 3, "click"], ["data-cy", "conditionalFilter-action-add", 1, "xpo-ConditionalFilter-add", 3, "disabled", "click"], [1, "material-icons"]], template: function XpoTimeRangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "hr");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, XpoTimeRangeFilterComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, XpoTimeRangeFilterComponent_div_6_Template, 7, 4, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoTimeRangeFilterComponent_button_8_Template, 5, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "xpo-button-group", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function XpoTimeRangeFilterComponent_Template_button_click_10_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(11, "APPLY");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function XpoTimeRangeFilterComponent_Template_button_click_12_listener() { return ctx.cancelFilter(); });
        i0.ɵɵtext(13, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function XpoTimeRangeFilterComponent_Template_button_click_15_listener() { return ctx.clearFiltersInModal(); });
        i0.ɵɵtext(16, "CLEAR FILTERS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column == null ? null : ctx.column.headerName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.filters == null ? null : ctx.filters.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.filters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowMultipleFilterRows || !ctx.filters.length);
    } }, directives: [i2.NgIf, i2.NgForOf, i2$1.XpoButtonGroup, i3$1.MatButton, XpoConditionsComponent, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i3.MatIcon], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ffffff;border:1px solid #e6e6e6;border-radius:2px;padding:4px}[_nghost-%COMP%]   input.error[_ngcontent-%COMP%], [_nghost-%COMP%]   textarea.error[_ngcontent-%COMP%], [_nghost-%COMP%]   select.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select.error[_ngcontent-%COMP%]{border-color:#d32f2f}-control[_nghost-%COMP%], .xpo-FilterCondition-control[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 4px}--between[_nghost-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]{align-items:center;display:flex}--between[_nghost-%COMP%]   span[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 4px}--between[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--between[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}--number[_nghost-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]{min-width:235px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-moz-appearance:textfield;max-width:90px}--number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, --number[_nghost-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button, .xpo-FilterCondition--number[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]   select[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:27px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   select[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus, .xpo-FilterCondition[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   textarea[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;height:75px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{color:#d32f2f;display:flex;font-size:14px;margin-top:8px}[_nghost-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .xpo-FilterCondition[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:18px}.xpo-DateTime-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-DateTime-control[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-DateTime-control[_ngcontent-%COMP%]   input[type=date][_ngcontent-%COMP%], .xpo-DateTime-control[_ngcontent-%COMP%]   input[type=time][_ngcontent-%COMP%]{-webkit-appearance:unset;margin:0 8px 8px 0}.xpo-ConditionalFilter[_ngcontent-%COMP%]{padding:16px}.xpo-ConditionalFilter[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:focus{outline:none}.xpo-ConditionalFilter-list[_ngcontent-%COMP%]{padding-bottom:8px}.xpo-ConditionalFilter-condition-wrapper[_ngcontent-%COMP%]{align-items:baseline;display:flex;margin-right:8px}.xpo-ConditionalFilter-separator[_ngcontent-%COMP%]{padding-right:8px}.xpo-ConditionalFilter-title[_ngcontent-%COMP%]{color:#000;font-size:1.45rem}.xpo-ConditionalFilter-remove[_ngcontent-%COMP%]{height:26px;line-height:26px;text-align:left;width:26px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:1rem;margin-bottom:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:first-child{margin-right:8px}.xpo-ConditionalFilter-item[_ngcontent-%COMP%]:last-child{margin-bottom:0;margin-right:0}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;margin-right:8px;vertical-align:middle}.xpo-ConditionalFilter-item-segment--and-or[_ngcontent-%COMP%]{height:27px;width:62px}.xpo-ConditionalFilter-item-segment[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:normal;width:auto}.xpo-ConditionalFilter-add[_ngcontent-%COMP%]{cursor:pointer}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]{display:flex;margin:8px 0 0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0868ac;cursor:pointer;display:flex;flex-direction:row;font-size:1rem;font-weight:500;padding-left:0}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0091ea;transition:color .2s}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{color:#9b9b9b;cursor:not-allowed}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-content:center;display:flex;flex-direction:column;height:23px;justify-content:center;padding-left:5px;vertical-align:middle}.xpo-ConditionalFilter-add-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:16px;line-height:24px}.xpo-ConditionalFilter-spacer[_ngcontent-%COMP%]{display:flex;flex-grow:1}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6;display:flex;flex-direction:row;margin-top:8px;padding-top:12px}.xpo-ConditionalFilter-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex;text-transform:uppercase}.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{overflow-y:scroll}@media (max-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:150px}}@media (min-height: 700px){.xpo-ConditionalFilter[_ngcontent-%COMP%]   .xpo-ConditionalFilter-list[_ngcontent-%COMP%]{max-height:300px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTimeRangeFilterComponent, [{
        type: Component,
        args: [{
                templateUrl: '../conditional-filter.component.html',
                styleUrls: ['../conditional-filter.component.scss'],
            }]
    }], null, null); })();

class XpoFilterDateSelectorComponent {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.startDate = new Date();
        this.invalidDate = false;
        this.dateChange = new EventEmitter();
        this.viewLevel = 'month';
    }
    get date() {
        return this.dateValue;
    }
    set date(v) {
        // If the value coming in is an invalid date or null, clear out the dateValue and set the startDate to today,
        if (!this.isDate(v)) {
            this.dateValue = null;
            this.startDate = new Date();
        }
        else {
            this.dateValue = new Date(v);
            this.startDate = this.dateValue;
        }
        if (this.calendarRef) {
            // We want to change the currentView after the mat-calendar logic finishes it's regular navigation between views.
            // Settings this normally has no effect because the currentView is changed after this is called inside
            // mat-calendar
            this.ngZone.onStable.pipe(take(1)).subscribe(() => {
                this.calendarRef._goToDateInView(this.dateValue, this.viewLevel);
                this.calendarRef.focusActiveCell();
            });
        }
    }
    updateDateValue(value) {
        this.invalidDate = false;
        if (!this.isValidDate(value)) {
            this.invalidDate = true;
            return;
        }
        const dateValue = this.zeroOutSecondsFromDate(value);
        if (!this.date || this.date.toDateString() !== dateValue.toDateString()) {
            this.date = dateValue;
            this.dateChange.next(this.date);
        }
    }
    onMonthSelected(value) {
        // We want to stick to the year view only for month tab
        if (this.viewLevel !== 'year') {
            return;
        }
        this.preserveCalendarView(value, 'year');
    }
    onYearSelected(value) {
        // We want to stick to the multi-year view only for year tab
        if (this.viewLevel !== 'multi-year') {
            return;
        }
        this.preserveCalendarView(value, 'multi-year');
    }
    isDate(date) {
        return !!date && !!Date.parse(date);
    }
    zeroOutSecondsFromDate(date) {
        return new Date(new Date(date).setSeconds(0, 0));
    }
    isValidDate(date) {
        return (this.isDate(date) &&
            this.validateMin(date) &&
            this.validateMax(date) &&
            (this.dateFilter ? this.dateFilter(date) : true));
    }
    validateMin(date) {
        return this.minDate ? new Date(date).getTime() >= this.minDate.getTime() : true;
    }
    validateMax(date) {
        return this.maxDate ? new Date(date).getTime() <= this.maxDate.getTime() : true;
    }
    preserveCalendarView(value, nextView) {
        let updatedValue = value;
        if (nextView === 'year') {
            updatedValue = this.getClosestMonthValidDate(value);
        }
        else if (nextView === 'multi-year') {
            updatedValue = this.getClosestYearValidDate(value);
        }
        this.updateDateValue(updatedValue);
        // We want to change the currentView after the mat-calendar logic finishes it's regular navigation between views.
        // Settings this normally has no effect because the currentView is changed after this is called inside mat-calendar
        setTimeout(() => {
            this.calendarRef.currentView = nextView;
            this.calendarRef.stateChanges.next();
        });
    }
    getClosestMonthValidDate(value) {
        switch (this.intervalType) {
            case 'start': {
                if (this.validateMin(value)) {
                    return value;
                }
                const resultValue = this.minDate ? new Date(this.minDate) : new Date();
                resultValue.setHours(0, 0, 0, 0);
                return resultValue;
            }
            case 'end': {
                if (this.validateMax(value)) {
                    return new Date(value.getFullYear(), value.getMonth() + 1, 0);
                }
                const refValue = this.maxDate ? new Date(this.minDate) : new Date();
                return new Date(refValue.getFullYear(), refValue.getMonth() + 1, 0);
            }
            default:
                throw new Error('The intervalType input must be specified on the xpo-filter-date-selector when using viewLevel');
        }
    }
    getClosestYearValidDate(value) {
        switch (this.intervalType) {
            case 'start': {
                if (this.validateMin(value)) {
                    return value;
                }
                const refValue = this.minDate ? new Date(this.minDate) : new Date();
                return new Date(refValue.getFullYear());
            }
            case 'end': {
                if (this.validateMax(value)) {
                    return new Date(value.getFullYear() + 1, 0);
                }
                const refValue = this.maxDate ? new Date(this.minDate) : new Date();
                return new Date(refValue.getFullYear() + 1, 0);
            }
            default:
                throw new Error('The intervalType input must be specified on the xpo-filter-date-selector when using viewLevel');
        }
    }
}
XpoFilterDateSelectorComponent.ɵfac = function XpoFilterDateSelectorComponent_Factory(t) { return new (t || XpoFilterDateSelectorComponent)(i0.ɵɵdirectiveInject(i0.NgZone)); };
XpoFilterDateSelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFilterDateSelectorComponent, selectors: [["xpo-filter-date-selector"]], viewQuery: function XpoFilterDateSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MatCalendar, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarRef = _t.first);
    } }, hostAttrs: [1, "xpo-FilterDateSelector"], inputs: { placeholder: "placeholder", date: "date", minDate: "minDate", maxDate: "maxDate", dateFilter: "dateFilter", viewLevel: "viewLevel", intervalType: "intervalType" }, outputs: { dateChange: "dateChange" }, decls: 4, vars: 13, consts: [["floatLabel", "never", 1, "xpo-FilterDateSelector-input"], ["matInput", "", "autocomplete", "off", 3, "placeholder", "ngModel", "blur", "keyup.enter"], [1, "xpo-FilterDateSelector-calender", 3, "selected", "startAt", "minDate", "maxDate", "dateFilter", "startView", "selectedChange", "monthSelected", "yearSelected"]], template: function XpoFilterDateSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-form-field", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("blur", function XpoFilterDateSelectorComponent_Template_input_blur_1_listener($event) { return ctx.updateDateValue($event.target.value); })("keyup.enter", function XpoFilterDateSelectorComponent_Template_input_keyup_enter_1_listener($event) { return ctx.updateDateValue($event.target.value); });
        i0.ɵɵpipe(2, "date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-calendar", 2);
        i0.ɵɵlistener("selectedChange", function XpoFilterDateSelectorComponent_Template_mat_calendar_selectedChange_3_listener($event) { return ctx.updateDateValue($event); })("monthSelected", function XpoFilterDateSelectorComponent_Template_mat_calendar_monthSelected_3_listener($event) { return ctx.onMonthSelected($event); })("yearSelected", function XpoFilterDateSelectorComponent_Template_mat_calendar_yearSelected_3_listener($event) { return ctx.onYearSelected($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("mat-form-field-invalid", ctx.invalidDate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("placeholder", ctx.placeholder)("ngModel", ctx.date ? i0.ɵɵpipeBind2(2, 10, ctx.date, "MM/dd/yyyy") : ctx.date);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selected", ctx.date)("startAt", ctx.startDate)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("dateFilter", ctx.dateFilter)("startView", ctx.viewLevel);
    } }, directives: [i4.MatFormField, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i1$2.MatCalendar], pipes: [i2.DatePipe], styles: [".flex--stretch{flex:1}.xpo-FilterDateSelector{display:flex;flex-direction:column;min-width:210px}.xpo-FilterDateSelector-input.mat-form-field .mat-form-field-wrapper{margin:8px 0}.xpo-FilterDateSelector-calender.mat-calendar .mat-calendar-header{padding-top:0}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterDateSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-filter-date-selector',
                templateUrl: './filter-date-selector.component.html',
                styleUrls: ['./filter-date-selector.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-FilterDateSelector' },
            }]
    }], function () { return [{ type: i0.NgZone }]; }, { placeholder: [{
            type: Input
        }], date: [{
            type: Input
        }], dateChange: [{
            type: Output
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], dateFilter: [{
            type: Input
        }], viewLevel: [{
            type: Input
        }], intervalType: [{
            type: Input
        }], calendarRef: [{
            type: ViewChild,
            args: [MatCalendar]
        }] }); })();

class XpoDateFilterComponent extends XpoDateFilterComponentBase {
    constructor(cd) {
        super(cd);
        this.cd = cd;
        // Since the user is only selecting one date, default this filter to close the filter conainer on selection
        this.closeOnApply = true;
    }
    onCalendarChanged(value) {
        this.selectedDate = value;
        this.storeCriteria(value);
    }
    onCriteriaModified(fieldValue, criteria) {
        this.selectedDate = fieldValue || null;
        this.cd.markForCheck();
    }
}
XpoDateFilterComponent.ɵfac = function XpoDateFilterComponent_Factory(t) { return new (t || XpoDateFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoDateFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDateFilterComponent, selectors: [["xpo-date-filter"]], hostAttrs: [1, "xpo-DateFilter"], hostVars: 1, hostBindings: function XpoDateFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 4, consts: [["placeholder", "MM/DD/YYYY", 3, "date", "minDate", "maxDate", "dateFilter", "dateChange"]], template: function XpoDateFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-filter-container");
        i0.ɵɵelementStart(1, "xpo-filter-date-selector", 0);
        i0.ɵɵlistener("dateChange", function XpoDateFilterComponent_Template_xpo_filter_date_selector_dateChange_1_listener($event) { return ctx.onCalendarChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("date", ctx.selectedDate)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("dateFilter", ctx.dateFilter);
    } }, directives: [XpoFilterContainer, XpoFilterDateSelectorComponent], styles: [".flex--stretch{flex:1}.xpo-DateFilter{flex-direction:row;position:relative;width:240px}.xpo-DateFilter .xpo-FilterDateSelector-input{margin:8px 8px 0}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDateFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-date-filter',
                templateUrl: 'date-filter.component.html',
                styleUrls: ['date-filter.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-DateFilter', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, null); })();

class XpoDateFilter extends XpoDateFilterBase {
    constructor(field, label, dateFilterConfigValue) {
        super(field, label, XpoDateFilterComponent, dateFilterConfigValue);
    }
}

var XpoQuickDate;
(function (XpoQuickDate) {
    XpoQuickDate["Yesterday"] = "yesterday";
    XpoQuickDate["Today"] = "today";
    XpoQuickDate["Tomorrow"] = "tomorrow";
    XpoQuickDate["LastWeek"] = "lastweek";
    XpoQuickDate["ThisWeek"] = "thisweek";
    XpoQuickDate["NextWeek"] = "nextweek";
    XpoQuickDate["LastMonth"] = "lastmonth";
    XpoQuickDate["ThisMonth"] = "thismonth";
    XpoQuickDate["NextMonth"] = "nextmonth";
    XpoQuickDate["LastQuarter"] = "lastquarter";
    XpoQuickDate["ThisQuarter"] = "thisquarter";
    XpoQuickDate["NextQuarter"] = "nextquarter";
    XpoQuickDate["LastYear"] = "lastyear";
    XpoQuickDate["ThisYear"] = "thisyear";
    XpoQuickDate["NextYear"] = "nextyear";
    XpoQuickDate["TodayMinusMinutes"] = "todayminusminutes";
    XpoQuickDate["TodayPlusMinutes"] = "todayplusminutes";
    XpoQuickDate["TodayMinusHours"] = "todayminushours";
    XpoQuickDate["TodayPlusHours"] = "todayplushours";
    XpoQuickDate["TodayMinusDays"] = "todayminusdays";
    XpoQuickDate["TodayPlusDays"] = "todayplusdays";
    XpoQuickDate["TodayMinusWeeks"] = "todayminusweeks";
    XpoQuickDate["TodayPlusWeeks"] = "todayplusweeks";
    XpoQuickDate["TodayMinusMonths"] = "todayminusmonths";
    XpoQuickDate["TodayPlusMonths"] = "todayplusmonths";
    XpoQuickDate["TodayMinusQuarters"] = "todayminusquarters";
    XpoQuickDate["TodayPlusQuarters"] = "todayplusquarters";
    XpoQuickDate["TodayMinusYears"] = "todayminusyears";
    XpoQuickDate["TodayPlusYears"] = "todayplusyears";
})(XpoQuickDate || (XpoQuickDate = {}));

class XpoDateRangeFilterHelper {
    static constructFilter(filterKey, offset = null) {
        let filterValue;
        switch (filterKey) {
            case XpoQuickDate.TodayMinusMinutes:
                filterValue = {
                    offset: offset,
                    min: this.minutes(offset * -1),
                    max: DateUtils.today(),
                    selected: XpoQuickDate.TodayMinusMinutes,
                    intervalType: 'minute',
                };
                break;
            case XpoQuickDate.TodayPlusMinutes:
                filterValue = {
                    offset: offset,
                    min: DateUtils.today(),
                    max: this.minutes(offset),
                    selected: XpoQuickDate.TodayPlusMinutes,
                    intervalType: 'minute',
                };
                break;
            case XpoQuickDate.TodayMinusHours:
                filterValue = {
                    offset: offset,
                    min: DateUtils.fromNow(offset * -1),
                    max: DateUtils.today(),
                    selected: XpoQuickDate.TodayMinusHours,
                    intervalType: 'hour',
                };
                break;
            case XpoQuickDate.TodayPlusHours:
                filterValue = {
                    offset: offset,
                    min: DateUtils.today(),
                    max: DateUtils.fromNow(offset),
                    selected: XpoQuickDate.TodayPlusHours,
                    intervalType: 'hour',
                };
                break;
            case XpoQuickDate.Today:
                filterValue = {
                    min: DateUtils.today(),
                    max: DateUtils.today(),
                    selected: XpoQuickDate.Today,
                    intervalType: 'hour',
                };
                break;
            case XpoQuickDate.Tomorrow:
                filterValue = {
                    min: DateUtils.tomorrow(),
                    max: DateUtils.tomorrow(),
                    selected: XpoQuickDate.Tomorrow,
                    intervalType: 'hour',
                };
                break;
            case XpoQuickDate.Yesterday:
                filterValue = {
                    min: DateUtils.yesterday(),
                    max: DateUtils.yesterday(),
                    selected: XpoQuickDate.Yesterday,
                    intervalType: 'hour',
                };
                break;
            case XpoQuickDate.TodayMinusDays:
                filterValue = {
                    offset: offset,
                    min: DateUtils.fromToday(offset * -1 + 1),
                    max: DateUtils.today(),
                    selected: XpoQuickDate.TodayMinusDays,
                    intervalType: 'day',
                };
                break;
            case XpoQuickDate.TodayPlusDays:
                filterValue = {
                    offset: offset,
                    min: DateUtils.today(),
                    max: DateUtils.fromToday(offset - 1),
                    selected: XpoQuickDate.TodayPlusDays,
                    intervalType: 'day',
                };
                break;
            case XpoQuickDate.NextWeek:
                filterValue = {
                    min: DateUtils.firstDayOfWeek(1),
                    max: DateUtils.lastDayOfWeek(1),
                    selected: XpoQuickDate.NextWeek,
                    intervalType: 'day',
                };
                break;
            case XpoQuickDate.ThisWeek:
                filterValue = {
                    min: DateUtils.firstDayOfWeek(),
                    max: DateUtils.lastDayOfWeek(),
                    selected: XpoQuickDate.ThisWeek,
                    intervalType: 'day',
                };
                break;
            case XpoQuickDate.LastWeek:
                filterValue = {
                    min: DateUtils.firstDayOfWeek(-1),
                    max: DateUtils.lastDayOfWeek(-1),
                    selected: XpoQuickDate.LastWeek,
                    intervalType: 'day',
                };
                break;
            case XpoQuickDate.TodayPlusWeeks:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfWeek(1),
                    max: DateUtils.lastDayOfWeek(offset),
                    selected: XpoQuickDate.TodayPlusWeeks,
                    intervalType: 'week',
                };
                break;
            case XpoQuickDate.TodayMinusWeeks:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfWeek(-offset),
                    max: DateUtils.lastDayOfWeek(-1),
                    selected: XpoQuickDate.TodayMinusWeeks,
                    intervalType: 'week',
                };
                break;
            case XpoQuickDate.NextMonth:
                filterValue = {
                    min: DateUtils.firstDayOfMonth(1),
                    max: DateUtils.lastDayOfMonth(1),
                    selected: XpoQuickDate.NextMonth,
                    intervalType: 'week',
                };
                break;
            case XpoQuickDate.ThisMonth:
                filterValue = {
                    min: DateUtils.firstDayOfMonth(),
                    max: DateUtils.lastDayOfMonth(),
                    selected: XpoQuickDate.ThisMonth,
                    intervalType: 'week',
                };
                break;
            case XpoQuickDate.LastMonth:
                filterValue = {
                    min: DateUtils.firstDayOfMonth(-1),
                    max: DateUtils.lastDayOfMonth(-1),
                    selected: XpoQuickDate.LastMonth,
                    intervalType: 'week',
                };
                break;
            case XpoQuickDate.TodayPlusMonths:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfMonth(1),
                    max: DateUtils.lastDayOfMonth(offset),
                    selected: XpoQuickDate.TodayPlusMonths,
                    intervalType: 'month',
                };
                break;
            case XpoQuickDate.TodayMinusMonths:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfMonth(-offset),
                    max: DateUtils.lastDayOfMonth(-1),
                    selected: XpoQuickDate.TodayMinusMonths,
                    intervalType: 'month',
                };
                break;
            case XpoQuickDate.NextQuarter:
                filterValue = {
                    min: DateUtils.firstDayOfQuarter(1),
                    max: DateUtils.lastDayOfQuarter(1),
                    selected: XpoQuickDate.NextQuarter,
                    intervalType: 'month',
                };
                break;
            case XpoQuickDate.ThisQuarter:
                filterValue = {
                    min: DateUtils.firstDayOfQuarter(),
                    max: DateUtils.lastDayOfQuarter(),
                    selected: XpoQuickDate.ThisQuarter,
                    intervalType: 'month',
                };
                break;
            case XpoQuickDate.LastQuarter:
                filterValue = {
                    min: DateUtils.firstDayOfQuarter(-1),
                    max: DateUtils.lastDayOfQuarter(-1),
                    selected: XpoQuickDate.LastQuarter,
                    intervalType: 'month',
                };
                break;
            case XpoQuickDate.TodayPlusQuarters:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfQuarter(1),
                    max: DateUtils.lastDayOfQuarter(offset),
                    selected: XpoQuickDate.TodayPlusQuarters,
                    intervalType: 'quarter',
                };
                break;
            case XpoQuickDate.TodayMinusQuarters:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfQuarter(-offset),
                    max: DateUtils.lastDayOfQuarter(-1),
                    selected: XpoQuickDate.TodayMinusQuarters,
                    intervalType: 'quarter',
                };
                break;
            case XpoQuickDate.NextYear:
                filterValue = {
                    min: DateUtils.firstDayOfYear(1),
                    max: DateUtils.lastDayOfYear(1),
                    selected: XpoQuickDate.NextYear,
                    intervalType: 'quarter',
                };
                break;
            case XpoQuickDate.ThisYear:
                filterValue = {
                    min: DateUtils.firstDayOfYear(),
                    max: DateUtils.lastDayOfYear(),
                    selected: XpoQuickDate.ThisYear,
                    intervalType: 'quarter',
                };
                break;
            case XpoQuickDate.LastYear:
                filterValue = {
                    min: DateUtils.firstDayOfYear(-1),
                    max: DateUtils.lastDayOfYear(-1),
                    selected: XpoQuickDate.LastYear,
                    intervalType: 'quarter',
                };
                break;
            case XpoQuickDate.TodayPlusYears:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfYear(1),
                    max: DateUtils.lastDayOfYear(offset),
                    selected: XpoQuickDate.TodayPlusYears,
                    intervalType: 'year',
                };
                break;
            case XpoQuickDate.TodayMinusYears:
                filterValue = {
                    offset: offset,
                    min: DateUtils.firstDayOfYear(-offset),
                    max: DateUtils.lastDayOfYear(-1),
                    selected: XpoQuickDate.TodayMinusYears,
                    intervalType: 'year',
                };
                break;
            default:
                filterValue = { selected: filterKey, offset: offset };
                break;
        }
        // Zeroing out mins and seconds so comparing dates is better
        if (filterValue.min) {
            filterValue.min.setSeconds(0, 0);
        }
        if (filterValue.max) {
            filterValue.max.setSeconds(0, 0);
        }
        return filterValue;
    }
    static minutes(offset) {
        const date = DateUtils.today();
        date.setMinutes(date.getMinutes() + offset);
        return date;
    }
}

class XpoDateRangeIntervalBase {
    constructor() {
        this.posValue = 0;
    }
    get pos() {
        return this.posValue;
    }
    set pos(value) {
        this.posValue = value;
    }
}

class XpoDateRangeDaily extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return 'day';
    }
    get label() {
        return 'Daily';
    }
    getQuickFilterOptions() {
        return [
            { code: XpoQuickDate.LastWeek, display: 'Last Week' },
            { code: XpoQuickDate.ThisWeek, display: 'This Week' },
            { code: XpoQuickDate.NextWeek, display: 'Next Week' },
        ];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayPlusDays, nextInput * 1);
    }
    setPrev(prevInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayMinusDays, prevInput * 1);
    }
}

class XpoDateRangeHourly extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return 'hour';
    }
    get label() {
        return 'Hourly';
    }
    getQuickFilterOptions() {
        return [
            { code: XpoQuickDate.Yesterday, display: 'Yesterday' },
            { code: XpoQuickDate.Today, display: 'Today' },
            { code: XpoQuickDate.Tomorrow, display: 'Tomorrow' },
        ];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayPlusHours, nextInput * 1);
    }
    setPrev(prevInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayMinusHours, prevInput * 1);
    }
}

class XpoDateRangeMinutes extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return 'minute';
    }
    get label() {
        return 'Minutes';
    }
    getQuickFilterOptions() {
        return [];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayPlusMinutes, nextInput * 1);
    }
    setPrev(prevInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayMinusMinutes, prevInput * 1);
    }
}

class XpoDateRangeMonthly extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return 'month';
    }
    get label() {
        return 'Monthly';
    }
    getQuickFilterOptions() {
        return [
            { code: XpoQuickDate.LastQuarter, display: 'Last Quarter' },
            { code: XpoQuickDate.ThisQuarter, display: 'This Quarter' },
            { code: XpoQuickDate.NextQuarter, display: 'Next Quarter' },
        ];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayPlusMonths, nextInput * 1);
    }
    setPrev(prevInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayMinusMonths, prevInput * 1);
    }
}

class XpoDateRangeQuarterly extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return 'quarter';
    }
    get label() {
        return 'Quarterly';
    }
    getQuickFilterOptions() {
        return [
            { code: XpoQuickDate.LastYear, display: 'Last Year' },
            { code: XpoQuickDate.ThisYear, display: 'This Year' },
            { code: XpoQuickDate.NextYear, display: 'Next Year' },
        ];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayPlusQuarters, nextInput * 1);
    }
    setPrev(prevInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayMinusQuarters, prevInput * 1);
    }
}

class XpoDateRangeWeekly extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return 'week';
    }
    get label() {
        return 'Weekly';
    }
    getQuickFilterOptions() {
        return [
            { code: XpoQuickDate.LastMonth, display: 'Last Month' },
            { code: XpoQuickDate.ThisMonth, display: 'This Month' },
            { code: XpoQuickDate.NextMonth, display: 'Next Month' },
        ];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayPlusWeeks, nextInput * 1);
    }
    setPrev(prevInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayMinusWeeks, prevInput * 1);
    }
}

class XpoDateRangeYearly extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return 'year';
    }
    get label() {
        return 'Yearly';
    }
    getQuickFilterOptions() {
        return [];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayPlusYears, nextInput * 1);
    }
    setPrev(prevInput) {
        return XpoDateRangeFilterHelper.constructFilter(XpoQuickDate.TodayMinusYears, prevInput * 1);
    }
}

var XpoNoDateHeader;
(function (XpoNoDateHeader) {
    XpoNoDateHeader["Label"] = "No Date";
    XpoNoDateHeader["NoDate"] = "noDate";
})(XpoNoDateHeader || (XpoNoDateHeader = {}));

class XpoNoDateRange extends XpoDateRangeIntervalBase {
    get groupByInterval() {
        return XpoNoDateHeader.NoDate;
    }
    get label() {
        return XpoNoDateHeader.Label;
    }
    getQuickFilterOptions() {
        return [];
    }
    getTabModel() {
        return {
            pos: this.pos,
            quickFilterOptions: this.getQuickFilterOptions(),
            groupByInterval: this.groupByInterval,
        };
    }
    setNext(nextInput) {
        return null;
    }
    setPrev(prevInput) {
        return null;
    }
}

class XpoDateRangeIntervalFactory {
    static getDateRangeInterval(index) {
        return XpoDateRangeIntervalFactory.activeIntervals[index];
    }
    static updateActiveIntervals(intervals) {
        this.activeIntervals = intervals;
    }
    static getAllIntervals() {
        if (this.allIntervals.length === 0) {
            this.allIntervals.push(new XpoDateRangeMinutes());
            this.allIntervals.push(new XpoDateRangeHourly());
            this.allIntervals.push(new XpoDateRangeDaily());
            this.allIntervals.push(new XpoDateRangeWeekly());
            this.allIntervals.push(new XpoDateRangeMonthly());
            this.allIntervals.push(new XpoDateRangeQuarterly());
            this.allIntervals.push(new XpoDateRangeYearly());
            this.allIntervals.push(new XpoNoDateRange());
        }
        return this.allIntervals;
    }
    static getPos(intervalType) {
        const interval = this.activeIntervals.filter((i) => i.getTabModel().groupByInterval === intervalType);
        return interval.length > 0 ? interval[0].getTabModel().pos : 0;
    }
}
XpoDateRangeIntervalFactory.allIntervals = [];
XpoDateRangeIntervalFactory.activeIntervals = [];

class XpoDateRangeFilterComponent extends XpoDateFilterComponentBase {
    constructor(cd) {
        super(cd);
        this.cd = cd;
        this.quickFilterOptions = [
            { code: XpoQuickDate.Yesterday, display: 'Yesterday' },
            { code: XpoQuickDate.Today, display: 'Today' },
            { code: XpoQuickDate.ThisWeek, display: 'This Week' },
            { code: XpoQuickDate.NextWeek, display: 'Next Week' },
        ];
    }
    onToCalendarChanged(value) {
        this.toDateValue = value;
        // make sure the min-date is not greater than the max data
        const minDate = this.fromDateValue && this.fromDateValue > this.toDateValue ? this.toDateValue : this.fromDateValue;
        this.onCalendarChanged(minDate, this.toDateValue);
    }
    onFromCalendarChanged(value) {
        this.fromDateValue = value;
        // make sure the min-date is not greater than the max data
        const maxDate = this.toDateValue && this.fromDateValue > this.toDateValue ? this.fromDateValue : this.toDateValue;
        this.onCalendarChanged(this.fromDateValue, maxDate);
    }
    onCriteriaModified(fieldValue, criteria) {
        const val = fieldValue || {};
        this.toDateValue = val.max;
        this.fromDateValue = val.min;
        this.cd.markForCheck();
    }
    onCalendarChanged(min, max) {
        this.storeCriteria({
            max: max,
            min: min,
            selected: 'date',
        });
    }
    updateCalendar() {
        /**
         * we need to update with minDate and maxDate the values in order to show up if it's a past DATE
         */
        this.minDate = this.currentCriteria.min;
        this.maxDate = this.currentCriteria.max;
        this.fromDateValue = this.currentCriteria.min;
        this.toDateValue = this.currentCriteria.max;
        this.cd.markForCheck();
    }
}
XpoDateRangeFilterComponent.ɵfac = function XpoDateRangeFilterComponent_Factory(t) { return new (t || XpoDateRangeFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoDateRangeFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDateRangeFilterComponent, selectors: [["xpo-date-range-filter"]], hostAttrs: [1, "xpo-DateRangeFilter"], hostVars: 1, hostBindings: function XpoDateRangeFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 8, consts: [[1, "xpo-DateRangeFilter-calendersWrapper"], ["placeholder", "Start Date: MM/DD/YYYY", 3, "date", "minDate", "maxDate", "dateFilter", "dateChange"], [1, "xpo-DateRangeFilter-calenderArrow"], ["placeholder", "End Date: MM/DD/YYYY", 3, "date", "minDate", "maxDate", "dateFilter", "dateChange"]], template: function XpoDateRangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-filter-container");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "xpo-filter-date-selector", 1);
        i0.ɵɵlistener("dateChange", function XpoDateRangeFilterComponent_Template_xpo_filter_date_selector_dateChange_2_listener($event) { return ctx.onFromCalendarChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-icon", 2);
        i0.ɵɵtext(4, "arrow_forward");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "xpo-filter-date-selector", 3);
        i0.ɵɵlistener("dateChange", function XpoDateRangeFilterComponent_Template_xpo_filter_date_selector_dateChange_5_listener($event) { return ctx.onToCalendarChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("date", ctx.fromDateValue)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("dateFilter", ctx.dateFilter);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("date", ctx.toDateValue)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("dateFilter", ctx.dateFilter);
    } }, directives: [XpoFilterContainer, XpoFilterDateSelectorComponent, i3.MatIcon], styles: [".flex--stretch{flex:1}.xpo-DateRangeFilter{display:flex;flex-direction:row}.xpo-DateRangeFilter .xpo-FilterContainer-content{display:flex;flex-direction:row;padding:16px 8px;position:relative}.xpo-DateRangeFilter-calendersWrapper{display:flex}.xpo-DateRangeFilter-calendersWrapper .mat-calendar{border:1px solid #d8d8d8}.xpo-DateRangeFilter-calenderArrow{margin:8px 4px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDateRangeFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-date-range-filter',
                templateUrl: 'date-range-filter.component.html',
                styleUrls: ['date-range-filter.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-DateRangeFilter', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, null); })();

class XpoDateRangeFilter extends XpoDateFilterBase {
    constructor(field, label, dateFilterConfig) {
        super(field, label, XpoDateRangeFilterComponent, dateFilterConfig);
    }
    getDisplayValue(val) {
        const filterModel = val || {};
        if (filterModel.selected === XpoQuickDate.Today) {
            return 'Today';
        }
        else if (filterModel.selected === XpoQuickDate.Tomorrow) {
            return 'Tomorrow';
        }
        else if (filterModel.selected === XpoQuickDate.Yesterday) {
            return 'Yesterday';
        }
        else if (filterModel.selected === XpoQuickDate.TodayPlusDays) {
            // - 1 to exclude the last day
            return 'Today - ' + this.formatDate(DateUtils.fromToday(filterModel.offset * 1 - 1));
        }
        else if (filterModel.selected === XpoQuickDate.TodayMinusDays) {
            // + 1 to exclude the last day
            return this.formatDate(DateUtils.fromToday(filterModel.offset * -1 + 1)) + '- Today';
        }
        else if (filterModel.min && !filterModel.max) {
            return 'After ' + this.formatDate(filterModel.min);
        }
        else if (!filterModel.min && filterModel.max) {
            return 'Before ' + this.formatDate(filterModel.max);
        }
        else if (filterModel.min && filterModel.max) {
            return this.formatDate(filterModel.min) + ' - ' + this.formatDate(filterModel.max);
        }
        return 'Any';
    }
    getInitialFilterValue(val) {
        val = super.getInitialFilterValue(val) || {};
        // if they are just using a simple date range return
        if (val['selected'] === 'date' || !val['selected']) {
            return val;
        }
        // we need to initialize the filter, because we need to translate, today, yesterday, etc..
        // into the proper representation of the dates
        return XpoDateRangeFilterHelper.constructFilter(val['selected'], val['offset'] || null);
    }
    formatDate(date) {
        // Ensuring that the string dates are converted to date objects
        return DateUtils.formatDate(date instanceof Date ? date : new Date(date));
    }
}

const _c0$p = ["next"];
const _c1$a = ["prev"];
function XpoDateRangeFilterGroupByComponent_mat_tab_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c2$4 = function (a0) { return { tabModel: a0 }; };
function XpoDateRangeFilterGroupByComponent_mat_tab_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoDateRangeFilterGroupByComponent_mat_tab_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2$4, ctx_r4.currentTabModel));
} }
function XpoDateRangeFilterGroupByComponent_mat_tab_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-tab", 3);
    i0.ɵɵtemplate(1, XpoDateRangeFilterGroupByComponent_mat_tab_2_ng_container_1_Template, 2, 4, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", tab_r3.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", tab_r3.pos === ctx_r0.currentTabModel.pos);
} }
function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_button_12_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const option_r13 = restoredCtx.$implicit; const ctx_r14 = i0.ɵɵnextContext(3); return ctx_r14.quickFilterSelected(option_r13.code); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r13 = ctx.$implicit;
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("xpo-DateRangeFilterGroupBy-filterButton--active", ctx_r12.selectedQuickFilterOptionCode === option_r13.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r13.display, " ");
} }
function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelementStart(2, "button", 10);
    i0.ɵɵlistener("click", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.setNext(ctx_r16.nextInput); });
    i0.ɵɵtext(3, " Next ");
    i0.ɵɵelementStart(4, "input", 11, 12);
    i0.ɵɵlistener("ngModelChange", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.setNext($event); })("keydown", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_input_keydown_4_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.onNextPrevKeydown($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 10);
    i0.ɵɵlistener("click", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r17); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.setPrev(ctx_r20.prevInput); });
    i0.ɵɵtext(8, " Prev ");
    i0.ɵɵelementStart(9, "input", 13, 14);
    i0.ɵɵlistener("ngModelChange", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.setPrev($event); })("keydown", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_input_keydown_9_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.onNextPrevKeydown($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_button_12_Template, 2, 3, "button", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 16);
    i0.ɵɵelementStart(14, "xpo-filter-date-selector", 17);
    i0.ɵɵlistener("dateChange", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_xpo_filter_date_selector_dateChange_14_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.onFromCalendarChanged($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "mat-icon", 18);
    i0.ɵɵtext(16, "arrow_forward");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "xpo-filter-date-selector", 19);
    i0.ɵɵlistener("dateChange", function XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template_xpo_filter_date_selector_dateChange_17_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.onToCalendarChanged($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tabModel_r6 = i0.ɵɵnextContext().tabModel;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("xpo-DateRangeFilter-filterButton--active", ctx_r7.selectedQuickFilterOptionCode.indexOf("plus") > -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r7.nextInput);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", tabModel_r6.groupByInterval, "(s) ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("xpo-DateRangeFilterGroupBy-filterButton--active", ctx_r7.selectedQuickFilterOptionCode.indexOf("minus") > -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r7.prevInput);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", tabModel_r6.groupByInterval, "(s) ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", tabModel_r6.quickFilterOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("date", ctx_r7.fromDateValue)("minDate", ctx_r7.minDate)("maxDate", ctx_r7.maxDate)("dateFilter", ctx_r7.dateFilter)("viewLevel", ctx_r7.viewLevel[tabModel_r6.groupByInterval]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("date", ctx_r7.toDateValue)("minDate", ctx_r7.minDate)("maxDate", ctx_r7.maxDate)("dateFilter", ctx_r7.dateFilter)("viewLevel", ctx_r7.viewLevel[tabModel_r6.groupByInterval]);
} }
function XpoDateRangeFilterGroupByComponent_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1, "Searches for empty dates.");
    i0.ɵɵelementEnd();
} }
function XpoDateRangeFilterGroupByComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, XpoDateRangeFilterGroupByComponent_ng_template_3_div_0_Template, 18, 19, "div", 6);
    i0.ɵɵtemplate(1, XpoDateRangeFilterGroupByComponent_ng_template_3_ng_template_1_Template, 2, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const tabModel_r6 = ctx.tabModel;
    const _r8 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", tabModel_r6.groupByInterval !== "noDate")("ngIfElse", _r8);
} }
class XpoDateRangeFilterGroupByComponent extends XpoDateRangeFilterComponent {
    constructor(changeDetectorRef) {
        super(changeDetectorRef);
        this.changeDetectorRef = changeDetectorRef;
        this.viewLevel = {
            month: 'year',
            quarter: 'year',
            year: 'multi-year',
            day: 'month',
            hour: 'month',
            minute: 'month',
            week: 'month',
            noDate: 'month',
        };
        this.tabLinks = [];
        this.selectedTabIndex = 0;
        this.shownIntervals = [];
    }
    quickFilterSelected(filterKey) {
        this.selectedQuickFilterOptionCode = filterKey;
        this.storeCriteria(XpoDateRangeFilterHelper.constructFilter(filterKey));
        this.updateCalendar();
    }
    onNextPrevKeydown(e) {
        // if enter key, trigger the change event on the button
        if (e.keyCode === 13) {
            e.target.parentNode.click();
        }
        else {
            const isNumericOrFuncKey = e.keyCode <= 57 || (e.keyCode >= 96 && e.keyCode <= 105);
            if (!isNumericOrFuncKey) {
                e.preventDefault();
            }
        }
    }
    tabChanged(tabChangeEvent) {
        this.dateRangeInterval = XpoDateRangeIntervalFactory.getDateRangeInterval(tabChangeEvent.index);
        this.currentTabModel = this.dateRangeInterval.getTabModel();
        if (tabChangeEvent.tab) {
            this.nextInput = 0;
            this.prevInput = 0;
            if (tabChangeEvent.tab.textLabel === XpoNoDateHeader.Label) {
                this.storeCriteria({
                    selected: XpoNoDateHeader.Label,
                    intervalType: XpoNoDateHeader.NoDate,
                });
            }
        }
    }
    setNext(value) {
        if (value !== this.nextInput) {
            this.nextElement.nativeElement.focus();
            this.nextInput = value;
            if (this.nextInput) {
                this.storeCriteria(this.dateRangeInterval.setNext(this.nextInput));
                this.selectedQuickFilterOptionCode = this.currentCriteria.selected;
                this.updateCalendar();
            }
        }
    }
    setPrev(value) {
        if (value !== this.prevInput) {
            this.prevElement.nativeElement.focus();
            this.prevInput = value;
            if (this.prevInput) {
                this.storeCriteria(this.dateRangeInterval.setPrev(this.prevInput));
                this.selectedQuickFilterOptionCode = this.currentCriteria.selected;
                this.updateCalendar();
            }
        }
    }
    initialize() {
        super.initialize();
        const config = this.configuration;
        if (config.displayOptions && config.displayOptions.shownIntervals) {
            this.shownIntervals = config.displayOptions.shownIntervals.slice(0);
        }
        this.updateTabLinks();
        this.dateRangeInterval = XpoDateRangeIntervalFactory.getDateRangeInterval(0);
        this.currentTabModel = this.dateRangeInterval.getTabModel();
    }
    onCriteriaModified(fieldValue, criteria) {
        const val = fieldValue || {};
        this.toDateValue = val.max;
        this.fromDateValue = val.min;
        this.selectedQuickFilterOptionCode = val.selected || 'date';
        this.prevInput = val.selected && val.selected.indexOf('minus') > -1 ? val.offset : null;
        this.nextInput = val.selected && val.selected.indexOf('plus') > -1 ? val.offset : null;
        this.selectedTabIndex = XpoDateRangeIntervalFactory.getPos(val['intervalType']);
        this.tabChanged({ index: this.selectedTabIndex, tab: null });
        this.changeDetectorRef.markForCheck();
    }
    updateTabLinks() {
        if (this.shownIntervals.length > 0) {
            this.showSelectedIntervals();
        }
        else {
            this.showDefaultIntervals();
        }
    }
    showSelectedIntervals() {
        let pos = 0;
        const tabLinks = [];
        const activeIntervals = [];
        XpoDateRangeIntervalFactory.getAllIntervals().forEach((interval) => {
            if (this.shownIntervals.indexOf(interval.label) > -1) {
                tabLinks.push({ pos: pos, label: interval.label });
                interval.pos = pos;
                pos++;
                activeIntervals.push(interval);
            }
        });
        this.tabLinks = tabLinks;
        XpoDateRangeIntervalFactory.updateActiveIntervals(activeIntervals);
    }
    showDefaultIntervals() {
        const tabLinks = [];
        const activeIntervals = [];
        XpoDateRangeIntervalFactory.getAllIntervals()
            .filter((i) => i.label !== 'Minutes') // Show everything but minutes since that is not typically used
            .forEach((interval, i) => {
            tabLinks.push({ pos: i, label: interval.label });
            interval.pos = i;
            activeIntervals.push(interval);
        });
        this.tabLinks = tabLinks;
        XpoDateRangeIntervalFactory.updateActiveIntervals(activeIntervals);
    }
    onCalendarChanged(min, max) {
        this.storeCriteria({
            // make sure max date is less than min-date
            max: max,
            min: min,
            selected: 'date',
            intervalType: this.dateRangeInterval.getTabModel().groupByInterval,
        });
    }
}
XpoDateRangeFilterGroupByComponent.ɵfac = function XpoDateRangeFilterGroupByComponent_Factory(t) { return new (t || XpoDateRangeFilterGroupByComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoDateRangeFilterGroupByComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDateRangeFilterGroupByComponent, selectors: [["xpo-date-range-filter-group-by"]], viewQuery: function XpoDateRangeFilterGroupByComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$p, 5);
        i0.ɵɵviewQuery(_c1$a, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextElement = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prevElement = _t.first);
    } }, hostAttrs: [1, "xpo-DateRangeFilterGroupBy", "xpo-DateRangeFilter"], hostVars: 1, hostBindings: function XpoDateRangeFilterGroupByComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 3, consts: [["dynamicHeight", "false", 3, "selectedIndex", "selectedTabChange"], [3, "label", 4, "ngFor", "ngForOf"], ["filterTemplate", ""], [3, "label"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "xpo-DateRangeFilterGroupBy-content", 4, "ngIf", "ngIfElse"], ["noDateTemplate", ""], [1, "xpo-DateRangeFilterGroupBy-content"], [1, "xpo-DateRangeFilterGroupBy-quickFilters"], [1, "xpo-DateRangeFilterGroupBy-filterButton", 3, "click"], ["matInput", "", "autocomplete", "off", "id", "nextInput", "name", "nextInput", "autocomplete", "off", "placeholder", "0", 1, "xpo-DateRangeFilterGroupBy-filterButton-input", 3, "ngModel", "ngModelChange", "keydown"], ["next", ""], ["matInput", "", "autocomplete", "off", "id", "prevInput", "name", "prevInput", "autocomplete", "off", "placeholder", "0", 1, "xpo-DateRangeFilterGroupBy-filterButton-input", 3, "ngModel", "ngModelChange", "keydown"], ["prev", ""], ["class", "xpo-DateRangeFilterGroupBy-filterButton", 3, "xpo-DateRangeFilterGroupBy-filterButton--active", "click", 4, "ngFor", "ngForOf"], [1, "xpo-DateRangeFilter-calendersWrapper"], ["placeholder", "Start Date: MM/DD/YYYY", "intervalType", "start", 3, "date", "minDate", "maxDate", "dateFilter", "viewLevel", "dateChange"], [1, "xpo-DateRangeFilter-calenderArrow"], ["placeholder", "End Date: MM/DD/YYYY", "intervalType", "end", 3, "date", "minDate", "maxDate", "dateFilter", "viewLevel", "dateChange"]], template: function XpoDateRangeFilterGroupByComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-filter-container");
        i0.ɵɵelementStart(1, "mat-tab-group", 0);
        i0.ɵɵlistener("selectedTabChange", function XpoDateRangeFilterGroupByComponent_Template_mat_tab_group_selectedTabChange_1_listener($event) { return ctx.tabChanged($event); });
        i0.ɵɵtemplate(2, XpoDateRangeFilterGroupByComponent_mat_tab_2_Template, 2, 2, "mat-tab", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoDateRangeFilterGroupByComponent_ng_template_3_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("@.disabled", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("selectedIndex", ctx.selectedTabIndex);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.tabLinks);
    } }, directives: [XpoFilterContainer, i2$2.MatTabGroup, i2.NgForOf, i2$2.MatTab, i2.NgIf, i2.NgTemplateOutlet, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, XpoFilterDateSelectorComponent, i3.MatIcon], styles: [".flex--stretch{flex:1}.xpo-DateRangeFilterGroupBy.xpo-DateRangeFilter .xpo-FilterContainer-content{padding:0 8px 16px}.xpo-DateRangeFilterGroupBy mat-tab-header.mat-tab-header{margin-bottom:5px}.xpo-DateRangeFilterGroupBy .mat-tab-group.mat-primary mat-ink-bar.mat-ink-bar{background-color:#0d94f4}.xpo-DateRangeFilterGroupBy .mat-tab-body-content{overflow:unset}.xpo-DateRangeFilterGroupBy-content{display:flex;flex-direction:row}.xpo-DateRangeFilterGroupBy-quickFilters{align-self:flex-start;display:flex;flex-direction:column;margin-right:8px;margin-top:8px}.xpo-DateRangeFilterGroupBy-filterButton{align-items:center;background-color:#f3f3f3;border:none;color:#4a4a4a;display:flex;font-size:14px;justify-content:space-between;line-height:20px;margin-top:4px;padding:8px}.xpo-DateRangeFilterGroupBy-filterButton:first-child{margin-top:0}.xpo-DateRangeFilterGroupBy-filterButton:hover{background-color:#0868ac;color:#fff;cursor:pointer}.xpo-DateRangeFilterGroupBy-filterButton--active{background-color:#0868ac;color:#fff}input.xpo-DateRangeFilterGroupBy-filterButton-input{background-color:#fff;border:1px solid #f3f3f3;color:#4a4a4a;margin:0 2px;width:2rem}\n", ".flex--stretch{flex:1}.xpo-DateRangeFilter{display:flex;flex-direction:row}.xpo-DateRangeFilter .xpo-FilterContainer-content{display:flex;flex-direction:row;padding:16px 8px;position:relative}.xpo-DateRangeFilter-calendersWrapper{display:flex}.xpo-DateRangeFilter-calendersWrapper .mat-calendar{border:1px solid #d8d8d8}.xpo-DateRangeFilter-calenderArrow{margin:8px 4px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDateRangeFilterGroupByComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-date-range-filter-group-by',
                templateUrl: './date-range-filter-group-by.component.html',
                styleUrls: ['./date-range-filter-group-by.component.scss', '../date-range-filter.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-DateRangeFilterGroupBy xpo-DateRangeFilter', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { nextElement: [{
            type: ViewChild,
            args: ['next']
        }], prevElement: [{
            type: ViewChild,
            args: ['prev']
        }] }); })();

class XpoDateRangeGroupByFilter extends XpoDateFilterBase {
    constructor(field, label, displayOptions, dateFilterConfig) {
        super(field, label, XpoDateRangeFilterGroupByComponent, dateFilterConfig);
        if (displayOptions) {
            this.displayOptions = displayOptions;
        }
    }
    static formatDate(date) {
        // Ensuring that the string dates are converted to date objects
        return DateUtils.formatDate(date instanceof Date ? date : new Date(date));
    }
    getDisplayValue(val) {
        const filterModel = val || {};
        if (filterModel.selected === XpoNoDateHeader.Label) {
            return XpoNoDateHeader.Label;
        }
        else if (filterModel.selected === XpoQuickDate.Today) {
            return 'Today';
        }
        else if (filterModel.selected === XpoQuickDate.Tomorrow) {
            return 'Tomorrow';
        }
        else if (filterModel.selected === XpoQuickDate.Yesterday) {
            return 'Yesterday';
        }
        else if (filterModel.selected === XpoQuickDate.TodayPlusDays) {
            // - 1 to exclude the last day
            return 'Today - ' + XpoDateRangeGroupByFilter.formatDate(DateUtils.fromToday(filterModel.offset * 1 - 1));
        }
        else if (filterModel.selected === XpoQuickDate.TodayMinusDays) {
            // + 1 to exclude the last day
            return XpoDateRangeGroupByFilter.formatDate(DateUtils.fromToday(filterModel.offset * -1 + 1)) + '- Today';
        }
        else if (filterModel.min && !filterModel.max) {
            return 'After ' + XpoDateRangeGroupByFilter.formatDate(filterModel.min);
        }
        else if (!filterModel.min && filterModel.max) {
            return 'Before ' + XpoDateRangeGroupByFilter.formatDate(filterModel.max);
        }
        else if (filterModel.min && filterModel.max) {
            return (XpoDateRangeGroupByFilter.formatDate(filterModel.min) +
                ' - ' +
                XpoDateRangeGroupByFilter.formatDate(filterModel.max));
        }
        return 'Any';
    }
    getInitialFilterValue(val) {
        val = super.getInitialFilterValue(val) || {};
        // if they are just using a simple date range return
        if (val['selected'] === 'date' || !val['selected']) {
            return val;
        }
        // we need to initialize the filter, because we need to translate, today, yesterday, etc..
        // into the proper representation of the dates
        return XpoDateRangeFilterHelper.constructFilter(val['selected'], val['offset'] || null);
    }
}

class XpoGlobalFilterBar {
}
XpoGlobalFilterBar.ɵfac = function XpoGlobalFilterBar_Factory(t) { return new (t || XpoGlobalFilterBar)(); };
XpoGlobalFilterBar.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoGlobalFilterBar, selectors: [["", "xpo-global-filter-bar", ""]], hostAttrs: [1, "xpo-GlobalFilterBar"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGlobalFilterBar, [{
        type: Directive,
        args: [{
                selector: '[xpo-global-filter-bar]',
                host: { class: 'xpo-GlobalFilterBar' },
            }]
    }], null, null); })();

var XpoBoardApiAction;
(function (XpoBoardApiAction) {
    XpoBoardApiAction["ToggleDataDrawer"] = "toggleDataDrawer";
    XpoBoardApiAction["ApplyFiltersCriteria"] = "applyFiltersCriteria";
    XpoBoardApiAction["ApplyFilterCriterion"] = "applyFilterCriterion";
    XpoBoardApiAction["HideView"] = "hideView";
    XpoBoardApiAction["ActivateView"] = "activateView";
})(XpoBoardApiAction || (XpoBoardApiAction = {}));

class XpoBoardApi {
    constructor(boardApiDispatcher) {
        this.boardApiDispatcher = boardApiDispatcher;
        this.stateChange$ = new ReplaySubject(1);
    }
    activateView(viewId) {
        this.boardApiDispatcher.executeAction(XpoBoardApiAction.ActivateView, viewId);
    }
    hideView(viewId) {
        this.boardApiDispatcher.executeAction(XpoBoardApiAction.HideView, viewId);
    }
    selectRecords(records) {
        this.stateChange$.next({ selection: records, source: 'BOARD-API-RECORDS-SELECTION' });
    }
    toggleDataDrawer(selection) {
        this.boardApiDispatcher.executeAction(XpoBoardApiAction.ToggleDataDrawer, selection);
    }
    applyFiltersCriteria(criteria) {
        this.boardApiDispatcher.executeAction(XpoBoardApiAction.ApplyFiltersCriteria, criteria);
    }
    applyFilterCriterion(field, criterion) {
        this.boardApiDispatcher.executeAction(XpoBoardApiAction.ApplyFilterCriterion, field, criterion);
    }
}

class XpoBoardApiDispatcherBase {
    constructor() {
        this.registeredHandlers = new Map();
    }
    registerHandler(action, handler) {
        this.registeredHandlers.set(action, handler);
    }
    executeAction(action, ...args) {
        const handler = this.registeredHandlers.get(action);
        if (!handler) {
            throw new Error(`No handler was registered for ${action} board action`);
        }
        return handler(...args);
    }
    ngOnDestroy() {
        this.registeredHandlers.clear();
    }
}
XpoBoardApiDispatcherBase.ɵfac = function XpoBoardApiDispatcherBase_Factory(t) { return new (t || XpoBoardApiDispatcherBase)(); };
XpoBoardApiDispatcherBase.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoBoardApiDispatcherBase, factory: XpoBoardApiDispatcherBase.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardApiDispatcherBase, [{
        type: Injectable
    }], null, null); })();

class XpoBoardApiDispatcherService extends XpoBoardApiDispatcherBase {
}
XpoBoardApiDispatcherService.ɵfac = /*@__PURE__*/ function () { let ɵXpoBoardApiDispatcherService_BaseFactory; return function XpoBoardApiDispatcherService_Factory(t) { return (ɵXpoBoardApiDispatcherService_BaseFactory || (ɵXpoBoardApiDispatcherService_BaseFactory = i0.ɵɵgetInheritedFactory(XpoBoardApiDispatcherService)))(t || XpoBoardApiDispatcherService); }; }();
XpoBoardApiDispatcherService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoBoardApiDispatcherService, factory: XpoBoardApiDispatcherService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardApiDispatcherService, [{
        type: Injectable
    }], null, null); })();

class XpoBoardDataSourceResolver {
    constructor() {
        this.dataSourceSource$ = new ReplaySubject(1);
    }
    get dataSource() {
        return this.dataSourceValue;
    }
    set dataSource(value) {
        this.dataSourceValue = value;
        this.dataSourceSource$.next(this.dataSourceValue);
    }
    get dataSource$() {
        return this.dataSourceSource$.asObservable();
    }
}
XpoBoardDataSourceResolver.ɵfac = function XpoBoardDataSourceResolver_Factory(t) { return new (t || XpoBoardDataSourceResolver)(); };
XpoBoardDataSourceResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoBoardDataSourceResolver, factory: XpoBoardDataSourceResolver.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardDataSourceResolver, [{
        type: Injectable
    }], null, null); })();

// TODO: Document
class XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd) {
        this.boardDataSourceResolver = boardDataSourceResolver;
        this.cd = cd;
        this.stateChange$ = new Subject();
        this.componentDestroyed$ = new Subject();
        this.dataSourceValue = null;
        this.currentStateVal = undefined;
    }
    get dataSource() {
        return this.dataSourceValue;
    }
    ngOnInit() {
        if (this.boardDataSourceResolver) {
            // this maybe a little too purist and will not work with
            // ag-grid because we might need some-kind of wrapper around it?
            // but maybe not since the ag-grid only has to worry about not double publishing the view change
            this.boardDataSourceResolver.dataSource$
                .pipe(distinctUntilChanged(), takeUntil(this.componentDestroyed$))
                .subscribe((ds) => this.onDataSourceChanged(ds));
        }
    }
    ngOnDestroy() {
        if (this.dataSourceValue) {
            this.dataSourceValue.disconnect(this);
        }
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /**
     * Method that will be called every time the dataSource on the board changes
     */
    onDataSourceChanged(ds) {
        if (this.dataSourceValue) {
            this.dataSourceValue.disconnect(this);
        }
        this.dataSourceValue = ds;
        if (!!ds) {
            const connections = ds.connect(this);
            let firstTimeSubscriber = true;
            // TODO: should we be cleaning these up on data-source change?
            connections
                .pipe(debounce((state) => (state === null || state === void 0 ? void 0 : state.rowModelType) === 'infinite' ? timer(50) : EMPTY), distinctUntilChanged((a, b) => {
                return isEqual(a, b);
            }), takeUntil(this.componentDestroyed$))
                .subscribe((state) => {
                if (!isEqual(this.currentStateVal, state) && state.stateVersion >= this.dataSource.stateVersion) {
                    // If this is the first time a viewer is subscribing
                    // be sure we send up all the keys as changes.
                    // So a new consumer will get the entire list state keys as changes the first time he's subscribing
                    // to be able to do proper initialization
                    const nextState = firstTimeSubscriber
                        ? Object.assign(Object.assign({}, state), { source: state.source, changes: Object.keys(state) }) : state;
                    firstTimeSubscriber = false;
                    this.onStateChange(nextState);
                    this.currentStateVal = nextState;
                    this.cd.markForCheck();
                }
            });
        }
    }
}
XpoBoardConsumer.ɵfac = function XpoBoardConsumer_Factory(t) { return new (t || XpoBoardConsumer)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoBoardConsumer.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBoardConsumer });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardConsumer, [{
        type: Directive
    }], function () { return [{ type: XpoBoardDataSourceResolver, decorators: [{
                type: Optional
            }] }, { type: i0.ChangeDetectorRef }]; }, null); })();

var XpoBoardDataFetchState;
(function (XpoBoardDataFetchState) {
    XpoBoardDataFetchState["Error"] = "error";
    XpoBoardDataFetchState["Loading"] = "loading";
    XpoBoardDataFetchState["NoResults"] = "no-results";
    XpoBoardDataFetchState["ResultsReturned"] = "results-returned";
})(XpoBoardDataFetchState || (XpoBoardDataFetchState = {}));

var XpoRowModelType;
(function (XpoRowModelType) {
    XpoRowModelType["ClientSide"] = "client-side";
    XpoRowModelType["Infinite"] = "infinite";
})(XpoRowModelType || (XpoRowModelType = {}));

var XpoBoardStateSources;
(function (XpoBoardStateSources) {
    XpoBoardStateSources["ExternalDataRefresh"] = "EXTERNAL-DATA-REFRESH";
    XpoBoardStateSources["BoardActivatingView"] = "BOARD-ACTIVATING-VIEW";
    XpoBoardStateSources["ActiveViewChange"] = "ACTIVE-VIEW-CHANGE";
    XpoBoardStateSources["AddNewView"] = "ADD-NEW-VIEW";
    XpoBoardStateSources["SaveView"] = "SAVE-VIEW";
    XpoBoardStateSources["SaveViewAs"] = "SAVE-VIEW-AS";
    XpoBoardStateSources["RefreshView"] = "REFRESH-VIEW";
    XpoBoardStateSources["DeleteView"] = "AVAILABLE-VIEWS-DELETE-VIEW";
    XpoBoardStateSources["RenameView"] = "RENAME-VIEW";
    XpoBoardStateSources["FilterChange"] = "FILTER-CHANGE";
    XpoBoardStateSources["BoardDataFetcher"] = "BOARD DATA FETCHER";
    XpoBoardStateSources["RowModelType"] = "ROW-MODEL-TYPE";
    XpoBoardStateSources["DataSourceRefresh"] = "DATA SOURCE REFRESH";
    XpoBoardStateSources["CellClicked"] = "CELL-CLICKED";
    XpoBoardStateSources["FirstDataRendered"] = "FIRST-DATA-RENDERED";
    XpoBoardStateSources["InitializeFloatingFilters"] = "INITIALIZE-FLOATING-FILTERS";
    XpoBoardStateSources["SelectionChange"] = "SELECTION-CHANGE";
    XpoBoardStateSources["GridSettingsUpdate"] = "GRID-SETTINGS-UPDATE";
    XpoBoardStateSources["ColumnLevelFilteringToggle"] = "COLUMN-LEVEL-FILTERING-TOGGLE";
    XpoBoardStateSources["PageChange"] = "AG-GRID-PAGE";
    XpoBoardStateSources["SortChange"] = "AG-GRID-SORT";
})(XpoBoardStateSources || (XpoBoardStateSources = {}));

/**
 * Helper class internally used by the board-data source to handle fetching of data when a state change occurs.
 */
class XpoBoardDataFetcher {
    constructor(stateSource$, fetcher) {
        this.stateSource$ = stateSource$;
        this.fetcher = fetcher;
        this.stateChange$ = new Subject();
        this.stateSource$
            .pipe(distinctUntilChanged(), filter((state) => this.isFetchRequiredBeforeCache(state)), 
        /**
         * The following debounce prevents multiple fetch dispatches when the same criteria changes
         * is fired from multiple components. We evaluated use a distinctUntilChange operator to dispatch
         * the fetcher only when the criteria change compared with the last state but that can be a limit
         * from some projects that emit the fetch from custom reasons even when the criteria didn't change.
         *
         * isUserScrollingInfinite added to resolve the error with the infinite scroll. We are skipping the debounceTime
         * in that case allowing immediately fetch data regarding quickly scrolling. Bug related: NGXLTL-1054
         */
        debounce((state) => (this.isUserScrollingInfinite(state) ? EMPTY : timer(100))), concatMap((state) => {
            return this.fetcher(state).pipe(
            // For the scenario that we get an observableOf(value), this will ensure that we processes this async
            // regardless
            observeOn(asyncScheduler), map((result) => {
                return {
                    context: state.context,
                    data: result,
                    dataFetchState: result.recordCount !== 0 ? XpoBoardDataFetchState.ResultsReturned : XpoBoardDataFetchState.NoResults,
                    source: XpoBoardDataFetcher.FetcherSource,
                    visibleViewData: XpoBoardDataFetcher.constructVisibleViewData(state, result),
                };
            }), catchError((_) => of({
                context: state.context,
                data: null,
                dataFetchState: XpoBoardDataFetchState.Error,
                source: XpoBoardDataFetcher.FetcherSource,
            })), take(1));
        }))
            .subscribe((state) => {
            this.stateChange$.next(state);
        }, (err) => {
            this.stateChange$.error({
                error: 'Unhandled error ' + err,
                dataFetchState: XpoBoardDataFetchState.Error,
                source: XpoBoardDataFetcher.FetcherSource,
            });
        });
    }
    static isFetchRequired(state, cachedState) {
        return state.rowModelType === XpoRowModelType.ClientSide ? isFetchRequiredClientSide() : isFetchRequiredCommon();
        // --- The following are some functions declared inside this static method scope to be used here ---
        function isFetchRequiredClientSide() {
            return (isFetchRequiredCommon() &&
                ([
                    ...'',
                    XpoBoardStateSources.BoardActivatingView,
                    XpoBoardStateSources.ActiveViewChange,
                    XpoBoardStateSources.AddNewView,
                ].includes(state.source) ||
                    (state.source === XpoBoardStateSources.FilterChange && !isConditionalFilter())));
            /**
             * the initial ...'' in the XpoBoardStateSources array is a momentary fix until the state.source be
             * completed migrated to be XpoBoardStateSources type. Contrary case it will not work because state.source
             *  only matchs string type now. It's related with the NGXLTL-505 ticket
             */
        }
        function isFetchRequiredCommon() {
            return (state.source !== XpoBoardDataFetcher.FetcherSource &&
                XpoBoardDataFetcher.CauseFetchChangeKeys.some((f) => state.changes.includes(f)));
        }
        function isConditionalFilter() {
            if (cachedState) {
                return isAllConditional(getNewCriteria());
            }
        }
        function isAllConditional(newCriteria) {
            /**
             * Evaluate if filter has 'conditions' property to know if it's a conditional filter
             * If newCriteria is empty, user has cleaned filters so evaluate if last state had
             * non-conditional to emit a fetch to restore dataset
             */
            return isEmpty(newCriteria)
                ? every$1(cachedState.criteria, (value, key) => cachedState.criteria[key] && cachedState.criteria[key].conditions)
                : every$1(newCriteria, (value, key) => newCriteria[key] && newCriteria[key].conditions);
        }
        function getNewCriteria() {
            // Get the new assign/remove criteria compared with last state
            return assign(diff(state.criteria, cachedState.criteria), diff(cachedState.criteria, state.criteria));
        }
        function diff(compared, comparator) {
            function changes(compared_, comparator_) {
                return transform(compared_, function (result, value, key) {
                    if (!isEqual(value, comparator_[key])) {
                        result[key] = isObject(value) && isObject(comparator_[key]) ? changes(value, comparator_[key]) : value;
                    }
                });
            }
            return changes(compared, comparator);
        }
    }
    // construct the visible view result, so the data count matches correctly
    static constructVisibleViewData(state, result) {
        const visibleViews = [...(state.visibleViewData || [])];
        const visibleIndex = visibleViews.findIndex((v) => v.viewId === result.state.viewId);
        if (visibleIndex !== -1) {
            visibleViews.splice(visibleIndex, 1, { viewId: result.state.viewId, recordCount: result.recordCount });
        }
        return visibleViews;
    }
    isFetchRequiredBeforeCache(state) {
        // First evaluate fetch then cache state
        const evaluation = state.source === XpoBoardStateSources.ExternalDataRefresh ||
            state.source === XpoBoardStateSources.DataSourceRefresh ||
            XpoBoardDataFetcher.isFetchRequired(state, this.cachedState);
        this.cacheState(state);
        return evaluation;
    }
    cacheState(state) {
        this.cachedState = state;
    }
    isUserScrollingInfinite(state) {
        return state.rowModelType === XpoRowModelType.Infinite && state.source === XpoBoardStateSources.PageChange;
    }
}
// Only cause a fetch when paging, or when criteria change
XpoBoardDataFetcher.CauseFetchChangeKeys = ['pageNumber', 'criteria'];
XpoBoardDataFetcher.FetcherSource = XpoBoardStateSources.BoardDataFetcher;

class XpoBoardDataSource {
    constructor() {
        this.pageSize = 50;
        // caches properties between requests so they can be replied on view change events
        this.stateCache = { source: 'UNKNOWN' };
        /**
         * Stores reference to any subscriptions, that were connected to via the connect method.
         * Any subscriptions in here will be disconnected when `disconnect` is called
         */
        this.subscriptions = new Map();
        this.stateVersion = 0;
        this.stateSource$ = new ReplaySubject(1);
        this.connect(new XpoBoardDataFetcher(this.stateSource$, this.fetchData.bind(this)));
    }
    /**
     * Clears values from the state cache that we dont want to be repeated back on next fetch
     */
    static clearNonCacheValuesFromState(newState) {
        XpoBoardDataSource.NonCachedKeys.filter((key) => !newState.changes.includes(key)).forEach((key) => delete newState[key]);
        return newState;
    }
    /**
     * Connects a collection viewer (such as a data-table) to this data source. Note that
     * the stream provided will be accessed during change detection and should not directly change
     * values that are bound in template views.
     *
     * @param boardDataViewer The component that exposes a view over the data provided by this
     *     data source.
     * @returns XpoBoardDataSourceConnections object that provides access too the various data-sources
     */
    connect(stateViewer) {
        const subscription = this.attachToViewChange(stateViewer);
        this.subscriptions.set(stateViewer, subscription);
        return this.stateSource$;
    }
    /**
     * Disconnects a collection viewer (such as a data-table) from this data source. Can be used
     * to perform any clean-up or tear-down operations when a view is being destroyed.
     *
     * @param boardDataViewer The component that exposes a view over the data provided by this
     *     data source.
     */
    disconnect(boardDataViewer) {
        const sub = this.subscriptions.get(boardDataViewer);
        if (!sub) {
            sub.unsubscribe();
            this.subscriptions.delete(boardDataViewer);
        }
    }
    /**
     * Refreshes the data in the grid.  The only mutation that will occur is the grid will go to page one.
     * If there is not a currently active view, the refresh will not occur
     */
    refresh() {
        // don't allow a refresh without an active view, this might occur if an outside event
        // causes a refresh of the board before it has finished displaying its first view
        if (this.stateCache && this.stateCache.viewId) {
            this.setState({ pageNumber: 1, source: 'DATA SOURCE REFRESH' });
        }
    }
    get state$() {
        return this.stateSource$.asObservable();
    }
    attachToViewChange(viewer) {
        // only process the last request from a viewChange
        // TODO: do we need aggregate the data from all XpoBoardStateViewers into a single stream and only collect the last
        // ajax request and cancel the last one?
        return viewer.stateChange$.subscribe((incomingState) => {
            this.setState(incomingState);
        }, (err) => {
            this.stateSource$.error(err);
            console.error(err.error);
        });
    }
    /**
     * Broadcasted out state changes, the incoming state change will be combined
     * with the previous state change and broadcast out
     */
    setState(incomingState) {
        this.stateCache = this.rebuildState(incomingState);
        this.stateVersion++;
        this.stateCache.stateVersion = this.stateVersion;
        this.stateSource$.next(this.stateCache);
    }
    rebuildState(state) {
        const newState = XpoBoardDataSource.clearNonCacheValuesFromState(Object.assign(Object.assign(Object.assign({}, this.stateCache), state), { changes: Object.keys(state) }));
        return this.evalFetchStatus(newState);
    }
    evalFetchStatus(newState) {
        if (XpoBoardDataFetcher.isFetchRequired(newState, this.stateCache) &&
            newState.dataFetchState !== XpoBoardDataFetchState.Loading) {
            newState.dataFetchState = XpoBoardDataFetchState.Loading;
            newState.changes.push('dataFetchState');
        }
        else if (newState.changes.includes('visibleRows')) {
            if (newState.visibleRows === 0) {
                newState.dataFetchState = XpoBoardDataFetchState.NoResults;
            }
            else {
                newState.dataFetchState = XpoBoardDataFetchState.ResultsReturned;
            }
            newState.changes.push('dataFetchState');
        }
        return newState;
    }
}
// Keys XpoBoardState that are send but not cached on the stateCache
XpoBoardDataSource.NonCachedKeys = ['context'];

/** Object to returned from the board-data-service when loading data  */
class XpoBoardData {
    constructor(state, consumerData, recordCount, pageSize) {
        this.state = state;
        this.consumerData = consumerData;
        this.recordCount = recordCount;
        this.pageSize = pageSize;
        this.startRecord = (state.pageNumber - 1) * pageSize;
        // We check the length of the array, against the page size to see if we have reached the end
        this.endRecord = recordCount = Math.min(recordCount, this.startRecord + pageSize);
    }
    static empty(state) {
        return new XpoBoardData(state, null, 0, 0);
    }
}

const XPO_BOARD_DEFAULT_OPTIONS = new InjectionToken('XpoBoardDefaultOptions');

/**
 * Use this when your grid is getting sent events from an external source (socket.io, firebase, etc)
 * You can pass in your stream source and the grid will handle those updates appropriately
 */
class XpoBoardStreamingDataSource extends XpoBoardDataSource {
    constructor(streamSource$) {
        super();
        this.streamSource$ = streamSource$;
        // Subscribing to the updates stream
        this.streamSourceSubscription = this.streamSource$.subscribe((updates) => {
            this.handleUpdate(updates);
        });
    }
    ngOnDestroy() {
        this.streamSourceSubscription.unsubscribe();
    }
    handleUpdate(updates) {
        if (!updates || !updates.length) {
            return;
        }
        // Update the visible view data with the amount of records that have been changes in the view.
        const visibleViewData = (this.stateCache.visibleViewData || []).map((vv) => {
            const recordChangeCount = (vv.recordChangeCount || 0) + updates.filter((v) => v.viewId === vv.viewId).length;
            return { viewId: vv.viewId, recordCount: vv.recordCount, recordChangeCount };
        });
        this.setState({ visibleViewData, source: 'BOARD-STREAM-VISIBLE-VIEW-DATA-UPDATE' });
    }
}
XpoBoardStreamingDataSource.ɵfac = function XpoBoardStreamingDataSource_Factory(t) { return new (t || XpoBoardStreamingDataSource)(i0.ɵɵinject(i1$3.Observable)); };
XpoBoardStreamingDataSource.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoBoardStreamingDataSource, factory: XpoBoardStreamingDataSource.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardStreamingDataSource, [{
        type: Injectable
    }], function () { return [{ type: i1$3.Observable }]; }, null); })();

class XpoBoardViewUtil {
    static activateView(view, currentState, source, persistCriteria = false) {
        const criteria = this.constructCriteria(view, currentState, persistCriteria);
        return Object.assign(Object.assign(Object.assign({}, view.getState(criteria)), this.viewStateUpdateResetValues), { availableViews: XpoBoardViewUtil.applyStateChangesToView(currentState), source: source });
    }
    static addView(view, state, source, persistCriteria = false) {
        const criteria = this.constructCriteria(view, state, persistCriteria);
        return Object.assign(Object.assign(Object.assign({}, view.getState(criteria)), this.viewStateUpdateResetValues), { availableViews: [...XpoBoardViewUtil.applyStateChangesToView(state), view], visibleViewData: [...state.visibleViewData, { viewId: view.id }], source: source, isViewSystemDefined: false });
    }
    static deleteView(viewId, state, source) {
        const resultState = XpoBoardViewUtil.hideView(viewId, state, source);
        resultState.availableViews = XpoBoardViewUtil.removeFromAvailableViews(viewId, state.availableViews);
        return resultState;
    }
    /**
     * Retrieves the currently active view from the state object
     * @param state
     */
    static findActiveView(state) {
        // separating this out from the return line since you will get a compile time error with using lambda functions on
        // a static function
        const result = state && state.viewId ? (state.availableViews || []).find((v) => v.id === state.viewId) : null;
        return result;
    }
    static getNextViewName(template) {
        const templateName = template.name ? template.name : 'New View';
        return templateName + ' ' + XpoBoardViewUtil.viewCounter++;
    }
    static hideView(viewId, state, source) {
        const visibleViewData = [...(state.visibleViewData || [])];
        const viewIDX = visibleViewData.findIndex((vv) => vv.viewId === viewId);
        if (viewIDX !== -1) {
            visibleViewData.splice(viewIDX, 1); // remove the view
        }
        // display the next view, if you are hiding the current view
        const result = state.viewId === viewId
            ? Object.assign(Object.assign({}, XpoBoardViewUtil.getNextView(viewId, state).getState()), { visibleViewData, source, pageNumber: 1 }) : { visibleViewData, source };
        // if closing a transient view, remove it from the list of available
        // else apply any transient changes to the view, so they are not lost
        const view = state.availableViews.find((v) => v.id === viewId);
        if (view && !view.lastSaved) {
            result.availableViews = XpoBoardViewUtil.removeFromAvailableViews(viewId, state.availableViews);
        }
        else {
            result.availableViews = XpoBoardViewUtil.applyStateChangesToView(state);
        }
        return result;
    }
    static showView(viewId, state, source) {
        const view = state.availableViews.find((v) => v.id === viewId);
        const visibleViewData = [...(state.visibleViewData || [])];
        visibleViewData.push({ viewId });
        return Object.assign(Object.assign({}, view.getState()), { visibleViewData, source, pageNumber: 1 });
    }
    static updateView(view, state, source) {
        // replace the old view, with the new copy
        const views = [...state.availableViews];
        const idx = views.findIndex((v) => v.id === view.id);
        views.splice(idx, 1, view);
        return Object.assign(Object.assign({}, view.getState()), { availableViews: views, pageNumber: 1, source: source });
    }
    /**
     * Updates the availableView with any pending changes from the state object
     */
    static applyStateChangesToView(state) {
        const activeView = XpoBoardViewUtil.findActiveView(state);
        // if there is no active view, nothing to do
        if (!activeView) {
            return state.availableViews;
        }
        // replace the old view, with the new copy
        const views = [...state.availableViews];
        const idx = views.findIndex((v) => v.id === activeView.id);
        views.splice(idx, 1, activeView.template.createView(activeView.toViewConfig(state)));
        return views;
    }
    /**
     * Determines the next view to show
     */
    static getNextView(viewId, state) {
        // TODO: handle closing the last view
        if (state.visibleViewData.length === 1) {
            throw new Error('Closing last view is not currently supported');
        }
        const currentViewIdx = state.visibleViewData.findIndex((vv) => vv.viewId === viewId);
        // if last view, go current position - 1, else position + 1
        const nextViewIdx = currentViewIdx + 1 === state.visibleViewData.length ? currentViewIdx - 1 : currentViewIdx + 1;
        return state.availableViews.find((v) => v.id === state.visibleViewData[nextViewIdx].viewId);
    }
    static removeFromAvailableViews(viewId, views) {
        const result = [...views];
        const viewIdx = result.findIndex((v) => v.id === viewId);
        if (viewIdx !== -1) {
            result.splice(viewIdx, 1);
        }
        return result;
    }
    static constructCriteria(view, currentState, persistCriteria) {
        let criteria = null;
        if (persistCriteria) {
            criteria = Object.assign(Object.assign({}, currentState.criteria), view.criteria);
        }
        else {
            criteria = currentState.viewId !== view.id ? view.criteria : currentState.criteria;
        }
        return criteria;
    }
}
XpoBoardViewUtil.viewCounter = 1;
/**
 * When a view change happens, we want to reset these values to their default values,
 * since we don't want to propigate a selection, pageNumber, or selection from view to view
 */
XpoBoardViewUtil.viewStateUpdateResetValues = {
    selection: [],
    focusedRecord: null,
    pageNumber: 1,
};

let viewIncrementor = 0;
class XpoBoardView {
    constructor(template, config) {
        this.template = template;
        this.id = config.id || 'auto-generated-view-' + viewIncrementor++;
        this.templateId = template ? template.id : config.templateId;
        this.name = config.name || '';
        this.children = config.children || [];
        this.children.forEach((c) => (c.parent = this));
        this.closeable = config.closeable || false;
        this.criteria = config.criteria || {};
        this.lastSaved = config.lastSaved || null;
        this.systemDefined = !!config.systemDefined;
        this.sortOrder = config.sortOrder || [];
        this.visible = config.visible != null ? config.visible : true;
        this.recordCount = config.recordCount;
        this.isActive = config.isActive;
        this.visibleFilters = config.visibleFilters || template.availableFilters;
        /*
          To avoid harcoding this 30 here.. we would need to do a whole refactor for the row height due to the mess done
          in grid-row-height-selection.component.ts and the injection token which adds non needed complexity.
          Grid settings (including rowHeight) is being already refactored in new toolbar so this will hopefully
          be deprecated soon.
        */
        this.rowHeight = config.rowHeight || 30;
    }
    getState(criteria) {
        return {
            viewId: this.id,
            criteria: criteria || this.criteria || {},
            viewName: this.name,
            viewLastSaved: this.lastSaved,
            isViewSystemDefined: this.systemDefined,
            source: 'INITIAL',
            template: this.template,
            sortOrder: this.sortOrder,
            rowHeight: this.rowHeight,
        };
    }
    toViewConfig(state) {
        // only use the state if we are the currently activeView
        state = state && state.viewId === this.id ? state : null;
        return {
            id: this.id,
            children: this.children,
            closeable: this.closeable,
            criteria: state ? state.criteria : this.criteria,
            name: this.name,
            templateId: this.templateId,
            lastSaved: this.lastSaved,
            sortOrder: state ? state.sortOrder : this.sortOrder,
            visible: this.visible,
            systemDefined: this.systemDefined,
            rowHeight: state ? state.rowHeight : this.rowHeight,
        };
    }
}
class XpoBoardViewTemplate {
    constructor(config) {
        this.id = config.id;
        this.name = config.name;
        this.availableFilters = config.availableFilters || [];
        this.allowAdditional = !!config.allowAdditional;
        this.keyField = config.keyField;
        this.detailGridKeyField = config.detailGridKeyField;
        this.context = config.context || undefined;
    }
    createView(config) {
        this.assignUniqueId(config);
        return new XpoBoardView(this, config);
    }
    assignUniqueId(config) {
        if (!config.id) {
            config.id = 'newView' + +new Date();
        }
    }
}

function isExportableDataSource(dataSource) {
    return dataSource && dataSource.export !== undefined;
}

class XpoSortExpression {
    constructor(column, direction) {
        this.column = column;
        this.direction = direction || 'asc';
    }
}

const XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT = new InjectionToken('xpoGridBoardDefaultRowHeight');

class XpoGridBoardInMemoryColumnFactory {
    constructor(columns) {
        // support taking in array or a map
        if (Array.isArray(columns)) {
            this.columns = new Map();
            columns.forEach((obj) => this.columns.set(obj['field'], obj));
        }
        else {
            this.columns = columns;
        }
    }
    get(columnId) {
        return this.columns.get(columnId);
    }
    getAll(columnIds) {
        return columnIds.map((id) => this.get(id)).filter((c) => !!c);
    }
}

class XpoGridBoardViewUtils {
    /**
     * Helper method to assist with the generation of the columns
     */
    static generateVisibleColumns(template, view) {
        // Container of the updated columns, combining the current template and the saved column's properties in the view
        const updatedColumnsDef = [];
        // There are some columns in the template which doesn't contain identifier like checkboxes, indexes, actions.
        // So we first iterate the current template to push those columns in the current position in the new
        // updatedColumnsDef. We iterate the template.availableColumns until we find some column with an identifier.
        // Then we break and start to match the saved column in the view with the current template.
        // Using here .every because iterates array until false is returned
        template.availableColumns.every((column) => {
            return !XpoGridBoardViewUtils.hasSomeColumnIdentifier(column) ? updatedColumnsDef.push(column) : false;
        });
        // Map the saved view colDef updating in the template the properties we want to keep
        view.visibleColumns.forEach((viewColumnDef) => {
            // Using the saved column in the view, get the column definition from the current template definition
            const templateColumnDef = XpoGridBoardViewUtils.getColDefByPrimaryIdentifier(template.availableColumns, viewColumnDef);
            // Create an updated column def with the merge of the template definition and the current column state in the view
            const updatedColumn = XpoGridBoardViewUtils.getMergeColumnDef(templateColumnDef, viewColumnDef);
            // Push updateColumn to the array of currentColumnsDef
            if (updatedColumn) {
                updatedColumnsDef.push(updatedColumn);
            }
        });
        // Once the iteration of saved column in the view ends we iterate from the back the template looking for columns
        // without identified to add them at the end of the updatedColumnsDef.
        // Using .slice to create a shallow copy. Using .reverse to start the iteration from the back.
        // Using .every to iterate the array until a false is returned
        template.availableColumns
            .slice()
            .reverse()
            .every((column) => {
            return !XpoGridBoardViewUtils.hasSomeColumnIdentifier(column) ? updatedColumnsDef.push(column) : false;
        });
        return updatedColumnsDef;
    }
    /**
     * Helper method to assist with determining if columns were updated
     */
    static wereColumnsUpdated(state, template) {
        if (!state || !state.visibleColumns || !template.availableColumns) {
            return false;
        }
        // Removes all other params that might be on the column object so we can just compare if the
        // field and header names have changed.
        const toNormalizedColumn = (column) => ({
            headerName: column.headerName,
            field: column.field,
            width: column.width,
            colId: column.colId,
            pinned: column.pinned,
            children: column.children,
            groupId: column.groupId,
        });
        const visibleColumns = state.visibleColumns.map(toNormalizedColumn);
        const availableColumns = template.availableColumns.map(toNormalizedColumn);
        return (visibleColumns.length !== availableColumns.length ||
            JSON.stringify(visibleColumns) !== JSON.stringify(availableColumns));
    }
    /**
     * Merge the template column definition with the saved properties of the view
     * @param templateColDef Col defined in the view
     * @param savedColDef Col saved in the view with the properties we saved
     * @returns The complete column definition from the template with the properties as saved in the view
     */
    static getMergeColumnDef(templateColDef, savedColDef) {
        let updatedColumn;
        if (templateColDef) {
            // Merge the template column definition with the state of properties we want to keep
            // Using _get from lodash because allows you to return the original value (third parameters) if the searched is undefined
            updatedColumn = Object.assign(Object.assign({}, templateColDef), { width: _get(savedColDef, 'width', templateColDef.width), pinned: _get(savedColDef, 'pinned', templateColDef.pinned), colId: _get(savedColDef, 'colId', templateColDef.colId), groupId: _get(savedColDef, 'groupId', templateColDef.groupId), headerName: _get(savedColDef, 'headerName', templateColDef.headerName), field: _get(savedColDef, 'field', templateColDef.field), hide: _get(savedColDef, 'hide', templateColDef.hide) });
            // Check if the currentColDef has children (because the original definition could has them but the current has them hidden)
            if (savedColDef && savedColDef.children) {
                updatedColumn.children = XpoGridBoardViewUtils.getMergeChildrenColDef(templateColDef, savedColDef);
            }
        }
        return updatedColumn;
    }
    /**
     * Update the children col definition of a parent column against the saved children in the view
     * @param templateColDef The col as defined in the template
     * @param parentSavedColDef The parent column saved in the view
     * @returns Returns a parent column with its children updated as they were saved in the view
     */
    static getMergeChildrenColDef(templateColDef, parentSavedColDef) {
        // Update the children def with the state saved in the view
        const updatedChildren = [];
        // If some one of the children hasn't an identifier, replace all the saved children for the ones on the template
        if (parentSavedColDef.children.some((childCol) => !XpoGridBoardViewUtils.hasSomeColumnIdentifier(childCol))) {
            templateColDef.children.forEach((child) => {
                updatedChildren.push(child);
            });
        }
        else {
            // Update the children declared on the template with the saved properties of the view
            // Iterate the currentColDef children to be sure iterate just the visible ones
            parentSavedColDef.children.forEach((viewChildColDef) => {
                const originalChildColDef = XpoGridBoardViewUtils.getColDefByPrimaryIdentifier(templateColDef.children, viewChildColDef);
                // Set all the original child definitions replacing the ones changed in the current state
                // This is necessary to get the col as defined in the template before the compilation. Some properties are missed during the execution.
                // For that reason we can't just let the currentChildColDef without merging the original def
                updatedChildren.push(Object.assign(Object.assign({}, originalChildColDef), viewChildColDef));
            });
            // NGXLTL-1147: regarding an edge case where some child is the owner of a row group definition we
            // must persist it as child even if it's hide
            templateColDef.children.forEach((originalChildColDef) => {
                if (originalChildColDef.rowGroup) {
                    // Check if it was already defined as an updatedChildren
                    if (!XpoGridBoardViewUtils.getColDefByPrimaryIdentifier(updatedChildren, originalChildColDef)) {
                        updatedChildren.push(originalChildColDef);
                    }
                }
            });
        }
        return updatedChildren;
    }
    /**
     * Get a column definition from a container using from the more specific identifier to the lesser specific.
     * @param columnsContainer The container of the columns.
     * @param searchedColumn The searched column in the container
     * @returns Returns the column reference from the container. If the column isn't find it returns the current searched column
     */
    static getColDefByPrimaryIdentifier(columnsContainer, searchedColumn) {
        const columnFound = columnsContainer.find((c) => (c.colId && c.colId === _get(searchedColumn, 'colId', searchedColumn)) ||
            (c.headerName && c.headerName === _get(searchedColumn, 'headerName', searchedColumn)) ||
            (c.field && c.field === _get(searchedColumn, 'field', searchedColumn)));
        // Using this return separated since you will get a compile time error returning lambdas on static classes
        return columnFound;
    }
    /**
     * This method updates the saved columns of the view considering the keys defined in the current template
     * @param template current view template defined in the project component
     * @param currentColumns columns saved in the view
     * @returns Returns the columns saved in the view updating keys as are now in the template
     */
    static oldViewsAdapter(template, currentColumns) {
        // Map the original colDef updating the properties we want to keep as currently are
        currentColumns.forEach((currentColumnDef) => {
            // Get the original column definition from the template definition
            const originalColumnDef = XpoGridBoardViewUtils.getColDefByPrimaryIdentifier(template.availableColumns, currentColumnDef);
            // Update column def in the reference with the merge of the original and the current column state
            currentColumnDef = XpoGridBoardViewUtils.getMergeColumnDef(originalColumnDef, currentColumnDef);
        });
        return currentColumns;
    }
    static hasSomeColumnIdentifier(col) {
        var _a, _b, _c;
        return ((_a = col.colId) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = col.headerName) === null || _b === void 0 ? void 0 : _b.length) > 0 || ((_c = col.field) === null || _c === void 0 ? void 0 : _c.length) > 0;
    }
}

class XpoGridBoardView extends XpoBoardView {
    constructor(template, config) {
        super(template, config);
        this.template = template;
        this.visibleColumns =
            config.visibleColumns && config.visibleColumns.length
                ? XpoGridBoardViewUtils.generateVisibleColumns(this.template, config)
                : [];
    }
    getState(criteria) {
        const state = super.getState(criteria);
        // Using cloneDeep below because availableColumn could contains functions which breaks JSON.parse(JSON.stringify())
        // If we don't copy the availableColumns deep the children refs are being shared among views
        // As lodash is already installed and used in the app is better to use cloneDeep than create a custom method
        state.visibleColumns = this.visibleColumns.length
            ? XpoGridBoardViewUtils.oldViewsAdapter(this.template, this.visibleColumns)
            : cloneDeep$1(this.template.availableColumns);
        return state;
    }
    toViewConfig(state) {
        // if visible columns are the exact same length as available columns
        // don't persist the data because, it means columns were not customized
        const columns = XpoGridBoardViewUtils.wereColumnsUpdated(state, this.template) ? state.visibleColumns || [] : [];
        return Object.assign(Object.assign({}, super.toViewConfig(state)), { visibleColumns: columns.map(({ colId, headerName, width, children, pinned, groupId, hide }) => ({
                colId,
                headerName,
                width,
                pinned,
                groupId,
                hide,
                children: children && children.length
                    ? children.map((child) => ({
                        colId: child.colId,
                        headerName: child.headerName,
                        width: child.width,
                        pinned: child.pinned,
                        hide: child.hide,
                    }))
                    : undefined,
            })) });
    }
}

const _c0$o = ["filterContainer"];
const _c1$9 = ["popover"];
function XpoFilterChip_ng_template_13_Template(rf, ctx) { }
const _c2$3 = function (a0) { return { "xpo-FilterChip-dropdownTrigger--disabled": a0 }; };
class XpoFilterChip {
    constructor(changeDetectorRef, factoryResolver) {
        this.changeDetectorRef = changeDetectorRef;
        this.factoryResolver = factoryResolver;
        /** Whether the filter is open. */
        this.opened = false;
        /** Emits a value when the filter is closed */
        this.filterClosed$ = new Subject();
        /** Used for component destroy */
        this.unsubscribe$ = new Subject();
    }
    ngOnDestroy() {
        this.close();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    ngOnInit() {
        this.criteriaStore.criteria$.pipe(takeUntil(this.unsubscribe$)).subscribe((c) => {
            const val = c != null ? c[this.filter.field] || null : null;
            const displayVal = this.filter.getDisplayValue(val);
            this.displayValue$ = displayVal instanceof Observable ? displayVal : of(displayVal);
            this.changeDetectorRef.markForCheck();
        });
        this.filterClosed$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            // When the filter popup is closed due to outside click, apply the filters if in container mode
            if (this.criteriaStore.applyFilterStrategy === 'container') {
                this.filterComponent.applyCriteria(true);
            }
        });
        if (this.filter.disabled$) {
            this.disabled$ = this.filter.disabled$.pipe(tap((x) => (this.disabledValue = x)), shareReplay());
        }
        this.id = `${this.criteriaStore.id}-filterChip-${this.filter.field}`;
    }
    /** Open the filter drop-down */
    open() {
        if (this.disabledValue) {
            return;
        }
        if (!this.opened) {
            this.opened = true;
            // Create the filter component and add it to view child template
            const factory = this.factoryResolver.resolveComponentFactory(this.filter.filterComponentType);
            const component = this.filterContainerRef.createComponent(factory);
            this.filterComponent = component.instance;
            this.filterComponent.configuration = this.filter;
            this.filterComponent.field = this.filter.field;
            this.filterComponent.filtersService = this.criteriaStore;
            this.filterComponent.closePopup
                .pipe(takeUntil(this.filterClosed$), takeUntil(this.unsubscribe$))
                .subscribe(() => this.popover.closed.emit());
        }
    }
    /** Close the Filter drop-down. */
    close() {
        if (!this.opened) {
            return;
        }
        this.filterClosed$.next();
        this.filterContainerRef.clear();
        this.opened = false;
    }
}
XpoFilterChip.ɵfac = function XpoFilterChip_Factory(t) { return new (t || XpoFilterChip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver)); };
XpoFilterChip.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFilterChip, selectors: [["xpo-filter-chip"]], viewQuery: function XpoFilterChip_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$o, 5, ViewContainerRef);
        i0.ɵɵviewQuery(_c1$9, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterContainerRef = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, hostAttrs: [1, "xpo-FilterChip"], hostVars: 1, hostBindings: function XpoFilterChip_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, inputs: { filter: "filter", criteriaStore: "criteriaStore" }, decls: 15, vars: 13, consts: [[1, "xpo-FilterChip-dropdownTrigger", 3, "ngClass", "xpoPopoverTriggerFor", "xpoPopoverDisabled", "menuOpened", "menuClosed"], [1, "xpo-FilterChip-labelWrapper"], [1, "xpo-FilterChip-labelPrefix"], [1, "xpo-FilterChip-labelSelected"], [1, "xpo-FilterChip-dropdownIcon"], ["color", "white"], ["popover", "xpoPopover"], ["filterContainer", ""]], template: function XpoFilterChip_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("menuOpened", function XpoFilterChip_Template_div_menuOpened_0_listener() { return ctx.open(); })("menuClosed", function XpoFilterChip_Template_div_menuClosed_0_listener() { return ctx.close(); });
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "span", 2);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "span", 3);
        i0.ɵɵtext(7);
        i0.ɵɵpipe(8, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "mat-icon", 4);
        i0.ɵɵtext(10, "arrow_drop_down");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "xpo-popover", 5, 6);
        i0.ɵɵtemplate(13, XpoFilterChip_ng_template_13_Template, 0, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(12);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2$3, i0.ɵɵpipeBind1(1, 5, ctx.disabled$)))("xpoPopoverTriggerFor", _r0)("xpoPopoverDisabled", i0.ɵɵpipeBind1(2, 7, ctx.disabled$));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.filter.label);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 9, ctx.displayValue$));
    } }, directives: [i2.NgClass, i4$1.XpoPopoverTrigger, i3.MatIcon, i4$1.XpoPopover], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-FilterChip{cursor:pointer;display:inline-block;font-size:.875rem;height:24px;margin:8px 0 8px 8px}.xpo-FilterChip-dropdownTrigger{align-items:center;border:1px solid #d8d8d8;color:#4a4a4a;display:flex;padding-left:8px;-webkit-user-select:none;user-select:none}.xpo-FilterChip-dropdownTrigger--disabled{cursor:default;opacity:.6}.xpo-FilterChip-labelPrefix{color:#6f6f6f;margin-right:8px}.xpo-FilterChip-labelPrefix:after{content:\":\"}.xpo-FilterChip-dropdownIcon{color:#0868ac;height:24px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterChip, [{
        type: Component,
        args: [{
                selector: 'xpo-filter-chip',
                templateUrl: 'filter-chip.component.html',
                styleUrls: ['filter-chip.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-FilterChip', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ComponentFactoryResolver }]; }, { filterContainerRef: [{
            type: ViewChild,
            args: ['filterContainer', {
                    read: ViewContainerRef,
                }]
        }], popover: [{
            type: ViewChild,
            args: ['popover']
        }], filter: [{
            type: Input
        }], criteriaStore: [{
            type: Input
        }] }); })();

function XpoFilterBar_ng_template_0_Template(rf, ctx) { }
function XpoFilterBar_ng_container_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function XpoFilterBar_ng_container_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.onApplyClicked(); });
    i0.ɵɵtext(1, " Apply ");
    i0.ɵɵelementEnd();
} }
function XpoFilterBar_ng_container_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function XpoFilterBar_ng_container_2_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.onResetClicked(); });
    i0.ɵɵtext(1, " Reset ");
    i0.ɵɵelementEnd();
} }
function XpoFilterBar_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoFilterBar_ng_container_2_button_1_Template, 2, 0, "button", 3);
    i0.ɵɵtemplate(2, XpoFilterBar_ng_container_2_button_2_Template, 2, 0, "button", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.applyFilterStrategy === "global");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.enableFilterReset);
} }
const _c0$n = ["*"];
class XpoFilterHost {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
XpoFilterHost.ɵfac = function XpoFilterHost_Factory(t) { return new (t || XpoFilterHost)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
XpoFilterHost.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoFilterHost, selectors: [["", "xpo-filter-host", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterHost, [{
        type: Directive,
        args: [{
                selector: '[xpo-filter-host]',
            }]
    }], function () { return [{ type: i0.ViewContainerRef }]; }, null); })();
function filtersServiceFactory(parentFiltersService) {
    return parentFiltersService !== null && parentFiltersService !== void 0 ? parentFiltersService : new XpoFiltersService();
}
class XpoFilterBar extends XpoBoardConsumer {
    constructor(filtersService, componentFactoryResolver, changeDetectorRef, 
    // Optional in for the case that the filter bar is not used outside the context of the board
    boardDataSourceResolver, boardApiDispatcherService) {
        super(boardDataSourceResolver, changeDetectorRef);
        this.filtersService = filtersService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.changeDetectorRef = changeDetectorRef;
        this.boardApiDispatcherService = boardApiDispatcherService;
        /** Input filter object that will be dynamically generated */
        this.previousCriteria = null;
        this.initialCriteriaList = {};
        this.criteriaValue = {};
        this.criteriaChange = new EventEmitter();
        this.enableFilterResetValue = false;
    }
    /** Filters that will be generated */
    get filters() {
        return this.filtersValue;
    }
    set filters(v) {
        this.filtersValue = v;
        this.createFilterChips();
    }
    /** Filter Criteria Value */
    get criteria() {
        return this.criteriaValue;
    }
    set criteria(v) {
        if (!_isEqual(this.criteriaValue, v)) {
            // no need to publish the change event because the filterService.criteria change
            // subscribe from the init method will handle this scenario
            this.filtersService.setCriteria((this.criteriaValue = v));
        }
    }
    get applyFilterStrategy() {
        return this.filtersService.applyFilterStrategy;
    }
    set applyFilterStrategy(config) {
        this.filtersService.applyFilterStrategy = config;
    }
    get id() {
        return this.filtersService.id;
    }
    set id(value) {
        this.filtersService.id = value;
    }
    /**
     *  The reset button should restore all filter values back to the previous saved values in the view.
     */
    get enableFilterReset() {
        return this.enableFilterResetValue;
    }
    set enableFilterReset(value) {
        this.enableFilterResetValue = coerceBooleanProperty(value);
    }
    ngOnInit() {
        super.ngOnInit();
        this.filtersService.criteria$.pipe(distinctUntilChanged(), takeUntil(this.componentDestroyed$)).subscribe((c) => {
            // global filters should be applied only on click not on each change
            if (this.applyFilterStrategy !== 'global') {
                this.applyCriteriaChange(c);
            }
        });
        if (this.boardApiDispatcherService) {
            this.boardApiDispatcherService.registerHandler(XpoBoardApiAction.ApplyFiltersCriteria, (criteria) => {
                this.criteria = criteria;
            });
            this.boardApiDispatcherService.registerHandler(XpoBoardApiAction.ApplyFilterCriterion, (field, criterion) => {
                this.filtersService.setFieldCriteria(field, criterion);
            });
        }
    }
    onApplyClicked() {
        this.filtersService.apply();
        this.applyCriteriaChange(this.filtersService.criteria);
    }
    /**
     * Triggered when reset button is clicked
     */
    onResetClicked() {
        const initialCriteria = this.initialCriteriaList[this.currentViewId];
        this.filtersService.reset(initialCriteria);
        // Make sure we reset on click even for global which doesn't get applied from the change subscription
        if (this.applyFilterStrategy === 'global') {
            this.applyCriteriaChange(initialCriteria);
        }
    }
    onStateChange(state) {
        // Update filer list when view changes
        if (state.changes.includes('availableViews') || state.changes.includes('viewId')) {
            const activeView = XpoBoardViewUtil.findActiveView(state);
            this.filters = activeView.visibleFilters;
        }
        if (!_isEqual(this.previousCriteria, state.criteria)) {
            this.previousCriteria = state.criteria;
            this.filtersService.setCriteria(state.criteria, this.filters);
        }
        // save the initial criteria if view changes
        if (this.currentViewId !== state.viewId) {
            this.currentViewId = state.viewId;
            // Save the initial criteria only the first time we activate the view
            if (!this.initialCriteriaList.hasOwnProperty(this.currentViewId)) {
                this.initialCriteriaList[this.currentViewId] = state.criteria;
            }
        }
    }
    /** Apply the filter criteria on the state*/
    applyCriteriaChange(criteria) {
        if (!_isEqual(this.criteriaValue, criteria)) {
            this.stateChange$.next({
                criteria: criteria,
                pageNumber: 1,
                source: XpoBoardStateSources.FilterChange,
            });
            this.criteriaChange.next(criteria);
        }
        this.criteriaValue = criteria;
    }
    /** Generates the child filter components. */
    createFilterChips() {
        // Remove anything thats in the filter container
        this.host.viewContainerRef.clear();
        if (!this.filters) {
            return;
        }
        this.filters.filter(Boolean).forEach((filter_) => {
            // check whether or no the filter renders inline
            if (filter_ instanceof XpoInlineFilter) {
                this.createInlineFilter(filter_);
            }
            else {
                this.createFilter(filter_);
            }
            this.changeDetectorRef.markForCheck();
        });
    }
    /**
     * Create Inline filter
     */
    createInlineFilter(filterModel) {
        // create the filter component
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(filterModel.filterComponentType);
        // Attach it to the container
        const componentRef = this.host.viewContainerRef.createComponent(componentFactory);
        // Get the component instance
        const component = componentRef.instance;
        // Assign data to the component
        component.configuration = filterModel;
        component.field = filterModel.field;
        component.filtersService = this.filtersService;
    }
    /**
     * Creates filter with filter chip
     */
    createFilter(filterModel) {
        // Create Filter Chip
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(XpoFilterChip);
        // Attach it to the container
        const componentRef = this.host.viewContainerRef.createComponent(componentFactory);
        // Get the component instance of the newc
        const component = componentRef.instance;
        // Assign filter to filter chip
        component.filter = filterModel;
        component.criteriaStore = this.filtersService;
    }
}
XpoFilterBar.ɵfac = function XpoFilterBar_Factory(t) { return new (t || XpoFilterBar)(i0.ɵɵdirectiveInject(XpoFiltersService), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver, 8), i0.ɵɵdirectiveInject(XpoBoardApiDispatcherService, 8)); };
XpoFilterBar.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFilterBar, selectors: [["xpo-filter-bar"]], viewQuery: function XpoFilterBar_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(XpoFilterHost, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.host = _t.first);
    } }, hostAttrs: [1, "xpo-FilterBar"], hostVars: 1, hostBindings: function XpoFilterBar_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, inputs: { filters: "filters", criteria: "criteria", applyFilterStrategy: "applyFilterStrategy", id: "id", enableFilterReset: "enableFilterReset" }, outputs: { criteriaChange: "criteriaChange" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: XpoFiltersService,
                useFactory: filtersServiceFactory,
                deps: [[new SkipSelf(), new Optional(), XpoFiltersService]],
            },
        ]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$n, decls: 4, vars: 1, consts: [["xpo-filter-host", ""], [1, "xpo-FilterBar-content"], [4, "ngIf"], ["id", "xpo-ApplyGlobalFilterButton", "mat-flat-button", "", "xpo-small-button", "", "color", "primary", 3, "click", 4, "ngIf"], ["id", "xpo-ResetGlobalFilterButton", "mat-button", "", "xpo-small-button", "", "color", "primary", 3, "click", 4, "ngIf"], ["id", "xpo-ApplyGlobalFilterButton", "mat-flat-button", "", "xpo-small-button", "", "color", "primary", 3, "click"], ["id", "xpo-ResetGlobalFilterButton", "mat-button", "", "xpo-small-button", "", "color", "primary", 3, "click"]], template: function XpoFilterBar_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, XpoFilterBar_ng_template_0_Template, 0, 0, "ng-template", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, XpoFilterBar_ng_container_2_Template, 3, 2, "ng-container", 2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.filters && ctx.filters.length);
    } }, directives: [XpoFilterHost, i2.NgIf, i3$1.MatButton, i2$1.XpoSmallButton], styles: [".flex--stretch{flex:1}.xpo-GlobalFilterBar{background-color:#fbfbfb;border-bottom:1px solid #d8d8d8;display:flex;flex-shrink:0;height:64px;justify-content:flex-start;overflow:visible;position:relative;z-index:1}.xpo-GlobalFilterBar .xpo-FilterChip{height:64px;margin:unset}.xpo-GlobalFilterBar .xpo-FilterChip-dropdownTrigger{border:unset;border-right:1px solid #d8d8d8;padding:8px 0}.xpo-GlobalFilterBar .xpo-FilterChip-labelWrapper{align-items:center;display:flex;flex-direction:column;margin-left:24px}.xpo-GlobalFilterBar .xpo-FilterChip-labelPrefix{font-size:.875rem;margin-right:unset}.xpo-GlobalFilterBar .xpo-FilterChip-labelPrefix:after{content:unset}.xpo-GlobalFilterBar .xpo-FilterChip-labelSelected{font-size:1.5rem;font-weight:500}.xpo-GlobalFilterBar .xpo-FilterChip-dropdownIcon{margin-left:24px;margin-right:8px}.xpo-FilterBar{align-items:center;display:flex;flex-wrap:wrap;width:100%}.xpo-FilterBar-content{align-items:center;display:flex;flex:1 1 auto;flex-direction:row;justify-content:space-between;margin-left:8px}.xpo-FilterBar-content .xpo-Board-actionsWrapper [mat-button].mat-button .mat-button-wrapper{align-items:center;display:flex;line-height:normal}.xpo-FilterBar-content .xpo-Board-actionsWrapper [mat-icon-button].mat-icon-button{line-height:normal}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterBar, [{
        type: Component,
        args: [{
                selector: 'xpo-filter-bar',
                templateUrl: 'filter-bar.component.html',
                styleUrls: ['filter-bar.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: XpoFiltersService,
                        useFactory: filtersServiceFactory,
                        deps: [[new SkipSelf(), new Optional(), XpoFiltersService]],
                    },
                ],
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-FilterBar', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: XpoFiltersService }, { type: i0.ComponentFactoryResolver }, { type: i0.ChangeDetectorRef }, { type: XpoBoardDataSourceResolver, decorators: [{
                type: Optional
            }] }, { type: XpoBoardApiDispatcherService, decorators: [{
                type: Optional
            }] }]; }, { host: [{
            type: ViewChild,
            args: [XpoFilterHost, { static: true }]
        }], filters: [{
            type: Input
        }], criteria: [{
            type: Input
        }], criteriaChange: [{
            type: Output
        }], applyFilterStrategy: [{
            type: Input
        }], id: [{
            type: Input
        }], enableFilterReset: [{
            type: Input
        }] }); })();

function XpoFilterForm_ng_template_0_Template(rf, ctx) { }
const _c0$m = ["*"];
class XpoFilterFormHost {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
XpoFilterFormHost.ɵfac = function XpoFilterFormHost_Factory(t) { return new (t || XpoFilterFormHost)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
XpoFilterFormHost.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoFilterFormHost, selectors: [["", "xpo-filter-form-host", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterFormHost, [{
        type: Directive,
        args: [{
                selector: '[xpo-filter-form-host]',
            }]
    }], function () { return [{ type: i0.ViewContainerRef }]; }, null); })();
class XpoFilterForm {
    constructor(componentFactoryResolver, filtersService, changeDetectorRef) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.filtersService = filtersService;
        this.changeDetectorRef = changeDetectorRef;
        this.componentDestroyed = new Subject();
        this.criteriaChange = new EventEmitter();
        this.inlineValue = false;
    }
    get criteria() {
        return this.criteriaValue;
    }
    set criteria(value) {
        if (this.criteriaValue !== value) {
            this.filtersService.setCriteria(value);
        }
    }
    /** Filters that will be generated */
    get filters() {
        return this.filtersValue;
    }
    set filters(v) {
        this.filtersValue = v;
        this.createFilterChips();
    }
    /**
     * If set to false will disable the default display layout
     * with 3 columns of filter chips and align start everything
     */
    get inline() {
        return this.inlineValue;
    }
    set inline(v) {
        this.inlineValue = coerceBooleanProperty(v);
    }
    ngOnDestroy() {
        this.componentDestroyed.next();
        this.componentDestroyed.complete();
    }
    ngOnInit() {
        this.filtersService.criteria$.pipe(takeUntil(this.componentDestroyed)).subscribe((c) => {
            this.criteriaValue = c;
            this.criteriaChange.emit(this.criteriaValue);
        });
    }
    /** Generates the child filter components. */
    createFilterChips() {
        // Remove anything thats in the filter container
        this.host.viewContainerRef.clear();
        if (!this.filters) {
            return;
        }
        this.filters.filter(Boolean).forEach((filter) => {
            // check whether or no the filter renders inline
            if (filter instanceof XpoInlineFilter) {
                this.createInlineFilter(filter);
            }
            else {
                this.createFilter(filter);
            }
            this.changeDetectorRef.markForCheck();
        });
    }
    /**
     * Create Inline filter
     */
    createInlineFilter(filter) {
        // create the filter component
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(filter.filterComponentType);
        // Attach it to the container
        const componentRef = this.host.viewContainerRef.createComponent(componentFactory);
        // Get the component instance
        const component = componentRef.instance;
        // Assign data to the component
        component.configuration = filter;
        component.field = filter.field;
        component.filtersService = this.filtersService;
    }
    /**
     * Creates filter with filter chip
     */
    createFilter(filter) {
        // Create Filter Chip
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(XpoFilterChip);
        // Attach it to the container
        const componentRef = this.host.viewContainerRef.createComponent(componentFactory);
        // Get the component instance of the newc
        const component = componentRef.instance;
        // Assign filter to filter chip
        component.filter = filter;
        component.criteriaStore = this.filtersService;
    }
}
XpoFilterForm.ɵfac = function XpoFilterForm_Factory(t) { return new (t || XpoFilterForm)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(XpoFiltersService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoFilterForm.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFilterForm, selectors: [["xpo-filter-form"]], viewQuery: function XpoFilterForm_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(XpoFilterFormHost, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.host = _t.first);
    } }, hostAttrs: [1, "xpo-FilterForm"], hostVars: 2, hostBindings: function XpoFilterForm_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("xpo-FilterForm--inline", ctx.inline);
    } }, inputs: { criteria: "criteria", filters: "filters", inline: "inline" }, outputs: { criteriaChange: "criteriaChange" }, features: [i0.ɵɵProvidersFeature([XpoFiltersService])], ngContentSelectors: _c0$m, decls: 2, vars: 0, consts: [["xpo-filter-form-host", ""]], template: function XpoFilterForm_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, XpoFilterForm_ng_template_0_Template, 0, 0, "ng-template", 0);
        i0.ɵɵprojection(1);
    } }, directives: [XpoFilterFormHost], styles: [".flex--stretch{flex:1}.xpo-FilterForm{display:flex;flex-direction:row;flex-wrap:wrap}.xpo-FilterForm:not(.xpo-FilterForm--inline)>.xpo-FilterChip{flex:1;flex-basis:calc(33% - (8px))}.xpo-FilterForm:not(.xpo-FilterForm--inline)>.xpo-FilterChip .xpo-TextInputFilter-formField{width:100%}.xpo-FilterForm:not(.xpo-FilterForm--inline)>.xpo-FilterChip .xpo-TextInputFilter-formField .mat-form-field-wrapper{line-height:1rem}.xpo-FilterForm:not(.xpo-FilterForm--inline)>.xpo-FilterChip .xpo-TextInputFilter-formField .mat-form-field-wrapper .xpo-TextInputFilter-input{padding:4px 8px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFilterForm, [{
        type: Component,
        args: [{
                selector: 'xpo-filter-form',
                templateUrl: 'filter-form.component.html',
                styleUrls: ['filter-form.component.scss'],
                providers: [XpoFiltersService],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-FilterForm' },
            }]
    }], function () { return [{ type: i0.ComponentFactoryResolver }, { type: XpoFiltersService }, { type: i0.ChangeDetectorRef }]; }, { host: [{
            type: ViewChild,
            args: [XpoFilterFormHost, { static: true }]
        }], criteria: [{
            type: Input
        }], criteriaChange: [{
            type: Output
        }], filters: [{
            type: Input
        }], inline: [{
            type: HostBinding,
            args: ['class.xpo-FilterForm--inline']
        }, {
            type: Input
        }] }); })();

function XpoInlineMultiSelectFilterComponent_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 2);
    i0.ɵɵlistener("change", function XpoInlineMultiSelectFilterComponent_mat_checkbox_1_Template_mat_checkbox_change_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r3); const opt_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.onCheckboxClicked($event, opt_r1.value); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r1 = ctx.$implicit;
    i0.ɵɵproperty("checked", opt_r1.checked);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", opt_r1.label, " ");
} }
class XpoInlineMultiSelectFilterComponent extends XpoFilterComponentBase {
    constructor() {
        super();
        this.options = [];
        this.optionsSource$ = new BehaviorSubject([]);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.optionsSource$.complete();
        this.optionsSource$ = undefined;
    }
    /** Updates the selected criterion of filter */
    onCheckboxClicked(el, selectedValue) {
        const itemIndex = this.options.findIndex((i) => i.value === selectedValue);
        this.options[itemIndex].checked = el.checked;
        // publish the values for any selected options
        const value = this.options.filter((opt) => opt.checked).map((opt) => opt.value);
        this.storeCriteria(value);
    }
    initialize() {
        const config = this.configuration;
        this.options = config.options.map((o) => {
            return {
                checked: false,
                label: o[config.labelField],
                value: o[config.valueField],
            };
        });
        this.optionsSource$.next(this.options);
    }
    onCriteriaModified(fieldValue, criteria) {
        const val = fieldValue || new Array();
        // check off the appropriate checkboxes
        this.options.forEach((opt) => {
            opt.checked = val.indexOf(opt.value) !== -1;
        });
        this.optionsSource$.next(this.options);
    }
}
XpoInlineMultiSelectFilterComponent.ɵfac = function XpoInlineMultiSelectFilterComponent_Factory(t) { return new (t || XpoInlineMultiSelectFilterComponent)(); };
XpoInlineMultiSelectFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoInlineMultiSelectFilterComponent, selectors: [["xpo-inline-multi-select-filter"]], hostAttrs: [1, "xpo-InlineMultiSelectFilter"], hostVars: 1, hostBindings: function XpoInlineMultiSelectFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[1, "xpo-InlineMultiSelectFilter-options"], ["labelPosition", "right", "class", "xpo-InlineMultiSelectFilter", 3, "checked", "change", 4, "ngFor", "ngForOf"], ["labelPosition", "right", 1, "xpo-InlineMultiSelectFilter", 3, "checked", "change"]], template: function XpoInlineMultiSelectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, XpoInlineMultiSelectFilterComponent_mat_checkbox_1_Template, 2, 2, "mat-checkbox", 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx.optionsSource$));
    } }, directives: [i2.NgForOf, i1.MatCheckbox], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-InlineMultiSelectFilter{cursor:pointer;display:inline-block;flex-wrap:wrap;font-size:.875rem;height:24px;margin:8px 0 8px 8px}.xpo-InlineMultiSelectFilter-options{border-left:1px solid #d8d8d8;display:flex;flex-direction:row;margin-right:4px;padding-right:4px}.xpo-InlineMultiSelectFilter-options .mat-checkbox{margin:0;padding-left:8px}xpo-inline-multi-select-filter:last-of-type{border-right:1px solid #d8d8d8}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoInlineMultiSelectFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-inline-multi-select-filter',
                templateUrl: 'inline-multi-select-filter.component.html',
                styleUrls: ['inline-multi-select-filter.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-InlineMultiSelectFilter', '[attr.id]': 'id' },
            }]
    }], function () { return []; }, null); })();

class XpoInlineMultiSelectFilter extends XpoInlineFilter {
    constructor(field, label, options) {
        super(field, label, XpoInlineMultiSelectFilterComponent);
        /**
         * Controls what field on the options array is used for the display. Defaults to title
         */
        this.labelField = 'title';
        /**
         * Controls the max number of number of characters to have in the displayValue. Defaults to 30
         */
        this.maxDisplayValueCharLength = 30;
        /**
         * Controls what field on the options array is used for filter value. Defaults to code
         */
        this.valueField = 'code';
        if (options instanceof Array) {
            this.options = options || [];
        }
        else if (options instanceof Observable) {
            this.options = [];
            options.pipe(take(1)).subscribe((opt) => (this.options = opt || []));
        }
        else if (options instanceof Promise) {
            this.options = [];
            options.then((opt) => (this.options = opt || []));
        }
        else {
            this.options = options();
        }
    }
    getDisplayValue(val) {
        return val;
    }
}

const _c0$l = ["searchBox"];
function XpoMultiSelectAutocompleteFilterComponent_ng_container_8_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 10);
    i0.ɵɵlistener("change", function XpoMultiSelectAutocompleteFilterComponent_ng_container_8_mat_checkbox_1_Template_mat_checkbox_change_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r7); const opt_r5 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.onCheckboxClicked($event, opt_r5[ctx_r6.config.valueField]); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", opt_r5.checked);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", opt_r5[ctx_r4.config.labelField], " ");
} }
function XpoMultiSelectAutocompleteFilterComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoMultiSelectAutocompleteFilterComponent_ng_container_8_mat_checkbox_1_Template, 2, 2, "mat-checkbox", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
} }
function XpoMultiSelectAutocompleteFilterComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "xpo-responsive-loading-spinner");
} }
class XpoMultiSelectAutocompleteFilterComponent extends XpoFilterComponentBase {
    constructor(changeDetectorRef) {
        super();
        this.changeDetectorRef = changeDetectorRef;
        this.loadingData = true;
        this.options = [];
        this.originalOptions = [];
        this.pendingOptions = [];
        this.initializing = true;
    }
    /** Updates the selected criterion of filter */
    onCheckboxClicked(el, selectedValue) {
        const selectedOptions = [...this.config.selectedOptions];
        const selectedItemIndex = selectedOptions.findIndex((i) => i[this.config.valueField] === selectedValue);
        const itemIndex = this.options.findIndex((i) => i[this.config.valueField] === selectedValue);
        this.options[itemIndex].checked = el.checked;
        if (el.checked) {
            selectedOptions.push(this.options[itemIndex]);
        }
        else if (selectedItemIndex !== -1) {
            selectedOptions.splice(selectedItemIndex, 1);
        }
        this.config.setSelectedOptions(selectedOptions);
        // publish the values for any selected options
        this.updateFieldCriteria();
    }
    onInputChange(value) {
        this.loadingData = true;
        this.searchOptions(value);
    }
    onOptionRemove(removedValue) {
        const selectedOptions = [...this.config.selectedOptions];
        const selectedItemIndex = selectedOptions.findIndex((i) => i[this.config.valueField] === removedValue);
        if (this.options[selectedItemIndex]) {
            this.options[selectedItemIndex].checked = false;
        }
        selectedOptions.splice(selectedItemIndex, 1);
        this.config.setSelectedOptions(selectedOptions);
        // publish the values for any selected options
        this.updateFieldCriteria();
    }
    initialize() {
        this.config = this.configuration;
        this.options = [];
        this.searchOptions('');
    }
    onCriteriaModified(fieldValue, criteria) {
        const val = fieldValue || new Array();
        // check off the appropriate checkboxes
        const selectedOptions = [];
        this.originalOptions.forEach((opt) => {
            opt.checked = val.indexOf(opt[this.config.valueField]) !== -1;
            if (opt.checked) {
                selectedOptions.push(opt);
            }
        });
        this.config.setSelectedOptions(selectedOptions);
        /**
         * store fieldValue if there are no option list yet (when onCriteriaModified called by the
         * board before searchOptions is fired)
         */
        if (!this.originalOptions.length) {
            this.pendingOptions = this.pendingOptions.concat(fieldValue);
        }
    }
    searchOptions(searchValue) {
        this.config
            .optionsResolver$(searchValue)
            .pipe(map((options) => {
            const values = options.map((o) => ({
                checked: this.isOptionInSelectedOptions(o) || this.isOptionInPendingOptions(o),
                [this.config.labelField]: o[this.config.labelField],
                [this.config.valueField]: o[this.config.valueField],
            }));
            return values;
        }), finalize(() => {
            this.resetFocusAndLoading();
        }), take(1))
            .subscribe((options) => {
            if (this.initializing) {
                this.originalOptions = options;
            }
            this.options = options || [];
            this.initializing = false;
            if (this.pendingOptions.length) {
                this.pendingOptions = [];
                this.config.setSelectedOptions(this.options.filter((o) => o.checked));
            }
        });
    }
    isOptionInPendingOptions(option) {
        return this.pendingOptions.some((po) => po === option[this.config.valueField]);
    }
    isOptionInSelectedOptions(option) {
        return this.config.selectedOptions.some((s) => s[this.config.valueField] === option[this.config.valueField]);
    }
    resetFocusAndLoading() {
        this.loadingData = false;
        this.searchBox.nativeElement.focus();
        this.changeDetectorRef.markForCheck();
    }
    updateFieldCriteria() {
        // publish the values for any selected options
        const value = this.config.selectedOptions.map((opt) => opt[this.config.valueField]);
        this.filtersService.setFieldCriteria(this.field, value);
    }
}
XpoMultiSelectAutocompleteFilterComponent.ɵfac = function XpoMultiSelectAutocompleteFilterComponent_Factory(t) { return new (t || XpoMultiSelectAutocompleteFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoMultiSelectAutocompleteFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoMultiSelectAutocompleteFilterComponent, selectors: [["xpo-multi-select-autocomplete-filter"]], viewQuery: function XpoMultiSelectAutocompleteFilterComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$l, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchBox = _t.first);
    } }, hostAttrs: [1, "xpo-MultiSelectAutocompleteFilter"], hostVars: 1, hostBindings: function XpoMultiSelectAutocompleteFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 12, vars: 4, consts: [[1, "xpo-MultiSelectAutocompleteFilter-options"], ["floatLabel", "never", 1, "xpo-MultiSelectAutocompleteFilter-options-input"], ["autocomplete", "off", "matInput", "", "type", "text", "placeholder", "Search", 3, "ngModel", "ngModelChange"], ["searchBox", ""], ["matSuffix", ""], [1, "xpo-FilterContainer-optionsContainer"], [4, "ngIf", "ngIfElse"], ["loading", ""], [3, "config", "optionRemoved"], ["class", "xpo-FilterContainer-option", "labelPosition", "right", 3, "checked", "change", 4, "ngFor", "ngForOf"], ["labelPosition", "right", 1, "xpo-FilterContainer-option", 3, "checked", "change"]], template: function XpoMultiSelectAutocompleteFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-filter-container");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "mat-form-field", 1);
        i0.ɵɵelementStart(3, "input", 2, 3);
        i0.ɵɵlistener("ngModelChange", function XpoMultiSelectAutocompleteFilterComponent_Template_input_ngModelChange_3_listener($event) { return ctx.search = $event; })("ngModelChange", function XpoMultiSelectAutocompleteFilterComponent_Template_input_ngModelChange_3_listener($event) { return ctx.onInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "mat-icon", 4);
        i0.ɵɵtext(6, "search");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, XpoMultiSelectAutocompleteFilterComponent_ng_container_8_Template, 2, 1, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, XpoMultiSelectAutocompleteFilterComponent_ng_template_9_Template, 1, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "xpo-multi-select-autocomplete-filter-selected-options", 8);
        i0.ɵɵlistener("optionRemoved", function XpoMultiSelectAutocompleteFilterComponent_Template_xpo_multi_select_autocomplete_filter_selected_options_optionRemoved_11_listener($event) { return ctx.onOptionRemove($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(10);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.search);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.loadingData)("ngIfElse", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("config", ctx.config);
    } }, styles: [".flex--stretch{flex:1}.xpo-MultiSelectAutocompleteFilter{display:flex}.xpo-MultiSelectAutocompleteFilter .xpo-FilterContainer-content{flex-direction:row;width:450px}.xpo-MultiSelectAutocompleteFilter-options{border-right:1px solid #d8d8d8;display:flex;flex:1 1 100%;flex-direction:column}.xpo-MultiSelectAutocompleteFilter-options-input.mat-form-field{margin:0 8px}.xpo-MultiSelectAutocompleteFilter-options-input.mat-form-field .mat-icon{font-size:1.143rem;margin:0 0 0 8px}.xpo-MultiSelectAutocompleteFilter-options-input.mat-form-field .mat-form-field-wrapper{margin-top:8px}.xpo-MultiSelectAutocompleteFilter .xpo-MultiSelectAutocompleteFilterSelectedOptions{flex:1 1 100%}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoMultiSelectAutocompleteFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-multi-select-autocomplete-filter',
                templateUrl: 'multi-select-autocomplete-filter.component.html',
                styleUrls: ['multi-select-autocomplete-filter.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-MultiSelectAutocompleteFilter', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { searchBox: [{
            type: ViewChild,
            args: ['searchBox', { static: true }]
        }] }); })();

class XpoMultiSelectAutocompleteFilter extends XpoFilter {
    constructor(field, label, optionsResolver$, _disabled$) {
        super(field, label, XpoMultiSelectAutocompleteFilterComponent);
        /**
         * Controls what field on the options array is used for the display. Defaults to title
         */
        this.labelField = 'title';
        /**
         * Controls what field on the options array is used for filter value. Defaults to code
         */
        this.valueField = 'code';
        /**
         * Controls the max number of characters to have in the displayValue. Defaults to 30
         */
        this.maxDisplayValueCharLength = 30;
        this.selectedOptionsSource$ = new BehaviorSubject([]);
        this.optionsResolver$ = optionsResolver$;
        this.disabled$ = _disabled$;
    }
    get selectedOptions() {
        return this.selectedOptionsSource$.value;
    }
    get selectedOptions$() {
        return this.selectedOptionsSource$.asObservable();
    }
    setSelectedOptions(v) {
        this.selectedOptionsSource$.next(v);
    }
    getDisplayValue(val) {
        if (!val || !val.length) {
            return 'Any';
        }
        const displayValue = this.selectedOptions
            .filter((opt) => val.indexOf(opt[this.valueField]) !== -1)
            .map((opt) => opt[this.labelField])
            .join(', ');
        return displayValue.length > this.maxDisplayValueCharLength
            ? displayValue.substr(0, this.maxDisplayValueCharLength - 1) + '...'
            : displayValue;
    }
}

function XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent_mat_chip_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 3);
    i0.ɵɵlistener("removed", function XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent_mat_chip_6_Template_mat_chip_removed_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.removeOption($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 4);
    i0.ɵɵtext(3, "clear");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", option_r1[ctx_r0.config.valueField]);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r1[ctx_r0.config.labelField], " ");
} }
class XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent {
    constructor() {
        this.optionRemoved = new EventEmitter();
    }
    removeOption(option) {
        this.optionRemoved.emit(option.chip.value);
    }
    ngOnInit() {
        this.selectedOptions$ = this.config.selectedOptions$;
    }
}
XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent.ɵfac = function XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent_Factory(t) { return new (t || XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent)(); };
XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent, selectors: [["xpo-multi-select-autocomplete-filter-selected-options"]], hostAttrs: [1, "xpo-MultiSelectAutocompleteFilterSelectedOptions"], inputs: { config: "config" }, outputs: { optionRemoved: "optionRemoved" }, decls: 8, vars: 6, consts: [[1, "xpo-MultiSelectAutocompleteFilterSelectedOptions-header"], [1, "xpo-FilterContainer-optionsContainer"], ["removable", "true", "color", "primary", 3, "value", "removed", 4, "ngFor", "ngForOf"], ["removable", "true", "color", "primary", 3, "value", "removed"], ["matChipRemove", ""]], template: function XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h3", 0);
        i0.ɵɵtext(1, " Selected Items ");
        i0.ɵɵelementStart(2, "mat-chip");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "mat-chip-list", 1);
        i0.ɵɵtemplate(6, XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent_mat_chip_6_Template, 4, 2, "mat-chip", 2);
        i0.ɵɵpipe(7, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, ctx.selectedOptions$).length);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(7, 4, ctx.selectedOptions$));
    } }, directives: [i1$4.MatChip, i1$4.MatChipList, i2.NgForOf, i3.MatIcon, i1$4.MatChipRemove], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-MultiSelectAutocompleteFilterSelectedOptions{display:flex;flex-direction:column}.xpo-MultiSelectAutocompleteFilterSelectedOptions-header{height:57px;line-height:57px;margin:0 8px}.xpo-MultiSelectAutocompleteFilterSelectedOptions .mat-chip-list-wrapper{margin:0;padding:0 8px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-multi-select-autocomplete-filter-selected-options',
                templateUrl: './multi-select-autocomplete-filter-selected-options.component.html',
                styleUrls: ['./multi-select-autocomplete-filter-selected-options.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-MultiSelectAutocompleteFilterSelectedOptions' },
            }]
    }], null, { config: [{
            type: Input
        }], optionRemoved: [{
            type: Output
        }] }); })();

function XpoQuickSearchFilterComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function XpoQuickSearchFilterComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.expandSearchField(); });
    i0.ɵɵelementStart(1, "mat-icon", 3);
    i0.ɵɵtext(2, "search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoQuickSearchFilterComponent_ng_template_1_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function XpoQuickSearchFilterComponent_ng_template_1_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.clearInput(); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "clear");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoQuickSearchFilterComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 4);
    i0.ɵɵelementStart(1, "button", 5);
    i0.ɵɵlistener("click", function XpoQuickSearchFilterComponent_ng_template_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.emitValue(ctx_r8.searchFormControl.value); });
    i0.ɵɵelementStart(2, "mat-icon", 3);
    i0.ɵɵtext(3, "search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 6);
    i0.ɵɵlistener("blur", function XpoQuickSearchFilterComponent_ng_template_1_Template_input_blur_4_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.collapseSearchField(ctx_r10.searchFormControl.value); })("keyup.enter", function XpoQuickSearchFilterComponent_ng_template_1_Template_input_keyup_enter_4_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.emitValue(ctx_r11.searchFormControl.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, XpoQuickSearchFilterComponent_ng_template_1_button_5_Template, 3, 0, "button", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("xpoAutofocus", !ctx_r2.disableAutofocus)("placeholder", ctx_r2.placeholderText)("formControl", ctx_r2.searchFormControl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r2.searchFormControl.value == null ? null : ctx_r2.searchFormControl.value.length) > 0);
} }
class XpoQuickSearchFilterComponent extends XpoFilterComponentBase {
    constructor() {
        super();
        this.collapsible = false;
        this.collapsed = false;
        this.disableAutofocus = false;
        this.placeholderText = 'Search';
        this.searchFormControl = new FormControl();
        this.inline = true;
        this.searchFormControl.valueChanges
            .pipe(debounceTime(XpoQuickSearchFilterComponent.InputValueChangeDebounceTime), distinctUntilChanged(), takeUntil(this.componentDestroyed))
            .subscribe((v) => {
            this.emitValue(v);
        });
    }
    /**
     * Clears inputs and sets focus back to input
     */
    clearInput() {
        this.searchFormControl.setValue(null);
    }
    /**
     * Emits quicksearch value change
     */
    emitValue(value) {
        this.storeCriteria(value ? value.toString() : null);
    }
    /**
     * expands search field
     */
    expandSearchField() {
        this.collapsed = false;
    }
    /**
     * collapses search field on blur if input field is blank
     */
    collapseSearchField(val) {
        this.collapsed = this.collapsible && !val && true;
    }
    initialize() {
        const config = this.configuration;
        this.collapsible = config.collapsible;
        this.collapsed = this.collapsible;
        this.disableAutofocus = config.disableAutofocus;
        this.placeholderText = config.placeholderText;
    }
    onCriteriaModified(fieldValue, criteria) {
        this.searchFormControl.setValue(fieldValue ? fieldValue.toString() : null, { emitEvent: false });
    }
}
XpoQuickSearchFilterComponent.InputValueChangeDebounceTime = 500;
XpoQuickSearchFilterComponent.ɵfac = function XpoQuickSearchFilterComponent_Factory(t) { return new (t || XpoQuickSearchFilterComponent)(); };
XpoQuickSearchFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoQuickSearchFilterComponent, selectors: [["xpo-quick-search-filter"]], hostAttrs: [1, "xpo-QuickSearchFilter"], hostVars: 1, hostBindings: function XpoQuickSearchFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["mat-icon-button", "", "class", "xpo-QuickSearchFilter-searchButton", "color", "primary", 3, "click", 4, "ngIf", "ngIfElse"], ["searchField", ""], ["mat-icon-button", "", "color", "primary", 1, "xpo-QuickSearchFilter-searchButton", 3, "click"], [1, "xpo-QuickSearchFilter-searchButton-icon"], ["floatLabel", "never", 1, "xpo-QuickSearchFilter-formField", "ngx-FormField--borderless", "ngx-FormField--inline"], ["mat-icon-button", "", "matPrefix", "", "color", "primary", 1, "xpo-QuickSearchFilter-searchButton", 3, "click"], ["autocomplete", "off", "matInput", "", "type", "text", 1, "xpo-QuickSearchFilter-input", 3, "xpoAutofocus", "placeholder", "formControl", "blur", "keyup.enter"], ["mat-icon-button", "", "matSuffix", "", "class", "xpo-QuickSearchFilter-clearButton", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "matSuffix", "", 1, "xpo-QuickSearchFilter-clearButton", 3, "click"]], template: function XpoQuickSearchFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, XpoQuickSearchFilterComponent_button_0_Template, 3, 0, "button", 0);
        i0.ɵɵtemplate(1, XpoQuickSearchFilterComponent_ng_template_1_Template, 6, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.collapsed)("ngIfElse", _r1);
    } }, directives: [i2.NgIf, i3$1.MatButton, i3.MatIcon, i4.MatFormField, i4.MatPrefix, i5.MatInput, i1$1.DefaultValueAccessor, i7.XpoAutofocusDirective, i1$1.NgControlStatus, i1$1.FormControlDirective, i4.MatSuffix], styles: [".flex--stretch{flex:1}.xpo-QuickSearchFilter{align-items:center;border-right:1px solid #d8d8d8;display:flex;flex-direction:row;height:24px;padding-left:8px}.xpo-QuickSearchFilter-formField .xpo-QuickSearchFilter-searchButton{margin-left:5px}.xpo-QuickSearchFilter-searchButton{margin-right:4px;margin-top:-3px}.xpo-QuickSearchFilter-searchButton-icon{font-size:1.5rem!important}.xpo-QuickSearchFilter-formField{line-height:24px;padding-right:8px;width:180px}.xpo-QuickSearchFilter-formField.mat-form-field-type-mat-input{margin:8px 0}.xpo-QuickSearchFilter-formField .mat-form-field-infix{border-top:0}.xpo-QuickSearchFilter-formField .mat-form-field-underline{display:none}.xpo-QuickSearchFilter-formField .mat-form-field-wrapper{padding-bottom:0}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoQuickSearchFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-quick-search-filter',
                templateUrl: 'quick-search-filter.component.html',
                styleUrls: ['quick-search-filter.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-QuickSearchFilter', '[attr.id]': 'id' },
            }]
    }], function () { return []; }, null); })();

class XpoQuickSearchFilter extends XpoInlineFilter {
    constructor(field, config = {}) {
        super(field, null, XpoQuickSearchFilterComponent);
        this.field = field;
        this.collapsible = config ? !!config.collapsible : false;
        this.disableAutofocus = config ? !!config.disableAutofocus : false;
        this.placeholderText = config && config.placeholderText ? config.placeholderText : 'Search';
    }
    getDisplayValue(val) {
        return val;
    }
}

class XpoSelectFilterComponent extends XpoFilterComponentBase {
    constructor() {
        super();
    }
    optionsSelected(fieldValues) {
        this.selection = fieldValues;
        this.storeCriteria(fieldValues);
    }
    initialize() { }
    onCriteriaModified(fieldValue, criteria) {
        this.selection = fieldValue;
    }
}
XpoSelectFilterComponent.ɵfac = function XpoSelectFilterComponent_Factory(t) { return new (t || XpoSelectFilterComponent)(); };
XpoSelectFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoSelectFilterComponent, selectors: [["xpo-select-filter"]], hostAttrs: [1, "xpo-SelectFilter"], hostVars: 1, hostBindings: function XpoSelectFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 6, consts: [[3, "isSingleSelect", "showSelectAll", "options", "selection", "selectionChange"]], template: function XpoSelectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-filter-container");
        i0.ɵɵelementStart(1, "xpo-advanced-select-panel", 0);
        i0.ɵɵlistener("selectionChange", function XpoSelectFilterComponent_Template_xpo_advanced_select_panel_selectionChange_1_listener($event) { return ctx.optionsSelected($event); });
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("isSingleSelect", ctx.configuration.isSingleSelect)("showSelectAll", ctx.configuration.enableSelectAll)("options", i0.ɵɵpipeBind1(2, 4, ctx.configuration.options$))("selection", ctx.selection);
    } }, directives: [XpoFilterContainer, XpoAdvancedSelectPanelComponent], pipes: [i2.AsyncPipe], styles: [""], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSelectFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-select-filter',
                templateUrl: 'select-filter.component.html',
                styleUrls: ['select-filter.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-SelectFilter', '[attr.id]': 'id' },
            }]
    }], function () { return []; }, null); })();

class XpoSelectFilter extends XpoFilter {
    constructor(params) {
        super(params.field, params.label, XpoSelectFilterComponent);
        /**
         * Controls what field on the options array is used for the display. Defaults to title
         */
        this.labelField = 'title';
        /**
         * Controls the max number of number of characters to have in the displayValue. Defaults to 30
         */
        this.maxDisplayValueCharLength = 30;
        /**
         * Controls what field on the options array is used for filter value. Defaults to code
         */
        this.valueField = 'code';
        /**
         * Controls what field on the options array is used for children value. Defaults to children
         */
        this.childrenField = 'children';
        /** Whether or not only a single option can be selected */
        this.isSingleSelect = false;
        /** Whether or not the select all checkbox is shown */
        this.enableSelectAll = false;
        this.disabled$ = params.disabled$;
        this.isSingleSelect = !!params.isSingleSelect;
        this.enableSelectAll = !!params.enableSelectAll;
        const options = params.options;
        let mappedOptions$;
        if (options instanceof Array) {
            mappedOptions$ = of(this.normalizeOptions(options || []));
        }
        else if (options instanceof Observable) {
            mappedOptions$ = options.pipe(map((opt) => this.normalizeOptions(opt || [])));
        }
        else if (options instanceof Promise) {
            mappedOptions$ = from(options).pipe(map((opt) => this.normalizeOptions(opt || [])));
        }
        else {
            mappedOptions$ = of(this.normalizeOptions(options()));
        }
        this.options$ = mappedOptions$.pipe(shareReplay());
        this.flatOptions$ = this.options$.pipe(map(XpoSelectFilter.flattenOptions), shareReplay());
    }
    static flattenOptions(options) {
        const flatResult = options.reduce((acc, option) => {
            let concatVal = option;
            if (option.children) {
                concatVal = XpoSelectFilter.flattenOptions(option.children);
            }
            return acc.concat(concatVal);
        }, []);
        return flatResult;
    }
    getDisplayValue(val) {
        return combineLatest([this.options$, this.flatOptions$]).pipe(map(([options, flatOptions]) => {
            if (!options || !val || (!this.isSingleSelect && (!val.length || val.length === flatOptions.length))) {
                return 'Any';
            }
            let displayValue = '';
            if (this.isSingleSelect) {
                const targetOption = options.find((opt) => opt.value === val);
                displayValue = targetOption ? targetOption.label : 'Any';
            }
            else if (val === null || val === void 0 ? void 0 : val.some) {
                const checkedOptions = flatOptions.filter((opt) => val.some((v) => v === opt.value));
                displayValue = checkedOptions.map((opt) => opt.label).join(', ');
            }
            else {
                displayValue = val;
            }
            return displayValue.length > this.maxDisplayValueCharLength
                ? displayValue.substr(0, this.maxDisplayValueCharLength - 1) + '...'
                : displayValue;
        }));
    }
    normalizeOptions(options) {
        return options.map((o) => {
            return {
                label: o[this.labelField],
                value: o[this.valueField],
                children: o[this.childrenField] && o[this.childrenField].length ? this.normalizeOptions(o[this.childrenField]) : null,
            };
        });
    }
}

class XpoMultiSelectFilter extends XpoSelectFilter {
    constructor(field, label, options) {
        super({ field, label, options });
        console.warn('WARN: `XpoMultiSelectFilter` is deprecated, use `XpoSelectFilter` instead');
    }
}

class XpoSingleSelectFilter extends XpoSelectFilter {
    constructor(field, label, options) {
        super({ field, label, options, isSingleSelect: true });
        console.warn('WARN: `XpoSingleSelectFilter` is deprecated, use `XpoSelectFilter` instead');
    }
}

const _c0$k = ["textInput"];
class XpoTextInputFilterComponent extends XpoFilterComponentBase {
    constructor(cdr) {
        super();
        this.cdr = cdr;
        this.searchFormControl = new FormControl();
        this.inline = true;
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.textInput.nativeElement.focus();
        this.cdr.detectChanges();
    }
    storeCriteriaIfValid(value) {
        if (this.searchFormControl.valid) {
            this.storeCriteria(value);
        }
    }
    /**
     * Clears inputs and sets focus back to input
     */
    clearInput() {
        this.searchFormControl.setValue('');
    }
    initialize() {
        this.initValidators();
        this.searchFormControl.valueChanges
            .pipe(debounceTime(this.configuration.inputDebounceTime), distinctUntilChanged(), takeUntil(this.componentDestroyed))
            .subscribe((v) => {
            this.storeCriteriaIfValid(v);
        });
    }
    /**
     * Initializes validators
     */
    initValidators() {
        const validators = this.configuration.validators;
        if (validators && validators.length) {
            this.searchFormControl.setValidators(validators);
            this.searchFormControl.updateValueAndValidity({ emitEvent: false });
        }
    }
    onCriteriaModified(fieldValue, criteria) {
        this.searchFormControl.setValue(fieldValue ? fieldValue.toString() : '', { emitEvent: false });
    }
}
XpoTextInputFilterComponent.ɵfac = function XpoTextInputFilterComponent_Factory(t) { return new (t || XpoTextInputFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoTextInputFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoTextInputFilterComponent, selectors: [["xpo-text-input-filter"]], viewQuery: function XpoTextInputFilterComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$k, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textInput = _t.first);
    } }, hostAttrs: [1, "xpo-TextInputFilter", "xpo-FilterChip"], hostVars: 1, hostBindings: function XpoTextInputFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [["floatLabel", "never", 1, "xpo-TextInputFilter-formField", "ngx-FormField--inline"], ["autocomplete", "off", "matInput", "", "type", "text", 1, "xpo-TextInputFilter-input", 3, "errorStateMatcher", "title", "placeholder", "formControl", "keyup.enter"], ["textInput", ""]], template: function XpoTextInputFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-form-field", 0);
        i0.ɵɵelementStart(1, "input", 1, 2);
        i0.ɵɵlistener("keyup.enter", function XpoTextInputFilterComponent_Template_input_keyup_enter_1_listener() { return ctx.storeCriteriaIfValid(ctx.searchFormControl.value); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("errorStateMatcher", ctx.configuration.matcher)("title", ctx.configuration.title)("placeholder", ctx.configuration.label)("formControl", ctx.searchFormControl);
    } }, directives: [i4.MatFormField, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective], styles: [".flex--stretch{flex:1}.xpo-TextInputFilter-formField .mat-form-field-infix{border-top:0}.xpo-TextInputFilter-formField .mat-form-field-underline{display:none}.xpo-TextInputFilter-formField .mat-form-field-wrapper{padding-bottom:0}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTextInputFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-text-input-filter',
                templateUrl: 'text-input-filter.component.html',
                styleUrls: ['text-input-filter.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-TextInputFilter xpo-FilterChip', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { textInput: [{
            type: ViewChild,
            args: ['textInput', { static: true }]
        }] }); })();

class XpoTextInputFilter extends XpoInlineFilter {
    constructor(params, noop) {
        super(params.field || params, params.label || noop, XpoTextInputFilterComponent);
        if (noop) {
            /**
             * target @v9.0.0
             */
            console.warn('WARN: XpoTextInputFilter(field, value) is deprecated, please use XpoTextInputFilter({field: field, value: value})');
        }
        else {
            this.title = params.title || '';
            this.validators = params.validators || null;
            this.inputDebounceTime = params.inputDebounceTime || XpoTextInputFilter.DefaultInputDebounceTime;
            this.matcher = params.matcher || null;
        }
    }
    getDisplayValue(val) {
        return val;
    }
}
XpoTextInputFilter.DefaultInputDebounceTime = 500;

class XpoYesNoFilterComponent extends XpoFilterComponentBase {
    constructor() {
        super();
    }
    /** updates the selected criterion of filter */
    onCheckboxClicked() {
        const value = [];
        if (this.yesValue) {
            value.push('1');
        }
        if (this.noValue) {
            value.push('0');
        }
        this.storeCriteria(value);
    }
    initialize() {
        // Nothing to initialize
    }
    onCriteriaModified(fieldValue, criteria) {
        const val = fieldValue || [];
        this.yesValue = val.indexOf('1') !== -1;
        this.noValue = val.indexOf('0') !== -1;
    }
}
XpoYesNoFilterComponent.ɵfac = function XpoYesNoFilterComponent_Factory(t) { return new (t || XpoYesNoFilterComponent)(); };
XpoYesNoFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoYesNoFilterComponent, selectors: [["xpo-yes-no-filter"]], hostAttrs: [1, "xpo-YesNoFilter"], hostVars: 1, hostBindings: function XpoYesNoFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [["name", "xpo-yes-checkbox", "id", "xpo-yes-checkbox", "labelPosition", "right", 1, "xpo-FilterContainer-option", 3, "ngModel", "ngModelChange"], ["name", "xpo-no-checkbox", "id", "xpo-no-checkbox", "labelPosition", "right", 1, "xpo-FilterContainer-option", 3, "ngModel", "ngModelChange"]], template: function XpoYesNoFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-filter-container");
        i0.ɵɵelementStart(1, "mat-checkbox", 0);
        i0.ɵɵlistener("ngModelChange", function XpoYesNoFilterComponent_Template_mat_checkbox_ngModelChange_1_listener($event) { return ctx.yesValue = $event; })("ngModelChange", function XpoYesNoFilterComponent_Template_mat_checkbox_ngModelChange_1_listener() { return ctx.onCheckboxClicked(); });
        i0.ɵɵtext(2, " Yes ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-checkbox", 1);
        i0.ɵɵlistener("ngModelChange", function XpoYesNoFilterComponent_Template_mat_checkbox_ngModelChange_3_listener($event) { return ctx.noValue = $event; })("ngModelChange", function XpoYesNoFilterComponent_Template_mat_checkbox_ngModelChange_3_listener() { return ctx.onCheckboxClicked(); });
        i0.ɵɵtext(4, " No ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.yesValue);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.noValue);
    } }, directives: [XpoFilterContainer, i1.MatCheckbox, i1$1.NgControlStatus, i1$1.NgModel], styles: [".xpo-YesNoFilter .mat-checkbox-layout{width:100%}.xpo-YesNoFilter .mat-checkbox-layout .mat-checkbox-label{width:100%}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoYesNoFilterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-yes-no-filter',
                templateUrl: 'yes-no-filter.component.html',
                styleUrls: ['yes-no-filter.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-YesNoFilter', '[attr.id]': 'id' },
            }]
    }], function () { return []; }, null); })();

class XpoYesNoFilter extends XpoFilter {
    constructor(field, label) {
        super(field, label, XpoYesNoFilterComponent);
        this.field = field;
        this.label = label;
    }
    getDisplayValue(val) {
        if (val == null || val.length === 0 || val.length === 2) {
            return 'All';
        }
        return val.indexOf('1') !== -1 ? 'Yes' : 'No';
    }
}

class XpoFiltersModule {
}
XpoFiltersModule.ɵfac = function XpoFiltersModule_Factory(t) { return new (t || XpoFiltersModule)(); };
XpoFiltersModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoFiltersModule });
XpoFiltersModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MatBadgeModule,
            MatButtonModule,
            MatCheckboxModule,
            MatChipsModule,
            MatNativeDateModule,
            // MatMomentDateModule, // TODO: maybe moment is the right way to go for internationalization?
            MatDatepickerModule,
            MatFormFieldModule,
            MatInputModule,
            MatRadioModule,
            MatTabsModule,
            OverlayModule,
            ReactiveFormsModule,
            XpoAutofocusModule,
            XpoButtonModule,
            XpoCardModule,
            XpoResponsiveLoadingSpinnerModule,
            XpoIconModule,
            XpoPopoverModule,
            XpoAdvancedSelectModule,
            MatSelectModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFiltersModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatBadgeModule,
                    MatButtonModule,
                    MatCheckboxModule,
                    MatChipsModule,
                    MatNativeDateModule,
                    // MatMomentDateModule, // TODO: maybe moment is the right way to go for internationalization?
                    MatDatepickerModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatRadioModule,
                    MatTabsModule,
                    OverlayModule,
                    ReactiveFormsModule,
                    XpoAutofocusModule,
                    XpoButtonModule,
                    XpoCardModule,
                    XpoResponsiveLoadingSpinnerModule,
                    XpoIconModule,
                    XpoPopoverModule,
                    XpoAdvancedSelectModule,
                    MatSelectModule,
                ],
                declarations: [
                    XpoBooleanFilterComponent,
                    XpoCalendarComponent,
                    XpoCheckboxFilterComponent,
                    XpoConditionEnumEqualsComponent,
                    XpoConditionDynamicEnumEqualsComponent,
                    XpoConditionBooleanFalseComponent,
                    XpoConditionBooleanTrueComponent,
                    XpoConditionComponentDirective,
                    XpoConditionDateEqualsComponent,
                    XpoConditionDateTimeBetweenComponent,
                    XpoConditionEmptyComponent,
                    XpoConditionIsNotEmptyComponent,
                    XpoConditionNumberEqualsComponent,
                    XpoConditionNumberGreaterEqualThanComponent,
                    XpoConditionNumberGreaterThanComponent,
                    XpoConditionNumberIsBetweenComponent,
                    XpoConditionNumberIsNotBetweenComponent,
                    XpoConditionNumberLessEqualThanComponent,
                    XpoConditionNumberLessThanComponent,
                    XpoConditionNumberNotEqualsComponent,
                    XpoConditionStringContainsComponent,
                    XpoConditionStringDoesNotContainComponent,
                    XpoConditionStringEndsWithComponent,
                    XpoConditionStringEqualsComponent,
                    XpoConditionStringIsBetweenComponent,
                    XpoConditionStringIsNotBetweenComponent,
                    XpoConditionStringIsNotEqualComponent,
                    XpoConditionIsOneOfComponent,
                    XpoConditionStringStartsWithComponent,
                    XpoConditionalFilterComponent,
                    XpoConditionsComponent,
                    XpoEnumFilterComponent,
                    XpoDynamicEnumFilterComponent,
                    XpoDateFilterComponent,
                    XpoDateOnlyFilterComponent,
                    XpoDateRangeFilterComponent,
                    XpoDateRangeFilterGroupByComponent,
                    XpoDateTimeFilterComponent,
                    XpoFilterBar,
                    XpoFilterChip,
                    XpoFilterContainer,
                    XpoFilterDateSelectorComponent,
                    XpoFilterForm,
                    XpoFilterFormHost,
                    XpoFilterHost,
                    XpoGlobalFilterBar,
                    XpoInlineMultiSelectFilterComponent,
                    XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent,
                    XpoMultiSelectAutocompleteFilterComponent,
                    XpoNumberFilterComponent,
                    XpoQuickSearchFilterComponent,
                    XpoSelectFilterComponent,
                    XpoStringFilterComponent,
                    XpoTextInputFilterComponent,
                    XpoTimeFilterComponent,
                    XpoTimeRangeFilterComponent,
                    XpoYesNoFilterComponent,
                    XpoConditionTimeBeforeSameComponent,
                    XpoConditionTimeNotBetweenComponent,
                    XpoConditionTimeIsComponent,
                    XpoConditionTimeEqualsComponent,
                    XpoConditionTimeBetweenComponent,
                    XpoConditionTimeRangeBetweenComponent,
                    XpoConditionTimeRangeNotBetweenComponent,
                    XpoConditionTimeRangeBeforeComponent,
                    XpoConditionTimeRangeAfterComponent,
                    XpoConditionRangeEmptyComponent,
                    XpoConditionRangeNotEmptyComponent,
                    XpoConditionTimeBeforeComponent,
                    XpoConditionTimeAfterComponent,
                    XpoConditionTimeAfterSameComponent,
                    XpoConditionDateNotBetweenComponent,
                    XpoConditionDateBetweenComponent,
                    XpoConditionDateBeforeComponent,
                    XpoConditionDateBeforeSameComponent,
                    XpoConditionDateAfterComponent,
                    XpoConditionDateAfterSameComponent,
                    XpoConditionDateTimeNotBetweenComponent,
                    XpoConditionDateTimeBeforeComponent,
                    XpoConditionDateTimeAfterComponent,
                    XpoConditionDateTimeBeforeSameComponent,
                    XpoConditionDateIsComponent,
                    XpoConditionDateTimeAfterSameComponent,
                    ExactTimeInputComponent,
                ],
                exports: [
                    XpoBooleanFilterComponent,
                    XpoConditionDateTimeBetweenComponent,
                    XpoDateFilterComponent,
                    XpoDateOnlyFilterComponent,
                    XpoDateRangeFilterComponent,
                    XpoDateRangeFilterGroupByComponent,
                    XpoDateTimeFilterComponent,
                    XpoFilterBar,
                    XpoFilterChip,
                    XpoFilterContainer,
                    XpoFilterDateSelectorComponent,
                    XpoFilterForm,
                    XpoFilterFormHost,
                    XpoFilterHost,
                    XpoGlobalFilterBar,
                    XpoInlineMultiSelectFilterComponent,
                    XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent,
                    XpoMultiSelectAutocompleteFilterComponent,
                    XpoNumberFilterComponent,
                    XpoQuickSearchFilterComponent,
                    XpoSelectFilterComponent,
                    XpoStringFilterComponent,
                    XpoTextInputFilterComponent,
                    XpoEnumFilterComponent,
                    XpoDynamicEnumFilterComponent,
                    XpoTimeFilterComponent,
                    XpoTimeRangeFilterComponent,
                    XpoYesNoFilterComponent,
                ],
                entryComponents: [
                    XpoBooleanFilterComponent,
                    XpoCheckboxFilterComponent,
                    XpoConditionBooleanFalseComponent,
                    XpoConditionBooleanTrueComponent,
                    XpoConditionDateEqualsComponent,
                    XpoConditionDateEqualsComponent,
                    XpoConditionDateTimeBetweenComponent,
                    XpoConditionDateTimeBetweenComponent,
                    XpoConditionEmptyComponent,
                    XpoConditionIsNotEmptyComponent,
                    XpoConditionNumberEqualsComponent,
                    XpoConditionNumberGreaterEqualThanComponent,
                    XpoConditionNumberGreaterThanComponent,
                    XpoConditionNumberIsBetweenComponent,
                    XpoConditionNumberIsNotBetweenComponent,
                    XpoConditionNumberLessEqualThanComponent,
                    XpoConditionNumberLessThanComponent,
                    XpoConditionNumberNotEqualsComponent,
                    XpoConditionStringContainsComponent,
                    XpoConditionStringDoesNotContainComponent,
                    XpoConditionStringEndsWithComponent,
                    XpoConditionStringEqualsComponent,
                    XpoConditionStringIsBetweenComponent,
                    XpoConditionStringIsNotBetweenComponent,
                    XpoConditionStringIsNotEqualComponent,
                    XpoConditionIsOneOfComponent,
                    XpoConditionStringStartsWithComponent,
                    XpoConditionalFilterComponent,
                    XpoDateFilterComponent,
                    XpoDateOnlyFilterComponent,
                    XpoDateRangeFilterComponent,
                    XpoDateRangeFilterGroupByComponent,
                    XpoDateTimeFilterComponent,
                    XpoFilterChip,
                    XpoFilterContainer,
                    XpoFilterDateSelectorComponent,
                    XpoInlineMultiSelectFilterComponent,
                    XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent,
                    XpoMultiSelectAutocompleteFilterComponent,
                    XpoNumberFilterComponent,
                    XpoQuickSearchFilterComponent,
                    XpoSelectFilterComponent,
                    XpoStringFilterComponent,
                    XpoTextInputFilterComponent,
                    XpoTimeFilterComponent,
                    XpoTimeRangeFilterComponent,
                    XpoEnumFilterComponent,
                    XpoDynamicEnumFilterComponent,
                    XpoConditionEnumEqualsComponent,
                    XpoConditionDynamicEnumEqualsComponent,
                    XpoYesNoFilterComponent,
                    XpoConditionTimeBeforeSameComponent,
                    XpoConditionTimeNotBetweenComponent,
                    XpoConditionTimeIsComponent,
                    XpoConditionTimeEqualsComponent,
                    XpoConditionTimeBetweenComponent,
                    XpoConditionTimeRangeBetweenComponent,
                    XpoConditionTimeRangeNotBetweenComponent,
                    XpoConditionTimeRangeBeforeComponent,
                    XpoConditionTimeRangeAfterComponent,
                    XpoConditionRangeEmptyComponent,
                    XpoConditionRangeNotEmptyComponent,
                    XpoConditionTimeBeforeComponent,
                    XpoConditionTimeAfterComponent,
                    XpoConditionTimeAfterSameComponent,
                    XpoConditionDateNotBetweenComponent,
                    XpoConditionDateBetweenComponent,
                    XpoConditionDateBeforeComponent,
                    XpoConditionDateBeforeSameComponent,
                    XpoConditionDateAfterComponent,
                    XpoConditionDateAfterSameComponent,
                    XpoConditionDateTimeNotBetweenComponent,
                    XpoConditionDateTimeBeforeComponent,
                    XpoConditionDateTimeAfterComponent,
                    XpoConditionDateTimeBeforeSameComponent,
                    XpoConditionDateIsComponent,
                    XpoConditionDateTimeAfterSameComponent,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoFiltersModule, { declarations: [XpoBooleanFilterComponent,
        XpoCalendarComponent,
        XpoCheckboxFilterComponent,
        XpoConditionEnumEqualsComponent,
        XpoConditionDynamicEnumEqualsComponent,
        XpoConditionBooleanFalseComponent,
        XpoConditionBooleanTrueComponent,
        XpoConditionComponentDirective,
        XpoConditionDateEqualsComponent,
        XpoConditionDateTimeBetweenComponent,
        XpoConditionEmptyComponent,
        XpoConditionIsNotEmptyComponent,
        XpoConditionNumberEqualsComponent,
        XpoConditionNumberGreaterEqualThanComponent,
        XpoConditionNumberGreaterThanComponent,
        XpoConditionNumberIsBetweenComponent,
        XpoConditionNumberIsNotBetweenComponent,
        XpoConditionNumberLessEqualThanComponent,
        XpoConditionNumberLessThanComponent,
        XpoConditionNumberNotEqualsComponent,
        XpoConditionStringContainsComponent,
        XpoConditionStringDoesNotContainComponent,
        XpoConditionStringEndsWithComponent,
        XpoConditionStringEqualsComponent,
        XpoConditionStringIsBetweenComponent,
        XpoConditionStringIsNotBetweenComponent,
        XpoConditionStringIsNotEqualComponent,
        XpoConditionIsOneOfComponent,
        XpoConditionStringStartsWithComponent,
        XpoConditionalFilterComponent,
        XpoConditionsComponent,
        XpoEnumFilterComponent,
        XpoDynamicEnumFilterComponent,
        XpoDateFilterComponent,
        XpoDateOnlyFilterComponent,
        XpoDateRangeFilterComponent,
        XpoDateRangeFilterGroupByComponent,
        XpoDateTimeFilterComponent,
        XpoFilterBar,
        XpoFilterChip,
        XpoFilterContainer,
        XpoFilterDateSelectorComponent,
        XpoFilterForm,
        XpoFilterFormHost,
        XpoFilterHost,
        XpoGlobalFilterBar,
        XpoInlineMultiSelectFilterComponent,
        XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent,
        XpoMultiSelectAutocompleteFilterComponent,
        XpoNumberFilterComponent,
        XpoQuickSearchFilterComponent,
        XpoSelectFilterComponent,
        XpoStringFilterComponent,
        XpoTextInputFilterComponent,
        XpoTimeFilterComponent,
        XpoTimeRangeFilterComponent,
        XpoYesNoFilterComponent,
        XpoConditionTimeBeforeSameComponent,
        XpoConditionTimeNotBetweenComponent,
        XpoConditionTimeIsComponent,
        XpoConditionTimeEqualsComponent,
        XpoConditionTimeBetweenComponent,
        XpoConditionTimeRangeBetweenComponent,
        XpoConditionTimeRangeNotBetweenComponent,
        XpoConditionTimeRangeBeforeComponent,
        XpoConditionTimeRangeAfterComponent,
        XpoConditionRangeEmptyComponent,
        XpoConditionRangeNotEmptyComponent,
        XpoConditionTimeBeforeComponent,
        XpoConditionTimeAfterComponent,
        XpoConditionTimeAfterSameComponent,
        XpoConditionDateNotBetweenComponent,
        XpoConditionDateBetweenComponent,
        XpoConditionDateBeforeComponent,
        XpoConditionDateBeforeSameComponent,
        XpoConditionDateAfterComponent,
        XpoConditionDateAfterSameComponent,
        XpoConditionDateTimeNotBetweenComponent,
        XpoConditionDateTimeBeforeComponent,
        XpoConditionDateTimeAfterComponent,
        XpoConditionDateTimeBeforeSameComponent,
        XpoConditionDateIsComponent,
        XpoConditionDateTimeAfterSameComponent,
        ExactTimeInputComponent], imports: [CommonModule,
        FormsModule,
        MatBadgeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatNativeDateModule,
        // MatMomentDateModule, // TODO: maybe moment is the right way to go for internationalization?
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatTabsModule,
        OverlayModule,
        ReactiveFormsModule,
        XpoAutofocusModule,
        XpoButtonModule,
        XpoCardModule,
        XpoResponsiveLoadingSpinnerModule,
        XpoIconModule,
        XpoPopoverModule,
        XpoAdvancedSelectModule,
        MatSelectModule], exports: [XpoBooleanFilterComponent,
        XpoConditionDateTimeBetweenComponent,
        XpoDateFilterComponent,
        XpoDateOnlyFilterComponent,
        XpoDateRangeFilterComponent,
        XpoDateRangeFilterGroupByComponent,
        XpoDateTimeFilterComponent,
        XpoFilterBar,
        XpoFilterChip,
        XpoFilterContainer,
        XpoFilterDateSelectorComponent,
        XpoFilterForm,
        XpoFilterFormHost,
        XpoFilterHost,
        XpoGlobalFilterBar,
        XpoInlineMultiSelectFilterComponent,
        XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent,
        XpoMultiSelectAutocompleteFilterComponent,
        XpoNumberFilterComponent,
        XpoQuickSearchFilterComponent,
        XpoSelectFilterComponent,
        XpoStringFilterComponent,
        XpoTextInputFilterComponent,
        XpoEnumFilterComponent,
        XpoDynamicEnumFilterComponent,
        XpoTimeFilterComponent,
        XpoTimeRangeFilterComponent,
        XpoYesNoFilterComponent] }); })();
i0.ɵɵsetComponentScope(XpoMultiSelectAutocompleteFilterComponent, [XpoFilterContainer, i4.MatFormField, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i3.MatIcon, i4.MatSuffix, i2.NgIf, i2.NgForOf, i1.MatCheckbox, i7$1.XpoResponsiveLoadingSpinner, XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent], []);

function XpoAppliedFilters_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-chip", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Applied filter", ctx_r0.currentFilters.length > 1 ? "s" : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.currentFilters.length);
} }
function XpoAppliedFilters_mat_chip_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 9);
    i0.ɵɵlistener("removed", function XpoAppliedFilters_mat_chip_4_Template_mat_chip_removed_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const filter_r3 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onFilterRemove(filter_r3); });
    i0.ɵɵelementStart(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 12);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 13);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-icon", 14);
    i0.ɵɵtext(10, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    i0.ɵɵproperty("removable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(filter_r3.combiner);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", filter_r3.columnName || filter_r3.columnField, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", filter_r3.displayOperator, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", filter_r3.displayValue, " ");
} }
function XpoAppliedFilters_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function XpoAppliedFilters_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.onFilterRemoveAll(); });
    i0.ɵɵtext(1, "Clear All");
    i0.ɵɵelementEnd();
} }
class XpoAppliedFilters extends XpoBoardConsumer {
    constructor() {
        super(...arguments);
        this.FILTER_CHAGE_SOURCE_NAME = XpoBoardStateSources.FilterChange;
        this.operatorsTexts = OperatorsToOperatorText;
        this.currentFilters = [];
        this.conditionalFiltersOnly = false;
    }
    /**
     * Handle filter remove action
     * @param filter
     */
    onFilterRemove(filter) {
        this.currentState.criteria = this.removeFilterFromCriteria(filter, cloneDeep(this.currentState.criteria));
        this.stateChange$.next({
            criteria: this.currentState.criteria,
            source: this.FILTER_CHAGE_SOURCE_NAME,
        });
    }
    /**
     * Handle filter remove all action
     */
    onFilterRemoveAll() {
        if (this.conditionalFiltersOnly) {
            this.removeConditionalFilters();
        }
        else {
            this.removeAllFilters();
        }
    }
    removeAllFilters() {
        this.stateChange$.next({
            criteria: {},
            source: this.FILTER_CHAGE_SOURCE_NAME,
        });
    }
    removeConditionalFilters() {
        const criteria = cloneDeep(this.currentState.criteria);
        Object.keys(criteria).forEach((key) => {
            if (criteria[key] && criteria[key].conditions) {
                delete criteria[key];
            }
        });
        this.stateChange$.next({
            criteria,
            source: this.FILTER_CHAGE_SOURCE_NAME,
        });
    }
    /**
     * Remove filter from criteria depending on the filter type.
     * @param filter
     * @param criteria
     */
    removeFilterFromCriteria(filter, criteria) {
        // if criteria contains conditions then it's a complex filter
        if (criteria[filter.columnField] && criteria[filter.columnField].conditions) {
            const columFilter = criteria[filter.columnField];
            const newConditions = columFilter.conditions.filter((condition) => {
                const conditionValue = this.getConditionalFilterValue(condition);
                return !(condition.operator === filter.operator && _isEqual(conditionValue, filter.value));
            });
            criteria[filter.columnField].conditions = newConditions;
            return criteria;
        }
        // othewise threat it as regular column filter
        if (criteria[filter.columnField]) {
            delete criteria[filter.columnField];
        }
        return criteria;
    }
    /**
     * Every time criteria changes on the state we display them on the tags.
     * @param state // board state
     */
    onStateChange(state) {
        if (!state.changes.includes('criteria')) {
            return;
        }
        this.currentState = state;
        this.currentFilters = [];
        Object.keys(state.criteria).forEach((colField) => {
            // merge current filters with incoming filters
            this.currentFilters = [...this.currentFilters, ...this.parseFilterValue(colField, state.criteria[colField])];
        });
    }
    /**
     * Parse filter values to applied filters representation.
     * @param colField
     * @param filterValue
     */
    parseFilterValue(colField, filterValue) {
        let filters = [];
        // avoid empty filters
        if (!filterValue || !Object.keys(filterValue).length) {
            return filters;
        }
        // conditional filters
        if (filterValue.conditions) {
            filters = this.parseConditionalFilterValues(colField, filterValue);
        }
        // regular column filters
        if (!filterValue.conditions && !this.conditionalFiltersOnly) {
            const column = this.findColumn(colField, this.currentState.visibleColumns);
            if (column) {
                const appliedFilter = {
                    combiner: '',
                    columnName: column.headerName,
                    columnField: colField,
                    value: filterValue,
                    displayValue: this.getSimpleFilterDisplayValue(filterValue, column),
                    operator: Operators.Equals,
                    displayOperator: this.operatorsTexts[Operators.Equals],
                };
                filters.push(appliedFilter);
            }
        }
        return filters;
    }
    /**
     * Find and return column based on colField. It walks over all children columns in case there
     * are nested columns.
     * @param colField
     * @param columns
     */
    findColumn(colField, columns) {
        return columns.find((column) => {
            if (column.children) {
                return this.findColumn(colField, column.children);
            }
            return column.field === colField;
        });
    }
    /**
     * Parse conditional filter values to applied filters standard format
     * @param columnName
     * @param filterValue
     */
    parseConditionalFilterValues(colField, filterValue) {
        const filters = [];
        const column = this.findColumn(colField, this.currentState.visibleColumns);
        if (column) {
            filterValue.conditions.forEach((condition, index) => {
                const conditionOperator = condition.operator || Operators.Equals;
                const appliedFilter = {
                    // do not add -combiner- (AND, OR) on first tag element.
                    combiner: index && filterValue.combiner ? filterValue.combiner : '',
                    columnName: column.headerName,
                    columnField: colField,
                    value: this.getConditionalFilterValue(condition),
                    // value can be represented in different ways based on the filter type.
                    displayValue: this.getConditionalFilterDisplayValue(condition),
                    // if no operator is present, use "is" as fallback (e.g.: in ag-grid default floating filters).
                    operator: condition.operator || Operators.Equals,
                    displayOperator: this.operatorsTexts[conditionOperator] || this.operatorsTexts[Operators.Equals],
                };
                filters.push(appliedFilter);
            });
        }
        return filters;
    }
    /**
     * Return appropriate value to be displayed when using complex filters which can have multiple representation values.
     * @param condition
     */
    getConditionalFilterDisplayValue(condition) {
        // 'and' is just the connector text for range filters, nothing to do with the -combiner- AND, OR.
        const RANGE_FILTER_CONNECTOR_TEXT = 'and';
        // display and displayTo used on range filters with custom display value.
        if (condition.display && condition.displayTo) {
            return `${condition.display} ${RANGE_FILTER_CONNECTOR_TEXT} ${condition.displayTo}`;
        }
        // value and valueTo used in range filters with no custom display value.
        if (condition.value && condition.valueTo) {
            return `${this.parseValueToString(condition.value)} ${RANGE_FILTER_CONNECTOR_TEXT} ${this.parseValueToString(condition.valueTo)}`;
        }
        // display value or value as is for non range filters. Empty string as fallback.
        return condition.display || this.parseValueToString(condition.value) || '';
    }
    /**
     * returns unified value if condition is a range or fallback to regular value instead
     * @param condition
     */
    getConditionalFilterValue(condition) {
        return condition.valueTo ? { from: condition.value, to: condition.valueTo } : condition.value;
    }
    /**
     * Return formatted value using valueFormatter from column when possible.
     * Supports simple filters using range values.
     * @param value
     * @param column
     */
    getSimpleFilterDisplayValue(value, column) {
        let formattedValue;
        const valueFormatter = column.valueFormatter || null;
        if (value.min) {
            formattedValue = valueFormatter ? valueFormatter({ value: value.min }) : this.parseValueToString(value.min);
        }
        if (value.max) {
            const maxValue = valueFormatter ? valueFormatter({ value: value.max }) : this.parseValueToString(value.max);
            formattedValue = `${formattedValue} - ${maxValue}`;
        }
        if (!value.min && !value.max) {
            formattedValue = this.parseValueToString(value);
        }
        return formattedValue;
    }
    /**
     * Try to parse the given value to string when possible.
     * @param value
     */
    parseValueToString(value) {
        // In most cases value will be already a string, so return same thing.
        if (typeof value === 'string') {
            return value;
        }
        // if array, return array elements separated by ', ' for readability.
        if (Array.isArray(value)) {
            return value.join(', ');
        }
        // try to parse to string when possible or fallback to JSON.stringify in the worst case.
        return value.toString ? value.toString() : JSON.stringify(value);
    }
}
XpoAppliedFilters.ɵfac = /*@__PURE__*/ function () { let ɵXpoAppliedFilters_BaseFactory; return function XpoAppliedFilters_Factory(t) { return (ɵXpoAppliedFilters_BaseFactory || (ɵXpoAppliedFilters_BaseFactory = i0.ɵɵgetInheritedFactory(XpoAppliedFilters)))(t || XpoAppliedFilters); }; }();
XpoAppliedFilters.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAppliedFilters, selectors: [["xpo-applied-filters"]], inputs: { conditionalFiltersOnly: "conditionalFiltersOnly" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 3, consts: [[1, "xpo-AppliedFilters"], ["class", "xpo-AppliedFilters__heading", 4, "ngIf"], [1, "xpo-AppliedFilters__filters"], [1, "xpo-AppliedFilters-list"], ["xpoTag", "", "class", "xpo-AppliedFilters-tag", 3, "removable", "removed", 4, "ngFor", "ngForOf"], ["class", "xpo-AppliedFilters-clearAll", 3, "click", 4, "ngIf"], [1, "xpo-AppliedFilters__heading"], [1, "xpo-AppliedFilters__text"], ["xpoBadgeChip", "", "color", "accent", "selected", ""], ["xpoTag", "", 1, "xpo-AppliedFilters-tag", 3, "removable", "removed"], [1, "xpo-AppliedFilters-combiner"], [1, "xpo-AppliedFilters-columnName"], [1, "xpo-AppliedFilters-operator"], [1, "xpo-AppliedFilters-value"], ["matChipRemove", ""], [1, "xpo-AppliedFilters-clearAll", 3, "click"]], template: function XpoAppliedFilters_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, XpoAppliedFilters_div_1_Template, 5, 2, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "mat-chip-list", 3);
        i0.ɵɵtemplate(4, XpoAppliedFilters_mat_chip_4_Template, 11, 5, "mat-chip", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoAppliedFilters_button_5_Template, 2, 0, "button", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentFilters.length);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.currentFilters);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentFilters.length);
    } }, directives: [i2.NgIf, i1$4.MatChipList, i2.NgForOf, i1$4.MatChip, i3$2.XpoBadgeChip, i3$2.XpoTag, i3.MatIcon, i1$4.MatChipRemove], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-AppliedFilters[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-AppliedFilters__heading[_ngcontent-%COMP%]{display:flex;margin-bottom:8px}.xpo-AppliedFilters__filters[_ngcontent-%COMP%]{display:flex;flex-direction:row}.xpo-AppliedFilters__text[_ngcontent-%COMP%]{font-weight:bold;padding-right:8px}.xpo-AppliedFilters-columnName[_ngcontent-%COMP%]{font-weight:500;padding-right:4px;text-transform:capitalize}.xpo-AppliedFilters-combiner[_ngcontent-%COMP%]{font-weight:normal;padding-right:4px}.xpo-AppliedFilters-operator[_ngcontent-%COMP%]{font-weight:normal;padding-right:4px}.xpo-AppliedFilters-value[_ngcontent-%COMP%]{font-weight:normal;padding-right:4px}.xpo-AppliedFilters-clearAll[_ngcontent-%COMP%]{background:none;border:none;color:#1976d2;cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAppliedFilters, [{
        type: Component,
        args: [{
                selector: 'xpo-applied-filters',
                templateUrl: './applied-filters.component.html',
                styleUrls: ['./applied-filters.component.scss'],
            }]
    }], null, { conditionalFiltersOnly: [{
            type: Input,
            args: ['conditionalFiltersOnly']
        }] }); })();

class XpoAvailableViewsFilter {
    transform(value, term) {
        if (value && value.length && term) {
            return value.filter((x) => x.name && x.name.toLowerCase().indexOf(term.toLowerCase()) !== -1);
        }
        return value;
    }
}
XpoAvailableViewsFilter.ɵfac = function XpoAvailableViewsFilter_Factory(t) { return new (t || XpoAvailableViewsFilter)(); };
XpoAvailableViewsFilter.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "xpoAvailableViewsFilter", type: XpoAvailableViewsFilter, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAvailableViewsFilter, [{
        type: Pipe,
        args: [{
                name: 'xpoAvailableViewsFilter',
            }]
    }], null, null); })();

function XpoDeleteViewConfirmDialog_mat_spinner_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 6);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 24);
} }
class XpoDeleteViewConfirmDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.deletingSource$ = new BehaviorSubject(false);
        this.deleting$ = this.deletingSource$.asObservable().pipe(share());
    }
    confirmDelete() {
        this.deletingSource$.next(true);
        this.data
            .deleteView()
            .pipe(finalize(() => {
            this.deletingSource$.next(false);
        }))
            .subscribe((newState) => {
            this.dialogRef.close(newState);
        });
    }
}
XpoDeleteViewConfirmDialog.ɵfac = function XpoDeleteViewConfirmDialog_Factory(t) { return new (t || XpoDeleteViewConfirmDialog)(i0.ɵɵdirectiveInject(i1$5.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
XpoDeleteViewConfirmDialog.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDeleteViewConfirmDialog, selectors: [["xpo-delete-confirm-dialog"]], hostAttrs: [1, "xpo-DeleteViewDialog"], decls: 17, vars: 9, consts: [["mat-dialog-title", ""], ["mat-dialog-content", ""], ["mat-dialog-actions", ""], ["mat-button", "", "color", "primary", "type", "button", 3, "disabled", "click"], ["mat-flat-button", "", "type", "button", "color", "warn", 3, "disabled", "click"], ["class", "xpo-DeleteViewDialog-spinner", 3, "diameter", 4, "ngIf"], [1, "xpo-DeleteViewDialog-spinner", 3, "diameter"]], template: function XpoDeleteViewConfirmDialog_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h1", 0);
        i0.ɵɵtext(1, " Delete View ");
        i0.ɵɵelement(2, "xpo-dialog-close-button");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵtext(4, "Deleting the view will remove it from your tabs, this action cannot be undone.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵelementStart(6, "xpo-button-group");
        i0.ɵɵelementStart(7, "button", 3);
        i0.ɵɵlistener("click", function XpoDeleteViewConfirmDialog_Template_button_click_7_listener() { return ctx.dialogRef.close(); });
        i0.ɵɵpipe(8, "async");
        i0.ɵɵtext(9, " Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "button", 4);
        i0.ɵɵlistener("click", function XpoDeleteViewConfirmDialog_Template_button_click_10_listener() { return ctx.confirmDelete(); });
        i0.ɵɵpipe(11, "async");
        i0.ɵɵelementStart(12, "mat-icon");
        i0.ɵɵtext(13, "delete");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(14, " Delete ");
        i0.ɵɵtemplate(15, XpoDeleteViewConfirmDialog_mat_spinner_15_Template, 1, 1, "mat-spinner", 5);
        i0.ɵɵpipe(16, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(8, 3, ctx.deleting$));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(11, 5, ctx.deleting$));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(16, 7, ctx.deleting$));
    } }, directives: [i1$5.MatDialogTitle, i2$3.XpoDialogCloseButtonComponent, i1$5.MatDialogContent, i1$5.MatDialogActions, i2$1.XpoButtonGroup, i3$1.MatButton, i3.MatIcon, i2.NgIf, i7$2.MatSpinner], pipes: [i2.AsyncPipe], styles: [".xpo-DeleteViewDialog-spinner[_ngcontent-%COMP%]{display:inline-block}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDeleteViewConfirmDialog, [{
        type: Component,
        args: [{
                selector: 'xpo-delete-confirm-dialog',
                templateUrl: './delete-confirm-dialog.component.html',
                styleUrls: ['./delete-confirm-dialog.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-DeleteViewDialog' },
            }]
    }], function () { return [{ type: i1$5.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

function XpoSaveViewDialog_mat_spinner_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 9);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 24);
} }
var XpoSaveViewDialogPurpose;
(function (XpoSaveViewDialogPurpose) {
    XpoSaveViewDialogPurpose["Save"] = "Save";
    XpoSaveViewDialogPurpose["Edit"] = "Edit";
})(XpoSaveViewDialogPurpose || (XpoSaveViewDialogPurpose = {}));
class XpoSaveViewDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialogTitle = '';
        this.submittingSource$ = new BehaviorSubject(false);
        this.submitting$ = this.submittingSource$.asObservable().pipe(share());
    }
    ngOnInit() {
        this.viewName = this.data.view.name;
        this.purpose = this.data.purpose || this.getDialogPurpose();
        this.dialogTitle = this.purpose === XpoSaveViewDialogPurpose.Edit ? 'Edit View' : 'Save View';
    }
    submitForm() {
        this.submittingSource$.next(true);
        const state = this.data.state;
        const viewToSave = this.data.view;
        // previously saved views or system defined views should save as a new view
        const isSaveAs = this.purpose === XpoSaveViewDialogPurpose.Save ? this.hasViewBeenSaved() || viewToSave.systemDefined : false;
        // if saveAs generate a new view
        const viewId = isSaveAs ? new Date().getTime().toString() : viewToSave.id;
        this.data
            .saveView(Object.assign(Object.assign({}, viewToSave.toViewConfig(state)), { id: viewId, lastSaved: new Date(), name: this.viewName, systemDefined: false, closeable: true }), isSaveAs)
            .pipe(take(1), finalize(() => this.submittingSource$.next(false)))
            .subscribe((newState) => {
            this.dialogRef.close(newState);
        });
    }
    getDialogPurpose() {
        return this.hasViewBeenSaved() ? XpoSaveViewDialogPurpose.Edit : XpoSaveViewDialogPurpose.Save;
    }
    /**
     * Checks if the entered view was saved before, if there is no entered view,
     * it checks if the active view was saved before
     */
    hasViewBeenSaved() {
        return !!this.data.view.lastSaved;
    }
}
XpoSaveViewDialog.ɵfac = function XpoSaveViewDialog_Factory(t) { return new (t || XpoSaveViewDialog)(i0.ɵɵdirectiveInject(i1$5.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
XpoSaveViewDialog.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoSaveViewDialog, selectors: [["xpo-save-view-dialog"]], hostAttrs: [1, "xpo-SaveViewDialog"], decls: 21, vars: 14, consts: [["mat-dialog-title", ""], [3, "ngSubmit"], ["saveForm", "ngForm"], ["mat-dialog-content", ""], ["matInput", "", "required", "", "placeholder", "Enter View Name", "name", "viewName", 3, "ngModel", "disabled", "ngModelChange"], ["mat-dialog-actions", ""], ["mat-button", "", "color", "primary", "type", "button", 3, "disabled", "click"], ["mat-flat-button", "", "type", "submit", 3, "disabled"], ["class", "xpo-SaveViewDialog-saveSpinner", 3, "diameter", 4, "ngIf"], [1, "xpo-SaveViewDialog-saveSpinner", 3, "diameter"]], template: function XpoSaveViewDialog_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h1", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelement(2, "xpo-dialog-close-button");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "form", 1, 2);
        i0.ɵɵlistener("ngSubmit", function XpoSaveViewDialog_Template_form_ngSubmit_3_listener() { return ctx.submitForm(); });
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "mat-form-field");
        i0.ɵɵelementStart(7, "input", 4);
        i0.ɵɵlistener("ngModelChange", function XpoSaveViewDialog_Template_input_ngModelChange_7_listener($event) { return ctx.viewName = $event; });
        i0.ɵɵpipe(8, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵelementStart(10, "xpo-button-group");
        i0.ɵɵelementStart(11, "button", 6);
        i0.ɵɵlistener("click", function XpoSaveViewDialog_Template_button_click_11_listener() { return ctx.dialogRef.close(); });
        i0.ɵɵpipe(12, "async");
        i0.ɵɵtext(13, " Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "button", 7);
        i0.ɵɵpipe(15, "async");
        i0.ɵɵelementStart(16, "mat-icon");
        i0.ɵɵtext(17, "save");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(18, " Save ");
        i0.ɵɵtemplate(19, XpoSaveViewDialog_mat_spinner_19_Template, 1, 1, "mat-spinner", 8);
        i0.ɵɵpipe(20, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.dialogTitle, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngModel", ctx.viewName)("disabled", i0.ɵɵpipeBind1(8, 6, ctx.submitting$));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(12, 8, ctx.submitting$));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(15, 10, !_r0.form.valid && ctx.submitting$));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(20, 12, ctx.submitting$));
    } }, directives: [i1$5.MatDialogTitle, i2$3.XpoDialogCloseButtonComponent, i1$1.ɵNgNoValidate, i1$1.NgControlStatusGroup, i1$1.NgForm, i1$5.MatDialogContent, i4.MatFormField, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.RequiredValidator, i1$1.NgControlStatus, i1$1.NgModel, i1$5.MatDialogActions, i2$1.XpoButtonGroup, i3$1.MatButton, i3.MatIcon, i2.NgIf, i7$2.MatSpinner], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-SaveViewDialog .mat-dialog-content{padding:32px .5}.xpo-SaveViewDialog .mat-dialog-content .mat-form-field{width:100%}.xpo-SaveViewDialog-saveSpinner{display:inline-block}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSaveViewDialog, [{
        type: Component,
        args: [{
                selector: 'xpo-save-view-dialog',
                templateUrl: './save-view-dialog.component.html',
                styleUrls: ['./save-view-dialog.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-SaveViewDialog' },
            }]
    }], function () { return [{ type: i1$5.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

function XpoAvailableViews_ng_container_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "mat-divider");
    i0.ɵɵelementStart(2, "h3", 10);
    i0.ɵɵtext(3, "System Default");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function XpoAvailableViews_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoAvailableViews_ng_container_10_ng_container_1_Template, 4, 0, "ng-container", 7);
    i0.ɵɵelementStart(2, "mat-list-item", 8);
    i0.ɵɵelementStart(3, "mat-checkbox", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const v_r3 = ctx.$implicit;
    const first_r4 = ctx.first;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", first_r4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", v_r3.visible)("disabled", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(v_r3.name);
} }
function XpoAvailableViews_ng_container_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "mat-divider");
    i0.ɵɵelementStart(2, "h3", 10);
    i0.ɵɵtext(3, "Custom Views");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function XpoAvailableViews_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoAvailableViews_ng_container_12_ng_container_1_Template, 4, 0, "ng-container", 7);
    i0.ɵɵelementStart(2, "mat-list-item", 11);
    i0.ɵɵelementStart(3, "mat-checkbox", 12);
    i0.ɵɵlistener("change", function XpoAvailableViews_ng_container_12_Template_mat_checkbox_change_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const v_r6 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.toggleViewDisplay(v_r6); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵelementStart(6, "button", 14);
    i0.ɵɵlistener("click", function XpoAvailableViews_ng_container_12_Template_button_click_6_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const v_r6 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.openEditViewDialog(v_r6); });
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 15);
    i0.ɵɵlistener("click", function XpoAvailableViews_ng_container_12_Template_button_click_9_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const v_r6 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.openDeleteConfirmDialog(v_r6); });
    i0.ɵɵelementStart(10, "mat-icon");
    i0.ɵɵtext(11, "delete_forever");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const v_r6 = ctx.$implicit;
    const first_r7 = ctx.first;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", first_r7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", v_r6.visible);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(v_r6.name);
} }
// TODO: Maybe we shouldnt use this model and use the XpoBoardView model
// directly in the template?
class XpoAvailableViewItem {
    constructor(view, visible) {
        this.deleteable = view.closeable;
        this.id = view.id;
        this.name = view.name;
        this.systemDefined = view.systemDefined;
        this.visible = visible;
        this.view = view;
    }
}
class XpoAvailableViews extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd, dialog) {
        super(boardDataSourceResolver, cd);
        this.dialog = dialog;
        this.systemViews = [];
        this.customViews = [];
        this.availableViews = [];
        this.visibleViewData = [];
        this.state = { source: 'AVAILABLE-VIEWS' };
    }
    get visibleCustomViews() {
        return this.customViews.filter((v) => v.visible);
    }
    get hiddenCustomViews() {
        return this.customViews.filter((v) => !v.visible);
    }
    toggleViewDisplay(toggleView) {
        // getting updated state with hidden/shown view applied
        const updatedState = toggleView.visible
            ? XpoBoardViewUtil.hideView(toggleView.id, this.state, 'AVAILABLE-VIEWS-HIDE')
            : XpoBoardViewUtil.showView(toggleView.id, this.state, 'AVAILABLE-VIEWS-SHOW');
        this.stateChange$.next(updatedState);
        // Sending it up to the viewDataStore to persist these changes
        this.viewDataStore
            .updateViewVisibility(toggleView.id, !toggleView.visible)
            .pipe(take(1))
            .subscribe();
    }
    openEditViewDialog(view) {
        this.dialog
            .open(XpoSaveViewDialog, {
            minWidth: '500px',
            data: {
                state: this.state,
                purpose: XpoSaveViewDialogPurpose.Edit,
                saveView: this.saveView.bind(this, view.view),
                view: view.view,
            },
        })
            .afterClosed()
            .pipe(take(1))
            .subscribe((newState) => {
            if (newState) {
                this.stateChange$.next(newState);
            }
        });
    }
    openDeleteConfirmDialog(view) {
        this.dialog
            .open(XpoDeleteViewConfirmDialog, {
            minWidth: '500px',
            data: { deleteView: this.deleteView.bind(this, view.view) },
        })
            .afterClosed()
            .pipe(take(1))
            .subscribe((newState) => {
            if (newState) {
                this.stateChange$.next(newState);
            }
        });
    }
    onStateChange(state) {
        this.state = state;
        if (this.shouldUpdateData(state)) {
            this.availableViews = state.availableViews;
            this.visibleViewData = state.visibleViewData;
            this.systemViews = state.availableViews
                .filter((v) => v.systemDefined)
                .map((v) => new XpoAvailableViewItem(v, state.visibleViewData.some((vv) => vv.viewId === v.id)));
            // show user views that have been persisted
            this.customViews = state.availableViews
                .filter((v) => !v.systemDefined && v.lastSaved)
                .map((v) => new XpoAvailableViewItem(v, state.visibleViewData.some((vv) => vv.viewId === v.id)));
        }
    }
    saveView(view, viewConfig, saveAs = false) {
        return this.viewDataStore.save(viewConfig).pipe(map((savedView) => {
            const newView = view.template.createView(viewConfig);
            return XpoBoardViewUtil.updateView(newView, this.state, 'AVAILABLE-VIEWS-SAVE-VIEW');
        }));
    }
    deleteView(view) {
        return this.viewDataStore.delete(view.id).pipe(map((res) => {
            if (res) {
                return XpoBoardViewUtil.deleteView(view.id, this.state, 'AVAILABLE-VIEWS-DELETE-VIEW');
            }
        }));
    }
    shouldUpdateData(state) {
        return ((this.state.changes.includes('availableViews') && this.availableViews !== state.availableViews) ||
            (this.state.changes.includes('visibleViewData') && this.visibleViewData !== state.visibleViewData));
    }
}
XpoAvailableViews.ɵfac = function XpoAvailableViews_Factory(t) { return new (t || XpoAvailableViews)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$5.MatDialog)); };
XpoAvailableViews.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAvailableViews, selectors: [["xpo-available-views"]], hostAttrs: [1, "xpo-AvailableViews"], inputs: { viewDataStore: "viewDataStore" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 10, consts: [["mat-icon-button", "", "matTooltip", "View Settings", "matTooltipPosition", "above", 3, "xpoPopoverTriggerFor"], ["position", "below", "caretPosition", "end"], ["popover", "xpoPopover"], ["floatLabel", "never", 1, "xpo-AvailableViews-search"], ["matInput", "", 3, "ngModel", "ngModelChange"], ["role", "list", 1, "xpo-AvailableViews-list"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["role", "listitem"], [3, "checked", "disabled"], ["mat-subheader", ""], ["role", "listitem", 1, "xpo-AvailableViews-userDefinedView"], [3, "checked", "change"], [1, "xpo-AvailableViews-actions"], ["mat-icon-button", "", "matTooltip", "Edit View Name", "matTooltipPosition", "above", 3, "click"], ["mat-icon-button", "", "color", "warn", "matTooltip", "Delete View", "matTooltipPosition", "above", 3, "click"]], template: function XpoAvailableViews_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "star");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "xpo-popover", 1, 2);
        i0.ɵɵelementStart(5, "mat-form-field", 3);
        i0.ɵɵelementStart(6, "mat-label");
        i0.ɵɵtext(7, "Search");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "input", 4);
        i0.ɵɵlistener("ngModelChange", function XpoAvailableViews_Template_input_ngModelChange_8_listener($event) { return ctx.query = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "mat-list", 5);
        i0.ɵɵtemplate(10, XpoAvailableViews_ng_container_10_Template, 5, 4, "ng-container", 6);
        i0.ɵɵpipe(11, "xpoAvailableViewsFilter");
        i0.ɵɵtemplate(12, XpoAvailableViews_ng_container_12_Template, 12, 3, "ng-container", 6);
        i0.ɵɵpipe(13, "xpoAvailableViewsFilter");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵproperty("xpoPopoverTriggerFor", _r0);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngModel", ctx.query);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(11, 4, ctx.systemViews, ctx.query));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(13, 7, ctx.customViews, ctx.query));
    } }, styles: [".flex--stretch{flex:1}.xpo-AvailableViews-search.mat-form-field{padding:8px;width:100%}.xpo-AvailableViews-search.mat-form-field .mat-form-field-wrapper{margin:0}.xpo-AvailableViews-list.mat-list{flex-grow:1;max-height:300px;overflow:auto;padding:0}.xpo-AvailableViews-list.mat-list .mat-subheader{color:#4a4a4a;font-size:14px;font-weight:500;height:40px;line-height:40px;opacity:1}.xpo-AvailableViews-list.mat-list .mat-checkbox-label{color:#6f6f6f;font-size:14px;line-height:16px;opacity:1}.xpo-AvailableViews-list.mat-list .mat-divider{border-top-color:#d8d8d8;margin-top:4px}.xpo-AvailableViews-list.mat-list .mat-list-item{height:32px}.xpo-AvailableViews-list.mat-list .mat-list-item .mat-list-item-content{padding:0 8px}.xpo-AvailableViews-userDefinedView.mat-list-item div.mat-list-item-content{padding-right:0}.xpo-AvailableViews-actions{display:inline-flex;justify-content:flex-end;padding-left:8px;width:100%}.xpo-AvailableViews-actions .mat-icon-button{height:32px;width:32px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAvailableViews, [{
        type: Component,
        args: [{
                selector: 'xpo-available-views',
                templateUrl: './available-views.component.html',
                styleUrls: ['./available-views.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-AvailableViews' },
            }]
    }], function () { return [{ type: XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }, { type: i1$5.MatDialog }]; }, { viewDataStore: [{
            type: Input
        }] }); })();

class XpoColumnLevelFilteringToggleComponent extends XpoBoardConsumer {
    constructor() {
        super(...arguments);
        this.isFiltersVisible = XpoColumnLevelFilteringToggleComponent.IsFilterVisibleDefaultValue;
    }
    toggleColumnLevelFiltering() {
        this.isFiltersVisible = !this.isFiltersVisible;
        this.stateChange$.next({
            columnLevelFilteringVisible: this.isFiltersVisible,
            source: XpoBoardStateSources.ColumnLevelFilteringToggle,
        });
    }
    onStateChange(state) {
        this.isFiltersVisible = state.columnLevelFilteringVisible;
    }
}
XpoColumnLevelFilteringToggleComponent.IsFilterVisibleDefaultValue = true;
XpoColumnLevelFilteringToggleComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoColumnLevelFilteringToggleComponent_BaseFactory; return function XpoColumnLevelFilteringToggleComponent_Factory(t) { return (ɵXpoColumnLevelFilteringToggleComponent_BaseFactory || (ɵXpoColumnLevelFilteringToggleComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoColumnLevelFilteringToggleComponent)))(t || XpoColumnLevelFilteringToggleComponent); }; }();
XpoColumnLevelFilteringToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoColumnLevelFilteringToggleComponent, selectors: [["xpo-column-level-filtering-toggle"]], hostAttrs: [1, "xpo-column-level-filtering-toggle"], features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["mat-icon-button", "", "matTooltip", "Show/Hide Column Filters", "matTooltipPosition", "above", 3, "click"]], template: function XpoColumnLevelFilteringToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function XpoColumnLevelFilteringToggleComponent_Template_button_click_0_listener() { return ctx.toggleColumnLevelFiltering(); });
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "filter_list");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, directives: [i3$1.MatButton, i3$3.MatTooltip, i3.MatIcon], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoColumnLevelFilteringToggleComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-column-level-filtering-toggle',
                templateUrl: './column-level-filtering-toggle.component.html',
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-column-level-filtering-toggle' },
            }]
    }], null, null); })();

function XpoGridColumnSelectionComponent_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-checkbox", 5);
    i0.ɵɵlistener("change", function XpoGridColumnSelectionComponent_ng_container_3_ng_container_2_Template_mat_checkbox_change_1_listener() { i0.ɵɵrestoreView(_r6); const col_r1 = i0.ɵɵnextContext().$implicit; const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.handleSelect(col_r1); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", col_r1.lockVisible)("checked", col_r1.isVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r1.headerName, " ");
} }
function XpoGridColumnSelectionComponent_ng_container_3_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "mat-checkbox", 8);
    i0.ɵɵlistener("change", function XpoGridColumnSelectionComponent_ng_container_3_ng_container_3_div_1_Template_mat_checkbox_change_1_listener() { i0.ɵɵrestoreView(_r12); const child_r8 = i0.ɵɵnextContext().$implicit; const col_r1 = i0.ɵɵnextContext().$implicit; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.handleChildSelect(child_r8, col_r1); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", child_r8.isVisible)("disabled", child_r8.lockVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", child_r8.headerName, " ");
} }
function XpoGridColumnSelectionComponent_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoGridColumnSelectionComponent_ng_container_3_ng_container_3_div_1_Template, 3, 3, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r8 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(child_r8.hide && child_r8.lockVisible && !child_r8.hideInGridSettings));
} }
function XpoGridColumnSelectionComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, XpoGridColumnSelectionComponent_ng_container_3_ng_container_2_Template, 3, 3, "ng-container", 4);
    i0.ɵɵtemplate(3, XpoGridColumnSelectionComponent_ng_container_3_ng_container_3_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !col_r1.hideInGridSettings);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", col_r1.children);
} }
class XpoGridColumnSelectionComponent {
    constructor() {
        this.isSelectAllChecked = true;
        this.isSelectAllIndeterminate = false;
        this.columnOptionsValueSubject = new BehaviorSubject(undefined);
        this.columnOptionsValue$ = this.columnOptionsValueSubject.asObservable();
        this.columnOptionsChange = new EventEmitter();
    }
    get columnOptions() {
        return this.columnOptionsValueSubject.value;
    }
    set columnOptions(v) {
        // update the col selections for the first time only
        this.columnOptionsValueSubject.next(v);
        this.updateSelectAllState();
    }
    handleSelect(column, toggle = !column.isVisible) {
        column.isVisible = toggle;
        this.updateChildrenState(column);
        this.dispatchSelectionChange();
    }
    handleChildSelect(child, parent, toggle = !child.isVisible) {
        child.isVisible = toggle;
        parent.isVisible = parent.children.some((c) => c.isVisible);
        this.dispatchSelectionChange();
    }
    updateChildrenState(column) {
        var _a;
        (_a = column.children) === null || _a === void 0 ? void 0 : _a.forEach((c) => {
            if (!c.lockVisible) {
                c.isVisible = column.isVisible;
            }
        });
    }
    dispatchSelectionChange() {
        this.updateSelectAllState();
        this.columnOptionsChange.next(this.columnOptions);
    }
    selectAll() {
        this.isSelectAllChecked = !this.isSelectAllChecked;
        this.columnOptions.forEach((column) => {
            if (!column.lockVisible) {
                column.isVisible = this.isSelectAllChecked;
                this.updateChildrenState(column);
            }
        });
        this.dispatchSelectionChange();
    }
    updateSelectAllState() {
        this.isSelectAllChecked = (this.columnOptions || []).every((column) => column.isVisible &&
            (column.children
                ? column.children.every((child) => child.isVisible || (child.hide && child.lockVisible))
                : true));
        this.isSelectAllIndeterminate =
            !this.isSelectAllChecked && (this.columnOptions || []).some((column) => column.isVisible);
    }
}
XpoGridColumnSelectionComponent.ɵfac = function XpoGridColumnSelectionComponent_Factory(t) { return new (t || XpoGridColumnSelectionComponent)(); };
XpoGridColumnSelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoGridColumnSelectionComponent, selectors: [["xpo-grid-column-selection"]], hostAttrs: [1, "xpo-GridColumnSelection"], inputs: { columnOptions: "columnOptions" }, outputs: { columnOptionsChange: "columnOptionsChange" }, decls: 5, vars: 5, consts: [[1, "xpo-GridColumnSelection-selectAll", 3, "indeterminate", "checked", "change"], [1, "xpo-GridColumnSelection-columns"], [4, "ngFor", "ngForOf"], [1, "xpo-GridColumnSelection-columns-group"], [4, "ngIf"], [3, "disabled", "checked", "change"], ["class", "xpo-GridColumnSelection-columns-group--Child", 4, "ngIf"], [1, "xpo-GridColumnSelection-columns-group--Child"], [3, "checked", "disabled", "change"]], template: function XpoGridColumnSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-checkbox", 0);
        i0.ɵɵlistener("change", function XpoGridColumnSelectionComponent_Template_mat_checkbox_change_0_listener() { return ctx.selectAll(); });
        i0.ɵɵtext(1, " Select/Deselect All\n");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, XpoGridColumnSelectionComponent_ng_container_3_Template, 4, 2, "ng-container", 2);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("indeterminate", ctx.isSelectAllIndeterminate)("checked", ctx.isSelectAllChecked);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 3, ctx.columnOptionsValue$));
    } }, directives: [i1.MatCheckbox, i2.NgForOf, i2.NgIf], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-GridColumnSelection{display:flex;flex-direction:column;overflow:hidden;overflow-y:auto}.xpo-GridColumnSelection-selectAll{font-weight:500}.xpo-GridColumnSelection-columns{display:flex;flex-direction:column;flex-wrap:wrap}.xpo-GridColumnSelection-columns .mat-checkbox{flex:0 1 33%}.xpo-GridColumnSelection-columns .xpo-GridColumnSelection-columns-group .xpo-GridColumnSelection-columns-group--Child{padding-left:16px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGridColumnSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-grid-column-selection',
                templateUrl: './grid-column-selection.component.html',
                styleUrls: ['./grid-column-selection.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-GridColumnSelection' },
            }]
    }], null, { columnOptions: [{
            type: Input
        }], columnOptionsChange: [{
            type: Output
        }] }); })();

function XpoGridSettingsColumnSelectionComponent_mat_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 3);
    i0.ɵɵlistener("change", function XpoGridSettingsColumnSelectionComponent_mat_checkbox_3_Template_mat_checkbox_change_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const col_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.handleSelect(col_r1); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r1 = ctx.$implicit;
    i0.ɵɵproperty("checked", col_r1.isVisible)("disabled", col_r1.lockVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r1.headerName, " ");
} }
class XpoGridSettingsColumnSelectionComponent {
    constructor() {
        this.isSelectAllChecked = true;
        this.isSelectAllIndeterminate = false;
        this.columnOptionsChange = new EventEmitter();
    }
    get columnOptions() {
        return this.columnOptionsValue;
    }
    set columnOptions(v) {
        this.columnOptionsValue = v;
        this.updateSelectAllState();
    }
    handleSelect(column) {
        column.isVisible = !column.isVisible;
        this.updateSelectAllState();
        this.columnOptionsChange.next(this.columnOptions);
    }
    selectAll() {
        this.isSelectAllChecked = !this.isSelectAllChecked;
        this.columnOptions.forEach((column) => {
            if (!column.lockVisible) {
                column.isVisible = this.isSelectAllChecked;
            }
        });
        this.columnOptionsChange.next(this.columnOptions);
    }
    updateSelectAllState() {
        this.isSelectAllChecked = (this.columnOptions || []).every((column) => column.isVisible);
        this.isSelectAllIndeterminate =
            !this.isSelectAllChecked && (this.columnOptions || []).some((column) => column.isVisible);
    }
}
XpoGridSettingsColumnSelectionComponent.ɵfac = function XpoGridSettingsColumnSelectionComponent_Factory(t) { return new (t || XpoGridSettingsColumnSelectionComponent)(); };
XpoGridSettingsColumnSelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoGridSettingsColumnSelectionComponent, selectors: [["xpo-grid-settings-column-selection"]], hostAttrs: [1, "xpo-GridSettingsColumnSelection"], inputs: { columnOptions: "columnOptions" }, outputs: { columnOptionsChange: "columnOptionsChange" }, decls: 4, vars: 3, consts: [[1, "xpo-GridSettingsColumnSelection-selectAll", 3, "indeterminate", "checked", "change"], [1, "xpo-GridSettingsColumnSelection-columns"], [3, "checked", "disabled", "change", 4, "ngFor", "ngForOf"], [3, "checked", "disabled", "change"]], template: function XpoGridSettingsColumnSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-checkbox", 0);
        i0.ɵɵlistener("change", function XpoGridSettingsColumnSelectionComponent_Template_mat_checkbox_change_0_listener() { return ctx.selectAll(); });
        i0.ɵɵtext(1, " Select/Deselect All\n");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, XpoGridSettingsColumnSelectionComponent_mat_checkbox_3_Template, 2, 3, "mat-checkbox", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("indeterminate", ctx.isSelectAllIndeterminate)("checked", ctx.isSelectAllChecked);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.columnOptions);
    } }, directives: [i1.MatCheckbox, i2.NgForOf], styles: [".flex--stretch{flex:1}.xpo-GridSettingsColumnSelection{display:flex;flex-direction:column}.xpo-GridSettingsColumnSelection-selectAll{font-weight:500}.xpo-GridSettingsColumnSelection-columns{display:flex;flex-wrap:wrap}.xpo-GridSettingsColumnSelection-columns .mat-checkbox{flex:0 1 33%}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGridSettingsColumnSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-grid-settings-column-selection',
                templateUrl: './grid-settings-column-selection.component.html',
                styleUrls: ['./grid-settings-column-selection.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-GridSettingsColumnSelection' },
            }]
    }], null, { columnOptions: [{
            type: Input
        }], columnOptionsChange: [{
            type: Output
        }] }); })();

class XpoSettingsGridOptionsComponent extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd) {
        super(boardDataSourceResolver, cd);
        /** Column Options that will be mutated from the grid column selection component via 2 way binding */
        this.columnOptions = [];
        /** All columns from the current template */
        this.availableColumns = [];
        /** List of columns with no header names */
        this.columnsWithNoHeaderName = [];
    }
    handlePopoverClose(closeData) {
        // If user doesn't hit apply, reset to previous state
        if (!closeData) {
            this.handleStateUpdate(this.cachedState);
        }
    }
    applySettingsUpdates() {
        const selectedColumnsToSubmit = this.availableColumns.filter((column) => {
            const sel = this.columnOptions.find((col) => col.headerName === column.headerName);
            if (sel && sel.isVisible) {
                return column;
            }
        });
        const newState = {
            visibleColumns: [...this.columnsWithNoHeaderName, ...selectedColumnsToSubmit],
            source: XpoBoardStateSources.GridSettingsUpdate,
        };
        this.stateChange$.next(newState);
    }
    onStateChange(state) {
        if (this.shouldUpdateState(state)) {
            this.cachedState = state;
            this.handleStateUpdate(state);
        }
    }
    handleStateUpdate(state) {
        this.updateColumnSelectionWithState(state);
    }
    updateColumnSelectionWithState(state) {
        const template = state.template;
        const visibleColumns = state.visibleColumns || [];
        this.availableColumns = (template && template.availableColumns) || [];
        // Storing the column headers with no header names so they can be appended to the selected columns
        this.columnsWithNoHeaderName = this.availableColumns.filter((c) => !c.headerName);
        // mapping columns to view model columns
        this.columnOptions = this.availableColumns
            .filter((c) => !!c.headerName)
            .map((column) => {
            return {
                headerName: column.headerName,
                isVisible: !visibleColumns.length || visibleColumns.some((c) => c.headerName === column.headerName),
                lockVisible: column.lockVisible,
            };
        });
    }
    shouldUpdateState(state) {
        const changeKeys = ['visibleColumns', 'template'];
        return changeKeys.some((v) => state.changes.includes(v));
    }
}
XpoSettingsGridOptionsComponent.ɵfac = function XpoSettingsGridOptionsComponent_Factory(t) { return new (t || XpoSettingsGridOptionsComponent)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoSettingsGridOptionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoSettingsGridOptionsComponent, selectors: [["xpo-settings-button-grid-options"]], hostAttrs: [1, "xpo-GridToolbar-settings-button"], features: [i0.ɵɵInheritDefinitionFeature], decls: 12, vars: 2, consts: [["mat-icon-button", "", "matTooltip", "Grid Settings", "matTooltipPosition", "above", 3, "xpoPopoverTriggerFor"], ["position", "below", "caretPosition", "end", 3, "closed"], ["popover", "xpoPopover"], [1, "xpo-GridToolbar-settings-button-popoverContent"], [1, "xpo-GridToolbar-settings-button-columnSelection", 3, "columnOptions", "columnOptionsChange"], [1, "xpo-GridToolbar-settings-button-actions"], ["mat-button", "", "xpo-popover-close", "", "color", "primary", 1, "xpo-GridToolbar-settings-button-cancel"], ["mat-flat-button", "", 1, "xpo-GridToolbar-settings-button-apply", 3, "click"]], template: function XpoSettingsGridOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "settings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "xpo-popover", 1, 2);
        i0.ɵɵlistener("closed", function XpoSettingsGridOptionsComponent_Template_xpo_popover_closed_3_listener($event) { return ctx.handlePopoverClose($event); });
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "xpo-grid-settings-column-selection", 4);
        i0.ɵɵlistener("columnOptionsChange", function XpoSettingsGridOptionsComponent_Template_xpo_grid_settings_column_selection_columnOptionsChange_6_listener($event) { return ctx.columnOptions = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "xpo-button-group", 5);
        i0.ɵɵelementStart(8, "button", 6);
        i0.ɵɵtext(9, " Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function XpoSettingsGridOptionsComponent_Template_button_click_10_listener() { return ctx.applySettingsUpdates(); });
        i0.ɵɵtext(11, " Apply Changes ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵproperty("xpoPopoverTriggerFor", _r0);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("columnOptions", ctx.columnOptions);
    } }, directives: [i3$1.MatButton, i3$3.MatTooltip, i4$1.XpoPopoverTrigger, i3.MatIcon, i4$1.XpoPopover, XpoGridSettingsColumnSelectionComponent, i2$1.XpoButtonGroup, i4$1.XpoPopoverClose], styles: [".flex--stretch{flex:1}.xpo-GridToolbar-settings-button-popoverContent{max-width:50vw;padding:8px}.xpo-GridToolbar-settings-button-columnSelection{padding-bottom:8px}.xpo-GridToolbar-settings-button-actions.xpo-ButtonGroup{border-top:1px solid #d8d8d8;display:flex;justify-content:flex-end;padding-top:8px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSettingsGridOptionsComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-settings-button-grid-options',
                templateUrl: './grid-settings-default-buttons.component.html',
                styleUrls: ['./grid-settings-default-buttons.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-GridToolbar-settings-button' },
            }]
    }], function () { return [{ type: XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }]; }, null); })();

var XpoGridDisplayDensityOptions;
(function (XpoGridDisplayDensityOptions) {
    XpoGridDisplayDensityOptions["Default"] = "Default";
    XpoGridDisplayDensityOptions["Compact"] = "Compact";
    XpoGridDisplayDensityOptions["Comfortable"] = "Comfortable";
})(XpoGridDisplayDensityOptions || (XpoGridDisplayDensityOptions = {}));

function XpoGridRowHeightSelectionComponent_mat_radio_button_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r1.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r1.name, " ");
} }
class XpoGridRowHeightSelectionComponent {
    constructor(defaultRowHeight) {
        this.rowHeightOptions = [];
        this.selectedRowHeightChange = new EventEmitter();
        const rowHeight = defaultRowHeight || 40;
        this.rowHeightOptions = [
            { name: XpoGridDisplayDensityOptions.Default, value: rowHeight },
            { name: XpoGridDisplayDensityOptions.Compact, value: rowHeight - 8 },
            { name: XpoGridDisplayDensityOptions.Comfortable, value: rowHeight + 8 },
        ];
    }
    updateSelectedRowHeight(value) {
        this.selectedRowHeight = value;
        this.selectedRowHeightChange.emit(this.selectedRowHeight);
    }
}
XpoGridRowHeightSelectionComponent.ɵfac = function XpoGridRowHeightSelectionComponent_Factory(t) { return new (t || XpoGridRowHeightSelectionComponent)(i0.ɵɵdirectiveInject(XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT, 8)); };
XpoGridRowHeightSelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoGridRowHeightSelectionComponent, selectors: [["xpo-grid-row-height-selection"]], hostAttrs: [1, "xpo-GridRowHeightSelection"], inputs: { selectedRowHeight: "selectedRowHeight" }, outputs: { selectedRowHeightChange: "selectedRowHeightChange" }, decls: 4, vars: 2, consts: [[1, "xpo-GridRowHeightSelection-label"], [1, "xpo-GridRowHeightSelection-radioGroup", 3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function XpoGridRowHeightSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "label", 0);
        i0.ɵɵtext(1, "Display Density");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "mat-radio-group", 1);
        i0.ɵɵlistener("ngModelChange", function XpoGridRowHeightSelectionComponent_Template_mat_radio_group_ngModelChange_2_listener($event) { return ctx.updateSelectedRowHeight($event); });
        i0.ɵɵtemplate(3, XpoGridRowHeightSelectionComponent_mat_radio_button_3_Template, 2, 2, "mat-radio-button", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.selectedRowHeight);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.rowHeightOptions);
    } }, directives: [i5$1.MatRadioGroup, i1$1.NgControlStatus, i1$1.NgModel, i2.NgForOf, i5$1.MatRadioButton], styles: [".flex--stretch{flex:1}.xpo-GridRowHeightSelection{display:flex;flex-direction:column;padding-bottom:8px}.xpo-GridRowHeightSelection-label{font-weight:500;margin-left:4px}.xpo-GridRowHeightSelection-radioGroup>.mat-radio-button{padding-right:4px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGridRowHeightSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-grid-row-height-selection',
                templateUrl: './grid-row-height-selection.component.html',
                styleUrls: ['./grid-row-height-selection.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-GridRowHeightSelection' },
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT]
            }, {
                type: Optional
            }] }]; }, { selectedRowHeight: [{
            type: Input
        }], selectedRowHeightChange: [{
            type: Output
        }] }); })();

class XpoBoardColumnsHelper {
    /**
     * Looks for a col reference in the first level of the dataset
     * and through its children just one level.
     * Default using col id, with third param can use headerName
     * TODO: Recursive children - NGXLTL-XXX
     * @param searchedId The searched col id
     * @param origin Dataset where look for
     * @param useHeaderName false by default. If true uses headerName in place of colId
     * @returns Returns the col reference or undefined
     */
    static getColRef(searchedId, origin, useHeaderName = false) {
        let searchMethod = XpoBoardColumnsHelper.getColByColIdOneLevel;
        if (useHeaderName) {
            searchMethod = XpoBoardColumnsHelper.getColByHeaderNameOneLevel;
        }
        // Iterate first level searching among parent columns
        let searchedColumn = searchMethod(searchedId, origin);
        // If not found search in children columns
        if (!searchedColumn) {
            // Iterate each parent accessing their children. If some child if found, stop iteration
            origin.some(({ children }) => {
                // Iterate each child searching the ID
                return (searchedColumn = searchMethod(searchedId, children));
            });
        }
        // If no column was found in parents and children (first level) return undefined
        return searchedColumn;
    }
    /**
     * Looks for a col reference in the first level of a dataset.
     * This column was abstracted to allow many methods to use it.
     * @param searchedId The searched col id
     * @param origin Dataset where look for
     * @returns Returns the col reference or undefined
     */
    static getColByColIdOneLevel(searchedId, origin) {
        // If origin is defined, search inside
        return origin && searchedId && origin.find((col) => col.colId && col.colId === searchedId);
    }
    /**
     * Looks for a col reference in the first level of a dataset.
     * This column was abstracted to allow many methods to use it.
     * @param searchedHeaderName The searched col id
     * @param origin Dataset where look for
     * @returns Returns the col reference or undefined
     */
    static getColByHeaderNameOneLevel(searchedHeaderName, origin) {
        // If origin is defined, search inside
        return (origin &&
            searchedHeaderName &&
            origin.find((col) => col.headerName && col.headerName === searchedHeaderName));
    }
}

const _c0$j = ["popover"];
function XpoGridSettingsComponent_xpo_grid_row_height_selection_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "xpo-grid-row-height-selection", 9);
    i0.ɵɵlistener("selectedRowHeightChange", function XpoGridSettingsComponent_xpo_grid_row_height_selection_6_Template_xpo_grid_row_height_selection_selectedRowHeightChange_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.selectedRowHeight = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedRowHeight", ctx_r1.selectedRowHeight);
} }
class XpoGridSettingsComponent extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd, defaultRowHeight) {
        super(boardDataSourceResolver, cd);
        this.defaultRowHeight = defaultRowHeight;
        /** Column Options that will be mutated from the grid column selection component via 2 way binding */
        this.columnOptions = [];
        /** All columns from the current template */
        this.availableColumns = [];
        /** This is used to verify the below,
         *  if the close event for popover is coming from "Apply Changes" button in grid settings */
        this.clickedApplyChangesButton = undefined;
        /** List of columns with no header names */
        this.columnsWithNoHeaderName = [];
        this.suppressGridDensity = false;
        this.sortAlphabetically = (firstColumn, secondColumn) => {
            if (firstColumn.lockVisible) {
                return 1;
            }
            if (secondColumn.lockVisible) {
                return 1;
            }
            if (firstColumn.headerName < secondColumn.headerName) {
                return -1;
            }
            if (firstColumn.headerName > secondColumn.headerName) {
                return 1;
            }
            return 0;
        };
    }
    handlePopoverClose(closeData) {
        // If user doesn't hit apply, reset to previous state
        if (!closeData && !this.clickedApplyChangesButton) {
            this.handleStateUpdate(this.cachedState);
        }
        this.clickedApplyChangesButton = false;
    }
    applyChangesClick($event) {
        this.applySettingsUpdates();
        this.popover.closed.emit();
    }
    applySettingsUpdates() {
        const selectedColumnsToSubmit = this.availableColumns
            .map((column) => {
            const columnOption = this.columnOptions.find((col) => col.headerName === column.headerName);
            // Clone the column to avoid changing the original ref on this.availableColumns
            const originalColumnDef = cloneDeep(column);
            // If the column is visible, return it to the selectedColumnsToSubmit Array
            if (columnOption) {
                // Show the column if it was hidden by default
                originalColumnDef.hide = !columnOption.isVisible;
                if (columnOption.isVisible) {
                    // If the column has children, check if they are visible or hide one by one
                    if (columnOption.children && columnOption.children.length) {
                        // Update the children ref filtering only the visible
                        originalColumnDef.children = originalColumnDef.children.filter((colChild) => {
                            // Get the child from the column option with the originalColDef headerName
                            const childOption = columnOption.children.find((child) => child.headerName === colChild.headerName);
                            if (childOption) {
                                // Show the column if it was hidden by default
                                colChild.hide = !childOption.isVisible;
                            }
                            return colChild;
                        });
                    }
                    return originalColumnDef;
                }
            }
        })
            // Return only the columns that are defined,
            // some columns come undefined because are not defined on this.columnOptions
            .filter((c) => c);
        const newState = {
            visibleColumns: [...this.columnsWithNoHeaderName, ...selectedColumnsToSubmit],
            source: XpoBoardStateSources.GridSettingsUpdate,
        };
        if (this.selectedRowHeight !== this.cachedState.rowHeight) {
            newState.rowHeight = this.selectedRowHeight;
            newState.changes = ['rowHeight'];
        }
        this.clickedApplyChangesButton = true;
        this.stateChange$.next(newState);
        this.popover.closed.emit();
    }
    onStateChange(state) {
        this.cachedState = state;
        this.handleStateUpdate(state);
        // Update selected row height in modal
        if (state.rowHeight !== this.selectedRowHeight) {
            this.selectedRowHeight = state.rowHeight;
        }
    }
    handleStateUpdate(state) {
        this.updateColumnSelectionWithState(state);
    }
    updateColumnSelectionWithState(state) {
        const template = state === null || state === void 0 ? void 0 : state.template;
        const visibleColumns = (state === null || state === void 0 ? void 0 : state.visibleColumns) || [];
        this.availableColumns = (template && template.availableColumns) || [];
        // Storing the column headers with no header names so they can be appended to the selected columns
        this.columnsWithNoHeaderName = this.availableColumns.filter((c) => !c.headerName);
        // mapping columns to view model columns
        this.columnOptions = this.formatColumnsOption(this.availableColumns, visibleColumns);
        this.selectedRowHeight = state.rowHeight || this.defaultRowHeight;
        this.cachedState.rowHeight = this.selectedRowHeight;
    }
    formatColumnsOption(columns, visibleColumns) {
        return columns
            .filter((c) => !!c.headerName)
            .map((column) => {
            return {
                headerName: column.headerName,
                isVisible: this.shouldShowMainColumn(column, visibleColumns),
                lockVisible: column.lockVisible,
                children: this.formatColumnsChildren(column.children, visibleColumns),
                hideInGridSettings: column.hideInGridSettings,
            };
        })
            .sort(this.sortAlphabetically);
    }
    formatColumnsChildren(childrenS, visibleColumns) {
        // If childrenS is undefined (because column.children) just return undefined, else return the mapping
        return (childrenS &&
            childrenS
                .filter((c) => !!c.headerName)
                .map((column) => {
                return {
                    headerName: column.headerName,
                    isVisible: this.shouldShowChildColum(column, visibleColumns),
                    lockVisible: column.lockVisible,
                    children: undefined,
                    hide: column.hide,
                    hideInGridSettings: column.hideInGridSettings,
                };
            }));
        // TODO: It's not considering recursive children since the whole board is not supporting it.
    }
    shouldShowMainColumn(column, visibleColumns) {
        var _a;
        // Get the current instance of the column and assign it a XpoGridBoardColumn interface to access their children
        const colGroup = XpoBoardColumnsHelper.getColRef(column.headerName, visibleColumns, true);
        // First check if the column has children and at least one of them is visible
        return ((!!(colGroup === null || colGroup === void 0 ? void 0 : colGroup.children) ? colGroup.children.some((c) => !c.hide) : true) &&
            // Then check if this column is visible in the visibleColumns state
            !!visibleColumns &&
            visibleColumns.some((c) => c.headerName === column.headerName) &&
            // Finally check if the column isn't hide by the user columns definition
            ((_a = !(colGroup === null || colGroup === void 0 ? void 0 : colGroup.hide)) !== null && _a !== void 0 ? _a : true));
    }
    shouldShowChildColum(column, visibleColumns) {
        var _a;
        // First check if this child is visible in the visibleColumns state
        return ((!visibleColumns.length ||
            XpoBoardColumnsHelper.getColRef(column.headerName, visibleColumns, true) !== undefined) &&
            // Finally check if the child isn't hide by the user columns definition
            !((_a = XpoBoardColumnsHelper.getColRef(column.headerName, visibleColumns, true)) === null || _a === void 0 ? void 0 : _a.hide));
    }
    shouldUpdateState(state) {
        const changeKeys = ['visibleColumns', 'template', 'rowHeight'];
        return (changeKeys.some((v) => state.changes.includes(v)) ||
            state.source === XpoBoardStateSources.BoardDataFetcher ||
            !this.cachedState);
    }
}
XpoGridSettingsComponent.ɵfac = function XpoGridSettingsComponent_Factory(t) { return new (t || XpoGridSettingsComponent)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT, 8)); };
XpoGridSettingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoGridSettingsComponent, selectors: [["xpo-grid-settings"]], viewQuery: function XpoGridSettingsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$j, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, hostAttrs: [1, "xpo-GridSettings"], inputs: { suppressGridDensity: "suppressGridDensity" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 13, vars: 3, consts: [["mat-icon-button", "", "matTooltip", "Grid Settings", "matTooltipPosition", "above", 3, "xpoPopoverTriggerFor"], ["position", "below", "caretPosition", "end", 3, "closed"], ["popover", "xpoPopover"], [1, "xpo-GridSettings-popoverContent"], [3, "selectedRowHeight", "selectedRowHeightChange", 4, "ngIf"], [1, "xpo-GridSettings-columnSelection", 3, "columnOptions", "columnOptionsChange"], [1, "xpo-GridSettings-actions"], ["mat-button", "", "xpo-popover-close", "", "color", "primary", 1, "xpo-GridSettings-cancel"], ["mat-flat-button", "", 1, "xpo-GridSettings-apply", 3, "click"], [3, "selectedRowHeight", "selectedRowHeightChange"]], template: function XpoGridSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "settings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "xpo-popover", 1, 2);
        i0.ɵɵlistener("closed", function XpoGridSettingsComponent_Template_xpo_popover_closed_3_listener($event) { return ctx.handlePopoverClose($event); });
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtemplate(6, XpoGridSettingsComponent_xpo_grid_row_height_selection_6_Template, 1, 1, "xpo-grid-row-height-selection", 4);
        i0.ɵɵelementStart(7, "xpo-grid-column-selection", 5);
        i0.ɵɵlistener("columnOptionsChange", function XpoGridSettingsComponent_Template_xpo_grid_column_selection_columnOptionsChange_7_listener($event) { return ctx.columnOptions = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "xpo-button-group", 6);
        i0.ɵɵelementStart(9, "button", 7);
        i0.ɵɵtext(10, " Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "button", 8);
        i0.ɵɵlistener("click", function XpoGridSettingsComponent_Template_button_click_11_listener() { return ctx.applySettingsUpdates(); });
        i0.ɵɵtext(12, " Apply Changes ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵproperty("xpoPopoverTriggerFor", _r0);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", !ctx.suppressGridDensity);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("columnOptions", ctx.columnOptions);
    } }, directives: [i3$1.MatButton, i3$3.MatTooltip, i4$1.XpoPopoverTrigger, i3.MatIcon, i4$1.XpoPopover, i2.NgIf, XpoGridColumnSelectionComponent, i2$1.XpoButtonGroup, i4$1.XpoPopoverClose, XpoGridRowHeightSelectionComponent], styles: [".flex--stretch{flex:1}.xpo-GridSettings-popoverContent{display:flex;flex-direction:column;max-height:50vh;max-width:50vw;padding:8px}.xpo-GridSettings-columnSelection{padding-bottom:8px}.xpo-GridSettings-actions.xpo-ButtonGroup{border-top:1px solid #d8d8d8;display:flex;justify-content:flex-end;padding-top:8px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGridSettingsComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-grid-settings',
                templateUrl: './grid-settings.component.html',
                styleUrls: ['./grid-settings.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: ' xpo-GridSettings' },
            }]
    }], function () { return [{ type: XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT]
            }, {
                type: Optional
            }] }]; }, { popover: [{
            type: ViewChild,
            args: ['popover']
        }], suppressGridDensity: [{
            type: Input
        }] }); })();

var XpoBoardActionType;
(function (XpoBoardActionType) {
    XpoBoardActionType["Save"] = "Save";
    XpoBoardActionType["SaveAs"] = "SaveAs";
    XpoBoardActionType["Edit"] = "Edit";
    XpoBoardActionType["Delete"] = "Delete";
    XpoBoardActionType["AvailableViews"] = "AvailableViews";
})(XpoBoardActionType || (XpoBoardActionType = {}));
class XpoBoardActionsVisibilityService {
    constructor() {
        this.views = null;
        this.viewTemplates = null;
        this.viewDataStore = null;
    }
    isVisible(actionType) {
        switch (actionType) {
            case XpoBoardActionType.Save:
            case XpoBoardActionType.SaveAs:
                return this.isVisibleFromDataStore();
            case XpoBoardActionType.AvailableViews:
            case XpoBoardActionType.Edit:
            case XpoBoardActionType.Delete:
                return this.isVisibleFromDataStore() && this.isVisibleFromViewsOrTemplates();
        }
    }
    isDisabled(actionType, state) {
        if (!state) {
            return true;
        }
        switch (actionType) {
            case XpoBoardActionType.Save:
                return !state.viewId || state.isViewSystemDefined;
            case XpoBoardActionType.SaveAs:
                return !state.viewId;
            case XpoBoardActionType.Delete:
                return state.isViewSystemDefined;
            case XpoBoardActionType.Edit:
                return state.isViewSystemDefined || !state.viewLastSaved;
        }
    }
    isVisibleFromDataStore() {
        return !!this.viewDataStore;
    }
    isVisibleFromViewsOrTemplates() {
        return ((this.views && this.views.length > 0 && this.views.some((v) => v.closeable)) ||
            (this.viewTemplates && this.viewTemplates.length > 0 && this.viewTemplates.some((t) => t.allowAdditional)));
    }
}
XpoBoardActionsVisibilityService.ɵfac = function XpoBoardActionsVisibilityService_Factory(t) { return new (t || XpoBoardActionsVisibilityService)(); };
XpoBoardActionsVisibilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoBoardActionsVisibilityService, factory: XpoBoardActionsVisibilityService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardActionsVisibilityService, [{
        type: Injectable
    }], null, null); })();

class XpoSaveViewComponent extends XpoBoardConsumer {
    constructor(dialog, actionsVisibilityService, boardDataSourceResolver, cd) {
        super(boardDataSourceResolver, cd);
        this.dialog = dialog;
        this.actionsVisibilityService = actionsVisibilityService;
        this.currentState = { source: 'SAVE-VIEW-INIT' };
        this.isMenuDisabled = false;
        this.isSaveDisabled = false;
        this.isSaveAsDisabled = false;
    }
    saveCurrentView() {
        if (!this.currentState.viewLastSaved) {
            this.showDialog();
            return;
        }
        const currentView = XpoBoardViewUtil.findActiveView(this.currentState);
        this.saveView(currentView.toViewConfig(this.currentState), false)
            .pipe(take(1))
            .subscribe((newState) => {
            this.stateChange$.next(newState);
        });
    }
    showDialog() {
        const currentView = XpoBoardViewUtil.findActiveView(this.currentState);
        this.dialog
            .open(XpoSaveViewDialog, {
            minWidth: '500px',
            data: {
                state: this.currentState,
                purpose: XpoSaveViewDialogPurpose.Save,
                saveView: this.saveView.bind(this),
                view: currentView,
            },
        })
            .afterClosed()
            .pipe(take(1))
            .subscribe((newState) => {
            if (newState) {
                this.stateChange$.next(newState);
            }
        });
    }
    onSaveClick() {
        this.isMenuDisabled = true;
    }
    onMenuClosed() {
        this.isMenuDisabled = false;
    }
    onStateChange(state) {
        // TODO: only update the disabled states when view change/view template change
        this.currentState = state;
        this.isSaveDisabled = this.actionsVisibilityService.isDisabled(XpoBoardActionType.Save, this.currentState);
        this.isSaveAsDisabled = this.actionsVisibilityService.isDisabled(XpoBoardActionType.SaveAs, this.currentState);
        this.isMenuDisabled = this.isSaveDisabled && this.isSaveAsDisabled;
    }
    saveView(viewConfig, saveAs = false) {
        return this.viewDataStore.save(viewConfig).pipe(map((savedView) => {
            const newView = this.currentState.template.createView(savedView);
            const nextState = saveAs
                ? XpoBoardViewUtil.addView(newView, this.currentState, 'SAVE-VIEW-AS')
                : XpoBoardViewUtil.updateView(newView, this.currentState, 'SAVE-VIEW');
            return nextState;
        }));
    }
}
XpoSaveViewComponent.ɵfac = function XpoSaveViewComponent_Factory(t) { return new (t || XpoSaveViewComponent)(i0.ɵɵdirectiveInject(i1$5.MatDialog), i0.ɵɵdirectiveInject(XpoBoardActionsVisibilityService), i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoSaveViewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoSaveViewComponent, selectors: [["xpo-save-view"]], hostAttrs: [1, "xpo-SaveView"], inputs: { viewDataStore: "viewDataStore" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 4, consts: [["mat-icon-button", "", "matTooltip", "Save View", "matTooltipPosition", "above", 3, "matMenuTriggerFor", "disabled", "click"], [3, "closed"], ["saveView", "matMenu"], ["mat-menu-item", "", 3, "disabled", "click"]], template: function XpoSaveViewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function XpoSaveViewComponent_Template_button_click_0_listener() { return ctx.onSaveClick(); });
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-menu", 1, 2);
        i0.ɵɵlistener("closed", function XpoSaveViewComponent_Template_mat_menu_closed_3_listener() { return ctx.onMenuClosed(); });
        i0.ɵɵelementStart(5, "button", 3);
        i0.ɵɵlistener("click", function XpoSaveViewComponent_Template_button_click_5_listener() { return ctx.saveCurrentView(); });
        i0.ɵɵtext(6, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "button", 3);
        i0.ɵɵlistener("click", function XpoSaveViewComponent_Template_button_click_7_listener() { return ctx.showDialog(); });
        i0.ɵɵtext(8, "Save As");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵproperty("matMenuTriggerFor", _r0)("disabled", ctx.isMenuDisabled);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("disabled", ctx.isSaveDisabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.isSaveAsDisabled);
    } }, directives: [i3$1.MatButton, i3$3.MatTooltip, i6.MatMenuTrigger, i3.MatIcon, i6.MatMenu, i6.MatMenuItem], styles: [""], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSaveViewComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-save-view',
                templateUrl: './save-view.component.html',
                styleUrls: ['./save-view.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-SaveView' },
            }]
    }], function () { return [{ type: i1$5.MatDialog }, { type: XpoBoardActionsVisibilityService }, { type: XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }]; }, { viewDataStore: [{
            type: Input
        }] }); })();

function XpoBoardDataFetchDisplay_div_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner");
} }
function XpoBoardDataFetchDisplay_div_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
function XpoBoardDataFetchDisplay_div_1_ng_template_4_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function XpoBoardDataFetchDisplay_div_1_ng_template_4_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(3); return ctx_r5.retry(); });
    i0.ɵɵtext(1, "Click Here To Retry");
    i0.ɵɵelementEnd();
} }
function XpoBoardDataFetchDisplay_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1, "An Error Has Occurred. ");
    i0.ɵɵtemplate(2, XpoBoardDataFetchDisplay_div_1_ng_template_4_button_2_Template, 2, 0, "button", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.dataSource);
} }
function XpoBoardDataFetchDisplay_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementContainerStart(1, 2);
    i0.ɵɵtemplate(2, XpoBoardDataFetchDisplay_div_1_ng_template_2_Template, 1, 0, "ng-template", 3);
    i0.ɵɵtemplate(3, XpoBoardDataFetchDisplay_div_1_ng_template_3_Template, 1, 0, "ng-template", 3);
    i0.ɵɵtemplate(4, XpoBoardDataFetchDisplay_div_1_ng_template_4_Template, 3, 1, "ng-template", 3);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r0.dataFetchState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.XpoBoardDataFetchState.Loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.XpoBoardDataFetchState.NoResults);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.XpoBoardDataFetchState.Error);
} }
const _c0$i = ["*"];
class XpoBoardNoResultsDisplay {
}
XpoBoardNoResultsDisplay.ɵfac = function XpoBoardNoResultsDisplay_Factory(t) { return new (t || XpoBoardNoResultsDisplay)(); };
XpoBoardNoResultsDisplay.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBoardNoResultsDisplay, selectors: [["xpo-board-no-results-display"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardNoResultsDisplay, [{
        type: Directive,
        args: [{
                selector: 'xpo-board-no-results-display',
            }]
    }], null, null); })();
class XpoBoardDataFetchDisplay extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd) {
        super(boardDataSourceResolver, cd);
        this.XpoBoardDataFetchState = XpoBoardDataFetchState; // allow enum in template
    }
    retry() {
        this.dataSource.refresh();
    }
    onStateChange(state) {
        this.dataFetchState = state.dataFetchState; // Updating the data fetch state so handle what to show in the template
    }
}
XpoBoardDataFetchDisplay.ɵfac = function XpoBoardDataFetchDisplay_Factory(t) { return new (t || XpoBoardDataFetchDisplay)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoBoardDataFetchDisplay.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardDataFetchDisplay, selectors: [["xpo-board-data-fetch-display"]], hostAttrs: [1, "xpo-BoardDataFetchDisplay"], features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$i, decls: 2, vars: 1, consts: [["class", "xpo-BoardUtils-centerContainer", 4, "ngIf"], [1, "xpo-BoardUtils-centerContainer"], [3, "ngSwitch"], [3, "ngSwitchCase"], ["mat-button", "", "color", "primary", 3, "click", 4, "ngIf"], ["mat-button", "", "color", "primary", 3, "click"]], template: function XpoBoardDataFetchDisplay_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵtemplate(1, XpoBoardDataFetchDisplay_div_1_Template, 5, 4, "div", 0);
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dataFetchState && ctx.dataFetchState !== ctx.XpoBoardDataFetchState.ResultsReturned);
    } }, directives: [i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i7$2.MatSpinner, i3$1.MatButton], styles: [".xpo-EmptyState{margin:0}.xpo-EmptyState-header{font-size:26px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardDataFetchDisplay, [{
        type: Component,
        args: [{
                selector: 'xpo-board-data-fetch-display',
                templateUrl: './board-data-fetch-display.component.html',
                styleUrls: ['./board-data-fetch-display.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-BoardDataFetchDisplay' },
            }]
    }], function () { return [{ type: XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }]; }, null); })();

const _c0$h = [[["xpo-board-header-title"]], "*"];
const _c1$8 = ["xpo-board-header-title", "*"];
class XpoBoardHeaderTitle {
}
XpoBoardHeaderTitle.ɵfac = function XpoBoardHeaderTitle_Factory(t) { return new (t || XpoBoardHeaderTitle)(); };
XpoBoardHeaderTitle.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBoardHeaderTitle, selectors: [["xpo-board-header-title"]], hostAttrs: [1, "xpo-BoardHeader-title"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardHeaderTitle, [{
        type: Directive,
        args: [{
                selector: 'xpo-board-header-title',
                host: { class: 'xpo-BoardHeader-title' },
            }]
    }], null, null); })();
class XpoBoardHeader {
}
XpoBoardHeader.ɵfac = function XpoBoardHeader_Factory(t) { return new (t || XpoBoardHeader)(); };
XpoBoardHeader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardHeader, selectors: [["xpo-board-header"]], hostAttrs: [1, "xpo-BoardHeader", "xpo-GridBar"], ngContentSelectors: _c1$8, decls: 2, vars: 0, template: function XpoBoardHeader_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$h);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
    } }, styles: [".flex--stretch{flex:1}.xpo-BoardHeader{align-items:center;height:50px;padding:8px}.xpo-BoardHeader-title{display:inline-flex;font-size:1.285rem;font-weight:500}.xpo-BoardHeader .xpo-BoardActions{margin-left:auto}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardHeader, [{
        type: Component,
        args: [{
                selector: 'xpo-board-header',
                templateUrl: 'board-header.component.html',
                styleUrls: ['board-header.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-BoardHeader xpo-GridBar' },
            }]
    }], null, null); })();

class XpoThousandsSeparator {
    transform(value) {
        return !!value ? value.toLocaleString('en-US') : '';
    }
}
XpoThousandsSeparator.ɵfac = function XpoThousandsSeparator_Factory(t) { return new (t || XpoThousandsSeparator)(); };
XpoThousandsSeparator.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "xpoThousandsSeparator", type: XpoThousandsSeparator, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoThousandsSeparator, [{
        type: Pipe,
        args: [{
                name: 'xpoThousandsSeparator',
            }]
    }], null, null); })();

function XpoBoardTotalRecords_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "xpoThousandsSeparator");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Showing ", i0.ɵɵpipeBind1(2, 1, ctx_r0.totalRecords), " Results\n");
} }
function XpoBoardTotalRecords_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "xpoThousandsSeparator");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Selected: ", i0.ɵɵpipeBind1(2, 1, ctx_r1.selectedRecords), "\n");
} }
const _c0$g = ["*"];
class XpoBoardTotalRecords extends XpoBoardConsumer {
    constructor() {
        super(...arguments);
        this.totalRecords = 0;
        this.selectedRecords = 0;
    }
    onStateChange(state) {
        if (state.source === 'update-row-count') {
            this.totalRecords = state.visibleRows;
        }
        if (state.changes.includes('selection')) {
            if (state.customSelection && state.customSelection.all) {
                this.selectedRecords = state.customSelection.countOfSelect;
            }
            else {
                this.selectedRecords = (state.selection || []).length;
            }
        }
    }
}
XpoBoardTotalRecords.ɵfac = /*@__PURE__*/ function () { let ɵXpoBoardTotalRecords_BaseFactory; return function XpoBoardTotalRecords_Factory(t) { return (ɵXpoBoardTotalRecords_BaseFactory || (ɵXpoBoardTotalRecords_BaseFactory = i0.ɵɵgetInheritedFactory(XpoBoardTotalRecords)))(t || XpoBoardTotalRecords); }; }();
XpoBoardTotalRecords.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardTotalRecords, selectors: [["xpo-board-total-records"]], hostAttrs: [1, "xpo-BoardTotalRecords"], features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$g, decls: 3, vars: 2, consts: [["class", "xpo-BoardTotalRecords-text", 4, "ngIf"], [1, "xpo-BoardTotalRecords-text"]], template: function XpoBoardTotalRecords_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, XpoBoardTotalRecords_span_0_Template, 3, 3, "span", 0);
        i0.ɵɵtemplate(1, XpoBoardTotalRecords_span_1_Template, 3, 3, "span", 0);
        i0.ɵɵprojection(2);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.totalRecords !== null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedRecords);
    } }, directives: [i2.NgIf], pipes: [XpoThousandsSeparator], styles: [".flex--stretch{flex:1}.xpo-BoardTotalRecords-text{margin:8px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardTotalRecords, [{
        type: Component,
        args: [{
                selector: 'xpo-board-total-records',
                templateUrl: 'board-total-records.component.html',
                styleUrls: ['board-total-records.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-BoardTotalRecords' },
            }]
    }], null, null); })();

const _c0$f = [[["xpo-board-toolbar-actions-group"]], [["xpo-board-toolbar-toggle-buttons-group"]], [["xpo-board-toolbar-settings-group"]]];
const _c1$7 = ["xpo-board-toolbar-actions-group", "xpo-board-toolbar-toggle-buttons-group", "xpo-board-toolbar-settings-group"];
class XpoBoardGridToolbar extends XpoBoardConsumer {
    constructor() {
        super(null, null);
    }
    onStateChange(state) {
        this.currentState = state;
    }
}
XpoBoardGridToolbar.ɵfac = function XpoBoardGridToolbar_Factory(t) { return new (t || XpoBoardGridToolbar)(); };
XpoBoardGridToolbar.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardGridToolbar, selectors: [["xpo-board-grid-toolbar"]], hostAttrs: [1, "xpo-GridToolbar"], features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$7, decls: 4, vars: 0, consts: [["data-cy", "grid-toolbar-navbar", 1, "xpo-GridToolbar-container"]], template: function XpoBoardGridToolbar_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$f);
        i0.ɵɵelementStart(0, "nav", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵprojection(2, 1);
        i0.ɵɵprojection(3, 2);
        i0.ɵɵelementEnd();
    } }, styles: [".flex--stretch{flex:1}.xpo-GridToolbar{align-content:center;align-items:center;background:#f6f6f6;border:1px solid #d8d8d8;border-bottom:0;display:flex;flex-wrap:wrap;height:42px;margin-top:16px;overflow:hidden;padding:16px 0}.xpo-GridToolbar-container{width:100%;display:flex;justify-content:space-between}.xpo-GridToolbar-container xpo-board-toolbar-toggle-buttons-group{align-items:center;display:flex;flex:2 2 initial;min-width:0;padding:0 8px}.xpo-GridToolbar-container button:disabled{color:#bdbdbd}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardGridToolbar, [{
        type: Component,
        args: [{
                selector: 'xpo-board-grid-toolbar',
                templateUrl: 'board-grid-toolbar.component.html',
                styleUrls: ['board-grid-toolbar.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-GridToolbar' },
            }]
    }], function () { return []; }, null); })();

const _c0$e = ["menuTrigger"];
const _c1$6 = ["projectedWrapper"];
function XpoBoardGridToolbarDynamicMore_button_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 5, 6);
    i0.ɵɵlistener("menuClosed", function XpoBoardGridToolbarDynamicMore_button_0_Template_button_menuClosed_0_listener() { return true; });
    i0.ɵɵtext(3, "More ");
    i0.ɵɵelementStart(4, "mat-icon", 7);
    i0.ɵɵtext(5, "arrow_drop_down");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("matMenuTriggerFor", _r1);
} }
function XpoBoardGridToolbarDynamicMore_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function XpoBoardGridToolbarDynamicMore_button_3_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const btn_r7 = restoredCtx.$implicit; return btn_r7.click(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r7 = ctx.$implicit;
    i0.ɵɵproperty("disabled", btn_r7.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(btn_r7.name || btn_r7.innerText);
} }
const _c2$2 = ["*"];
class XpoBoardGridToolbarActionsMore {
}
XpoBoardGridToolbarActionsMore.ɵfac = function XpoBoardGridToolbarActionsMore_Factory(t) { return new (t || XpoBoardGridToolbarActionsMore)(); };
XpoBoardGridToolbarActionsMore.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBoardGridToolbarActionsMore, selectors: [["xpo-board-toolbar-actions-group-more"]], hostAttrs: ["data-cy", "action-buttons-group-more"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardGridToolbarActionsMore, [{
        type: Directive,
        args: [{
                selector: 'xpo-board-toolbar-actions-group-more',
                host: {
                    'data-cy': 'action-buttons-group-more',
                },
            }]
    }], null, null); })();
class XpoBoardGridToolbarDynamicMore {
    constructor(cd) {
        this.cd = cd;
        // Projected buttons coming from implementation
        this.projectedButtons = [];
        // If showMenu=false hide the dropdown button
        this.showMenu = true;
    }
    /*
     * This ngOnChanges is being dispatched by the "@Input() dynButton" when the screen is
     * resized or when the dropdown is expanded
     */
    ngOnChanges() {
        if (this.menuTrigger) {
            this.menuTrigger.closeMenu();
        }
        this.showMenu = this.projectedButtons.length > 0 || this.dynButtons.length > 0;
        this.cd.detectChanges();
    }
    ngAfterViewInit() {
        // As the projected buttons are simple button without @Component or @Directive isn't possible
        // To get them using @ContendChildren. The option is to get the container with @ViewChild and
        // then use the QuerySelector to get finally the buttons.
        this.projectedButtons =
            (this.projectedWrapper && this.projectedWrapper.nativeElement.getElementsByTagName('button')) || [];
    }
}
XpoBoardGridToolbarDynamicMore.ɵfac = function XpoBoardGridToolbarDynamicMore_Factory(t) { return new (t || XpoBoardGridToolbarDynamicMore)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoBoardGridToolbarDynamicMore.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardGridToolbarDynamicMore, selectors: [["xpo-board-toolbar-dynamic-more"]], viewQuery: function XpoBoardGridToolbarDynamicMore_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$e, 5);
        i0.ɵɵviewQuery(_c1$6, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.projectedWrapper = _t.first);
    } }, inputs: { dynButtons: "dynButtons" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2$2, decls: 7, vars: 2, consts: [["class", "more-button", 3, "matMenuTriggerFor", "menuClosed", 4, "ngIf"], [1, "xpo-GridToolbar-container--button-list-more"], ["menu", "matMenu"], [3, "disabled", "click", 4, "ngFor", "ngForOf"], ["projectedWrapper", ""], [1, "more-button", 3, "matMenuTriggerFor", "menuClosed"], ["moreButton", "", "menuTrigger", "matMenuTrigger"], [1, "material-icons"], [3, "disabled", "click"]], template: function XpoBoardGridToolbarDynamicMore_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, XpoBoardGridToolbarDynamicMore_button_0_Template, 6, 1, "button", 0);
        i0.ɵɵelementStart(1, "mat-menu", 1, 2);
        i0.ɵɵtemplate(3, XpoBoardGridToolbarDynamicMore_button_3_Template, 2, 2, "button", 3);
        i0.ɵɵelementStart(4, "div", null, 4);
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showMenu);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.dynButtons);
    } }, directives: [i2.NgIf, i6.MatMenu, i2.NgForOf, i6.MatMenuTrigger, i3.MatIcon], styles: [".flex--stretch{flex:1}.xpo-GridToolbar-container--button-list-more.mat-menu-panel{border:1px solid #d8d8d8;box-shadow:none}.xpo-GridToolbar-container--button-list-more .mat-menu-content,.xpo-GridToolbar-container--button-list-more .mat-menu-content div{display:flex;flex-direction:column;width:150px}.xpo-GridToolbar-container--button-list-more .mat-menu-content>*,.xpo-GridToolbar-container--button-list-more .mat-menu-content div>*{display:flex;flex-direction:column}.xpo-GridToolbar-container--button-list-more .mat-menu-content button,.xpo-GridToolbar-container--button-list-more .mat-menu-content div button{background:transparent;border:0;cursor:pointer;font-family:inherit;padding:8px;text-align:left}.xpo-GridToolbar-container--button-list-more .mat-menu-content button:hover,.xpo-GridToolbar-container--button-list-more .mat-menu-content div button:hover{background:#e8f5fe}.xpo-GridToolbar-container--button-list-more .mat-menu-content button:focus,.xpo-GridToolbar-container--button-list-more .mat-menu-content div button:focus{outline:none}.xpo-GridToolbar-container--button-list-more .mat-menu-content button:disabled,.xpo-GridToolbar-container--button-list-more .mat-menu-content div button:disabled{opacity:unset}.xpo-GridToolbar-container--button-list-more .mat-menu-content .mat-icon,.xpo-GridToolbar-container--button-list-more .mat-menu-content div .mat-icon{display:none}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardGridToolbarDynamicMore, [{
        type: Component,
        args: [{
                selector: 'xpo-board-toolbar-dynamic-more',
                templateUrl: 'board-grid-toolbar-dynamic-more.component.html',
                styleUrls: ['board-grid-toolbar-dynamic-more.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { dynButtons: [{
            type: Input
        }], menuTrigger: [{
            type: ViewChild,
            args: ['menuTrigger', { static: false }]
        }], projectedWrapper: [{
            type: ViewChild,
            args: ['projectedWrapper']
        }] }); })();

const _c0$d = ["*", [["xpo-board-toolbar-actions-group-more"]]];
const _c1$5 = ["*", "xpo-board-toolbar-actions-group-more"];
class XpoBoardGridToolbarActions extends XpoBoardConsumer {
    constructor() {
        super(...arguments);
        this.buttons = [];
    }
    onStateChange() { }
    updateButtonsVisibility(event) {
        this.buttons = event;
    }
}
XpoBoardGridToolbarActions.ɵfac = /*@__PURE__*/ function () { let ɵXpoBoardGridToolbarActions_BaseFactory; return function XpoBoardGridToolbarActions_Factory(t) { return (ɵXpoBoardGridToolbarActions_BaseFactory || (ɵXpoBoardGridToolbarActions_BaseFactory = i0.ɵɵgetInheritedFactory(XpoBoardGridToolbarActions)))(t || XpoBoardGridToolbarActions); }; }();
XpoBoardGridToolbarActions.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardGridToolbarActions, selectors: [["xpo-board-toolbar-actions-group"]], hostAttrs: ["data-cy", "actions-buttons-group", 1, "xpo-GridToolbar-container-actions-buttons-group"], features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$5, decls: 4, vars: 1, consts: [["xpoDynamicMenu", "", 3, "hiddenBtnEvent"], ["xpoDynamicMenuBlock", "", 3, "dynButtons"]], template: function XpoBoardGridToolbarActions_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$d);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("hiddenBtnEvent", function XpoBoardGridToolbarActions_Template_div_hiddenBtnEvent_0_listener($event) { return ctx.updateButtonsVisibility($event); });
        i0.ɵɵprojection(1);
        i0.ɵɵelementStart(2, "xpo-board-toolbar-dynamic-more", 1);
        i0.ɵɵprojection(3, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dynButtons", ctx.buttons);
    } }, directives: [i1$6.XpoDynamicMenuDirective, XpoBoardGridToolbarDynamicMore, i1$6.XpoDynamicMenuBlockDirective], styles: [".flex--stretch{flex:1}.xpo-GridToolbar-container-actions-buttons-group,.xpo-GridToolbar-container-actions-buttons-group div{display:flex;flex:1 1 auto;min-width:8em;overflow:hidden;padding-left:8px;place-content:flex-start}.xpo-GridToolbar-container-actions-buttons-group button,.xpo-GridToolbar-container-actions-buttons-group div button{align-items:center;background:transparent;border:0;color:#4a4a4a;cursor:pointer;display:flex;font-family:inherit;font-size:100%;height:100%;justify-content:space-between;padding:0 10px}.xpo-GridToolbar-container-actions-buttons-group button:hover,.xpo-GridToolbar-container-actions-buttons-group div button:hover{opacity:50%}.xpo-GridToolbar-container-actions-buttons-group button:disabled,.xpo-GridToolbar-container-actions-buttons-group div button:disabled{opacity:unset}.xpo-GridToolbar-container-actions-buttons-group button:focus,.xpo-GridToolbar-container-actions-buttons-group div button:focus{outline:none}.xpo-GridToolbar-container-actions-buttons-group button.hide,.xpo-GridToolbar-container-actions-buttons-group div button.hide{display:none}.xpo-GridToolbar-container-actions-buttons-group>button:first-child,.xpo-GridToolbar-container-actions-buttons-group div>button:first-child{padding-left:0}.xpo-GridToolbar-container-actions-buttons-group .mat-icon,.xpo-GridToolbar-container-actions-buttons-group div .mat-icon{font-size:1.428rem;line-height:24px;margin-right:4px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardGridToolbarActions, [{
        type: Component,
        args: [{
                selector: 'xpo-board-toolbar-actions-group',
                templateUrl: 'board-grid-toolbar-actions.component.html',
                styleUrls: ['board-grid-toolbar-actions.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-GridToolbar-container-actions-buttons-group',
                    'data-cy': 'actions-buttons-group',
                },
            }]
    }], null, null); })();

const _c0$c = ["*"];
class XpoBoardGridToolbarSettings {
}
XpoBoardGridToolbarSettings.ɵfac = function XpoBoardGridToolbarSettings_Factory(t) { return new (t || XpoBoardGridToolbarSettings)(); };
XpoBoardGridToolbarSettings.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardGridToolbarSettings, selectors: [["xpo-board-toolbar-settings-group"]], hostAttrs: ["data-cy", "settings-buttons-group", 1, "xpo-GridToolbar-container-settings-buttons-group"], ngContentSelectors: _c0$c, decls: 1, vars: 0, template: function XpoBoardGridToolbarSettings_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [".flex--stretch{flex:1}.xpo-GridToolbar-container-settings-buttons-group{display:flex;flex:0 0 auto;min-width:5%;overflow:hidden;place-content:flex-start}.xpo-GridToolbar-container-settings-buttons-group>*{border:0;border-left:1px solid #d8d8d8}.xpo-GridToolbar-container-settings-buttons-group button{background:transparent;color:#4a4a4a;cursor:pointer;padding:0 8px}.xpo-GridToolbar-container-settings-buttons-group button:focus{color:#4a4a4a;outline:none}.xpo-GridToolbar-container-settings-buttons-group .mat-icon{font-size:1.428rem;line-height:24px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardGridToolbarSettings, [{
        type: Component,
        args: [{
                selector: 'xpo-board-toolbar-settings-group',
                templateUrl: 'board-grid-toolbar-settings.component.html',
                styleUrls: ['board-grid-toolbar-settings.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-GridToolbar-container-settings-buttons-group',
                    'data-cy': 'settings-buttons-group',
                },
            }]
    }], null, null); })();

const _c0$b = function (a0) { return { "active": a0 }; };
class XpoSettingsFloatingFiltersComponent extends XpoBoardConsumer {
    constructor() {
        super(...arguments);
        this.isFiltersVisible = XpoColumnLevelFilteringToggleComponent.IsFilterVisibleDefaultValue;
    }
    toggleColumnLevelFiltering() {
        this.stateChange$.next({
            columnLevelFilteringVisible: !this.isFiltersVisible,
            source: XpoBoardStateSources.ColumnLevelFilteringToggle,
        });
    }
    onStateChange(state) {
        if (state.changes.includes('columnLevelFilteringVisible')) {
            this.isFiltersVisible = state.columnLevelFilteringVisible;
        }
    }
}
XpoSettingsFloatingFiltersComponent.IsFilterVisibleDefaultValue = true;
XpoSettingsFloatingFiltersComponent.ɵfac = /*@__PURE__*/ function () { let ɵXpoSettingsFloatingFiltersComponent_BaseFactory; return function XpoSettingsFloatingFiltersComponent_Factory(t) { return (ɵXpoSettingsFloatingFiltersComponent_BaseFactory || (ɵXpoSettingsFloatingFiltersComponent_BaseFactory = i0.ɵɵgetInheritedFactory(XpoSettingsFloatingFiltersComponent)))(t || XpoSettingsFloatingFiltersComponent); }; }();
XpoSettingsFloatingFiltersComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoSettingsFloatingFiltersComponent, selectors: [["xpo-settings-button-floating-filters"]], hostAttrs: ["data-cy", "settings-buttons-floating", 1, "xpo-column-level-filtering-toggle"], features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [["mat-icon-button", "", "matTooltip", "Show/Hide Column Filters", "matTooltipPosition", "above", 3, "ngClass", "click"]], template: function XpoSettingsFloatingFiltersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function XpoSettingsFloatingFiltersComponent_Template_button_click_0_listener() { return ctx.toggleColumnLevelFiltering(); });
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "filter_alt");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$b, ctx.isFiltersVisible));
    } }, directives: [i3$1.MatButton, i3$3.MatTooltip, i2.NgClass, i3.MatIcon], styles: [".flex--stretch{flex:1}.xpo-column-level-filtering-toggle button.active{color:#1976d2}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSettingsFloatingFiltersComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-settings-button-floating-filters',
                templateUrl: './floating-settings-default-buttons.component.html',
                styleUrls: ['./floating-settings-default-buttons.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-column-level-filtering-toggle',
                    'data-cy': 'settings-buttons-floating',
                },
            }]
    }], null, null); })();

function XpoSettingsRowHeightComponent_button_5_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "check_circle");
    i0.ɵɵelementEnd();
} }
function XpoSettingsRowHeightComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function XpoSettingsRowHeightComponent_button_5_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const option_r2 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.updateSelectedRowHeight(option_r2.value); });
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, XpoSettingsRowHeightComponent_button_5_mat_icon_2_Template, 2, 0, "mat-icon", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedRowHeight === option_r2.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", option_r2.name, " ");
} }
const _c0$a = function (a0) { return { "active": a0 }; };
class XpoSettingsRowHeightComponent extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd, defaultRowHeight) {
        super(boardDataSourceResolver, cd);
        this.rowHeightOptions = [];
        this.isDefault = true;
        this.onRowHeightChange = new EventEmitter();
        this.defaultRowHeight = defaultRowHeight || 40;
        this.selectedRowHeight = this.defaultRowHeight;
        this.rowHeightOptions = [
            { name: XpoGridDisplayDensityOptions.Default, value: this.defaultRowHeight },
            { name: XpoGridDisplayDensityOptions.Compact, value: this.defaultRowHeight - 8 },
            { name: XpoGridDisplayDensityOptions.Comfortable, value: this.defaultRowHeight + 8 },
        ];
        this.changeRowHeight(this.selectedRowHeight);
    }
    updateSelectedRowHeight(value) {
        this.selectedRowHeight = value;
        const newState = {
            source: XpoBoardStateSources.GridSettingsUpdate,
            rowHeight: this.selectedRowHeight,
        };
        this.stateChange$.next(newState);
    }
    onStateChange(state) {
        if (state.changes.includes('rowHeight') && state.rowHeight) {
            this.changeRowHeight(state.rowHeight);
        }
    }
    changeRowHeight(newHeight) {
        this.selectedRowHeight = newHeight;
        this.onRowHeightChange.emit(this.selectedRowHeight);
    }
}
XpoSettingsRowHeightComponent.ɵfac = function XpoSettingsRowHeightComponent_Factory(t) { return new (t || XpoSettingsRowHeightComponent)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT, 8)); };
XpoSettingsRowHeightComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoSettingsRowHeightComponent, selectors: [["xpo-settings-button-row-height"]], hostAttrs: ["data-cy", "settings-buttons-row-height", 1, "xpo-GridToolbar-settings-button-row-height"], outputs: { onRowHeightChange: "onRowHeightChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 5, consts: [["mat-icon-button", "", "matTooltip", "Row Height", "matTooltipPosition", "above", 3, "matMenuTriggerFor", "ngClass"], [1, "xpo-GridToolbar-settings-button-row-height-dropdown"], ["rowHeightMenu", "matMenu"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], [1, "icon-container"], [4, "ngIf"]], template: function XpoSettingsRowHeightComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "line_weight");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-menu", 1, 2);
        i0.ɵɵtemplate(5, XpoSettingsRowHeightComponent_button_5_Template, 4, 2, "button", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵproperty("matMenuTriggerFor", _r0)("ngClass", i0.ɵɵpureFunction1(3, _c0$a, ctx.selectedRowHeight !== ctx.defaultRowHeight));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.rowHeightOptions);
    } }, directives: [i3$1.MatButton, i3$3.MatTooltip, i6.MatMenuTrigger, i2.NgClass, i3.MatIcon, i6.MatMenu, i2.NgForOf, i2.NgIf], styles: [".flex--stretch{flex:1}.xpo-GridToolbar-settings-button-row-height button.active{color:#1976d2}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content{display:flex;flex-direction:column;width:150px}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content>*{display:flex;flex-direction:column}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content button{background:transparent;border:0;cursor:pointer;display:inline-flex;flex-direction:row;font-family:inherit;padding:4px 8px;text-align:left}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content button:hover{background:#e8f5fe}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content button:focus{outline:none}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content button:disabled{opacity:30%}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content button .icon-container{height:16px;margin-right:8px;width:16px}.xpo-GridToolbar-settings-button-row-height-dropdown .mat-menu-content button .icon-container .mat-icon{font-size:1.143rem}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSettingsRowHeightComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-settings-button-row-height',
                templateUrl: './row-height-settings-default-buttons.component.html',
                styleUrls: ['./row-height-settings-default-buttons.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-GridToolbar-settings-button-row-height',
                    'data-cy': 'settings-buttons-row-height',
                },
            }]
    }], function () { return [{ type: XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT]
            }, {
                type: Optional
            }] }]; }, { onRowHeightChange: [{
            type: Output
        }] }); })();

class XpoGridToolbarModule {
}
XpoGridToolbarModule.ɵfac = function XpoGridToolbarModule_Factory(t) { return new (t || XpoGridToolbarModule)(); };
XpoGridToolbarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoGridToolbarModule });
XpoGridToolbarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MatMenuModule,
            MatTooltipModule,
            MatIconModule,
            MatButtonModule,
            MatRadioModule,
            MatCheckboxModule,
            XpoUtilsModule,
            XpoDownloadButtonModule,
            XpoPopoverModule,
            XpoButtonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGridToolbarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatMenuModule,
                    MatTooltipModule,
                    MatIconModule,
                    MatButtonModule,
                    MatRadioModule,
                    MatCheckboxModule,
                    XpoUtilsModule,
                    XpoDownloadButtonModule,
                    XpoPopoverModule,
                    XpoButtonModule,
                ],
                declarations: [
                    XpoBoardGridToolbar,
                    XpoBoardGridToolbarActions,
                    XpoBoardGridToolbarActionsMore,
                    XpoBoardGridToolbarDynamicMore,
                    XpoBoardGridToolbarSettings,
                    XpoSettingsGridOptionsComponent,
                    XpoSettingsFloatingFiltersComponent,
                    XpoGridSettingsColumnSelectionComponent,
                    XpoSettingsRowHeightComponent,
                ],
                exports: [
                    XpoBoardGridToolbar,
                    XpoBoardGridToolbarActions,
                    XpoBoardGridToolbarActionsMore,
                    XpoBoardGridToolbarDynamicMore,
                    XpoBoardGridToolbarSettings,
                    XpoSettingsGridOptionsComponent,
                    XpoSettingsFloatingFiltersComponent,
                    XpoGridSettingsColumnSelectionComponent,
                    XpoSettingsRowHeightComponent,
                ],
                entryComponents: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoGridToolbarModule, { declarations: [XpoBoardGridToolbar,
        XpoBoardGridToolbarActions,
        XpoBoardGridToolbarActionsMore,
        XpoBoardGridToolbarDynamicMore,
        XpoBoardGridToolbarSettings,
        XpoSettingsGridOptionsComponent,
        XpoSettingsFloatingFiltersComponent,
        XpoGridSettingsColumnSelectionComponent,
        XpoSettingsRowHeightComponent], imports: [CommonModule,
        FormsModule,
        MatMenuModule,
        MatTooltipModule,
        MatIconModule,
        MatButtonModule,
        MatRadioModule,
        MatCheckboxModule,
        XpoUtilsModule,
        XpoDownloadButtonModule,
        XpoPopoverModule,
        XpoButtonModule], exports: [XpoBoardGridToolbar,
        XpoBoardGridToolbarActions,
        XpoBoardGridToolbarActionsMore,
        XpoBoardGridToolbarDynamicMore,
        XpoBoardGridToolbarSettings,
        XpoSettingsGridOptionsComponent,
        XpoSettingsFloatingFiltersComponent,
        XpoGridSettingsColumnSelectionComponent,
        XpoSettingsRowHeightComponent] }); })();

function XpoBoardPagination_div_0_mat_option_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const size_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2.disableOption(size_r3))("value", size_r3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(size_r3);
} }
function XpoBoardPagination_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "mat-icon", 7);
    i0.ɵɵlistener("click", function XpoBoardPagination_div_0_Template_mat_icon_click_2_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.triggerArrowSetting("skip_previous"); });
    i0.ɵɵtext(3, "skip_previous");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon", 8);
    i0.ɵɵlistener("click", function XpoBoardPagination_div_0_Template_mat_icon_click_4_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.triggerArrowSetting("navigate_before"); });
    i0.ɵɵtext(5, "navigate_before");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-icon", 9);
    i0.ɵɵlistener("click", function XpoBoardPagination_div_0_Template_mat_icon_click_6_listener() { i0.ɵɵrestoreView(_r5); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.triggerArrowSetting("navigate_next"); });
    i0.ɵɵtext(7, "navigate_next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mat-icon", 10);
    i0.ɵɵlistener("click", function XpoBoardPagination_div_0_Template_mat_icon_click_8_listener() { i0.ɵɵrestoreView(_r5); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.triggerArrowSetting("skip_next"); });
    i0.ɵɵtext(9, "skip_next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 11);
    i0.ɵɵlistener("ngModelChange", function XpoBoardPagination_div_0_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.pageToGo = $event; })("keypress", function XpoBoardPagination_div_0_Template_input_keypress_10_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.goPress($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 12);
    i0.ɵɵlistener("click", function XpoBoardPagination_div_0_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r5); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.goTo(); });
    i0.ɵɵtext(12, "GO");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 13);
    i0.ɵɵelementStart(14, "mat-form-field", 14);
    i0.ɵɵelementStart(15, "mat-select", 15);
    i0.ɵɵlistener("selectionChange", function XpoBoardPagination_div_0_Template_mat_select_selectionChange_15_listener() { i0.ɵɵrestoreView(_r5); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.changePageSize(ctx_r12.currentPageSize); })("ngModelChange", function XpoBoardPagination_div_0_Template_mat_select_ngModelChange_15_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.currentPageSize = $event; });
    i0.ɵɵtemplate(16, XpoBoardPagination_div_0_mat_option_16_Template, 2, 3, "mat-option", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("xpo-BoardPagination-settings-arrow-icon--disabled", ctx_r0.currentPage === 1);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("xpo-BoardPagination-settings-arrow-icon--disabled", ctx_r0.currentPage === 1);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("xpo-BoardPagination-settings-arrow-icon--disabled", ctx_r0.totalPages === ctx_r0.currentPage);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("xpo-BoardPagination-settings-arrow-icon--disabled", ctx_r0.totalPages === ctx_r0.currentPage);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("max", ctx_r0.totalPages);
    i0.ɵɵpropertyInterpolate("maxlength", ctx_r0.totalPages.toString().length);
    i0.ɵɵproperty("disabled", ctx_r0.rowCount < ctx_r0.currentPageSize)("ngModel", ctx_r0.pageToGo);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r0.currentPageSize);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.pageSizes);
} }
function XpoBoardPagination_span_6_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.currentRowTo);
} }
function XpoBoardPagination_span_6_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r15.rowCount);
} }
function XpoBoardPagination_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, XpoBoardPagination_span_6_span_2_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(3, XpoBoardPagination_span_6_span_3_Template, 2, 1, "span", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r1.currentRowTo + 1 - ctx_r1.currentPageSize, " to ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.currentRowTo <= ctx_r1.rowCount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.currentRowTo > ctx_r1.rowCount);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" of ", ctx_r1.rowCount, " ");
} }
const XPO_PAGINATION_DEFAULT_PAGE_SIZES = [10, 25, 50, 100];
class XpoBoardPagination {
    constructor(cd) {
        this.cd = cd;
        this._pageSizes = XPO_PAGINATION_DEFAULT_PAGE_SIZES;
        this._currentPageSize = XPO_PAGINATION_DEFAULT_PAGE_SIZES[0];
        this.currentPage = 1;
        this.totalPages = 1;
        this.pageToGo = 1;
        this.rowCount = 0;
        this.currentRowTo = 0;
        this.displayPagination = true;
        this.pageSizeChange = new EventEmitter();
        this.SKIP_PREVIOUS = 'skip_previous';
        this.NAVIGATE_BEFORE = 'navigate_before';
        this.SKIP_NEXT = 'skip_next';
        this.NAVIGATE_NEXT = 'navigate_next';
        this.KEY_ENTER_NAME = 'Enter';
    }
    set pageSizes(value) {
        this._pageSizes = value;
    }
    get pageSizes() {
        return this._pageSizes;
    }
    set currentPageSize(value) {
        this._currentPageSize = value;
    }
    get currentPageSize() {
        return this._currentPageSize;
    }
    /**
     * Page information to display in the component
     */
    setPageInfo() {
        if (!this.agGridApi) {
            return;
        }
        this.totalPages = this.agGridApi.paginationGetTotalPages();
        this.rowCount = this.agGridApi.paginationGetRowCount();
        this.cd.detectChanges();
    }
    /**
     * Refresh pagination when xpo-ag-grid-board emits event on state change
     */
    notifyPagination() {
        if (!this.agGridApi) {
            return;
        }
        this.totalPages = 0;
        this.setPageInfo();
        this.currentRowTo = (this.agGridApi.paginationGetCurrentPage() + 1) * this.agGridApi.paginationGetPageSize();
        this.currentPage = this.agGridApi.paginationGetCurrentPage() + 1;
        this.pageToGo = this.currentPage;
        // Set minimun value or custom
        this.displayPagination = Math.min(...this.pageSizes) <= this.rowCount;
        this.cd.detectChanges();
    }
    /**
     * Receives the agGridApi and persit it locally
     * @param event
     */
    initialize(agGridApi) {
        /* TODO: this event type should be XpoAgGridBoardReadyEvent but it's from xpo-ltl-board-grid lib which is not
          being allowed to be imported here from @xpo-ltl/ngx-ltl-board-grid neither from /lib.
        */
        this.agGridApi = agGridApi;
        this.agGridApi.paginationSetPageSize(this.currentPageSize);
        this.setPageInfo();
    }
    /**
     * Page sizes configuration based on user settings or default
     * @param pageSizes
     * @param pageStart
     */
    configurePageSettings(pageSizes, pageStart) {
        if (pageSizes) {
            this.pageSizes = pageSizes;
        }
        this.currentPageSize = this.pageSizes.find((size) => size === pageStart) || Math.min(...this.pageSizes);
    }
    /**
     *  Go to selected page
     */
    goTo() {
        this.agGridApi.paginationGoToPage(this.pageToGo - 1);
        this.notifyPagination();
    }
    /**
     *  Set page size on dropdown change
     * @param pageSize Selected page size
     */
    changePageSize(pageSize) {
        this.agGridApi.paginationSetPageSize(pageSize);
        this.agGridApi.paginationGoToFirstPage();
        this.notifyPagination();
        this.pageSizeChange.emit(pageSize);
    }
    /**
     *  Arrow buttons actions
     */
    triggerArrowSetting(settingAction) {
        switch (settingAction) {
            case this.SKIP_PREVIOUS:
                this.agGridApi.paginationGoToFirstPage();
                break;
            case this.NAVIGATE_BEFORE:
                this.agGridApi.paginationGoToPreviousPage();
                break;
            case this.SKIP_NEXT:
                this.agGridApi.paginationGoToLastPage();
                break;
            case this.NAVIGATE_NEXT:
                this.agGridApi.paginationGoToNextPage();
                break;
            default:
                break;
        }
        this.notifyPagination();
    }
    /**
     *  Allow only numbers on keypress
     */
    goPress(event) {
        // Enter key press fires pagiantion goto
        if (event.key === this.KEY_ENTER_NAME) {
            this.goTo();
        }
        return !isNaN(Number(event.key)) && event.key !== null && event.key !== ' ';
    }
    /**
     * Check if option should be desabled in case the size in the option is higher than avialable rows
     * @param size
     */
    disableOption(size) {
        const currentIndex = this.pageSizes.indexOf(size);
        return this.rowCount < size && this.rowCount <= this.pageSizes[currentIndex - 1];
    }
}
XpoBoardPagination.ɵfac = function XpoBoardPagination_Factory(t) { return new (t || XpoBoardPagination)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoBoardPagination.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardPagination, selectors: [["xpo-board-pagination"]], hostAttrs: [1, "xpo-BoardPagination"], decls: 7, vars: 4, consts: [["class", "xpo-BoardPagination-settings", 4, "ngIf"], [1, "xpo-BoardPagination-info"], [1, "xpo-BoardPagination-settings-page"], ["data-cy", "xpo-BoardPagination-settings-page"], ["data-cy", "xpo-BoardPagination-settings-page-rows", 4, "ngIf"], [1, "xpo-BoardPagination-settings"], [1, "xpo-BoardPagination-settings-arrow"], ["data-cy", "xpo-BoardPagination-settings-arrow-icon-skipPrevious", 1, "xpo-BoardPagination-settings-arrow-icon", 3, "click"], ["data-cy", "xpo-BoardPagination-settings-arrow-icon-navigatePrevious", 1, "xpo-BoardPagination-settings-arrow-icon", 3, "click"], ["data-cy", "xpo-BoardPagination-settings-arrow-icon-navigateNext", 1, "xpo-BoardPagination-settings-arrow-icon", 3, "click"], ["data-cy", "xpo-BoardPagination-settings-arrow-icon-skipNext", 1, "xpo-BoardPagination-settings-arrow-icon", 3, "click"], ["type", "text", "pattern", "\\d*", "data-cy", "xpo-BoardPagination-settings-arrow-input", 1, "xpo-BoardPagination-settings-arrow-input", 3, "disabled", "ngModel", "max", "maxlength", "ngModelChange", "keypress"], ["data-cy", "xpo-BoardPagination-settings-arrow-goButton", 1, "xpo-BoardPagination-settings-arrow-goButton", 3, "click"], [1, "xpo-BoardPagination-settings-pageSize"], ["appearance", "standard"], ["data-cy", "xpo-BoardPagination-settings-pageSize-select", "xpoSelect", "", "disableOptionCentering", "", "panelClass", "xpo-BoardPagination-sizeSelect", 3, "ngModel", "selectionChange", "ngModelChange"], [3, "disabled", "value", 4, "ngFor", "ngForOf"], [3, "disabled", "value"], ["data-cy", "xpo-BoardPagination-settings-page-rows"], [4, "ngIf"]], template: function XpoBoardPagination_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, XpoBoardPagination_div_0_Template, 17, 14, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div");
        i0.ɵɵtemplate(6, XpoBoardPagination_span_6_Template, 5, 4, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displayPagination);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate2("Page ", ctx.currentPage, " of ", ctx.totalPages, "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.currentRowTo > 0);
    } }, directives: [i2.NgIf, i3.MatIcon, i1$1.DefaultValueAccessor, i1$1.PatternValidator, i1$1.NgControlStatus, i1$1.NgModel, i1$1.MaxLengthValidator, i4.MatFormField, i5$2.MatSelect, i6$1.XpoDisableOptionCenteringDirective, i6$1.XpoSelectDirective, i2.NgForOf, i7$3.MatOption], styles: [".flex--stretch{flex:1}.xpo-BoardPagination{background-color:#fff;display:flex;flex-direction:column;justify-content:space-between}.xpo-BoardPagination *{outline:0}.xpo-BoardPagination input::-webkit-outer-spin-button,.xpo-BoardPagination input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.xpo-BoardPagination input[type=number]{-moz-appearance:textfield}.xpo-BoardPagination-sizeSelect.xpo-Select-panel.mat-select-panel{margin-top:28px}.xpo-BoardPagination-text{margin:8px}.xpo-BoardPagination-info{display:flex;justify-content:space-between;padding:16px}.xpo-BoardPagination-settings{display:flex;justify-content:space-between;padding:16px 16px 0}.xpo-BoardPagination-settings-pageSize .mat-form-field-infix{align-items:center;display:flex;height:40px;width:100px}.xpo-BoardPagination-settings-pageSize .mat-form-field.mat-form-field-type-mat-select.mat-form-field-appearance-legacy,.xpo-BoardPagination-settings-pageSize .mat-form-field.mat-form-field-type-mat-select.mat-form-field-appearance-standard{display:flex;margin-bottom:0;margin-top:0}.xpo-BoardPagination-settings-arrow{align-items:center;display:flex}.xpo-BoardPagination-settings-arrow mat-icon{cursor:pointer}.xpo-BoardPagination-settings-arrow-icon{align-items:center;background-color:#f6f6f6;border:1px solid #d8d8d8;border-right:0;color:#4a4a4a;display:flex;height:40px;justify-content:center;width:40px}.xpo-BoardPagination-settings-arrow-icon:last-of-type{border-right:1px solid #d8d8d8}.xpo-BoardPagination-settings-arrow-icon--disabled{color:#c3c3c3}.xpo-BoardPagination-settings-arrow-input{border:1px solid #d8d8d8;border-radius:0;border-right:0;color:#212121;font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:1rem;font-style:normal;font-weight:400;height:40px;letter-spacing:normal;margin-left:16px;padding:8px;width:50px}.xpo-BoardPagination-settings-arrow-goButton{background-color:#f6f6f6;border:1px solid #d8d8d8;border-radius:0;cursor:pointer;font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:1rem;font-weight:500;height:40px;width:40px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardPagination, [{
        type: Component,
        args: [{
                selector: 'xpo-board-pagination',
                templateUrl: 'board-pagination.component.html',
                styleUrls: ['board-pagination.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-BoardPagination' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, null); })();

/**
 * Class to extend to fetch an individual entity
 *
 * TInput selected record model
 *
 * TOutput defaults to TInput if no TOutput, we are going to assume that
 * there is no transformation from the incoming record selection
 * to the consumer of the selection change.
 */
class XpoDataDrawerDataSource {
    constructor() {
        this.transformedSelectedRecordSource$ = new Subject();
        this.dataDrawerStateSource$ = new BehaviorSubject({
            focusedRecord: null,
            selection: [],
        });
        this.dataFetchStateSource$ = new BehaviorSubject(null);
    }
    // Transformed Selected Record
    get transformedSelectedRecord() {
        return this.transformedSelectedRecordValue;
    }
    get transformedSelectedRecord$() {
        return this.transformedSelectedRecordSource$.asObservable();
    }
    // Selection
    get dataDrawerState() {
        return this.dataDrawerStateSource$.value;
    }
    get dataDrawerState$() {
        return this.dataDrawerStateSource$.asObservable();
    }
    setDataDrawerState(v) {
        this.dataDrawerStateSource$.next(v);
        this.retrieveRecord(); // Update transformed record on selection change
    }
    // Data fetch state
    get dataFetchState$() {
        return this.dataFetchStateSource$.asObservable();
    }
    retrieveRecord() {
        // Fetching the selected record from the observable instead of the getting the value directly since
        // I want to use a switchMap so that the previous fetch is canceled when an updated selection is made
        this.dataDrawerStateSource$
            .pipe(
        // Make sure we to the fetch when we actually have data. Maybe we ended up here due to a focus/selection reset
        filter((state) => !!state.focusedRecord || !!(state.selection && state.selection.length > 0)), tap(() => this.dataFetchStateSource$.next(XpoBoardDataFetchState.Loading)), switchMap((state) => this.fetchEntity(state.focusedRecord, state.selection)), take(1))
            .subscribe((r) => {
            this.dataFetchStateSource$.next(XpoBoardDataFetchState.ResultsReturned);
            this.transformedSelectedRecordValue = r;
            this.transformedSelectedRecordSource$.next(r);
        }, (err) => {
            this.dataFetchStateSource$.next(XpoBoardDataFetchState.Error);
        });
    }
}

/**
 * Default data drawer data source, it just echos back the selected record as an observable.
 */
class XpoDataDrawerDefaultDataSource extends XpoDataDrawerDataSource {
    fetchEntity(focusedRecord, selection) {
        return of(focusedRecord);
    }
}
XpoDataDrawerDefaultDataSource.ɵfac = /*@__PURE__*/ function () { let ɵXpoDataDrawerDefaultDataSource_BaseFactory; return function XpoDataDrawerDefaultDataSource_Factory(t) { return (ɵXpoDataDrawerDefaultDataSource_BaseFactory || (ɵXpoDataDrawerDefaultDataSource_BaseFactory = i0.ɵɵgetInheritedFactory(XpoDataDrawerDefaultDataSource)))(t || XpoDataDrawerDefaultDataSource); }; }();
XpoDataDrawerDefaultDataSource.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoDataDrawerDefaultDataSource, factory: XpoDataDrawerDefaultDataSource.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDataDrawerDefaultDataSource, [{
        type: Injectable
    }], null, null); })();

function XpoDataDrawer_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
} }
function XpoDataDrawer_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "xpo-responsive-loading-spinner");
    i0.ɵɵelementEnd();
} }
function XpoDataDrawer_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2, "An Error Has Occurred. ");
    i0.ɵɵelementStart(3, "button", 8);
    i0.ɵɵlistener("click", function XpoDataDrawer_ng_template_9_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.retry(); });
    i0.ɵɵtext(4, "Click Here To Retry");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0$9 = [[["xpo-data-drawer-header"]], "*"];
const _c1$4 = ["xpo-data-drawer-header", "*"];
// future proofing for when we have multiple data-drawer sizes
var XpoDataDrawerVisibility;
(function (XpoDataDrawerVisibility) {
    XpoDataDrawerVisibility["Closed"] = "closed";
    XpoDataDrawerVisibility["Full"] = "full";
    XpoDataDrawerVisibility["Minimized"] = "minimized";
    XpoDataDrawerVisibility["Partial"] = "partial";
})(XpoDataDrawerVisibility || (XpoDataDrawerVisibility = {}));
class XpoDataDrawerHeader {
}
XpoDataDrawerHeader.ɵfac = function XpoDataDrawerHeader_Factory(t) { return new (t || XpoDataDrawerHeader)(); };
XpoDataDrawerHeader.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDataDrawerHeader, selectors: [["xpo-data-drawer-header"]], hostAttrs: [1, "xpo-DataDrawerHeader"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDataDrawerHeader, [{
        type: Directive,
        args: [{
                selector: 'xpo-data-drawer-header',
                host: { class: 'xpo-DataDrawerHeader' },
            }]
    }], null, null); })();
function DEFAULT_DATA_DRAWER_VISIBILITY_STRATEGY(focusedRecord, selection) {
    return !!focusedRecord;
}
class XpoDataDrawer extends XpoBoardConsumer {
    constructor(changeDetectorRef, defaultDataSource, boardApiDispatcherService, boardDataSourceResolver) {
        super(boardDataSourceResolver, changeDetectorRef);
        this.defaultDataSource = defaultDataSource;
        this.boardApiDispatcherService = boardApiDispatcherService;
        // allow the enum to be used in the html
        this.XpoBoardDataFetchState = XpoBoardDataFetchState;
        this.dataDrawerVisibility = XpoDataDrawerVisibility.Closed;
        this.previousDrawerAppearance = XpoDataDrawerVisibility.Full;
        this.drawerVisibilityStrategy = DEFAULT_DATA_DRAWER_VISIBILITY_STRATEGY;
        this.visibilityChange = new EventEmitter();
    }
    get dataDrawerDataSource() {
        return this.dataDrawerDataSourceValue;
    }
    set dataDrawerDataSource(v) {
        this.dataDrawerDataSourceValue = v;
        this.initDataDrawerDataSource();
    }
    get selection() {
        return this.selectionValue;
    }
    set selection(value) {
        this.selectionValue = value;
        this.updateDrawerStateWithInputValues();
    }
    get focusedRecord() {
        return this.focusedRecordValue;
    }
    set focusedRecord(value) {
        this.focusedRecordValue = value;
        this.updateDrawerStateWithInputValues();
    }
    ngOnInit() {
        super.ngOnInit();
        // If no dataDrawerDataSource, run init and default it to the default data source,
        // if there is a dataDrawerDataSource it will call this function in the set method and skip
        // defaulting the value.
        if (!this.dataDrawerDataSource) {
            this.initDataDrawerDataSource();
        }
        if (this.boardApiDispatcherService) {
            this.boardApiDispatcherService.registerHandler(XpoBoardApiAction.ToggleDataDrawer, (focusedRecord, selection) => {
                const dataDrawerState = { focusedRecord, selection: selection || [] };
                this.updateDataDrawerState(dataDrawerState);
            });
        }
    }
    closedClicked() {
        this.dataDrawerVisibility = XpoDataDrawerVisibility.Closed;
        this.visibilityChange.emit(false);
    }
    retry() {
        this.dataDrawerDataSource.retrieveRecord();
    }
    onStateChange(state) {
        if (!state.changes.includes('focusedRecord') && !state.changes.includes('selection')) {
            return;
        }
        // If state is repeated, don't continue
        const dataDrawerState = { focusedRecord: state.focusedRecord, selection: state.selection };
        this.updateDataDrawerState(dataDrawerState);
    }
    setDrawerVisibility(visible) {
        // if the strategy dictates we should be closed, then go ahead and set the closed state
        if (!visible) {
            this.dataDrawerVisibility = XpoDataDrawerVisibility.Closed;
            this.visibilityChange.emit(false);
            return;
        }
        // if the data drawer is closed, restore it to the previous state
        if (this.dataDrawerVisibility === XpoDataDrawerVisibility.Closed) {
            this.dataDrawerVisibility = this.previousDrawerAppearance;
            this.visibilityChange.emit(true);
        }
    }
    initDataDrawerDataSource() {
        if (!this.dataDrawerDataSourceValue) {
            this.dataDrawerDataSourceValue = this.defaultDataSource;
        }
        this.dataFetchState$ = this.dataDrawerDataSourceValue.dataFetchState$;
    }
    /**
     * Updates the drawer state and drawer visibility
     * @param state
     */
    updateDataDrawerState(state) {
        const drawerVisible = this.drawerVisibilityStrategy(state.focusedRecord, state.selection);
        // Trigger the data source update only if we decided the drawer is visible
        if (drawerVisible) {
            this.dataDrawerDataSource.setDataDrawerState(state);
        }
        this.setDrawerVisibility(drawerVisible);
    }
    /**
     * Updates the drawer state with the component's inputted values values
     */
    updateDrawerStateWithInputValues() {
        this.updateDataDrawerState({ focusedRecord: this.focusedRecord, selection: this.selection });
    }
}
XpoDataDrawer.ɵfac = function XpoDataDrawer_Factory(t) { return new (t || XpoDataDrawer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XpoDataDrawerDefaultDataSource), i0.ɵɵdirectiveInject(XpoBoardApiDispatcherService, 8), i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver, 8)); };
XpoDataDrawer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDataDrawer, selectors: [["xpo-data-drawer"]], hostAttrs: [1, "xpo-DataDrawer"], inputs: { dataDrawerDataSource: ["dataSource", "dataDrawerDataSource"], selection: "selection", focusedRecord: "focusedRecord", drawerVisibilityStrategy: "drawerVisibilityStrategy" }, outputs: { visibilityChange: "visibilityChange" }, exportAs: ["xpoDataDrawer"], features: [i0.ɵɵProvidersFeature([XpoDataDrawerDefaultDataSource]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$4, decls: 11, vars: 7, consts: [[1, "xpo-DataDrawer-headerWrapper"], ["mat-icon-button", "", 1, "xpo-DataDrawer-closeButton", 3, "click"], ["class", "xpo-DataDrawer-content", 4, "ngIf", "ngIfElse"], ["class", "xpo-DataDrawer-overlay", 4, "ngIf"], ["displayError", ""], [1, "xpo-DataDrawer-content"], [1, "xpo-DataDrawer-overlay"], [1, "xpo-BoardUtils-centerContainer"], ["mat-button", "", "color", "primary", 3, "click"]], template: function XpoDataDrawer_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$9);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementStart(2, "button", 1);
        i0.ɵɵlistener("click", function XpoDataDrawer_Template_button_click_2_listener() { return ctx.closedClicked(); });
        i0.ɵɵelementStart(3, "mat-icon");
        i0.ɵɵtext(4, "clear");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoDataDrawer_div_5_Template, 2, 0, "div", 2);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵtemplate(7, XpoDataDrawer_div_7_Template, 2, 0, "div", 3);
        i0.ɵɵpipe(8, "async");
        i0.ɵɵtemplate(9, XpoDataDrawer_ng_template_9_Template, 5, 0, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(10);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 3, ctx.dataFetchState$) !== ctx.XpoBoardDataFetchState.Error)("ngIfElse", _r2);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 5, ctx.dataFetchState$) === ctx.XpoBoardDataFetchState.Loading);
    } }, directives: [i3$1.MatButton, i3.MatIcon, i2.NgIf, i7$1.XpoResponsiveLoadingSpinner], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-DataDrawer{display:flex;flex-direction:column;height:100%;overflow:auto}.xpo-DataDrawer-headerWrapper{align-items:center;background-color:#4a4a4a;color:#fff;display:flex;flex-direction:row;flex-shrink:0;height:56px;justify-content:space-between;padding:8px 8px 8px 16px}.xpo-DataDrawer-closeButton.mat-icon-button{color:#fff;line-height:0}.xpo-DataDrawer-closeButton.mat-icon-button:hover{color:#d8d8d8}.xpo-DataDrawer-content{height:100%;overflow:auto}.xpo-DataDrawer-overlay{background-color:#6f6f6f4d;height:100%;left:0;position:absolute;top:0;width:100%}.xpo-DataDrawerHeader{display:flex;flex-direction:column;font-size:1.285rem;font-weight:500;letter-spacing:2px;text-transform:uppercase;width:100%}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDataDrawer, [{
        type: Component,
        args: [{
                selector: 'xpo-data-drawer',
                templateUrl: './data-drawer.component.html',
                styleUrls: ['./data-drawer.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-DataDrawer' },
                providers: [XpoDataDrawerDefaultDataSource],
                exportAs: 'xpoDataDrawer',
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: XpoDataDrawerDefaultDataSource }, { type: XpoBoardApiDispatcherService, decorators: [{
                type: Optional
            }] }, { type: XpoBoardDataSourceResolver, decorators: [{
                type: Optional
            }] }]; }, { dataDrawerDataSource: [{
            type: Input,
            args: ['dataSource']
        }], selection: [{
            type: Input
        }], focusedRecord: [{
            type: Input
        }], drawerVisibilityStrategy: [{
            type: Input
        }], visibilityChange: [{
            type: Output
        }] }); })();

class XpoDataDrawerModule {
}
XpoDataDrawerModule.ɵfac = function XpoDataDrawerModule_Factory(t) { return new (t || XpoDataDrawerModule)(); };
XpoDataDrawerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoDataDrawerModule });
XpoDataDrawerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatButtonModule, XpoResponsiveLoadingSpinnerModule, MatIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDataDrawerModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoDataDrawer, XpoDataDrawerHeader],
                imports: [CommonModule, MatButtonModule, XpoResponsiveLoadingSpinnerModule, MatIconModule],
                exports: [XpoDataDrawer, XpoDataDrawerHeader],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoDataDrawerModule, { declarations: [XpoDataDrawer, XpoDataDrawerHeader], imports: [CommonModule, MatButtonModule, XpoResponsiveLoadingSpinnerModule, MatIconModule], exports: [XpoDataDrawer, XpoDataDrawerHeader] }); })();

class XpoDataDrawerState {
}

class XpoBoardViewsAlternateTabs {
}
XpoBoardViewsAlternateTabs.ɵfac = function XpoBoardViewsAlternateTabs_Factory(t) { return new (t || XpoBoardViewsAlternateTabs)(); };
XpoBoardViewsAlternateTabs.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBoardViewsAlternateTabs, selectors: [["", "xpoBoardViewsAlternateTabs", ""]], hostAttrs: [1, "xpo-BoardViewsAlternateTabs"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardViewsAlternateTabs, [{
        type: Directive,
        args: [{
                selector: '[xpoBoardViewsAlternateTabs]',
                host: { class: 'xpo-BoardViewsAlternateTabs' },
            }]
    }], null, null); })();

/**
 * @deprecated
 */
class XpoNoBorderTabs {
    constructor() {
        console.warn('[xpo-no-borders-tabs] is deprecated, please remove it from your board element');
    }
}
XpoNoBorderTabs.ɵfac = function XpoNoBorderTabs_Factory(t) { return new (t || XpoNoBorderTabs)(); };
XpoNoBorderTabs.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoNoBorderTabs, selectors: [["", "xpo-no-borders-tabs", ""]], hostAttrs: [1, "xpo-no-borders-tabs"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoNoBorderTabs, [{
        type: Directive,
        args: [{
                selector: '[xpo-no-borders-tabs]',
                host: {
                    class: 'xpo-no-borders-tabs',
                },
            }]
    }], function () { return []; }, null); })();

const BOARD_ACTIVE_VIEW_QUERY_PARAM = 'xpoBoardActiveView';

class XpoBoardViewDataStoreBase {
    loadAll() {
        return this.getAll().pipe(tap((views) => (this.availableViews = views)));
    }
    delete(viewId) {
        const viewIdx = this.availableViews.findIndex((v) => v.id === viewId);
        if (viewIdx !== -1) {
            this.availableViews.splice(viewIdx, 1);
        }
        return viewIdx !== -1 ? this.updateDataStore(this.availableViews).pipe(mapTo(true)) : of(false);
    }
    save(view) {
        // append or replace current and store them all
        const viewIdx = this.availableViews.findIndex((v) => v.id === view.id);
        if (viewIdx !== -1) {
            this.availableViews.splice(viewIdx, 1, view);
        }
        else {
            this.availableViews.push(view);
        }
        return this.updateDataStore(this.availableViews).pipe(mapTo(view));
    }
    updateViewVisibility(viewId, visibility) {
        const viewIdx = this.availableViews.findIndex((v) => v.id === viewId);
        if (viewIdx !== -1) {
            this.availableViews[viewIdx].visible = visibility;
        }
        return this.updateDataStore(this.availableViews);
    }
}

class XpoBoardViewInMemoryDataStore {
    constructor(views) {
        this.boardViews = views || [];
    }
    getAll() {
        return of(this.boardViews);
    }
    loadAll() {
        return this.getAll();
    }
    save(view) {
        throw new Error('InMemoryDataStore does not support saving views.');
    }
    delete(viewId) {
        throw new Error('InMemoryDataStore does not support deleting views.');
    }
    updateViewVisibility(viewId, visibility) {
        throw new Error('InMemoryDataStore does not support updating visibilities of views');
    }
}

const XPO_LOCAL_STORAGE_FULL_ERROR_CODE = 22;
class XpoLocalStorageBoardViewDataStore extends XpoBoardViewDataStoreBase {
    constructor(localStorageKey, initialViews = null) {
        super();
        this.localStorageKey = localStorageKey;
        this.initialViews = initialViews;
    }
    getAll() {
        let views = [...(this.initialViews || [])];
        if (localStorage.getItem(this.localStorageKey) !== null) {
            // retrieve the views from local storage and add any views that are not already loaded to the view collection
            const storedViews = JSON.parse(localStorage.getItem(this.localStorageKey)) || [];
            views.push(...storedViews.filter((sv) => !views.some((iv) => iv.id === sv.id)));
            // copy any properties persisted on the template views
            views = views.map((v) => {
                const savedView = storedViews.find((sv) => sv.id === v.id);
                return savedView ? Object.assign(Object.assign({}, v), savedView) : v;
            });
        }
        return of(views, asyncScheduler);
    }
    updateDataStore(configs) {
        // TODO: This is just to prevent the application to fail and also a console error when storage is full,
        // we should find some way to notify the user but can't handle this refactor now and also projects
        // don't use local storage, they save for real in user preferences.
        try {
            localStorage.setItem(this.localStorageKey, JSON.stringify(configs));
        }
        catch (e) {
            // Local storage is full
            if (e.code === XPO_LOCAL_STORAGE_FULL_ERROR_CODE) {
                console.warn(`[XPO-LTL-BOARD] Storage is full, can't save this item.`);
            }
        }
        return of(configs, asyncScheduler);
    }
}

function XpoBoardViews_a_0_mat_chip_list_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip-list", 7);
    i0.ɵɵelementStart(1, "mat-chip", 8);
    i0.ɵɵlistener("click", function XpoBoardViews_a_0_mat_chip_list_4_Template_mat_chip_click_1_listener() { i0.ɵɵrestoreView(_r7); const view_r2 = i0.ɵɵnextContext().$implicit; const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.setActiveView(view_r2.view); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const view_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("color", view_r2.recordChangeCount ? "warn" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.getRecordCountDisplay(view_r2.recordCount) || "\u00A0", " ");
} }
function XpoBoardViews_a_0_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function XpoBoardViews_a_0_button_5_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r11); const view_r2 = i0.ɵɵnextContext().$implicit; const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.closeView(view_r2.view, $event); });
    i0.ɵɵelementStart(1, "mat-icon", 10);
    i0.ɵɵtext(2, "clear");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoBoardViews_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵlistener("click", function XpoBoardViews_a_0_Template_a_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const view_r2 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.setActiveView(view_r2.view); });
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, XpoBoardViews_a_0_mat_chip_list_4_Template, 3, 2, "mat-chip-list", 5);
    i0.ɵɵtemplate(5, XpoBoardViews_a_0_button_5_Template, 3, 0, "button", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const view_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("xpo-BoardViews-tab--active", view_r2.active)("xpo-BoardViews-tab--closeable", view_r2.closeable);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.id, "-", view_r2.viewId, "");
    i0.ɵɵproperty("title", view_r2.recordCount ? view_r2.recordCount + " items" : "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(view_r2.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.suppressRecordCounts);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", view_r2.closeable);
} }
function XpoBoardViews_ng_container_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function XpoBoardViews_ng_container_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.checkViewTemplateCount(); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r17 = i0.ɵɵreference(5);
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r14.id, "-addAdditionalViewButton");
    i0.ɵɵproperty("matMenuTriggerFor", _r17);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.addNewViewButtonLabel, " ");
} }
function XpoBoardViews_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function XpoBoardViews_ng_container_2_ng_template_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.checkViewTemplateCount(); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r16.id, "-addAdditionalViewButton");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.addNewViewButtonLabel, " ");
} }
function XpoBoardViews_ng_container_2_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function XpoBoardViews_ng_container_2_button_6_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r26); const viewTemplate_r23 = restoredCtx.$implicit; const ctx_r25 = i0.ɵɵnextContext(2); return ctx_r25.addNewView(viewTemplate_r23.id); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const viewTemplate_r23 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", viewTemplate_r23.name, " ");
} }
function XpoBoardViews_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoBoardViews_ng_container_2_button_1_Template, 4, 3, "button", 11);
    i0.ɵɵtemplate(2, XpoBoardViews_ng_container_2_ng_template_2_Template, 4, 2, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(4, "mat-menu", null, 13);
    i0.ɵɵtemplate(6, XpoBoardViews_ng_container_2_button_6_Template, 2, 1, "button", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.viewsWithAllowAdditional.length > 1)("ngIfElse", _r15);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.viewsWithAllowAdditional);
} }
let nextUniqueId$1 = 0;
/** Display model for the repeater in the UI */
class VisibleBoardViewModel {
    constructor(datum, active, view) {
        if (view) {
            this.active = active;
            this.closeable = view.closeable;
            this.name = view ? view.name : 'UNKNOWN';
            this.recordCount = VisibleBoardViewModel.hasRecordCount(datum.recordCount) ? datum.recordCount : view.recordCount;
            this.viewId = datum.viewId;
            this.view = view;
            this.recordChangeCount = datum.recordChangeCount;
        }
    }
    static hasRecordCount(recordCount) {
        return !!recordCount || recordCount === 0;
    }
}
class XpoBoardViews extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd, boardApiDispatcherService, router, activatedRoute) {
        super(boardDataSourceResolver, cd);
        this.boardApiDispatcherService = boardApiDispatcherService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.viewTemplates = [];
        this.uid = `xpo-BoardViews-${nextUniqueId$1++}`;
        this.currentState = { source: XpoBoardViews.XpoBoardViewsSources.Init };
        this.maxNumberOfRecords = 10000;
        this.suppressRecordCountsValue = false;
        this.preloadViewDataValue = false;
        this.enableQueryParamStatePersistanceValue = false;
        this.persistFiltersBetweenViewsValue = false;
    }
    get persistFiltersBetweenViews() {
        return this.persistFiltersBetweenViewsValue;
    }
    set persistFiltersBetweenViews(value) {
        this.persistFiltersBetweenViewsValue = coerceBooleanProperty(value);
    }
    get enableQueryParamStatePersistance() {
        return this.enableQueryParamStatePersistanceValue;
    }
    set enableQueryParamStatePersistance(value) {
        this.enableQueryParamStatePersistanceValue = coerceBooleanProperty(value);
    }
    get suppressRecordCounts() {
        return this.suppressRecordCountsValue;
    }
    set suppressRecordCounts(value) {
        this.suppressRecordCountsValue = coerceBooleanProperty(value);
    }
    get preloadViewData() {
        return this.preloadViewDataValue;
    }
    set preloadViewData(v) {
        this.preloadViewDataValue = coerceBooleanProperty(v);
    }
    get id() {
        return this.idValue;
    }
    set id(value) {
        this.idValue = value || this.uid;
    }
    get viewsWithAllowAdditional() {
        return this.viewTemplates.filter((x) => x.allowAdditional === true);
    }
    ngOnInit() {
        super.ngOnInit();
        this.registerBoardApiHandlers();
    }
    addNewView(viewTemplateId) {
        const template = this.viewTemplates.find((x) => x.id === viewTemplateId);
        const view = template.createView({
            closeable: true,
            name: XpoBoardViewUtil.getNextViewName(template),
            visible: true,
        });
        this.stateChange$.next(XpoBoardViewUtil.addView(view, this.currentState, XpoBoardViews.XpoBoardViewsSources.AddView, this.persistFiltersBetweenViews));
    }
    closeView(view, clickEvent = null) {
        // Avoid calling multiple click handlers - like the other one for activating view
        if (clickEvent) {
            clickEvent.stopPropagation();
        }
        // Not passing in the current state since the user might have changed the
        // criteria of the state, but not saved it, so we dont
        // want to persist that when the user closes the view.
        this.stateChange$.next(XpoBoardViewUtil.hideView(view.id, this.currentState, XpoBoardViews.XpoBoardViewsSources.CloseView));
        // If view data store is inputted or if the view is created and not saved, then just remove the view.
        // TODO: maybe we should normalize the view data store to always exist?
        if (this.viewDataStore || !view.lastSaved) {
            // TODO: handle error
            this.viewDataStore.updateViewVisibility(view.id, false).pipe(take(1)).subscribe();
        }
    }
    checkViewTemplateCount() {
        if (this.viewsWithAllowAdditional.length > 1) {
            this.trigger.openMenu();
        }
        else {
            // if theres only one viewTemplate, create a new view with it
            this.addNewView(this.viewsWithAllowAdditional[0].id);
        }
    }
    setActiveView(view) {
        if (this.enableQueryParamStatePersistance) {
            const queryParams = { [BOARD_ACTIVE_VIEW_QUERY_PARAM]: view.id };
            this.router.navigate([], {
                relativeTo: this.activatedRoute,
                queryParams: queryParams,
                queryParamsHandling: 'merge',
            });
        }
        this.stateChange$.next(XpoBoardViewUtil.activateView(view, this.currentState, XpoBoardViews.XpoBoardViewsSources.ActiveViewChange, this.persistFiltersBetweenViews));
    }
    getRecordCountDisplay(recordCount) {
        if (!VisibleBoardViewModel.hasRecordCount(recordCount)) {
            return null;
        }
        return recordCount > this.maxNumberOfRecords ? this.maxNumberOfRecords / 1000 + 'K+' : `${recordCount}`;
    }
    onStateChange(state) {
        if (state.viewTemplates !== this.currentState.viewTemplates) {
            this.viewTemplates = state.viewTemplates || [];
            this.allowAdditionalViews = this.viewTemplates.some((t) => t.allowAdditional);
        }
        // Map the visible views, if they changed or an error occurred, while retrieving data
        if (this.currentState.visibleViewData !== state.visibleViewData ||
            state.dataFetchState === XpoBoardDataFetchState.Error) {
            // Flag to cause an update in state when a view has to preload data.
            // This is so other state observers can get the update in the view record count.
            let updateStateWithNewVisibleViewData = false;
            this.visibleViews$ = combineLatest((state.visibleViewData || []).map((visibleView) => {
                const isActive = visibleView.viewId === state.viewId;
                const view = state.availableViews.find((x) => x.id === visibleView.viewId);
                const visibleView$ = of(new VisibleBoardViewModel(visibleView, isActive, view));
                // If the board is configured to preload all view data & the view does
                // not have a record count & the view is not the active
                // view (since we are already fetching the data for that in another call)
                // then fetch the data of the view so we have the
                // record count pre-loaded, else, return the view with no record count loaded
                if (this.preloadViewData &&
                    !VisibleBoardViewModel.hasRecordCount(visibleView.recordCount) &&
                    !isActive &&
                    view) {
                    // Setting this to true so that the state will update with the new record counts for views.
                    updateStateWithNewVisibleViewData = true;
                    // Return the merge result between the view with no recordCount
                    // (a completed observable) and the request for fetching data.
                    // This way we immediately display the views, and later update the count too.
                    return merge(visibleView$, this.dataSource.fetchData(view.getState(view.criteria)).pipe(take(1), map((result) => new VisibleBoardViewModel({ recordCount: result.recordCount, viewId: view.id }, isActive, view))));
                }
                return visibleView$;
            })).pipe(tap((v) => {
                // If we pre-loaded the view data, update the state of the board so other observers can get this update
                if (updateStateWithNewVisibleViewData) {
                    // Update the local current state value with the newly
                    // updated visible view data so that when this state change is emitted
                    // and comes back to this function
                    // this.currentState.visibleViewData !== state.visibleViewData can be true and not
                    // cause another fetch
                    this.currentState.visibleViewData = v;
                    this.stateChange$.next({ visibleViewData: v, source: XpoBoardViews.XpoBoardViewsSources.PreloadData });
                }
            }));
        }
        this.currentState = state;
    }
    registerBoardApiHandlers() {
        this.boardApiDispatcherService.registerHandler(XpoBoardApiAction.HideView, (viewId) => {
            const view = this.currentState.availableViews.find((x) => x.id === viewId);
            if (view) {
                this.closeView(view);
            }
            else {
                console.error(`XpoBoardViews: ${viewId} was trying to be hidden but it was not found`);
            }
        });
        this.boardApiDispatcherService.registerHandler(XpoBoardApiAction.ActivateView, (viewId) => {
            const view = this.currentState.availableViews.find((x) => x.id === viewId);
            if (view) {
                this.setActiveView(view);
            }
            else {
                console.error(`XpoBoardViews: ${viewId} was trying to be activated but it was not found`);
            }
        });
    }
}
XpoBoardViews.XpoBoardViewsSources = {
    Init: 'BOARD-VIEWS-INIT',
    CloseView: 'BOARD-VIEWS-CLOSE-VIEW',
    AddView: 'ADD-NEW-VIEW',
    ActiveViewChange: 'ACTIVE-VIEW-CHANGE',
    PreloadData: 'BOARD-VIEW-PRELOAD-DATA',
};
XpoBoardViews.ɵfac = function XpoBoardViews_Factory(t) { return new (t || XpoBoardViews)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XpoBoardApiDispatcherService), i0.ɵɵdirectiveInject(i3$4.Router), i0.ɵɵdirectiveInject(i3$4.ActivatedRoute)); };
XpoBoardViews.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoardViews, selectors: [["xpo-board-views"]], viewQuery: function XpoBoardViews_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MatMenuTrigger, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
    } }, hostAttrs: [1, "xpo-BoardViews"], hostVars: 1, hostBindings: function XpoBoardViews_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, inputs: { addNewViewButtonLabel: "addNewViewButtonLabel", viewDataStore: "viewDataStore", persistFiltersBetweenViews: "persistFiltersBetweenViews", enableQueryParamStatePersistance: "enableQueryParamStatePersistance", suppressRecordCounts: "suppressRecordCounts", preloadViewData: "preloadViewData", id: "id" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [["class", "xpo-BoardViews-tab", 3, "id", "title", "xpo-BoardViews-tab--active", "xpo-BoardViews-tab--closeable", "click", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "xpo-BoardViews-tab", 3, "id", "title", "click"], [1, "xpo-BoardViews-tab-contentWrapper"], [1, "xpo-BoardViews-tab-name"], ["selectable", "true", "class", "xpo-BoardViews-tab-count", 4, "ngIf"], ["class", "xpo-BoardViews-tab-close", "matTooltip", "Hide View", "matTooltipShowDelay", "500", 3, "click", 4, "ngIf"], ["selectable", "true", 1, "xpo-BoardViews-tab-count"], ["xpoChipSmall", "", 3, "color", "click"], ["matTooltip", "Hide View", "matTooltipShowDelay", "500", 1, "xpo-BoardViews-tab-close", 3, "click"], [1, "xpo-BoardViews-tab-closeIcon"], ["mat-icon-button", "", "class", "xpo-BoardViews-add", 3, "id", "matMenuTriggerFor", "click", 4, "ngIf", "ngIfElse"], ["noMenu", ""], ["templateMenu", "matMenu"], ["mat-menu-item", "", 3, "click", 4, "ngFor", "ngForOf"], ["mat-icon-button", "", 1, "xpo-BoardViews-add", 3, "id", "matMenuTriggerFor", "click"], ["mat-icon-button", "", 1, "xpo-BoardViews-add", 3, "id", "click"], ["mat-menu-item", "", 3, "click"]], template: function XpoBoardViews_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, XpoBoardViews_a_0_Template, 6, 10, "a", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, XpoBoardViews_ng_container_2_Template, 7, 3, "ng-container", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 2, ctx.visibleViews$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowAdditionalViews);
    } }, directives: [i2.NgForOf, i2.NgIf, i1$4.MatChipList, i1$4.MatChip, i3$2.XpoChipSmall, i3$3.MatTooltip, i3.MatIcon, i6.MatMenu, i3$1.MatButton, i6.MatMenuTrigger, i6.MatMenuItem], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-BoardViews{background-color:#fff;border-bottom:1px solid #d8d8d8;display:flex;flex-direction:row;flex-shrink:0;flex-wrap:wrap;font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;min-height:40px;padding:4px 8px 0}.xpo-BoardViews>*{margin-top:4px}.xpo-BoardViews-tab{background-color:transparent;border-left:1px solid #d8d8d8;border-right:1px solid #d8d8d8;border-top-color:#d8d8d8;border-top-style:solid;border-top-width:2px;color:#6f6f6f;cursor:pointer;display:flex;font-family:inherit;font-weight:500;height:40px;line-height:40px;margin-right:4px;max-width:275px;min-width:90px;padding:0 8px;position:relative;text-decoration:none;-webkit-user-select:none;user-select:none}.xpo-BoardViews-tab[disabled]{color:#d8d8d8}.xpo-BoardViews-tab:focus,.xpo-BoardViews-tab:hover:not(.xpo-BoardViews-tab--active){border-top-color:#0868ac;color:#4a4a4a}.xpo-BoardViews-tab--active{background-color:#fff;border-top-color:#0d94f4;color:#4a4a4a}.xpo-BoardViews-tab--active:after{background-color:#fff;bottom:-1px;content:\"\";display:block;height:1px;left:0;position:absolute;right:0}.xpo-BoardViews-tab--active:focus,.xpo-BoardViews-tab--active:hover{color:#4a4a4a}.xpo-BoardViews-tab--closeable:hover .xpo-BoardViews-tab-close{display:flex}.xpo-BoardViews-tab--closeable:hover .xpo-BoardViews-tab-count{visibility:hidden}.xpo-BoardViews-tab-contentWrapper{align-items:center;display:flex;justify-content:center;position:relative;width:100%}.xpo-BoardViews-tab-name{font-size:1rem;overflow:hidden;padding-right:4px;text-overflow:ellipsis;white-space:nowrap}.xpo-BoardViews-tab-count{margin-left:auto;position:relative}.xpo-BoardViews-tab-count .mat-chip{cursor:pointer}.xpo-BoardViews-tab-count .mat-chip.mat-warn{background-color:#d50000;color:#fff}.xpo-BoardViews-tab-close{background-color:transparent;border:none;cursor:pointer;display:none;outline:none;padding:0;position:absolute;right:0;top:0;transform:translateY(75%)}.xpo-BoardViews-tab-close:hover .mat-icon{background-color:#6f6f6f}.xpo-BoardViews-tab-close,.xpo-BoardViews-tab-close .mat-icon{height:14px;width:14px}.xpo-BoardViews-tab-close .mat-icon{background-color:#9b9b9b;border-radius:50%;color:#fff;font-size:14px}.xpo-BoardViews-add{color:#0868ac;font-weight:500}.xpo-BoardViews-add .mat-icon{font-size:1.143rem;height:24px;outline:1px solid #d8d8d8;width:24px}.xpo-Board.xpo-no-borders-tabs .xpo-BoardViews-tab{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent;color:#0868ac}.xpo-Board.xpo-no-borders-tabs .xpo-BoardViews-tab--active{border-left-color:#d8d8d8;border-right-color:#d8d8d8;border-top-color:#0d94f4;color:#4a4a4a}.xpo-Board.xpo-no-borders-tabs .xpo-BoardViews-tab-name{text-align:center;width:100%}.xpo-BoardViewsAlternateTabs.xpo-Board .xpo-BoardViews-tab,.xpo-BoardViewsAlternateTabs.xpo-BoardViews .xpo-BoardViews-tab{border:none;border-bottom-color:transparent;border-bottom-style:solid;border-bottom-width:2px;margin-bottom:4px;margin-top:0}.xpo-BoardViewsAlternateTabs.xpo-Board .xpo-BoardViews-tab:focus:not(.xpo-BoardViews-tab--active),.xpo-BoardViewsAlternateTabs.xpo-Board .xpo-BoardViews-tab:hover:not(.xpo-BoardViews-tab--active),.xpo-BoardViewsAlternateTabs.xpo-BoardViews .xpo-BoardViews-tab:focus:not(.xpo-BoardViews-tab--active),.xpo-BoardViewsAlternateTabs.xpo-BoardViews .xpo-BoardViews-tab:hover:not(.xpo-BoardViews-tab--active){border-bottom-color:#0868ac}.xpo-BoardViewsAlternateTabs.xpo-Board .xpo-BoardViews-tab--active,.xpo-BoardViewsAlternateTabs.xpo-BoardViews .xpo-BoardViews-tab--active{border-bottom-color:#0d94f4}.xpo-BoardViewsAlternateTabs.xpo-Board .xpo-BoardViews-tab--active:after,.xpo-BoardViewsAlternateTabs.xpo-BoardViews .xpo-BoardViews-tab--active:after{bottom:0;height:0}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardViews, [{
        type: Component,
        args: [{
                selector: 'xpo-board-views',
                templateUrl: 'board-views.component.html',
                styleUrls: ['board-views.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-BoardViews', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }, { type: XpoBoardApiDispatcherService }, { type: i3$4.Router }, { type: i3$4.ActivatedRoute }]; }, { trigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], addNewViewButtonLabel: [{
            type: Input
        }], viewDataStore: [{
            type: Input
        }], persistFiltersBetweenViews: [{
            type: Input
        }], enableQueryParamStatePersistance: [{
            type: Input
        }], suppressRecordCounts: [{
            type: Input
        }], preloadViewData: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();

class XpoBoardViewsModule {
}
XpoBoardViewsModule.ɵfac = function XpoBoardViewsModule_Factory(t) { return new (t || XpoBoardViewsModule)(); };
XpoBoardViewsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoBoardViewsModule });
XpoBoardViewsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatButtonModule, MatMenuModule, MatTooltipModule, XpoIconModule, XpoChipsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardViewsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatButtonModule, MatMenuModule, MatTooltipModule, XpoIconModule, XpoChipsModule],
                declarations: [
                    XpoBoardViews,
                    // tslint:disable-next-line: deprecation
                    XpoNoBorderTabs,
                    XpoBoardViewsAlternateTabs,
                ],
                exports: [
                    XpoBoardViews,
                    // tslint:disable-next-line: deprecation
                    XpoNoBorderTabs,
                    XpoBoardViewsAlternateTabs,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoBoardViewsModule, { declarations: [XpoBoardViews,
        // tslint:disable-next-line: deprecation
        XpoNoBorderTabs,
        XpoBoardViewsAlternateTabs], imports: [CommonModule, MatButtonModule, MatMenuModule, MatTooltipModule, XpoIconModule, XpoChipsModule], exports: [XpoBoardViews,
        // tslint:disable-next-line: deprecation
        XpoNoBorderTabs,
        XpoBoardViewsAlternateTabs] }); })();

/**
 * Internal service used by the board component to improve code readability
 */
class XpoBoardService {
    constructor(activatedRoute, router) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.serviceDestroyed$ = new Subject();
        // make behavior because null is a valid value
        this.viewDataStoreSubject$ = new BehaviorSubject(null);
        this.viewsSubject$ = new ReplaySubject(1);
        this.viewTemplatesSubject$ = new ReplaySubject(1);
        this.viewsValue = [];
        this.viewTemplatesValue = [];
        this.stateChange$ = new ReplaySubject(1);
        // listen every time the views or templates change and push out event
        // TODO: Views can be null, so this will never hit if views are empty
        combineLatest(this.views$, this.viewTemplates$)
            .pipe(takeUntil(this.serviceDestroyed$))
            .subscribe(([views, viewTemplates]) => this.initializeViews(views, viewTemplates));
        // listen every time the dataStore or templates change
        combineLatest(this.viewDataStore$, this.viewTemplates$)
            .pipe(takeUntil(this.serviceDestroyed$))
            .subscribe(([viewDataStore, viewTemplates]) => this.loadViewsFromDataStore(viewDataStore, viewTemplates));
    }
    get viewDataStore() {
        return this.viewDataStoreValue;
    }
    set viewDataStore(value) {
        this.viewDataStoreSubject$.next((this.viewDataStoreValue = value));
    }
    get viewDataStore$() {
        return this.viewDataStoreSubject$.asObservable();
    }
    get views() {
        return this.viewsValue;
    }
    set views(value) {
        this.viewsSubject$.next((this.viewsValue = value));
    }
    get views$() {
        return this.viewsSubject$.asObservable();
    }
    get viewTemplates() {
        return this.viewTemplatesValue;
    }
    set viewTemplates(value) {
        this.viewTemplatesSubject$.next((this.viewTemplatesValue = value));
    }
    get viewTemplates$() {
        return this.viewTemplatesSubject$.asObservable();
    }
    ngOnDestroy() {
        this.destroyDataStoreViewSubscription();
        this.serviceDestroyed$.next();
        this.serviceDestroyed$.complete();
    }
    activateInitialView(views, templates) {
        const activeView = this.getDefaultActiveView(views);
        this.stateChange$.next(Object.assign(Object.assign({}, activeView.getState()), { pageNumber: 1, source: 'BOARD-ACTIVATING-VIEW', availableViews: views, visibleViewData: views.filter((v) => v.visible).map((v) => ({ viewId: v.id })), viewTemplates: templates }));
    }
    getDefaultActiveView(views) {
        let activeView = null;
        const activeViewFromQueryParams = this.activatedRoute.snapshot.queryParamMap.get(BOARD_ACTIVE_VIEW_QUERY_PARAM);
        if (!!activeViewFromQueryParams) {
            const queryParamActiveView = views.find((v) => v.id === activeViewFromQueryParams);
            // If there is no view associated with the view id in the query param, remove it if the current board has
            // enableQueryParamStatePersistance. The reason we want to not remove it if the  current board doesn't have
            // enableQueryParamStatePersistance enabled is if the end application routes to a view with another board,
            // we still want the ability to route back to the board with enableQueryParamStatePersistance and set
            // the active view.
            if (!queryParamActiveView) {
                if (this.boardOptions && this.boardOptions.enableQueryParamStatePersistance) {
                    // Clear out query param from route and continue
                    const queryParams = { [BOARD_ACTIVE_VIEW_QUERY_PARAM]: null };
                    this.router.navigate([], {
                        relativeTo: this.activatedRoute,
                        queryParams: queryParams,
                        queryParamsHandling: 'merge',
                    });
                }
            }
            else {
                activeView = queryParamActiveView;
            }
        }
        if (!activeView) {
            activeView = views.find((v) => v.isActive) || views[0];
        }
        return activeView;
    }
    createView(viewConfig) {
        // find associated template, none found use the first one
        const template = this.viewTemplates.find((t) => t.id === viewConfig.templateId) || this.viewTemplates[0];
        return template.createView(viewConfig);
    }
    initializeViews(views, templates) {
        // if there are no views create on and wait for this method to re-execute
        if (!views || !views.length) {
            const configValue = {
                name: XpoBoardViewUtil.getNextViewName(templates[0]),
                visible: true,
                id: templates[0].id,
            };
            const newView = templates[0].createView(configValue);
            this.views = [newView];
        }
        this.activateInitialView(views, templates);
    }
    loadViewsFromDataStore(dataStore, templates) {
        if (!dataStore || !templates || !templates.length) {
            return;
        }
        this.destroyDataStoreViewSubscription();
        this.dataStoreViewSubscription = dataStore
            .loadAll()
            .pipe(map((viewConfigs) => {
            return (viewConfigs || []).map((config) => this.createView(config));
        }))
            .subscribe((persistedViews) => {
            this.views = [...(persistedViews || [])];
        });
    }
    destroyDataStoreViewSubscription() {
        if (this.dataStoreViewSubscription && !this.dataStoreViewSubscription.closed) {
            this.dataStoreViewSubscription.unsubscribe();
            this.dataStoreViewSubscription = undefined;
        }
    }
}
XpoBoardService.ɵfac = function XpoBoardService_Factory(t) { return new (t || XpoBoardService)(i0.ɵɵinject(i3$4.ActivatedRoute), i0.ɵɵinject(i3$4.Router)); };
XpoBoardService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoBoardService, factory: XpoBoardService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardService, [{
        type: Injectable
    }], function () { return [{ type: i3$4.ActivatedRoute }, { type: i3$4.Router }]; }, null); })();

const _c0$8 = [[["xpo-filter-bar"]], "*"];
const _c1$3 = ["xpo-filter-bar", "*"];
class XpoGridBar {
}
XpoGridBar.ɵfac = function XpoGridBar_Factory(t) { return new (t || XpoGridBar)(); };
XpoGridBar.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoGridBar, selectors: [["xpo-grid-bar"]], hostAttrs: [1, "xpo-GridBar"], ngContentSelectors: _c1$3, decls: 2, vars: 0, template: function XpoGridBar_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$8);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
    } }, styles: [".flex--stretch{flex:1}.xpo-GridBar{background-color:#fff;border:1px solid #d8d8d8;display:flex;flex-shrink:0;min-height:42px;overflow:visible;position:relative;z-index:1}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGridBar, [{
        type: Component,
        args: [{
                selector: 'xpo-grid-bar',
                templateUrl: 'grid-bar.component.html',
                styleUrls: ['grid-bar.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-GridBar' },
            }]
    }], null, null); })();

function XpoBoard_xpo_grid_bar_3_xpo_column_level_filtering_toggle_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "xpo-column-level-filtering-toggle", 12);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r2.id, "-columnFiltersButton");
} }
function XpoBoard_xpo_grid_bar_3_xpo_save_view_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "xpo-save-view", 13);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r3.id, "-saveView");
    i0.ɵɵproperty("viewDataStore", ctx_r3.viewDataStore);
} }
function XpoBoard_xpo_grid_bar_3_button_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 14);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r4.id, "-downloadButton");
    i0.ɵɵproperty("handleDownload", ctx_r4.dataSource["export"].bind(ctx_r4.dataSource, ctx_r4.currentState));
} }
function XpoBoard_xpo_grid_bar_3_xpo_available_views_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "xpo-available-views", 13);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r5.id, "-availableViews");
    i0.ɵɵproperty("viewDataStore", ctx_r5.viewDataStore);
} }
function XpoBoard_xpo_grid_bar_3_xpo_grid_settings_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "xpo-grid-settings", 15);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r6.id, "-gridSettings");
    i0.ɵɵproperty("suppressGridDensity", ctx_r6.boardOptions == null ? null : ctx_r6.boardOptions.suppressGridDensity);
} }
function XpoBoard_xpo_grid_bar_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "xpo-grid-bar");
    i0.ɵɵelementStart(1, "xpo-filter-bar", 6);
    i0.ɵɵprojection(2, 6);
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵprojection(4, 7);
    i0.ɵɵtemplate(5, XpoBoard_xpo_grid_bar_3_xpo_column_level_filtering_toggle_5_Template, 1, 1, "xpo-column-level-filtering-toggle", 8);
    i0.ɵɵtemplate(6, XpoBoard_xpo_grid_bar_3_xpo_save_view_6_Template, 1, 2, "xpo-save-view", 9);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtemplate(8, XpoBoard_xpo_grid_bar_3_button_8_Template, 1, 2, "button", 10);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, XpoBoard_xpo_grid_bar_3_xpo_available_views_10_Template, 1, 2, "xpo-available-views", 9);
    i0.ɵɵtemplate(11, XpoBoard_xpo_grid_bar_3_xpo_grid_settings_11_Template, 1, 2, "xpo-grid-settings", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.id, "-filterBar");
    i0.ɵɵproperty("applyFilterStrategy", ctx_r0.boardOptions.applyFilterStrategy)("enableFilterReset", ctx_r0.boardOptions.enableFilterReset);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.showFiltersButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isActionVisible(ctx_r0.XpoBoardActionType.Save));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showExportButton && !i0.ɵɵpipeBind1(9, 8, ctx_r0.disableExportButton$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isActionVisible(ctx_r0.XpoBoardActionType.AvailableViews));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r0.boardOptions == null ? null : ctx_r0.boardOptions.suppressGridSettingsPopover));
} }
function XpoBoard_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵprojection(1, 8);
    i0.ɵɵelementEnd();
} }
const _c0$7 = [[["xpo-Board-header"]], [["xpo-board-header"]], [["xpo-board-grid-toolbar"]], "*", [["xpo-empty-state"]], [["xpo-data-drawer"]], [["xpo-board-actions", "filterActions", ""]], [["xpo-board-actions"]], [["xpo-board-total-records"]]];
const _c1$2 = function (a0) { return { "xpo-Board-boardViews--hidden": a0 }; };
const _c2$1 = ["xpo-Board-header", "xpo-board-header", "xpo-board-grid-toolbar", "*", "xpo-empty-state", "xpo-data-drawer", "xpo-board-actions[filterActions]", "xpo-board-actions", "xpo-board-total-records"];
let nextUniqueId = 0;
class XpoBoardActions {
}
XpoBoardActions.ɵfac = function XpoBoardActions_Factory(t) { return new (t || XpoBoardActions)(); };
XpoBoardActions.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBoardActions, selectors: [["xpo-board-actions"]], hostAttrs: [1, "xpo-BoardActions"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardActions, [{
        type: Directive,
        args: [{
                selector: 'xpo-board-actions',
                host: { class: 'xpo-BoardActions' },
            }]
    }], null, null); })();
class XpoBoard {
    constructor(boardDataSourceResolver, boardService, actionsVisibilityService, boardApiService, cd, filterService, globalBoardOptions) {
        this.boardDataSourceResolver = boardDataSourceResolver;
        this.boardService = boardService;
        this.actionsVisibilityService = actionsVisibilityService;
        this.boardApiService = boardApiService;
        this.cd = cd;
        this.filterService = filterService;
        this.globalBoardOptions = globalBoardOptions;
        this.dataDrawerOpen = false;
        this.XpoBoardActionType = XpoBoardActionType;
        this.showExportButton = false;
        this.showFiltersButton = false;
        this.disableExportButton$ = EMPTY;
        this.uid = `xpo-Board-${nextUniqueId++}`;
        this.idValue = this.uid;
        this.componentDestroyed$ = new Subject();
        this.boardOptionsValue = {};
        this.boardReady = new EventEmitter();
        this.selectionChange = new EventEmitter();
        this.stateChange$ = this.boardService.stateChange$;
        this.viewTemplates$ = this.boardService.viewTemplates$;
        this.boardApi = new XpoBoardApi(this.boardApiService);
        if (this.globalBoardOptions) {
            this.boardOptions = Object.assign(Object.assign({}, this.globalBoardOptions), this.boardOptions);
        }
    }
    // User a getter/setter here to handle cases where data drawer has an *ngIf attached
    get dataDrawer() {
        return this.dataDrawerValue;
    }
    set dataDrawer(value) {
        if (this.dataDrawerVisibilitySubscription) {
            this.dataDrawerVisibilitySubscription.unsubscribe();
        }
        this.dataDrawerValue = value;
        if (this.dataDrawerValue) {
            this.dataDrawerVisibilitySubscription = this.dataDrawerValue.visibilityChange
                .pipe(takeUntil(this.componentDestroyed$))
                .subscribe((visibility) => {
                this.dataDrawerOpen = visibility;
                this.cd.markForCheck();
            });
        }
    }
    get id() {
        return this.idValue;
    }
    set id(value) {
        this.idValue = value || this.uid;
    }
    /** Data Source of the board */
    get dataSource() {
        return this.dataSourceValue;
    }
    set dataSource(value) {
        if (this.dataSourceValue) {
            this.dataSourceValue.disconnect(this);
        }
        this.dataSourceValue = value;
        this.dataSourceValue
            .connect(this)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((state) => this.handleStateChange(state));
        this.dataSourceValue.connect(this.boardApi);
        this.boardDataSourceResolver.dataSource = value;
        this.initializeExportButton();
    }
    /** Views to display, can be used instead of setting the viewDataStore */
    get views() {
        return this.boardService.views;
    }
    set views(v) {
        this.actionsVisibilityService.views = this.boardService.views = v;
    }
    /** Available View Templates */
    get viewTemplates() {
        return this.boardService.viewTemplates;
    }
    set viewTemplates(value) {
        this.actionsVisibilityService.viewTemplates = this.boardService.viewTemplates = value;
    }
    /** Data store that can provide the list of views */
    get viewDataStore() {
        return this.boardService.viewDataStore;
    }
    set viewDataStore(value) {
        this.actionsVisibilityService.viewDataStore = this.boardService.viewDataStore = value;
    }
    /** Configuration object to control child components options */
    get boardOptions() {
        return this.boardOptionsValue;
    }
    set boardOptions(boardOptions) {
        this.boardOptionsValue = Object.assign(boardOptions, 
        // Keep global option properties only if they are not explicitly set on the input
        ...Object.keys(this.globalBoardOptions || {})
            .filter((globalKey) => !boardOptions.hasOwnProperty(globalKey))
            .map((key) => ({ [key]: this.globalBoardOptions[key] })));
        this.boardService.boardOptions = this.boardOptionsValue;
    }
    /**
     * @deprecated  use the boardOptions input with "addNewViewButtonLabel: 'value'"
     * Text displayed next to the + icon for adding new views.
     * */
    get addBoardViewLabel() {
        return this.boardOptionsValue.addNewViewButtonLabel;
    }
    set addBoardViewLabel(value) {
        this.setDeprecatedPropertyOnOptions('addNewViewButtonLabel', coerceBooleanProperty(value));
    }
    /**
     * @deprecated  use the boardOptions input with "enableFilterReset: true"
     * Shows the Reset button in the filter bar
     * */
    get enableFilterReset() {
        return this.boardOptions.enableFilterReset;
    }
    set enableFilterReset(value) {
        this.setDeprecatedPropertyOnOptions('enableFilterReset', coerceBooleanProperty(value));
    }
    /**
     * @deprecated  use the boardOptions input with "enableFilterReset: true"
     * Adds the current view name to query params to it's persisted in the url
     * */
    get enableQueryParamStatePersistance() {
        return this.boardOptions.enableQueryParamStatePersistance;
    }
    set enableQueryParamStatePersistance(value) {
        this.setDeprecatedPropertyOnOptions('enableQueryParamStatePersistance', coerceBooleanProperty(value));
    }
    /**
     * @deprecated  use the boardOptions input with "hideViewSwitcher: true"
     * Hide board view tab switcher
     * */
    get hideViewSwitcher() {
        return this.boardOptions.suppressViewSwitcher;
    }
    set hideViewSwitcher(value) {
        this.setDeprecatedPropertyOnOptions('hideViewSwitcher', coerceBooleanProperty(value), 'suppressViewSwitcher');
    }
    /**
     * @deprecated  use the boardOptions input with "suppressGridSettingsPopover: true"
     * Hide board view settings menu
     * */
    get hideViewSettingsMenu() {
        return this.boardOptions.suppressGridSettingsPopover;
    }
    set hideViewSettingsMenu(value) {
        this.setDeprecatedPropertyOnOptions('hideViewSettingsMenu', coerceBooleanProperty(value), 'suppressGridSettingsPopover');
    }
    /**
     * @deprecated  use the boardOptions input with "preloadViewData: true"
     * Whether or not the board preloads all view data
     * */
    get preloadViewData() {
        return this.boardOptions.preloadViewData;
    }
    set preloadViewData(value) {
        this.setDeprecatedPropertyOnOptions('preloadViewData', coerceBooleanProperty(value));
    }
    /**
     * @deprecated  use the boardOptions input with "applyFilterStrategy"
     * Options on when to apply the filters values
     * */
    get applyFilterStrategy() {
        return this.boardOptions.applyFilterStrategy;
    }
    set applyFilterStrategy(value) {
        this.setDeprecatedPropertyOnOptions('applyFilterStrategy', value);
    }
    /**
     * @deprecated  use the boardOptions input with "hideRecordCounts: true"
     * If true will hide the total number of records displayed in the view tabs
     * */
    get showRecordCounts() {
        return !this.boardOptions.suppressRecordCounts;
    }
    set showRecordCounts(value) {
        const hideValue = !coerceBooleanProperty(value);
        this.setDeprecatedPropertyOnOptions('showRecordCounts', hideValue, 'suppressRecordCounts');
    }
    /**
     * @deprecated  use the boardOptions input with "persistFiltersBetweenViews: true"
     * If true will persist the filter values when switching between views
     * */
    get persistFiltersBetweenViews() {
        return this.boardOptions.persistFiltersBetweenViews;
    }
    set persistFiltersBetweenViews(value) {
        this.setDeprecatedPropertyOnOptions('persistFiltersBetweenViews', coerceBooleanProperty(value));
    }
    ngAfterViewInit() {
        this.boardReady.emit({ boardApi: this.boardApi, filterService: this.filterService });
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    isActionVisible(actionType) {
        return this.actionsVisibilityService.isVisible(actionType);
    }
    handleStateChange(state) {
        this.currentState = state;
        this.checkAndEmitSelectionChanges(state);
        this.checkFiltersButtonVisibility(state);
    }
    checkAndEmitSelectionChanges(state) {
        if (state && state.changes && state.changes.includes('selection')) {
            this.selectionChange.emit(state.selection);
        }
    }
    checkFiltersButtonVisibility(state) {
        if (state && state.changes && state.changes.includes('filtersButtonVisible')) {
            this.showFiltersButton = state.filtersButtonVisible;
        }
    }
    initializeExportButton() {
        // If the dataSource is an exportable data source, show export button
        this.showExportButton = isExportableDataSource(this.dataSource);
        // If the dataSource is an exportable data source, if the isExportDisabled function is
        // implemented in that class, call that function to get the disabled value, if not,
        // we will not disable the export button
        this.disableExportButton$ =
            isExportableDataSource(this.dataSource) && this.dataSource.isExportDisabled
                ? this.dataSource.isExportDisabled()
                : of(false);
    }
    setDeprecatedPropertyOnOptions(propertyName, value, newPropertyName) {
        const newPropName = newPropertyName || propertyName;
        console.warn(`[${propertyName}] is deprecated, use the boardOptions input with "${newPropName}: true"`);
        if (!this.boardOptions) {
            this.boardOptions = {};
        }
        this.boardOptions[newPropName] = value;
    }
}
XpoBoard.ɵfac = function XpoBoard_Factory(t) { return new (t || XpoBoard)(i0.ɵɵdirectiveInject(XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(XpoBoardService), i0.ɵɵdirectiveInject(XpoBoardActionsVisibilityService), i0.ɵɵdirectiveInject(XpoBoardApiDispatcherService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XpoFiltersService), i0.ɵɵdirectiveInject(XPO_BOARD_DEFAULT_OPTIONS, 8)); };
XpoBoard.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoBoard, selectors: [["xpo-board"]], contentQueries: function XpoBoard_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, XpoBoardActions, 5);
        i0.ɵɵcontentQuery(dirIndex, XpoBoardTotalRecords, 5);
        i0.ɵɵcontentQuery(dirIndex, XpoBoardGridToolbar, 5);
        i0.ɵɵcontentQuery(dirIndex, XpoDataDrawer, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.boardActions = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.boardTotalRecords = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.gridToolbar = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataDrawer = _t.first);
    } }, hostAttrs: [1, "xpo-Board"], hostVars: 1, hostBindings: function XpoBoard_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id);
    } }, inputs: { id: "id", dataSource: "dataSource", views: "views", viewTemplates: "viewTemplates", viewDataStore: "viewDataStore", boardOptions: "boardOptions", addBoardViewLabel: "addBoardViewLabel", enableFilterReset: "enableFilterReset", enableQueryParamStatePersistance: "enableQueryParamStatePersistance", hideViewSwitcher: "hideViewSwitcher", hideViewSettingsMenu: "hideViewSettingsMenu", preloadViewData: "preloadViewData", applyFilterStrategy: "applyFilterStrategy", showRecordCounts: "showRecordCounts", persistFiltersBetweenViews: "persistFiltersBetweenViews" }, outputs: { boardReady: "boardReady", selectionChange: "selectionChange" }, features: [i0.ɵɵProvidersFeature([
            XpoBoardDataSourceResolver,
            XpoBoardService,
            XpoBoardActionsVisibilityService,
            XpoBoardApiDispatcherService,
            XpoFiltersService,
        ])], ngContentSelectors: _c2$1, decls: 13, vars: 13, consts: [[3, "id", "ngClass", "addNewViewButtonLabel", "persistFiltersBetweenViews", "preloadViewData", "suppressRecordCounts", "viewDataStore", "enableQueryParamStatePersistance"], [4, "ngIf"], [1, "xpo-Board-dataDrawer-container"], [1, "xpo-Board-dataDrawer-content"], ["class", "xpo-Board-footer", 4, "ngIf"], ["mode", "side", "position", "end", 1, "xpo-Board-dataDrawer-drawer", 3, "opened"], [3, "id", "applyFilterStrategy", "enableFilterReset"], [1, "xpo-Board-actionsWrapper"], [3, "id", 4, "ngIf"], [3, "id", "viewDataStore", 4, "ngIf"], ["mat-icon-button", "", "matTooltip", "Download", "matTooltipPosition", "above", "xpoDownloadButton", "", 3, "id", "handleDownload", 4, "ngIf"], [3, "id", "suppressGridDensity", 4, "ngIf"], [3, "id"], [3, "id", "viewDataStore"], ["mat-icon-button", "", "matTooltip", "Download", "matTooltipPosition", "above", "xpoDownloadButton", "", 3, "id", "handleDownload"], [3, "id", "suppressGridDensity"], [1, "xpo-Board-footer"]], template: function XpoBoard_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$7);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
        i0.ɵɵelement(2, "xpo-board-views", 0);
        i0.ɵɵtemplate(3, XpoBoard_xpo_grid_bar_3_Template, 12, 10, "xpo-grid-bar", 1);
        i0.ɵɵprojection(4, 2);
        i0.ɵɵelementStart(5, "mat-drawer-container", 2);
        i0.ɵɵelementStart(6, "mat-drawer-content", 3);
        i0.ɵɵprojection(7, 3);
        i0.ɵɵelementStart(8, "xpo-board-data-fetch-display");
        i0.ɵɵprojection(9, 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, XpoBoard_div_10_Template, 2, 0, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "mat-drawer", 5);
        i0.ɵɵprojection(12, 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-boardViews");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1$2, ctx.boardOptions.suppressViewSwitcher))("addNewViewButtonLabel", ctx.boardOptions.addNewViewButtonLabel)("persistFiltersBetweenViews", ctx.boardOptions.persistFiltersBetweenViews)("preloadViewData", ctx.boardOptions.preloadViewData)("suppressRecordCounts", ctx.boardOptions.suppressRecordCounts)("viewDataStore", ctx.viewDataStore)("enableQueryParamStatePersistance", ctx.boardOptions.enableQueryParamStatePersistance);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.gridToolbar);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.boardTotalRecords);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("opened", ctx.dataDrawerOpen);
    } }, directives: [XpoBoardViews, i2.NgClass, i2.NgIf, i8.MatDrawerContainer, i8.MatDrawerContent, XpoBoardDataFetchDisplay, i8.MatDrawer, XpoGridBar, XpoFilterBar, XpoColumnLevelFilteringToggleComponent, XpoSaveViewComponent, i3$1.MatButton, i15.XpoDownloadButtonDirective, i3$3.MatTooltip, XpoAvailableViews, XpoGridSettingsComponent], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-Board{background:#ffffff;display:flex;flex-basis:100%;flex-direction:column;width:100%}.xpo-Board-boardViews--hidden{display:none!important}.xpo-Board-actionsWrapper{align-items:center;display:flex;height:100%;margin-left:auto;outline:1px solid #d8d8d8}.xpo-Board-actionsWrapper>*{align-items:center;display:flex;height:100%}.xpo-Board-actionsWrapper>*:not(:last-child){border-right:1px solid #d8d8d8}.xpo-Board-dataDrawer-content{display:flex;flex-direction:column}.xpo-Board-dataDrawer-container{height:100%}.xpo-Board-dataDrawer-drawer{background-color:#f3f3f3;box-shadow:0 2px 4px #4a4a4a;width:75%}.xpo-Board-footer{align-items:center;background-color:#fff;display:flex;height:40px}.xpo-Board .ag-theme-material .ag-header-cell-menu-button{opacity:1!important}.xpo-Board .ag-theme-material .ag-header-cell-filtered .ag-header-icon{color:#0868ac}.xpo-BoardUtils-centerContainer{left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%)}.xpo-BoardUtils-centerContainer .mat-spinner{z-index:100}.xpo-BoardUtils-boardContainer{display:flex;flex-direction:row;height:100%}.xpo-GMapBoard{height:100%}.xpo-MatTableBoard{width:100%}.xpo-MatTableBoard .xpo-BoardUtils-centerContainer{position:fixed}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoard, [{
        type: Component,
        args: [{
                selector: 'xpo-board',
                templateUrl: './board.component.html',
                styleUrls: ['./board.component.scss'],
                providers: [
                    XpoBoardDataSourceResolver,
                    XpoBoardService,
                    XpoBoardActionsVisibilityService,
                    XpoBoardApiDispatcherService,
                    XpoFiltersService,
                ],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-Board', '[attr.id]': 'id' },
            }]
    }], function () { return [{ type: XpoBoardDataSourceResolver }, { type: XpoBoardService }, { type: XpoBoardActionsVisibilityService }, { type: XpoBoardApiDispatcherService }, { type: i0.ChangeDetectorRef }, { type: XpoFiltersService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [XPO_BOARD_DEFAULT_OPTIONS]
            }] }]; }, { boardActions: [{
            type: ContentChild,
            args: [XpoBoardActions]
        }], boardTotalRecords: [{
            type: ContentChild,
            args: [XpoBoardTotalRecords]
        }], gridToolbar: [{
            type: ContentChild,
            args: [XpoBoardGridToolbar, { static: false }]
        }], dataDrawer: [{
            type: ContentChild,
            args: [XpoDataDrawer]
        }], id: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], views: [{
            type: Input
        }], viewTemplates: [{
            type: Input
        }], viewDataStore: [{
            type: Input
        }], boardOptions: [{
            type: Input
        }], addBoardViewLabel: [{
            type: Input
        }], enableFilterReset: [{
            type: Input
        }], enableQueryParamStatePersistance: [{
            type: Input
        }], hideViewSwitcher: [{
            type: Input
        }], hideViewSettingsMenu: [{
            type: Input
        }], preloadViewData: [{
            type: Input
        }], applyFilterStrategy: [{
            type: Input
        }], showRecordCounts: [{
            type: Input
        }], persistFiltersBetweenViews: [{
            type: Input
        }], boardReady: [{
            type: Output
        }], selectionChange: [{
            type: Output
        }] }); })();

class XpoAccordionGroupCellRendererComponent {
    constructor() {
        this.isRowExpanded = false;
    }
    agInit(params) {
        this.groupName = params.value;
        this.rowCount = params.node && params.node.allChildrenCount ? params.node.allChildrenCount : 0;
        this.node = params.node;
    }
    refresh() {
        return false;
    }
}
XpoAccordionGroupCellRendererComponent.ɵfac = function XpoAccordionGroupCellRendererComponent_Factory(t) { return new (t || XpoAccordionGroupCellRendererComponent)(); };
XpoAccordionGroupCellRendererComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAccordionGroupCellRendererComponent, selectors: [["xpo-accordion-group-cell-renderer"]], decls: 5, vars: 2, consts: [[1, "xpoAccordionGroup"], [1, "xpoAccordionGroup-value"], [1, "xpoAccordionGroup-count"]], template: function XpoAccordionGroupCellRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.groupName);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.rowCount);
    } }, styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpoAccordionGroup[_ngcontent-%COMP%]{align-items:center;display:flex;height:100%}.xpoAccordionGroup-toggle[_ngcontent-%COMP%]{background:none;border:none}.xpoAccordionGroup-count[_ngcontent-%COMP%]{background:#333333;border-radius:14px;color:#fff;display:inline-block;font-size:10px;font-weight:500;height:auto;line-height:normal;margin:0 8px;padding:4px 6px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAccordionGroupCellRendererComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-accordion-group-cell-renderer',
                templateUrl: './accordion-group-cell-renderer.component.html',
                styleUrls: ['./accordion-group-cell-renderer.component.scss'],
            }]
    }], null, null); })();

class XpoCellRenderersModule {
}
XpoCellRenderersModule.ɵfac = function XpoCellRenderersModule_Factory(t) { return new (t || XpoCellRenderersModule)(); };
XpoCellRenderersModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoCellRenderersModule });
XpoCellRenderersModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCellRenderersModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [XpoAccordionGroupCellRendererComponent],
                exports: [XpoAccordionGroupCellRendererComponent],
                entryComponents: [XpoAccordionGroupCellRendererComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoCellRenderersModule, { declarations: [XpoAccordionGroupCellRendererComponent], imports: [CommonModule], exports: [XpoAccordionGroupCellRendererComponent] }); })();

class XpoGridBarModule {
}
XpoGridBarModule.ɵfac = function XpoGridBarModule_Factory(t) { return new (t || XpoGridBarModule)(); };
XpoGridBarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoGridBarModule });
XpoGridBarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoGridBarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [XpoGridBar],
                exports: [XpoGridBar],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoGridBarModule, { declarations: [XpoGridBar], imports: [CommonModule], exports: [XpoGridBar] }); })();

class XpoBoardModule {
}
XpoBoardModule.ɵfac = function XpoBoardModule_Factory(t) { return new (t || XpoBoardModule)(); };
XpoBoardModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoBoardModule });
XpoBoardModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MatBadgeModule,
            MatButtonModule,
            MatButtonToggleModule,
            MatCheckboxModule,
            MatCheckboxModule,
            MatFormFieldModule,
            MatInputModule,
            MatListModule,
            MatMenuModule,
            MatMenuModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSidenavModule,
            MatTooltipModule,
            XpoBoardViewsModule,
            XpoButtonModule,
            XpoChipsModule,
            XpoConfirmDialogModule,
            XpoDialogModule,
            XpoDownloadButtonModule,
            XpoFiltersModule,
            XpoGridBarModule,
            XpoIconModule,
            XpoPopoverModule,
            XpoUtilsModule,
            XpoGridToolbarModule,
            MatSelectModule,
            XpoSelectModule,
        ], XpoBoardViewsModule,
        XpoGridBarModule,
        XpoCellRenderersModule,
        XpoGridToolbarModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBoardModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatBadgeModule,
                    MatButtonModule,
                    MatButtonToggleModule,
                    MatCheckboxModule,
                    MatCheckboxModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatListModule,
                    MatMenuModule,
                    MatMenuModule,
                    MatProgressSpinnerModule,
                    MatRadioModule,
                    MatSidenavModule,
                    MatTooltipModule,
                    XpoBoardViewsModule,
                    XpoButtonModule,
                    XpoChipsModule,
                    XpoConfirmDialogModule,
                    XpoDialogModule,
                    XpoDownloadButtonModule,
                    XpoFiltersModule,
                    XpoGridBarModule,
                    XpoIconModule,
                    XpoPopoverModule,
                    XpoUtilsModule,
                    XpoGridToolbarModule,
                    MatSelectModule,
                    XpoSelectModule,
                ],
                declarations: [
                    XpoAvailableViews,
                    XpoAvailableViewsFilter,
                    XpoThousandsSeparator,
                    XpoBoard,
                    XpoBoardActions,
                    XpoBoardDataFetchDisplay,
                    XpoBoardHeader,
                    XpoBoardHeaderTitle,
                    XpoBoardNoResultsDisplay,
                    XpoBoardTotalRecords,
                    XpoColumnLevelFilteringToggleComponent,
                    XpoDeleteViewConfirmDialog,
                    XpoGridColumnSelectionComponent,
                    XpoGridRowHeightSelectionComponent,
                    XpoGridSettingsComponent,
                    XpoSaveViewComponent,
                    XpoSaveViewDialog,
                    XpoAppliedFilters,
                    XpoBoardPagination,
                ],
                exports: [
                    XpoAvailableViewsFilter,
                    XpoThousandsSeparator,
                    XpoBoard,
                    XpoBoardViewsModule,
                    XpoGridBarModule,
                    XpoBoardHeader,
                    XpoBoardTotalRecords,
                    XpoBoardHeaderTitle,
                    XpoBoardActions,
                    XpoBoardNoResultsDisplay,
                    XpoBoardDataFetchDisplay,
                    XpoAppliedFilters,
                    XpoBoardPagination,
                    XpoCellRenderersModule,
                    XpoGridToolbarModule,
                ],
                entryComponents: [XpoSaveViewDialog, XpoBoardDataFetchDisplay, XpoDeleteViewConfirmDialog],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoBoardModule, { declarations: [XpoAvailableViews,
        XpoAvailableViewsFilter,
        XpoThousandsSeparator,
        XpoBoard,
        XpoBoardActions,
        XpoBoardDataFetchDisplay,
        XpoBoardHeader,
        XpoBoardHeaderTitle,
        XpoBoardNoResultsDisplay,
        XpoBoardTotalRecords,
        XpoColumnLevelFilteringToggleComponent,
        XpoDeleteViewConfirmDialog,
        XpoGridColumnSelectionComponent,
        XpoGridRowHeightSelectionComponent,
        XpoGridSettingsComponent,
        XpoSaveViewComponent,
        XpoSaveViewDialog,
        XpoAppliedFilters,
        XpoBoardPagination], imports: [CommonModule,
        FormsModule,
        MatBadgeModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSidenavModule,
        MatTooltipModule,
        XpoBoardViewsModule,
        XpoButtonModule,
        XpoChipsModule,
        XpoConfirmDialogModule,
        XpoDialogModule,
        XpoDownloadButtonModule,
        XpoFiltersModule,
        XpoGridBarModule,
        XpoIconModule,
        XpoPopoverModule,
        XpoUtilsModule,
        XpoGridToolbarModule,
        MatSelectModule,
        XpoSelectModule], exports: [XpoAvailableViewsFilter,
        XpoThousandsSeparator,
        XpoBoard,
        XpoBoardViewsModule,
        XpoGridBarModule,
        XpoBoardHeader,
        XpoBoardTotalRecords,
        XpoBoardHeaderTitle,
        XpoBoardActions,
        XpoBoardNoResultsDisplay,
        XpoBoardDataFetchDisplay,
        XpoAppliedFilters,
        XpoBoardPagination,
        XpoCellRenderersModule,
        XpoGridToolbarModule] }); })();
i0.ɵɵsetComponentScope(XpoAvailableViews, [i3$1.MatButton, i3$3.MatTooltip, i4$1.XpoPopoverTrigger, i3.MatIcon, i4$1.XpoPopover, i4.MatFormField, i4.MatLabel, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i8$1.MatList, i2.NgForOf, i2.NgIf, i10.MatDivider, i8$1.MatListSubheaderCssMatStyler, i8$1.MatListItem, i1.MatCheckbox], [XpoAvailableViewsFilter]);

class XpoDashbarMetricPopover {
    constructor() { }
}
XpoDashbarMetricPopover.ɵfac = function XpoDashbarMetricPopover_Factory(t) { return new (t || XpoDashbarMetricPopover)(); };
XpoDashbarMetricPopover.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDashbarMetricPopover, selectors: [["xpo-dashbar-metric-popover"], ["", "xpoDashbarMetricPopover", ""]], contentQueries: function XpoDashbarMetricPopover_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDashbarMetricPopover, [{
        type: Directive,
        args: [{
                selector: 'xpo-dashbar-metric-popover, [xpoDashbarMetricPopover]',
            }]
    }], function () { return []; }, { template: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class DashbarService {
    constructor() {
        this.openedPopoverSubject$ = new ReplaySubject(1);
    }
    get openedPopover$() {
        return this.openedPopoverSubject$.asObservable();
    }
    get openedPopover() {
        return this.openedPopoverValue;
    }
    set openedPopover(value) {
        this.openedPopoverSubject$.next((this.openedPopoverValue = value));
    }
    togglePopover(popover) {
        if (this.openedPopover !== popover) {
            this.openedPopover = popover;
        }
        else {
            this.openedPopover = null;
        }
    }
}
DashbarService.ɵfac = function DashbarService_Factory(t) { return new (t || DashbarService)(); };
DashbarService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DashbarService, factory: DashbarService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DashbarService, [{
        type: Injectable
    }], function () { return []; }, null); })();

function XpoDashbarMetric_div_9_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "arrow_drop_down");
    i0.ɵɵelementEnd();
} }
function XpoDashbarMetric_div_9_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "arrow_drop_up");
    i0.ɵɵelementEnd();
} }
function XpoDashbarMetric_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementContainerStart(1, 6);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, XpoDashbarMetric_div_9_mat_icon_3_Template, 2, 0, "mat-icon", 7);
    i0.ɵɵtemplate(4, XpoDashbarMetric_div_9_mat_icon_4_Template, 2, 0, "mat-icon", 8);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", i0.ɵɵpipeBind1(2, 2, ctx_r0.popoverOpened$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", true);
} }
const _c0$6 = function (a1, a2) { return { "xpo-DashbarMetric": true, "xpo-DashbarMetric-opened": a1, "xpo-DashbarMetric-withPopover": a2 }; };
class XpoDashbarMetric {
    constructor(dashbarService) {
        this.dashbarService = dashbarService;
        this.componentDestroyed$ = new Subject();
        this.hasPopoverSubject = new ReplaySubject(1);
    }
    get hasPopoverContent$() {
        return this.hasPopoverSubject.asObservable().pipe(share());
    }
    ngOnInit() {
        this.popoverOpened$ = this.dashbarService.openedPopover$.pipe(map((servicePopover) => this.popover === servicePopover), share(), takeUntil(this.componentDestroyed$));
    }
    ngAfterContentInit() {
        this.hasPopoverSubject.next(this.popover != null && this.popover.template != null);
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    togglePopover() {
        if (!this.popover) {
            return;
        }
        this.dashbarService.togglePopover(this.popover);
    }
}
XpoDashbarMetric.ɵfac = function XpoDashbarMetric_Factory(t) { return new (t || XpoDashbarMetric)(i0.ɵɵdirectiveInject(DashbarService)); };
XpoDashbarMetric.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDashbarMetric, selectors: [["xpo-dashbar-metric"]], contentQueries: function XpoDashbarMetric_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, XpoDashbarMetricPopover, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, inputs: { description: "description", value: "value" }, decls: 11, vars: 13, consts: [[3, "ngClass", "click"], [1, "xpo-DashbarMetric-item"], [1, "xpo-DashbarMetric-item-value"], [1, "xpo-DashbarMetric-item-label"], ["class", "xpo-DashbarMetric-icon", 4, "ngIf"], [1, "xpo-DashbarMetric-icon"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"]], template: function XpoDashbarMetric_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function XpoDashbarMetric_Template_div_click_0_listener() { return ctx.togglePopover(); });
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "span", 2);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "br");
        i0.ɵɵelementStart(7, "span", 3);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, XpoDashbarMetric_div_9_Template, 5, 4, "div", 4);
        i0.ɵɵpipe(10, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c0$6, i0.ɵɵpipeBind1(1, 4, ctx.popoverOpened$), i0.ɵɵpipeBind1(2, 6, ctx.hasPopoverContent$)));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.value, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.description, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 8, ctx.hasPopoverContent$));
    } }, directives: [i2.NgClass, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i2.NgSwitchDefault, i3.MatIcon], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-DashbarMetric{border-right:1px solid #d8d8d8;border-top:2px solid #d8d8d8;display:flex;flex-direction:row;-webkit-user-select:none;user-select:none}.xpo-DashbarMetric-opened{background-color:#fff;border-top:2px solid #0d94f4}.xpo-DashbarMetric-withPopover{cursor:pointer;padding-left:16px}.xpo-DashbarMetric-item{padding:8px 32px;text-align:center}.xpo-DashbarMetric-item-value{font-size:1.5rem;font-weight:500}.xpo-DashbarMetric-item-label{font-size:.875rem}.xpo-DashbarMetric-icon .mat-icon{color:#0868ac;display:flex;flex-direction:column;height:100%;justify-content:center}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDashbarMetric, [{
        type: Component,
        args: [{
                selector: 'xpo-dashbar-metric',
                templateUrl: 'dashbar-metric.component.html',
                styleUrls: ['dashbar-metric.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: DashbarService }]; }, { description: [{
            type: Input
        }], value: [{
            type: Input
        }], popover: [{
            type: ContentChild,
            args: [XpoDashbarMetricPopover]
        }] }); })();

function XpoDashbar_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementContainer(2, 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const metricPopover_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", metricPopover_r1.template);
} }
const _c0$5 = [[["xpo-dashbar-metric"]]];
const _c1$1 = ["xpo-dashbar-metric"];
class XpoDashbar {
    constructor(dashbarService) {
        this.dashbarService = dashbarService;
    }
    get metricPopover$() {
        return this.dashbarService.openedPopover$;
    }
}
XpoDashbar.ɵfac = function XpoDashbar_Factory(t) { return new (t || XpoDashbar)(i0.ɵɵdirectiveInject(DashbarService)); };
XpoDashbar.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDashbar, selectors: [["xpo-dashbar"]], hostAttrs: [1, "xpo-Dashbar"], features: [i0.ɵɵProvidersFeature([DashbarService])], ngContentSelectors: _c1$1, decls: 5, vars: 3, consts: [[1, "xpo-Dashbar-metrics"], [1, "xpo-Dashbar-metrics-fill"], ["class", "xpo-Dashbar-metricPopover", 4, "ngIf"], [1, "xpo-Dashbar-metricPopover"], [1, "xpo-Dashbar-metricPopover-content"], [3, "ngTemplateOutlet"]], template: function XpoDashbar_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$5);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelement(2, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, XpoDashbar_div_3_Template, 3, 1, "div", 2);
        i0.ɵɵpipe(4, "async");
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 1, ctx.metricPopover$));
    } }, directives: [i2.NgIf, i2.NgTemplateOutlet], pipes: [i2.AsyncPipe], styles: [".flex--stretch{flex:1}.xpo-Dashbar{display:flex;flex-direction:column-reverse;overflow:visible;position:relative;z-index:1}.xpo-Dashbar-metrics{background-color:#fbfbfb;border-top:1px solid #d8d8d8;display:flex;flex-shrink:0;height:64px;justify-content:flex-start}.xpo-Dashbar-metrics-fill{border-left:1px solid #d8d8d8;border-top:2px solid #d8d8d8;display:flex;flex:1}.xpo-Dashbar-metricPopover{align-items:center;background-color:#fff;bottom:64px;display:flex;min-height:128px;padding:16px;position:absolute;width:100%}.xpo-Dashbar-metricPopover-content{display:flex;flex:1}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDashbar, [{
        type: Component,
        args: [{
                selector: 'xpo-dashbar',
                templateUrl: 'dashbar.component.html',
                styleUrls: ['dashbar.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-Dashbar' },
                providers: [DashbarService],
            }]
    }], function () { return [{ type: DashbarService }]; }, null); })();

class XpoDashbarModule {
}
XpoDashbarModule.ɵfac = function XpoDashbarModule_Factory(t) { return new (t || XpoDashbarModule)(); };
XpoDashbarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoDashbarModule });
XpoDashbarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, XpoPopoverModule, MatIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDashbarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, XpoPopoverModule, MatIconModule],
                declarations: [XpoDashbar, XpoDashbarMetric, XpoDashbarMetricPopover],
                exports: [XpoDashbar, XpoDashbarMetric, XpoDashbarMetricPopover],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoDashbarModule, { declarations: [XpoDashbar, XpoDashbarMetric, XpoDashbarMetricPopover], imports: [CommonModule, XpoPopoverModule, MatIconModule], exports: [XpoDashbar, XpoDashbarMetric, XpoDashbarMetricPopover] }); })();

class XpoViewMgtFullWidthDirective {
}
XpoViewMgtFullWidthDirective.ɵfac = function XpoViewMgtFullWidthDirective_Factory(t) { return new (t || XpoViewMgtFullWidthDirective)(); };
XpoViewMgtFullWidthDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoViewMgtFullWidthDirective, selectors: [["", "xpo-view-mgt-full-width", ""]], hostAttrs: [1, "xpo-ViewMgt-FullWidth"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewMgtFullWidthDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-view-mgt-full-width]',
                host: { class: 'xpo-ViewMgt-FullWidth' },
            }]
    }], null, null); })();

/*
Tests for new view management logic will be handled in 	NGXLTL-967
*/
function XpoViewListComponent_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 9);
    i0.ɵɵtext(1, " Available view ");
    i0.ɵɵelementEnd();
} }
function XpoViewListComponent_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r10 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(listItem_r10.name);
} }
function XpoViewListComponent_th_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 9);
    i0.ɵɵtext(1, " Group ");
    i0.ɵɵelementEnd();
} }
function XpoViewListComponent_td_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", listItem_r11.group, " ");
} }
function XpoViewListComponent_th_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 9);
    i0.ɵɵtext(1, " Owner ");
    i0.ɵɵelementEnd();
} }
function XpoViewListComponent_td_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r12 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", listItem_r12.owner, " ");
} }
function XpoViewListComponent_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 9);
    i0.ɵɵtext(1, " Last Used On ");
    i0.ɵɵelementEnd();
} }
function XpoViewListComponent_td_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, listItem_r13.lastUpdated, "short"), " ");
} }
function XpoViewListComponent_tr_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 13);
} }
function XpoViewListComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 14);
    i0.ɵɵlistener("click", function XpoViewListComponent_tr_14_Template_tr_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const row_r14 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.onRowClick(row_r14); });
    i0.ɵɵelementEnd();
} }
class XpoViewListComponent {
    constructor() {
        // TODO: [NGXLTL-1018] Group and Owner handled in second iteration
        this.displayedColumns = ['name', /*'group', 'owner',*/ 'lastUpdated'];
        this.itemClick = new EventEmitter();
    }
    onRowClick(viewItem) {
        this.itemClick.emit(viewItem);
    }
}
XpoViewListComponent.ɵfac = function XpoViewListComponent_Factory(t) { return new (t || XpoViewListComponent)(); };
XpoViewListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoViewListComponent, selectors: [["xpo-view-list"]], inputs: { displayedColumns: "displayedColumns", viewList: "viewList" }, outputs: { itemClick: "itemClick" }, decls: 15, vars: 3, consts: [["mat-table", "", 1, "xpo-ViewManagement-list", 3, "dataSource"], ["matColumnDef", "name"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["matColumnDef", "group"], ["matColumnDef", "owner"], ["matColumnDef", "lastUpdated"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "xpo-ViewManagement-row", 3, "click", 4, "matRowDef", "matRowDefColumns"], ["mat-header-cell", ""], ["mat-cell", ""], [1, "xpo-ViewManagement-cellWrapper"], [1, "xpo-ViewManagement-cellText"], ["mat-header-row", ""], ["mat-row", "", 1, "xpo-ViewManagement-row", 3, "click"]], template: function XpoViewListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "table", 0);
        i0.ɵɵelementContainerStart(1, 1);
        i0.ɵɵtemplate(2, XpoViewListComponent_th_2_Template, 2, 0, "th", 2);
        i0.ɵɵtemplate(3, XpoViewListComponent_td_3_Template, 4, 1, "td", 3);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementContainerStart(4, 4);
        i0.ɵɵtemplate(5, XpoViewListComponent_th_5_Template, 2, 0, "th", 2);
        i0.ɵɵtemplate(6, XpoViewListComponent_td_6_Template, 2, 1, "td", 3);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementContainerStart(7, 5);
        i0.ɵɵtemplate(8, XpoViewListComponent_th_8_Template, 2, 0, "th", 2);
        i0.ɵɵtemplate(9, XpoViewListComponent_td_9_Template, 2, 1, "td", 3);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementContainerStart(10, 6);
        i0.ɵɵtemplate(11, XpoViewListComponent_th_11_Template, 2, 0, "th", 2);
        i0.ɵɵtemplate(12, XpoViewListComponent_td_12_Template, 3, 4, "td", 3);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(13, XpoViewListComponent_tr_13_Template, 1, 0, "tr", 7);
        i0.ɵɵtemplate(14, XpoViewListComponent_tr_14_Template, 1, 0, "tr", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("dataSource", ctx.viewList);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
    } }, directives: [i1$7.MatTable, i1$7.MatColumnDef, i1$7.MatHeaderCellDef, i1$7.MatCellDef, i1$7.MatHeaderRowDef, i1$7.MatRowDef, i1$7.MatHeaderCell, i1$7.MatCell, i1$7.MatHeaderRow, i1$7.MatRow], pipes: [i2.DatePipe], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-ViewManagement-cellWrapper[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:flex-start}.xpo-ViewManagement-cellButton[_ngcontent-%COMP%]{color:#000;display:flex;height:30px;width:30px}.xpo-ViewManagement-cellButton[_ngcontent-%COMP%]:hover, .xpo-ViewManagement-cellButton[_ngcontent-%COMP%]:focus, .xpo-ViewManagement-cellButton[_ngcontent-%COMP%]:active{color:#000}.xpo-ViewManagement-cellButtonIcon[_ngcontent-%COMP%]{line-height:normal}.xpo-ViewManagement-cellText[_ngcontent-%COMP%]{display:flex}.xpo-ViewManagement-row[_ngcontent-%COMP%]:hover{background-color:#f3f3f3;cursor:pointer}.xpo-ViewManagement-list[_ngcontent-%COMP%]{border-top:none;width:100%}.xpo-ViewManagement-list[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewListComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-view-list',
                templateUrl: 'view-list.component.html',
                styleUrls: ['view-list.component.scss'],
            }]
    }], null, { displayedColumns: [{
            type: Input,
            args: ['displayedColumns']
        }], viewList: [{
            type: Input,
            args: ['viewList']
        }], itemClick: [{
            type: Output,
            args: ['itemClick']
        }] }); })();

var XpoViewMgtMessages;
(function (XpoViewMgtMessages) {
    // Save view
    XpoViewMgtMessages["SaveViewSuccess"] = "View is\u00A0saved successfully.";
    XpoViewMgtMessages["SaveViewAsSuccess"] = "View is saved successfully.";
    // Rename view
    XpoViewMgtMessages["RenameViewSuccess"] = "Selected view is renamed successfully.";
    // Delete view
    XpoViewMgtMessages["DeleteViewSuccess"] = "View is deleted successfully";
})(XpoViewMgtMessages || (XpoViewMgtMessages = {}));

function XpoViewMgtModal_mat_progress_spinner_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-progress-spinner", 7);
} }
const _c0$4 = ["*"];
/**
 * This is the bas modal component used to handle all modals inside View Management
 */
class XpoViewMgtModal {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.isSubmitting = false;
        this.onSubmit = new EventEmitter();
        this.onCancel = new EventEmitter();
    }
    /**
     * Submit action
     */
    submit() {
        this.isSubmitting = true;
        this.onSubmit.emit();
    }
    /**
     * Cancel action
     */
    cancel() {
        this.onCancel.emit();
        this.close();
    }
    /**
     * Close modal
     */
    close() {
        this.dialogRef.close();
    }
}
XpoViewMgtModal.ɵfac = function XpoViewMgtModal_Factory(t) { return new (t || XpoViewMgtModal)(i0.ɵɵdirectiveInject(i1$5.MatDialogRef)); };
XpoViewMgtModal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoViewMgtModal, selectors: [["xpo-view-modal"]], inputs: { modalData: "modalData" }, outputs: { onSubmit: "onSubmit", onCancel: "onCancel" }, ngContentSelectors: _c0$4, decls: 13, vars: 6, consts: [["mat-dialog-title", "", 1, "xpo-ViewMgt-dialogTitle"], [1, "xpo-ViewMgt-dialogTitle-wrapper"], ["class", "xpo-ViewMgt-dialogSpinner", "mode", "indeterminate", "color", "primary", "diameter", "16", 4, "ngIf"], ["mat-dialog-content", "", 1, "xpo-ViewMgt-dialogContent"], ["mat-dialog-actions", "", 1, "xpo-ViewMgt-dialogActions"], ["mat-flat-button", "", 1, "xpo-ViewMgt-dialogActions-button", 3, "disabled", "click"], ["mat-stroked-button", "", 1, "xpo-ViewMgt-dialogActions-button", 3, "disabled", "click"], ["mode", "indeterminate", "color", "primary", "diameter", "16", 1, "xpo-ViewMgt-dialogSpinner"]], template: function XpoViewMgtModal_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "h1", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵtemplate(3, XpoViewMgtModal_mat_progress_spinner_3_Template, 1, 0, "mat-progress-spinner", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "xpo-dialog-close-button");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "xpo-button-group");
        i0.ɵɵelementStart(9, "button", 5);
        i0.ɵɵlistener("click", function XpoViewMgtModal_Template_button_click_9_listener() { return ctx.submit(); });
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "button", 6);
        i0.ɵɵlistener("click", function XpoViewMgtModal_Template_button_click_11_listener() { return ctx.cancel(); });
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.modalData == null ? null : ctx.modalData.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSubmitting);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.isSubmitting);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", (ctx.modalData == null ? null : ctx.modalData.submitButtonText) || "Submit", "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.isSubmitting);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate((ctx.modalData == null ? null : ctx.modalData.cancelButtonText) || "Cancel");
    } }, directives: [i1$5.MatDialogTitle, i2.NgIf, i2$3.XpoDialogCloseButtonComponent, i1$5.MatDialogContent, i1$5.MatDialogActions, i2$1.XpoButtonGroup, i3$1.MatButton, i7$2.MatProgressSpinner], styles: [".flex--stretch{flex:1}.xpo-ViewMgt-dialogContent{padding-bottom:16px!important;padding-top:16px!important}.xpo-ViewMgt-dialogActions-button{text-transform:uppercase}.xpo-ViewMgt-dialogTitle-wrapper{align-items:center;display:flex;justify-content:center}.xpo-ViewMgt-dialogSpinner{margin-left:8px}.xpo-ViewMgt-formField{width:100%}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewMgtModal, [{
        type: Component,
        args: [{
                selector: 'xpo-view-modal',
                templateUrl: './view-modal.component.html',
                styleUrls: ['./view-modal.component.scss'],
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i1$5.MatDialogRef }]; }, { modalData: [{
            type: Input
        }], onSubmit: [{
            type: Output
        }], onCancel: [{
            type: Output
        }] }); })();

var XpoViewMgtModalTexts;
(function (XpoViewMgtModalTexts) {
    // Save view as
    XpoViewMgtModalTexts["DefaultViewName"] = "Untitled";
    XpoViewMgtModalTexts["SaveViewAsTitle"] = "Save as";
    XpoViewMgtModalTexts["SaveViewAsSubmitBtn"] = "Save view";
    XpoViewMgtModalTexts["SaveViewAsCancelBtn"] = "Cancel";
    // Rename view
    XpoViewMgtModalTexts["RenameViewTitle"] = "Rename Selected View";
    XpoViewMgtModalTexts["RenameViewSubmitBtn"] = "Save";
    XpoViewMgtModalTexts["RenameViewCancelBtn"] = "Cancel";
    // Delete view
    XpoViewMgtModalTexts["DeleteViewTitle"] = "Delete view";
    XpoViewMgtModalTexts["DeleteViewSubmitBtn"] = "Delete";
    XpoViewMgtModalTexts["DeleteViewCancelBtn"] = "Cancel";
})(XpoViewMgtModalTexts || (XpoViewMgtModalTexts = {}));

const _c0$3 = ["xpoViewModal"];
class XpoViewMgtModalSaveViewAs {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.saveAsForm = new FormGroup({
            viewName: new FormControl(XpoViewMgtModalTexts.DefaultViewName, [Validators.required]),
        });
        this.saveViewAsData = {
            title: XpoViewMgtModalTexts.SaveViewAsTitle,
            submitButtonText: XpoViewMgtModalTexts.SaveViewAsSubmitBtn,
            cancelButtonText: XpoViewMgtModalTexts.SaveViewAsCancelBtn,
        };
        this.modalActions = data.actions;
    }
    /**
     * Save button action in modal
     */
    saveViewAs() {
        var _a;
        if (!this.saveAsForm.valid) {
            this.saveAsForm.markAllAsTouched();
            return;
        }
        this.xpoViewModal.isSubmitting = true;
        // Callback for save view
        (_a = this.modalActions) === null || _a === void 0 ? void 0 : _a.onSubmit({
            viewName: this.saveAsForm.get('viewName').value,
        });
    }
    /**
     * Cancel button action in modal
     */
    cancel() {
        var _a;
        // Callback for cancel
        (_a = this.modalActions) === null || _a === void 0 ? void 0 : _a.onCancel();
    }
}
XpoViewMgtModalSaveViewAs.ɵfac = function XpoViewMgtModalSaveViewAs_Factory(t) { return new (t || XpoViewMgtModalSaveViewAs)(i0.ɵɵdirectiveInject(i1$5.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
XpoViewMgtModalSaveViewAs.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoViewMgtModalSaveViewAs, selectors: [["xpo-save-view-as-modal"]], viewQuery: function XpoViewMgtModalSaveViewAs_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.xpoViewModal = _t.first);
    } }, decls: 8, vars: 2, consts: [[3, "modalData", "onSubmit", "onCancel"], ["xpoViewModal", ""], [1, "xpo-ViewMgt-modalContent", 3, "formGroup", "ngSubmit"], [1, "xpo-ViewMgt-formFieldWrapper"], ["floatLabel", "always", 1, "xpo-ViewMgt-formField"], ["matInput", "", "placeholder", "View Name", "required", "", "formControlName", "viewName"]], template: function XpoViewMgtModalSaveViewAs_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-view-modal", 0, 1);
        i0.ɵɵlistener("onSubmit", function XpoViewMgtModalSaveViewAs_Template_xpo_view_modal_onSubmit_0_listener() { return ctx.saveViewAs(); })("onCancel", function XpoViewMgtModalSaveViewAs_Template_xpo_view_modal_onCancel_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵlistener("ngSubmit", function XpoViewMgtModalSaveViewAs_Template_form_ngSubmit_2_listener() { return ctx.saveViewAs(); });
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "mat-form-field", 4);
        i0.ɵɵelementStart(5, "mat-label");
        i0.ɵɵtext(6, "View Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "input", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalData", ctx.saveViewAsData);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.saveAsForm);
    } }, directives: [XpoViewMgtModal, i1$1.ɵNgNoValidate, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i4.MatFormField, i4.MatLabel, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.RequiredValidator, i1$1.NgControlStatus, i1$1.FormControlName], styles: [".xpo-ViewMgt-modalContent[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-ViewMgt-formFieldWrapper[_ngcontent-%COMP%]{display:flex}.xpo-ViewMgt-sharing[_ngcontent-%COMP%]{flex-direction:column}.xpo-ViewMgt-defaultOwner[_ngcontent-%COMP%]{flex-direction:column}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewMgtModalSaveViewAs, [{
        type: Component,
        args: [{
                selector: 'xpo-save-view-as-modal',
                templateUrl: './save-view-as.component.html',
                styleUrls: ['./save-view-as.component.scss'],
            }]
    }], function () { return [{ type: i1$5.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { xpoViewModal: [{
            type: ViewChild,
            args: ['xpoViewModal']
        }] }); })();

const _c0$2 = ["xpoViewModal"];
class XpoViewMgtModalRenameView {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.renameViewForm = new FormGroup({
            viewName: new FormControl('', [Validators.required]),
        });
        this.renameViewData = {
            title: XpoViewMgtModalTexts.RenameViewTitle,
            submitButtonText: XpoViewMgtModalTexts.RenameViewSubmitBtn,
            cancelButtonText: XpoViewMgtModalTexts.RenameViewCancelBtn,
        };
        this.modalActions = data.actions;
        this.renameViewForm.patchValue({
            viewName: data.formData.viewName,
        });
    }
    /**
     * On rename submit
     */
    renameView() {
        var _a;
        if (!this.renameViewForm.valid) {
            this.renameViewForm.markAllAsTouched();
            return;
        }
        this.xpoViewModal.isSubmitting = true;
        // Callback for rename view
        (_a = this.modalActions) === null || _a === void 0 ? void 0 : _a.onSubmit({
            viewName: this.renameViewForm.get('viewName').value,
        });
    }
    /**
     * Cancel button action in modal
     */
    cancel() {
        var _a;
        // Callback for cancel
        (_a = this.modalActions) === null || _a === void 0 ? void 0 : _a.onCancel();
    }
}
XpoViewMgtModalRenameView.ɵfac = function XpoViewMgtModalRenameView_Factory(t) { return new (t || XpoViewMgtModalRenameView)(i0.ɵɵdirectiveInject(i1$5.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
XpoViewMgtModalRenameView.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoViewMgtModalRenameView, selectors: [["xpo-rename-view-modal"]], viewQuery: function XpoViewMgtModalRenameView_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.xpoViewModal = _t.first);
    } }, decls: 8, vars: 2, consts: [[3, "modalData", "onSubmit", "onCancel"], ["xpoViewModal", ""], [1, "xpo-ViewMgt-modalContent", 3, "formGroup", "ngSubmit"], [1, "xpo-ViewMgt-formFieldWrapper"], ["floatLabel", "always", 1, "xpo-ViewMgt-formField"], ["matInput", "", "placeholder", "View Name", "required", "", "formControlName", "viewName", 1, "xpo-ViewMgt-formFieldInput"]], template: function XpoViewMgtModalRenameView_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-view-modal", 0, 1);
        i0.ɵɵlistener("onSubmit", function XpoViewMgtModalRenameView_Template_xpo_view_modal_onSubmit_0_listener() { return ctx.renameView(); })("onCancel", function XpoViewMgtModalRenameView_Template_xpo_view_modal_onCancel_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵlistener("ngSubmit", function XpoViewMgtModalRenameView_Template_form_ngSubmit_2_listener() { return ctx.renameView(); });
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "mat-form-field", 4);
        i0.ɵɵelementStart(5, "mat-label");
        i0.ɵɵtext(6, "View Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "input", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalData", ctx.renameViewData);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.renameViewForm);
    } }, directives: [XpoViewMgtModal, i1$1.ɵNgNoValidate, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i4.MatFormField, i4.MatLabel, i5.MatInput, i1$1.DefaultValueAccessor, i1$1.RequiredValidator, i1$1.NgControlStatus, i1$1.FormControlName], styles: [".xpo-ViewMgt-modalContent{display:flex;flex-direction:column}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewMgtModalRenameView, [{
        type: Component,
        args: [{
                selector: 'xpo-rename-view-modal',
                templateUrl: './rename-view.component.html',
                styleUrls: ['./rename-view.component.scss'],
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i1$5.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { xpoViewModal: [{
            type: ViewChild,
            args: ['xpoViewModal']
        }] }); })();

const _c0$1 = ["xpoViewModal"];
class XpoViewMgtModalDeleteView {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.renameViewData = {
            title: XpoViewMgtModalTexts.DeleteViewTitle,
            submitButtonText: XpoViewMgtModalTexts.DeleteViewSubmitBtn,
            cancelButtonText: XpoViewMgtModalTexts.DeleteViewCancelBtn,
        };
        this.modalActions = data.actions;
        this.viewName = data.formData.viewName;
    }
    /**
     * On delete submit
     */
    deleteView() {
        var _a;
        // Callback for rename view
        this.xpoViewModal.isSubmitting = true;
        (_a = this.modalActions) === null || _a === void 0 ? void 0 : _a.onSubmit();
    }
    /**
     * Cancel button action in modal
     */
    cancel() {
        var _a;
        // Callback for cancel
        (_a = this.modalActions) === null || _a === void 0 ? void 0 : _a.onCancel();
    }
}
XpoViewMgtModalDeleteView.ɵfac = function XpoViewMgtModalDeleteView_Factory(t) { return new (t || XpoViewMgtModalDeleteView)(i0.ɵɵdirectiveInject(i1$5.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
XpoViewMgtModalDeleteView.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoViewMgtModalDeleteView, selectors: [["xpo-delete-view-modal"]], viewQuery: function XpoViewMgtModalDeleteView_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.xpoViewModal = _t.first);
    } }, decls: 8, vars: 2, consts: [[3, "modalData", "onSubmit", "onCancel"], ["xpoViewModal", ""], [1, "xpo-ViewMgt-modalContent", 3, "ngSubmit"], [1, "xpo-ViewMgt-formFieldWrapper"], [1, "xpo-ViewMgt-viewName"]], template: function XpoViewMgtModalDeleteView_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "xpo-view-modal", 0, 1);
        i0.ɵɵlistener("onSubmit", function XpoViewMgtModalDeleteView_Template_xpo_view_modal_onSubmit_0_listener() { return ctx.deleteView(); })("onCancel", function XpoViewMgtModalDeleteView_Template_xpo_view_modal_onCancel_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵlistener("ngSubmit", function XpoViewMgtModalDeleteView_Template_form_ngSubmit_2_listener() { return ctx.deleteView(); });
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵtext(5, "Are you sure you want to delete the following view?:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalData", ctx.renameViewData);
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(ctx.viewName);
    } }, directives: [XpoViewMgtModal, i1$1.ɵNgNoValidate, i1$1.NgControlStatusGroup, i1$1.NgForm], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-ViewMgt-modalContent[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-ViewMgt-formFieldWrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}.xpo-ViewMgt-viewName[_ngcontent-%COMP%]{display:flex;font-size:1.143rem;font-weight:bold}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewMgtModalDeleteView, [{
        type: Component,
        args: [{
                selector: 'xpo-delete-view-modal',
                templateUrl: './delete-view.component.html',
                styleUrls: ['./delete-view.component.scss'],
            }]
    }], function () { return [{ type: i1$5.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { xpoViewModal: [{
            type: ViewChild,
            args: ['xpoViewModal']
        }] }); })();

/*
Tests for new view management logic will be handled in 	NGXLTL-967
*/
const _c0 = ["viewsMenuTrigger"];
const _c1 = ["viewsSaveActions"];
const _c2 = ["viewsMoreActions"];
function XpoViewManagementComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, " PENDING SAVE ");
    i0.ɵɵelementEnd();
} }
const _c3 = ["*"];
class XpoViewManagementComponent {
    constructor(viewMgtDialog, viewMgtSnackbar) {
        this.viewMgtDialog = viewMgtDialog;
        this.viewMgtSnackbar = viewMgtSnackbar;
        this.CONNECTION_ERROR_MESSAGE = '[XPO-LTL-BOARD] View Management: Data source could not connect';
        this.stateChange$ = new ReplaySubject(1);
        this.viewIncrementor = 0;
        this.isMenuExpanded = false;
        this.viewList = [];
        // State changes for which we want to react on state change
        this.viewStateSources = [
            XpoBoardStateSources.BoardActivatingView,
            XpoBoardStateSources.ActiveViewChange,
            XpoBoardStateSources.SaveViewAs,
            XpoBoardStateSources.DeleteView,
        ];
        this.viewMgtOptions = {
            persistFiltersBetweenViews: false,
        };
    }
    ngAfterViewInit() {
        var _a;
        if ((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.connect) {
            this.dataSource.connect(this).subscribe((state) => {
                this.onStateChange(state);
            });
        }
        else {
            console.error(`${this.CONNECTION_ERROR_MESSAGE}`);
        }
    }
    /**
     * Handles state change
     * @param state
     */
    onStateChange(state) {
        if (!state) {
            return;
        }
        this.currentState = state;
        // Mark the view as dirty and enable saving.
        if (state.source === XpoBoardStateSources.GridSettingsUpdate) {
            this.markViewAsDirty();
        }
        // Map available views to current view list
        if (this.shouldRefreshViewList(state)) {
            this.populateViewList(state.availableViews);
        }
    }
    /**
     * Check if should move forward handling the state change
     * @param stateSource
     */
    shouldRefreshViewList(state) {
        return this.viewStateSources.some((source) => source === state.source) && state.availableViews.length > 0;
    }
    /**
     * Map viewList with current availableViews from state
     * @param availableViews
     */
    populateViewList(availableViews) {
        /* We need to preserve dirty views before re-creating the list. We should not add dirty as a view property because
        we would need to update/save the view every time it gets dirty but this property should no be 'saved' as part of the view,
        it's an in memory thing. */
        const dirtyViews = this.viewList.filter((view) => view.dirty);
        this.viewList = [];
        availableViews.forEach((view) => {
            this.viewList.push({
                id: view.id,
                name: view.name || XpoViewMgtModalTexts.DefaultViewName,
                group: 'TBD',
                owner: 'TBD',
                lastUpdated: view.lastSaved,
                bookmarked: true,
                dirty: dirtyViews.some((dView) => dView.id === view.id),
            });
        });
        this.updateSelectedView(this.currentState.viewId);
    }
    /**
     * Handle click on view item
     * @param view
     */
    onItemClick(view) {
        const selectedView = this.currentState.availableViews.find((availableView) => availableView.id === view.id);
        this.setActiveView(selectedView);
        this.viewsMenuTrigger.closeMenu();
    }
    /**
     * Switch to the given view
     * @param view
     */
    setActiveView(view) {
        var _a;
        // TODO: [NGXLTL-971] Check if enableQueryParamStatePersistance should be still supported
        this.dataSource.setState(XpoBoardViewUtil.activateView(view, this.currentState, XpoBoardViews.XpoBoardViewsSources.ActiveViewChange, (_a = this.viewMgtOptions) === null || _a === void 0 ? void 0 : _a.persistFiltersBetweenViews));
        this.updateSelectedView(view.id);
    }
    /**
     * Expand / Collapse menu
     */
    onMenuTriggerClick() {
        this.isMenuExpanded = !this.isMenuExpanded;
    }
    // TODO:[NGXLTL-1018] Defining this for future use
    onMenuOpened() { }
    // TODO:[NGXLTL-1018] Defining this for future use
    onMenuClosed() { }
    /**
     * Returns favorite views
     */
    getFavorites() {
        // TODO:[NGXLTL-1018] This will be handled in another way, this is just a mocked thing
        return this.viewList.filter((item) => item.bookmarked === true);
    }
    /**
     * Save view dialog
     * @param isSaveAs
     */
    openSaveViewAsDialog() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '600px'; // [NGXLTL-1018] TODO we'll try to handle this differently
        dialogConfig.data = {
            actions: {
                onSubmit: (formData) => {
                    this.saveViewAs(formData.viewName);
                },
            },
        };
        this.viewMgtDialog.open(XpoViewMgtModalSaveViewAs, dialogConfig);
        this.viewSaveActions.closed.emit();
    }
    /**
     * Rename view dialog
     */
    openRenameViewDialog() {
        const currentView = XpoBoardViewUtil.findActiveView(this.currentState);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '600px'; // [NGXLTL-1018] TODO we'll try to handle this differently
        dialogConfig.data = {
            formData: {
                viewName: currentView.name,
            },
            actions: {
                onSubmit: (formData) => {
                    this.renameView(formData.viewName);
                },
            },
        };
        this.viewMgtDialog.open(XpoViewMgtModalRenameView, dialogConfig);
        this.viewsMoreActions.closed.emit();
    }
    /**
     * Delete view dialog
     */
    openDeleteViewDialog() {
        const currentView = XpoBoardViewUtil.findActiveView(this.currentState);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '600px'; // [NGXLTL-1018] TODO we'll try to handle this differently
        dialogConfig.data = {
            formData: {
                viewName: currentView.name,
            },
            actions: {
                onSubmit: () => {
                    this.deleteView();
                },
            },
        };
        this.viewMgtDialog.open(XpoViewMgtModalDeleteView, dialogConfig);
        this.viewsMoreActions.closed.emit();
    }
    /**
     * Save as new view
     * @param viewName
     */
    saveViewAs(viewName) {
        const saveViewId = `${viewName}-${this.viewIncrementor++}`;
        const result = this.viewDataStore
            .save(Object.assign(Object.assign({}, this.currentState), { id: saveViewId, lastSaved: new Date(), name: viewName, systemDefined: false, closeable: true }))
            .pipe(map((savedView) => {
            const newView = this.currentState.template.createView(savedView);
            const nextState = XpoBoardViewUtil.addView(newView, this.currentState, XpoBoardStateSources.SaveViewAs);
            return nextState;
        }));
        result.pipe(take(1)).subscribe((newState) => {
            this.viewMgtDialog.closeAll();
            this.viewMgtSnackbar.success(XpoViewMgtMessages.SaveViewAsSuccess);
            this.markViewAsDirty(false);
            this.dataSource.setState(newState);
        });
    }
    /**
     * Save changes on current view
     */
    saveCurrentView() {
        const currentView = XpoBoardViewUtil.findActiveView(this.currentState);
        const updatedView = currentView.toViewConfig(this.currentState);
        const result = this.viewDataStore.save(updatedView).pipe(map((savedView) => {
            const newView = this.currentState.template.createView(savedView);
            const nextState = XpoBoardViewUtil.updateView(newView, this.currentState, XpoBoardStateSources.SaveView);
            return nextState;
        }));
        result.pipe(take(1)).subscribe((newState) => {
            this.viewMgtDialog.closeAll();
            this.viewMgtSnackbar.success(XpoViewMgtMessages.SaveViewSuccess);
            this.markViewAsDirty(false);
            this.dataSource.setState(newState);
        });
    }
    /**
     * Rename current view
     * @param viewName
     */
    renameView(viewName) {
        const currentView = XpoBoardViewUtil.findActiveView(this.currentState);
        const viewConfig = currentView.toViewConfig(this.currentState);
        viewConfig.name = viewName;
        const result = this.viewDataStore.save(viewConfig).pipe(map((savedView) => {
            const newView = this.currentState.template.createView(savedView);
            const nextState = XpoBoardViewUtil.updateView(newView, this.currentState, XpoBoardStateSources.ActiveViewChange);
            return nextState;
        }));
        result.pipe(take(1)).subscribe((newState) => {
            this.viewMgtDialog.closeAll();
            this.viewMgtSnackbar.success(XpoViewMgtMessages.RenameViewSuccess);
            this.dataSource.setState(newState);
        });
    }
    /**
     * Refresh current view
     */
    refreshView() {
        this.setActiveView(XpoBoardViewUtil.findActiveView(this.currentState));
        this.markViewAsDirty(false);
    }
    /**
     * Delete current view
     */
    deleteView() {
        const activeView = XpoBoardViewUtil.findActiveView(this.currentState);
        const result = this.viewDataStore.delete(activeView.id).pipe(map((status) => {
            return XpoBoardViewUtil.deleteView(activeView.id, this.currentState, XpoBoardStateSources.DeleteView);
        }));
        result.pipe(take(1)).subscribe((newState) => {
            this.viewMgtDialog.closeAll();
            this.viewMgtSnackbar.success(XpoViewMgtMessages.DeleteViewSuccess);
            this.markViewAsDirty(false);
            this.dataSource.setState(newState);
        });
        this.viewsMoreActions.closed.emit();
    }
    /**
     * Set a view as dirty
     * @param dirty
     */
    markViewAsDirty(dirty = true) {
        const view = this.viewList.find((view) => view.id === this.selectedView.id);
        view.dirty = dirty;
    }
    /**
     * Update selected view from viewId
     * @param viewId
     */
    updateSelectedView(viewId) {
        this.selectedView = this.viewList.find((view) => view.id === viewId);
    }
}
XpoViewManagementComponent.ɵfac = function XpoViewManagementComponent_Factory(t) { return new (t || XpoViewManagementComponent)(i0.ɵɵdirectiveInject(i1$5.MatDialog), i0.ɵɵdirectiveInject(i2$4.XpoSnackBar)); };
XpoViewManagementComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoViewManagementComponent, selectors: [["xpo-view-management"]], viewQuery: function XpoViewManagementComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewsMenuTrigger = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewSaveActions = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewsMoreActions = _t.first);
    } }, inputs: { viewMgtOptions: "viewMgtOptions", dataSource: "dataSource", viewDataStore: "viewDataStore" }, ngContentSelectors: _c3, decls: 56, vars: 9, consts: [[1, "xpo-ViewMgt-wrapper"], [1, "xpo-ViewMgt-trigger", 3, "matMenuTriggerFor", "click", "menuOpened", "menuClosed"], ["viewsMenuTrigger", "matMenuTrigger"], [1, "xpo-ViewMgt-triggerTitle"], [1, "xpo-ViewMgt-triggerSubtitle"], ["class", "xpo-ViewMgt-trigger-dirtyIndicator", 4, "ngIf"], [1, "xpo-ViewMgt-externalContentWrapper"], ["viewsMenu", "matMenu"], [1, "xpo-ViewMgt-menu", 3, "click"], ["selectedIndex", "0", 1, "xpo-ViewMgt-tabs"], ["label", "All"], [3, "viewList", "itemClick"], ["label", "Favorite", "disabled", ""], ["label", "Recent", "disabled", ""], ["label", "Shared with me", "disabled", ""], [1, "xpo-ViewMgt-toolbar"], ["xpo-action-button", "", "aria-tooltip", "Action button", 1, "xpo-ViewMgt-toolbarButton", "xpo-ViewMgt-toolbarActionButton", 3, "click"], [1, "xpo-ViewMgt-toolbarActionButtonIcon"], ["xpo-action-button", "", "matTooltip", "More Actions", "aria-tooltip", "Action button", 1, "xpo-ViewMgt-toolbarButton", "xpo-ViewMgt-toolbarActionButton", 3, "xpoLtlpopoverTriggerFor"], [1, "xpo-ViewMgt-toolbarButton", "xpo-ViewMgt-toolbarButton-save"], ["mat-flat-button", "", "xpoSmallButton", "", 1, "xpo-ViewMgt-toolbarButton", "xpo-ViewMgt-toolbarButton-savePrimaryAction", 3, "disabled", "click"], ["mat-flat-button", "", "xpoSmallButton", "", 1, "xpo-ViewMgt-toolbarButton", "xpo-ViewMgt-toolbarButton-saveExpander", 3, "xpoLtlpopoverTriggerFor"], [1, "xpo-ViewMgt-toolbarButton-saveExpanderIcon"], ["arrowBehaviourAuto", "true", "position", "below"], ["viewsMoreActions", ""], [1, "xpo-ViewMgt-Popover-content"], [1, "xpo-ViewMgt-menuList"], [1, "xpo-ViewMgt-menuItem"], ["color", "accent", 1, "xpo-ViewMgt-menuItem-action", 3, "click"], ["color", "accent", 1, "xpo-ViewMgt-menuItem-action", 3, "disabled", "click"], [1, "xpo-ViewMgt-menuItem", "xpo-ViewMgt-menuItem--disabled"], ["disabled", "", "color", "accent", 1, "xpo-ViewMgt-menuItem-action"], ["viewsSaveActions", ""], [1, "xpo-ViewMgt-actions"], [1, "xpo-ViewMgt-actionItem"], ["xpo-regular-link", "", "color", "accent", 1, "xpo-ViewMgt-menuItem-action", 3, "click"], [1, "xpo-ViewMgt-trigger-dirtyIndicator"]], template: function XpoViewManagementComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1, 2);
        i0.ɵɵlistener("click", function XpoViewManagementComponent_Template_div_click_1_listener() { return ctx.onMenuTriggerClick(); })("menuOpened", function XpoViewManagementComponent_Template_div_menuOpened_1_listener() { return ctx.onMenuOpened(); })("menuClosed", function XpoViewManagementComponent_Template_div_menuClosed_1_listener() { return ctx.onMenuClosed(); });
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, "SELECTED VIEW");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "span");
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, XpoViewManagementComponent_span_8_Template, 2, 0, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵprojection(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "mat-menu", null, 7);
        i0.ɵɵelementStart(13, "div", 8);
        i0.ɵɵlistener("click", function XpoViewManagementComponent_Template_div_click_13_listener($event) { return $event.stopPropagation(); });
        i0.ɵɵelementStart(14, "mat-tab-group", 9);
        i0.ɵɵelementStart(15, "mat-tab", 10);
        i0.ɵɵelementStart(16, "div");
        i0.ɵɵelementStart(17, "xpo-view-list", 11);
        i0.ɵɵlistener("itemClick", function XpoViewManagementComponent_Template_xpo_view_list_itemClick_17_listener($event) { return ctx.onItemClick($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "mat-tab", 12);
        i0.ɵɵelementStart(19, "div");
        i0.ɵɵelementStart(20, "xpo-view-list", 11);
        i0.ɵɵlistener("itemClick", function XpoViewManagementComponent_Template_xpo_view_list_itemClick_20_listener($event) { return ctx.onItemClick($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(21, "mat-tab", 13);
        i0.ɵɵelement(22, "mat-tab", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 15);
        i0.ɵɵelementStart(24, "button", 16);
        i0.ɵɵlistener("click", function XpoViewManagementComponent_Template_button_click_24_listener() { return ctx.refreshView(); });
        i0.ɵɵelementStart(25, "mat-icon", 17);
        i0.ɵɵtext(26, "refresh");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "button", 18);
        i0.ɵɵelementStart(28, "mat-icon", 17);
        i0.ɵɵtext(29, "more_horiz");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 19);
        i0.ɵɵelementStart(31, "button", 20);
        i0.ɵɵlistener("click", function XpoViewManagementComponent_Template_button_click_31_listener() { return ctx.saveCurrentView(); });
        i0.ɵɵtext(32, " Save View ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "button", 21);
        i0.ɵɵelementStart(34, "mat-icon", 22);
        i0.ɵɵtext(35, "arrow_drop_down");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "xpo-ltl-popover", 23, 24);
        i0.ɵɵelementStart(38, "xpo-ltl-popover-content", 25);
        i0.ɵɵelementStart(39, "ul", 26);
        i0.ɵɵelementStart(40, "li", 27);
        i0.ɵɵelementStart(41, "button", 28);
        i0.ɵɵlistener("click", function XpoViewManagementComponent_Template_button_click_41_listener() { return ctx.openRenameViewDialog(); });
        i0.ɵɵtext(42, "Rename View");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "li", 27);
        i0.ɵɵelementStart(44, "button", 29);
        i0.ɵɵlistener("click", function XpoViewManagementComponent_Template_button_click_44_listener() { return ctx.openDeleteViewDialog(); });
        i0.ɵɵtext(45, "Delete View");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "li", 30);
        i0.ɵɵelementStart(47, "button", 31);
        i0.ɵɵtext(48, "Share View");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "xpo-ltl-popover", 23, 32);
        i0.ɵɵelementStart(51, "xpo-ltl-popover-content", 25);
        i0.ɵɵelementStart(52, "ul", 33);
        i0.ɵɵelementStart(53, "li", 34);
        i0.ɵɵelementStart(54, "button", 35);
        i0.ɵɵlistener("click", function XpoViewManagementComponent_Template_button_click_54_listener() { return ctx.openSaveViewAsDialog(); });
        i0.ɵɵtext(55, "Save as");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(12);
        const _r3 = i0.ɵɵreference(37);
        const _r4 = i0.ɵɵreference(50);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matMenuTriggerFor", _r2);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedView == null ? null : ctx.selectedView.name, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedView == null ? null : ctx.selectedView.dirty);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("viewList", ctx.viewList);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("viewList", ctx.getFavorites());
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("xpoLtlpopoverTriggerFor", _r3);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", !(ctx.selectedView == null ? null : ctx.selectedView.dirty));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("xpoLtlpopoverTriggerFor", _r4);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("disabled", ctx.viewList.length <= 1);
    } }, directives: [i6.MatMenuTrigger, i2.NgIf, i6.MatMenu, i2$2.MatTabGroup, i2$2.MatTab, XpoViewListComponent, i2$1.XpoActionButton, i3.MatIcon, i9.XpoLtlPopoverTrigger, i3$1.MatButton, i2$1.XpoSmallButton, i9.XpoLtlPopover, i9.XpoLtlPopoverContent], styles: [".flex--stretch{flex:1}.xpo-ViewMgt-FullWidth .xpo-ViewMgt-wrapper{width:100%}.xpo-ViewMgt-FullWidth .xpo-ViewMgt-externalContentWrapper{flex-grow:1}.xpo-ViewMgt-wrapper{background-color:#fff;display:flex;flex-direction:row}.xpo-ViewMgt-trigger{background-color:#fff;border-left:none;border-right:1px solid #dddddd;cursor:pointer;display:flex;flex-direction:column;margin:8px 0;min-width:300px;padding:0 8px;position:relative}.xpo-ViewMgt-trigger:after{border-bottom:0 solid transparent;border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #000000;content:\"\";position:absolute;right:10px;top:50%;transform:translate-y(-50%)}.xpo-ViewMgt-triggerTitle{color:#6f6f6f;display:flex;font-size:12px}.xpo-ViewMgt-triggerSubtitle{align-items:center;display:flex;font-size:16px;line-height:16px}.xpo-ViewMgt-triggerSubtitle span{display:flex;flex-direction:column}.xpo-ViewMgt-trigger-dirtyIndicator{align-items:center;background-color:#d32f2f;color:#fff;font-size:10px;font-weight:bold;height:auto;justify-content:center;margin-left:16px;padding:1px 4px}.xpo-ViewMgt-externalContentWrapper{display:flex}.xpo-ViewMgt-toolbar{align-items:center;display:flex;justify-content:center;padding:0 16px}.xpo-ViewMgt-toolbarButton{cursor:pointer;margin-right:8px}.xpo-ViewMgt-toolbarButton:last-child{margin-right:0}.xpo-ViewMgt-toolbarButton-savePrimaryAction{border-bottom-right-radius:0;border-top-right-radius:0;font-size:1rem;margin-right:0;padding:0 5px 0 16px;text-transform:uppercase}.xpo-ViewMgt-toolbarButton-savePrimaryAction[disabled]{background-color:#68b3e1;border-color:#68b3e1}.xpo-ViewMgt-toolbarButton-savePrimaryAction[disabled]:hover{background-color:#68b3e1;border-color:#68b3e1}.xpo-ViewMgt-toolbarButton-saveExpander{border-bottom-left-radius:0!important;border-top-left-radius:0!important;justify-content:center;padding:0 5px!important;width:25px!important}.xpo-ViewMgt-toolbarButton-saveExpanderIcon{font-size:22px}.xpo-ViewMgt-toolbarActionButton{border-radius:2px}.xpo-ViewMgt-toolbarActionButtonIcon{align-items:center;display:flex;font-size:22px;justify-content:center;padding:0}.xpo-ViewMgt-menu{align-items:center;background:#ffffff;box-shadow:4px 3px 5px #9b9b9b;display:flex;height:300px;justify-content:center;padding:0;width:500px}.xpo-ViewMgt-menuItem--disabled a{color:#9b9b9b;cursor:default;text-decoration:none}.xpo-ViewMgt-menuItem-action{background:none;border:none;color:#000;cursor:pointer;min-width:120px;padding:8px;text-align:left;width:100%}.xpo-ViewMgt-menuItem-action:hover{background-color:#e4effa}.xpo-ViewMgt-menuItem-action[disabled]{color:#9b9b9b;cursor:auto}.xpo-ViewMgt-menuItem-action[disabled]:hover{background-color:#fff}.xpo-ViewMgt-tabs{height:100%;width:100%}.xpo-ViewMgt-Popover-content{min-width:100px;padding:0!important}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewManagementComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-view-management',
                templateUrl: 'view-management.component.html',
                styleUrls: ['view-management.component.scss'],
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i1$5.MatDialog }, { type: i2$4.XpoSnackBar }]; }, { viewMgtOptions: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], viewDataStore: [{
            type: Input
        }], viewsMenuTrigger: [{
            type: ViewChild,
            args: ['viewsMenuTrigger']
        }], viewSaveActions: [{
            type: ViewChild,
            args: ['viewsSaveActions']
        }], viewsMoreActions: [{
            type: ViewChild,
            args: ['viewsMoreActions']
        }] }); })();

class XpoViewManagementModule {
}
XpoViewManagementModule.ɵfac = function XpoViewManagementModule_Factory(t) { return new (t || XpoViewManagementModule)(); };
XpoViewManagementModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoViewManagementModule });
XpoViewManagementModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatIconModule,
            MatMenuModule,
            MatTableModule,
            MatFormFieldModule,
            MatInputModule,
            MatRadioModule,
            MatCheckboxModule,
            XpoDialogModule,
            MatProgressSpinnerModule,
            XpoTabsModule,
            XpoButtonModule,
            XpoCheckboxModule,
            XpoLtlPopoverModule,
            XpoIconModule,
            XpoSnackBarModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoViewManagementModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatIconModule,
                    MatMenuModule,
                    MatTableModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatRadioModule,
                    MatCheckboxModule,
                    XpoDialogModule,
                    MatProgressSpinnerModule,
                    XpoTabsModule,
                    XpoButtonModule,
                    XpoCheckboxModule,
                    XpoLtlPopoverModule,
                    XpoIconModule,
                    XpoSnackBarModule,
                ],
                declarations: [
                    XpoViewManagementComponent,
                    XpoViewListComponent,
                    XpoViewMgtModal,
                    XpoViewMgtModalSaveViewAs,
                    XpoViewMgtModalRenameView,
                    XpoViewMgtModalDeleteView,
                    XpoViewMgtFullWidthDirective,
                ],
                exports: [
                    XpoViewManagementComponent,
                    XpoViewListComponent,
                    XpoViewMgtModal,
                    XpoViewMgtModalSaveViewAs,
                    XpoViewMgtModalRenameView,
                    XpoViewMgtModalDeleteView,
                    XpoViewMgtFullWidthDirective,
                ],
                entryComponents: [XpoViewMgtModal, XpoViewMgtModalSaveViewAs, XpoViewMgtModalRenameView, XpoViewMgtModalDeleteView],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoViewManagementModule, { declarations: [XpoViewManagementComponent,
        XpoViewListComponent,
        XpoViewMgtModal,
        XpoViewMgtModalSaveViewAs,
        XpoViewMgtModalRenameView,
        XpoViewMgtModalDeleteView,
        XpoViewMgtFullWidthDirective], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatMenuModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatCheckboxModule,
        XpoDialogModule,
        MatProgressSpinnerModule,
        XpoTabsModule,
        XpoButtonModule,
        XpoCheckboxModule,
        XpoLtlPopoverModule,
        XpoIconModule,
        XpoSnackBarModule], exports: [XpoViewManagementComponent,
        XpoViewListComponent,
        XpoViewMgtModal,
        XpoViewMgtModalSaveViewAs,
        XpoViewMgtModalRenameView,
        XpoViewMgtModalDeleteView,
        XpoViewMgtFullWidthDirective] }); })();

/*
 * Public API Surface of xpo-ui-board
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BOARD_ACTIVE_VIEW_QUERY_PARAM, ConditionalFilterCombiner, DEFAULT_DATA_DRAWER_VISIBILITY_STRATEGY, DEFAULT_FILER_STRATEGY, DashbarService, OperatorText, Operators, OperatorsToOperatorText, VisibleBoardViewModel, XPO_BOARD_DEFAULT_OPTIONS, XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT, XPO_PAGINATION_DEFAULT_PAGE_SIZES, XpoAccordionGroupCellRendererComponent, XpoAdvancedSelectModule, XpoAdvancedSelectPanelComponent, XpoAdvancedSelectTreeNodeComponent, XpoAppliedFilters, XpoAvailableViewItem, XpoAvailableViews, XpoAvailableViewsFilter, XpoBoard, XpoBoardActionType, XpoBoardActions, XpoBoardActionsVisibilityService, XpoBoardApi, XpoBoardApiAction, XpoBoardApiDispatcherBase, XpoBoardApiDispatcherService, XpoBoardConsumer, XpoBoardData, XpoBoardDataFetchDisplay, XpoBoardDataFetchState, XpoBoardDataFetcher, XpoBoardDataSource, XpoBoardDataSourceResolver, XpoBoardGridToolbar, XpoBoardGridToolbarActions, XpoBoardGridToolbarActionsMore, XpoBoardGridToolbarDynamicMore, XpoBoardGridToolbarSettings, XpoBoardHeader, XpoBoardHeaderTitle, XpoBoardModule, XpoBoardNoResultsDisplay, XpoBoardPagination, XpoBoardStateSources, XpoBoardStreamingDataSource, XpoBoardTotalRecords, XpoBoardView, XpoBoardViewDataStoreBase, XpoBoardViewInMemoryDataStore, XpoBoardViewTemplate, XpoBoardViewUtil, XpoBoardViews, XpoBoardViewsAlternateTabs, XpoBoardViewsModule, XpoBooleanFilterComponent, XpoCalendarComponent, XpoCellRenderersModule, XpoCheckboxFilter, XpoCheckboxFilterComponent, XpoColumnLevelFilteringToggleComponent, XpoConditionBooleanFalseComponent, XpoConditionBooleanTrueComponent, XpoConditionComponentDirective, XpoConditionDateAfterComponent, XpoConditionDateAfterSameComponent, XpoConditionDateBeforeComponent, XpoConditionDateBeforeSameComponent, XpoConditionDateBetweenComponent, XpoConditionDateEqualsComponent, XpoConditionDateIsComponent, XpoConditionDateNotBetweenComponent, XpoConditionDateTimeAfterComponent, XpoConditionDateTimeAfterSameComponent, XpoConditionDateTimeBeforeComponent, XpoConditionDateTimeBeforeSameComponent, XpoConditionDateTimeBetweenComponent, XpoConditionDateTimeNotBetweenComponent, XpoConditionDynamicEnumEqualsComponent, XpoConditionEmptyComponent, XpoConditionEnumEqualsComponent, XpoConditionIsNotEmptyComponent, XpoConditionIsOneOfComponent, XpoConditionNumberEqualsComponent, XpoConditionNumberGreaterEqualThanComponent, XpoConditionNumberGreaterThanComponent, XpoConditionNumberIsBetweenComponent, XpoConditionNumberIsNotBetweenComponent, XpoConditionNumberLessEqualThanComponent, XpoConditionNumberLessThanComponent, XpoConditionNumberNotEqualsComponent, XpoConditionRangeEmptyComponent, XpoConditionRangeNotEmptyComponent, XpoConditionStringContainsComponent, XpoConditionStringDoesNotContainComponent, XpoConditionStringEndsWithComponent, XpoConditionStringEqualsComponent, XpoConditionStringIsBetweenComponent, XpoConditionStringIsNotBetweenComponent, XpoConditionStringIsNotEqualComponent, XpoConditionStringStartsWithComponent, XpoConditionTimeAfterComponent, XpoConditionTimeAfterSameComponent, XpoConditionTimeBeforeComponent, XpoConditionTimeBeforeSameComponent, XpoConditionTimeBetweenComponent, XpoConditionTimeEqualsComponent, XpoConditionTimeIsComponent, XpoConditionTimeNotBetweenComponent, XpoConditionTimeRangeAfterComponent, XpoConditionTimeRangeBeforeComponent, XpoConditionTimeRangeBetweenComponent, XpoConditionTimeRangeNotBetweenComponent, XpoConditionalFilterComponent, XpoDashbar, XpoDashbarMetric, XpoDashbarMetricPopover, XpoDashbarModule, XpoDataDrawer, XpoDataDrawerDataSource, XpoDataDrawerDefaultDataSource, XpoDataDrawerHeader, XpoDataDrawerModule, XpoDataDrawerState, XpoDataDrawerVisibility, XpoDateFilter, XpoDateFilterBase, XpoDateFilterComponent, XpoDateFilterComponentBase, XpoDateOnlyFilterComponent, XpoDateRangeDaily, XpoDateRangeFilter, XpoDateRangeFilterComponent, XpoDateRangeFilterGroupByComponent, XpoDateRangeFilterHelper, XpoDateRangeGroupByFilter, XpoDateRangeHourly, XpoDateRangeIntervalBase, XpoDateRangeIntervalFactory, XpoDateRangeMonthly, XpoDateRangeQuarterly, XpoDateRangeWeekly, XpoDateRangeYearly, XpoDateTimeFilterComponent, XpoDeleteViewConfirmDialog, XpoDynamicEnumFilterComponent, XpoEnumFilterComponent, XpoFilter, XpoFilterBar, XpoFilterChip, XpoFilterComponentBase, XpoFilterContainer, XpoFilterDateSelectorComponent, XpoFilterForm, XpoFilterFormHost, XpoFilterHost, XpoFiltersModule, XpoFiltersService, XpoGlobalFilterBar, XpoGridBar, XpoGridBarModule, XpoGridBoardInMemoryColumnFactory, XpoGridBoardView, XpoGridBoardViewUtils, XpoGridColumnSelectionComponent, XpoGridDisplayDensityOptions, XpoGridRowHeightSelectionComponent, XpoGridSettingsColumnSelectionComponent, XpoGridSettingsComponent, XpoGridToolbarModule, XpoInMemoryFilterFactory, XpoInlineFilter, XpoInlineMultiSelectFilter, XpoInlineMultiSelectFilterComponent, XpoLocalStorageBoardViewDataStore, XpoMultiSelectAutoCompleteFilterSelectedOptionsComponent, XpoMultiSelectAutocompleteFilter, XpoMultiSelectAutocompleteFilterComponent, XpoMultiSelectFilter, XpoNoBorderTabs, XpoNumberFilterComponent, XpoQuickDate, XpoQuickSearchFilter, XpoQuickSearchFilterComponent, XpoRowModelType, XpoSaveViewComponent, XpoSaveViewDialog, XpoSaveViewDialogPurpose, XpoSelectFilter, XpoSelectFilterComponent, XpoSettingsFloatingFiltersComponent, XpoSettingsGridOptionsComponent, XpoSettingsRowHeightComponent, XpoSingleSelectFilter, XpoSortExpression, XpoStringFilterComponent, XpoTextInputFilter, XpoTextInputFilterComponent, XpoThousandsSeparator, XpoTimeFilterComponent, XpoTimeRangeFilterComponent, XpoViewListComponent, XpoViewManagementComponent, XpoViewManagementModule, XpoViewMgtFullWidthDirective, XpoViewMgtModal, XpoViewMgtModalDeleteView, XpoViewMgtModalRenameView, XpoViewMgtModalSaveViewAs, XpoViewMgtModalTexts, XpoYesNoFilter, XpoYesNoFilterComponent, filterFormats, filtersServiceFactory, getTodayAt, isExportableDataSource, ordersMinMaxDate, ordersMinMaxDateTime, ordersMinMaxTime, xpoDateFormatter, xpoDateTimeFormatter, xpoShortDateFormatter, xpoTimeFormatter };
